import gql from 'graphql-tag'
import * as Urql from 'urql'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never
}
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	BigInt: { input: any; output: any }
	DateTime: { input: any; output: any }
	DateTimeISO: { input: any; output: any }
	Decimal: { input: any; output: any }
	JSON: { input: any; output: any }
	JSONObject: { input: any; output: any }
}

/** The mode used to acknowledge the stored card */
export enum AcknowledgementMode {
	Email = 'email',
	Esign = 'esign',
	Selection = 'selection',
	Toggle = 'toggle'
}

export enum ActionItemResoltionTypes {
	AddedToPims = 'added_to_pims',
	GetLockboxId = 'get_lockbox_id',
	LockboxMailed = 'lockbox_mailed',
	NoResolution = 'no_resolution',
	NotCollected = 'not_collected',
	PaidByOtherMeans = 'paid_by_other_means',
	PaymentEntered = 'payment_entered',
	Recorded = 'recorded',
	ReranCheck = 'reran_check'
}

export enum ActionItemTypes {
	ArPaymentReceived = 'AR_PAYMENT_RECEIVED',
	DailyCashCountReminder = 'DAILY_CASH_COUNT_REMINDER',
	FailedCheck = 'FAILED_CHECK',
	FailedLockbox = 'FAILED_LOCKBOX',
	MobilePayment = 'MOBILE_PAYMENT',
	OfflinePaymentFailed = 'OFFLINE_PAYMENT_FAILED',
	OfflinePaymentSucceeded = 'OFFLINE_PAYMENT_SUCCEEDED',
	PaperCheckBounced = 'PAPER_CHECK_BOUNCED',
	PaperCheckRejected = 'PAPER_CHECK_REJECTED'
}

/** ActionNeeded item */
export type ActionNeeded = {
	__typename?: 'ActionNeeded'
	actionItemType: ActionItemTypes
	amount: Scalars['Float']['output']
	chargeId?: Maybe<Scalars['String']['output']>
	clientId?: Maybe<Scalars['String']['output']>
	clientName?: Maybe<Scalars['String']['output']>
	completedAt?: Maybe<Scalars['DateTimeISO']['output']>
	completedBy?: Maybe<Scalars['String']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidator?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	dateAdjustedInPims?: Maybe<Scalars['DateTimeISO']['output']>
	failureCode?: Maybe<Scalars['String']['output']>
	failureMessage?: Maybe<Scalars['String']['output']>
	id: Scalars['ID']['output']
	invoiceId?: Maybe<Scalars['String']['output']>
	isComplete: Scalars['Boolean']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
	notes?: Maybe<Scalars['String']['output']>
	paid?: Maybe<Scalars['Boolean']['output']>
	paymentIntentId?: Maybe<Scalars['String']['output']>
	practice: ActionNeededPractice
	resolution?: Maybe<ActionItemResoltionTypes>
	resolutionNote?: Maybe<Scalars['String']['output']>
	scratchPaymentMethod?: Maybe<Scalars['String']['output']>
	stripeCreatedDate?: Maybe<Scalars['DateTimeISO']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

/** List of ActionNeeded items with pagination */
export type ActionNeededList = {
	__typename?: 'ActionNeededList'
	args: BaseListArgs
	items: Array<ActionNeeded>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A sort order for a field on Action Needed */
export type ActionNeededOrderByInput = {
	actionItemType?: InputMaybe<SortOrder>
	amount?: InputMaybe<SortOrder>
	clientName?: InputMaybe<SortOrder>
	dateAdjustedInPims?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	practice?: InputMaybe<PracticeOrderByInput>
	practiceId?: InputMaybe<SortOrder>
	stripeCreatedDate?: InputMaybe<SortOrder>
}

/** ActionNeeded practice */
export type ActionNeededPractice = {
	__typename?: 'ActionNeededPractice'
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	netsuiteId?: Maybe<Scalars['String']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
}

/** A query filter for a list of actionNeeded rows */
export type ActionNeededWhereInput = {
	AND?: InputMaybe<Array<ActionNeededWhereInput>>
	OR?: InputMaybe<Array<ActionNeededWhereInput>>
	actionItemType?: InputMaybe<StringNullableFilter>
	amount?: InputMaybe<FloatFilter>
	clientName?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	isComplete?: InputMaybe<Scalars['Boolean']['input']>
	practice?: InputMaybe<PracticeWhereInput>
	stripeCreatedDate?: InputMaybe<DateTimeFilter>
}

/** Response for rebate approval */
export type ApproveRebateResponse = {
	__typename?: 'ApproveRebateResponse'
	/** Error message if approval failed */
	error?: Maybe<Scalars['String']['output']>
	/** The updated rebate */
	rebate?: Maybe<InvoiceDetectedRebate>
	/** Whether the approval was successful */
	success: Scalars['Boolean']['output']
}

/** Invoice Detected Rebate Audit Log */
export type AuditLog = {
	__typename?: 'AuditLog'
	actionNotes?: Maybe<Scalars['String']['output']>
	actionReason?: Maybe<Scalars['String']['output']>
	actionType: InvoiceDetectedRebateAuditLogActionType
	changes: Scalars['JSON']['output']
	createdAt: Scalars['DateTime']['output']
	id: Scalars['String']['output']
	invoiceDetectedRebateId: Scalars['String']['output']
	reviewedBy?: Maybe<Scalars['String']['output']>
}

/** A B2B rebate payout upload file and its processing metadata */
export type B2bRebatePayoutFile = {
	__typename?: 'B2bRebatePayoutFile'
	/** Time processing completed */
	completedAt?: Maybe<Scalars['DateTime']['output']>
	/** Created at timestamp */
	createdAt: Scalars['DateTime']['output']
	/** Original uploaded file name */
	fileName: Scalars['String']['output']
	/** Unique identifier for the payout file */
	id: Scalars['String']['output']
	/** Processing notes (warnings, errors) */
	notes?: Maybe<Scalars['JSON']['output']>
	/** Total records parsed from the file */
	recordsCount?: Maybe<Scalars['Int']['output']>
	/** Time processing started */
	startedAt?: Maybe<Scalars['DateTime']['output']>
	/** File status (QUEUED, PROCESSING, PROCESSED, FAILED) */
	status: Scalars['String']['output']
	/** Updated at timestamp */
	updatedAt: Scalars['DateTime']['output']
	/** User ID of the uploader */
	uploadedBy: Scalars['String']['output']
	/** Display name of the uploader */
	uploadedByName?: Maybe<Scalars['String']['output']>
	/** Valid records persisted from the file */
	validRecordsCount?: Maybe<Scalars['Int']['output']>
}

/** Response containing B2B rebate payout files with count */
export type B2bRebatePayoutFileListWithCount = {
	__typename?: 'B2bRebatePayoutFileListWithCount'
	args: BaseListArgs
	/** List of B2B rebate payout files */
	items: Array<B2bRebatePayoutFile>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for B2B rebate payout files */
export type B2bRebatePayoutFileOrderByInput = {
	completedAt?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	fileName?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
	uploadedBy?: InputMaybe<SortOrder>
}

/** Filter conditions for B2B rebate payout files */
export type B2bRebatePayoutFileWhereInput = {
	AND?: InputMaybe<Array<B2bRebatePayoutFileWhereInput>>
	NOT?: InputMaybe<Array<B2bRebatePayoutFileWhereInput>>
	OR?: InputMaybe<Array<B2bRebatePayoutFileWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	fileName?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	status?: InputMaybe<StringNullableFilter>
	uploadedBy?: InputMaybe<StringFilter>
}

/** A single B2B rebate payout record parsed from an upload file */
export type B2bRebatePayoutRecord = {
	__typename?: 'B2bRebatePayoutRecord'
	/** Consolidated practice ID */
	consolidatedPracticeId?: Maybe<Scalars['String']['output']>
	/** Created at timestamp */
	createdAt: Scalars['DateTime']['output']
	/** Unique identifier for the payout record */
	id: Scalars['String']['output']
	/** Manufacturer ID */
	manufacturerId: Scalars['String']['output']
	/** Manufacturer name */
	manufacturerName?: Maybe<Scalars['String']['output']>
	/** Payout date */
	payoutDate: Scalars['DateTime']['output']
	/** Practice name snapshot captured at upload time */
	practiceName?: Maybe<Scalars['String']['output']>
	/** Number of individual rebates this record represents */
	rebateCount?: Maybe<Scalars['Int']['output']>
	/** Associated rebate payout batch ID */
	rebatePayoutBatchId?: Maybe<Scalars['String']['output']>
	/** Reimbursement amount (in cents) */
	reimbursementAmount: Scalars['Int']['output']
	/** Statement descriptor */
	statementDescriptor?: Maybe<Scalars['String']['output']>
	/** Record status (APPROVED, REJECTED) */
	status: Scalars['String']['output']
	/** Updated at timestamp */
	updatedAt: Scalars['DateTime']['output']
	/** ID of the payout upload file this record belongs to */
	uploadId: Scalars['String']['output']
}

/** Response containing B2B rebate payout records with count */
export type B2bRebatePayoutRecordListWithCount = {
	__typename?: 'B2bRebatePayoutRecordListWithCount'
	args: BaseListArgs
	/** List of B2B rebate payout records */
	items: Array<B2bRebatePayoutRecord>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for B2B rebate payout records */
export type B2bRebatePayoutRecordOrderByInput = {
	consolidatedPracticeId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	manufacturerId?: InputMaybe<SortOrder>
	payoutDate?: InputMaybe<SortOrder>
	reimbursementAmount?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** Filter conditions for B2B rebate payout records */
export type B2bRebatePayoutRecordWhereInput = {
	AND?: InputMaybe<Array<B2bRebatePayoutRecordWhereInput>>
	NOT?: InputMaybe<Array<B2bRebatePayoutRecordWhereInput>>
	OR?: InputMaybe<Array<B2bRebatePayoutRecordWhereInput>>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	manufacturerId?: InputMaybe<StringFilter>
	/** Filters on the joined manufacturer name (manufacturer relation) */
	manufacturerName?: InputMaybe<StringNullableFilter>
	payoutDate?: InputMaybe<DateTimeFilter>
	/** Filters on the practiceName snapshot column */
	practiceName?: InputMaybe<StringNullableFilter>
	status?: InputMaybe<StringNullableFilter>
	uploadId?: InputMaybe<StringFilter>
}

export enum BankAccountStatus {
	Active = 'ACTIVE',
	Closed = 'CLOSED',
	Draft = 'DRAFT',
	Fraud = 'FRAUD',
	Inactive = 'INACTIVE'
}

/** Base Args for List queries */
export type BaseListArgs = {
	__typename?: 'BaseListArgs'
	skip: Scalars['Int']['output']
	take?: Maybe<Scalars['Int']['output']>
}

/** BillingTask item */
export type BillingTask = {
	__typename?: 'BillingTask'
	createdAt: Scalars['DateTimeISO']['output']
	id: Scalars['String']['output']
	identifier: Scalars['String']['output']
	isAutomatedRun: Scalars['Boolean']['output']
	logExplorerLink: Scalars['String']['output']
	monthlyBillingLogId: Scalars['String']['output']
	request?: Maybe<Scalars['JSON']['output']>
	requestedBy?: Maybe<Scalars['String']['output']>
	responseSnapshot?: Maybe<Scalars['JSON']['output']>
	status: Scalars['String']['output']
	target: Scalars['String']['output']
	updatedAt: Scalars['DateTimeISO']['output']
}

/** List of Billing Tasks with pagination */
export type BillingTaskListWithCount = {
	__typename?: 'BillingTaskListWithCount'
	args: BaseListArgs
	items: Array<BillingTask>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type BillingTaskOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	identifier?: InputMaybe<SortOrder>
	isAutomatedRun?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	target?: InputMaybe<SortOrder>
}

export type BillingTaskWhereInput = {
	AND?: InputMaybe<Array<BillingTaskWhereInput>>
	NOT?: InputMaybe<Array<BillingTaskWhereInput>>
	OR?: InputMaybe<Array<BillingTaskWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	identifier?: InputMaybe<StringFilter>
	isAutomatedRun?: InputMaybe<BoolNullableFilter>
	status?: InputMaybe<StringFilter>
	target?: InputMaybe<StringFilter>
}

export type BoolFilter = {
	equals?: InputMaybe<Scalars['Boolean']['input']>
	not?: InputMaybe<NestedBoolFilter>
}

export type BoolNullableFilter = {
	equals?: InputMaybe<Scalars['Boolean']['input']>
	not?: InputMaybe<NestedBoolNullableFilter>
}

/** Represents a brand reference. */
export type BrandReference = {
	__typename?: 'BrandReference'
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** Unique identifier for the brand reference. */
	id: Scalars['String']['output']
	/** Manufacturer associated with this brand */
	manufacturer?: Maybe<Manufacturer>
	/** Manufacturer identifier. */
	manufacturerId?: Maybe<Scalars['String']['output']>
	/** Brand name. */
	name: Scalars['String']['output']
	/** Products associated with this brand */
	products?: Maybe<Array<ProductReference>>
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
}

export type BrandReferenceListWithCount = {
	__typename?: 'BrandReferenceListWithCount'
	args: BaseListArgs
	items: Array<BrandReference>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type BrandReferenceOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	manufacturerId?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type BrandReferenceWhereInput = {
	AND?: InputMaybe<Array<BrandReferenceWhereInput>>
	NOT?: InputMaybe<Array<BrandReferenceWhereInput>>
	OR?: InputMaybe<Array<BrandReferenceWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	manufacturerId?: InputMaybe<StringNullableFilter>
	name?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** A bulk practice import record */
export type BulkPracticeImport = {
	__typename?: 'BulkPracticeImport'
	completedAt?: Maybe<Scalars['DateTime']['output']>
	createdAt: Scalars['DateTime']['output']
	fileName: Scalars['String']['output']
	gcsFilePath: Scalars['String']['output']
	id: Scalars['String']['output']
	importedBy: Scalars['String']['output']
	preview?: Maybe<Scalars['JSON']['output']>
	results?: Maybe<Scalars['JSON']['output']>
	status: Scalars['String']['output']
	summary?: Maybe<Scalars['JSON']['output']>
	totalRows: Scalars['Int']['output']
	updatedAt: Scalars['DateTime']['output']
}

/** Response containing bulk practice imports with count */
export type BulkPracticeImportListWithCount = {
	__typename?: 'BulkPracticeImportListWithCount'
	args: BaseListArgs
	/** List of bulk practice imports */
	items: Array<BulkPracticeImport>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for bulk practice imports */
export type BulkPracticeImportOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
}

/** Filter conditions for bulk practice imports */
export type BulkPracticeImportWhereInput = {
	createdAt?: InputMaybe<DateTimeFilter>
	fileName?: InputMaybe<StringFilter>
	importedBy?: InputMaybe<StringFilter>
	status?: InputMaybe<StringFilter>
}

/** How the EIN was verified — documentary review, IRS TIN match, or Stripe. */
export enum BusinessVerificationMethod {
	Documentary = 'DOCUMENTARY',
	IrsTinMatch = 'IRS_TIN_MATCH',
	Manual = 'MANUAL',
	Stripe = 'STRIPE'
}

/** How the EIN reached us — practice dashboard, spreadsheet backfill, or Stripe. */
export enum BusinessVerificationSource {
	Backfill = 'BACKFILL',
	Dashboard = 'DASHBOARD',
	Stripe = 'STRIPE'
}

/** Where a practice stands in business verification. */
export enum BusinessVerificationStatus {
	Failed = 'FAILED',
	NotCollected = 'NOT_COLLECTED',
	Submitted = 'SUBMITTED',
	Verified = 'VERIFIED'
}

/** One business verification submission in the admin review queue. */
export type BusinessVerificationSubmission = {
	__typename?: 'BusinessVerificationSubmission'
	/** The clinic this submission belongs to. */
	consolidatedPractice: BusinessVerificationSubmissionPractice
	/** Consolidated practice id (`prc_*`). */
	consolidatedPracticeId: Scalars['String']['output']
	/** Last 4 digits of the submitted EIN. */
	einLast4?: Maybe<Scalars['String']['output']>
	/** Why the submission was rejected. */
	failureReason?: Maybe<Scalars['String']['output']>
	/** Submission id (`bvs_*`). */
	id: Scalars['ID']['output']
	/** Filename of the uploaded IRS document. */
	irsDocName?: Maybe<Scalars['String']['output']>
	/** URL of the uploaded IRS document. */
	irsDocUrl?: Maybe<Scalars['String']['output']>
	/** Legal name as the practice filed it, snapshotted at submission time. */
	legalBusinessName?: Maybe<Scalars['String']['output']>
	/** When a reviewer ruled on it. */
	reviewedAt?: Maybe<Scalars['DateTime']['output']>
	/** Email of the reviewer who ruled on it. */
	reviewedBy?: Maybe<Scalars['String']['output']>
	/** Reviewer's free-text notes. */
	reviewerNotes?: Maybe<Scalars['String']['output']>
	/** Where this submission came from. */
	source: BusinessVerificationSource
	/** Status of this submission. */
	status: BusinessVerificationStatus
	/** When the practice submitted. */
	submittedAt: Scalars['DateTime']['output']
	/** How it is being verified. */
	verificationMethod: BusinessVerificationMethod
	/** Filename of the uploaded W9. */
	w9Name?: Maybe<Scalars['String']['output']>
	/** URL of the uploaded W9, when provided. */
	w9Url?: Maybe<Scalars['String']['output']>
}

/** One submission opened for review, including the full decrypted EIN. */
export type BusinessVerificationSubmissionDetail = {
	__typename?: 'BusinessVerificationSubmissionDetail'
	/** The clinic this submission belongs to. */
	consolidatedPractice: BusinessVerificationSubmissionPractice
	/** Consolidated practice id (`prc_*`). */
	consolidatedPracticeId: Scalars['String']['output']
	/** Full EIN as submitted, decrypted. Visible to the admin reviewer only; every read is audit-logged. */
	ein?: Maybe<Scalars['String']['output']>
	/** Last 4 digits of the submitted EIN. */
	einLast4?: Maybe<Scalars['String']['output']>
	/** Why the submission was rejected. */
	failureReason?: Maybe<Scalars['String']['output']>
	/** Submission id (`bvs_*`). */
	id: Scalars['ID']['output']
	/** Filename of the uploaded IRS document. */
	irsDocName?: Maybe<Scalars['String']['output']>
	/** URL of the uploaded IRS document. */
	irsDocUrl?: Maybe<Scalars['String']['output']>
	/** Legal name as the practice filed it, snapshotted at submission time. */
	legalBusinessName?: Maybe<Scalars['String']['output']>
	/** When a reviewer ruled on it. */
	reviewedAt?: Maybe<Scalars['DateTime']['output']>
	/** Email of the reviewer who ruled on it. */
	reviewedBy?: Maybe<Scalars['String']['output']>
	/** Reviewer's free-text notes. */
	reviewerNotes?: Maybe<Scalars['String']['output']>
	/** Where this submission came from. */
	source: BusinessVerificationSource
	/** Status of this submission. */
	status: BusinessVerificationStatus
	/** When the practice submitted. */
	submittedAt: Scalars['DateTime']['output']
	/** How it is being verified. */
	verificationMethod: BusinessVerificationMethod
	/** Filename of the uploaded W9. */
	w9Name?: Maybe<Scalars['String']['output']>
	/** URL of the uploaded W9, when provided. */
	w9Url?: Maybe<Scalars['String']['output']>
}

/** A page of review-queue submissions with the total matching count. */
export type BusinessVerificationSubmissionListWithCount = {
	__typename?: 'BusinessVerificationSubmissionListWithCount'
	args: BaseListArgs
	/** The submissions on this page. */
	items: Array<BusinessVerificationSubmission>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** The clinic a submission belongs to, as shown in the review queue. */
export type BusinessVerificationSubmissionPractice = {
	__typename?: 'BusinessVerificationSubmissionPractice'
	/** Denormalized verification status on the practice. */
	businessVerificationStatus?: Maybe<BusinessVerificationStatus>
	/** Practice contact email. */
	email?: Maybe<Scalars['String']['output']>
	/** Consolidated practice id (`prc_*`). */
	id: Scalars['ID']['output']
	/** Legal name currently on the practice record. */
	legalBusinessName?: Maybe<Scalars['String']['output']>
	/** Lending practice id. */
	lendingId?: Maybe<Scalars['Int']['output']>
	/** Practice display name. */
	name?: Maybe<Scalars['String']['output']>
	/** Stripe account id (`acct_*`), absent for lending-only clinics. */
	paymentId?: Maybe<Scalars['String']['output']>
}

/** A request sent to a client to save a card on file */
export type CardRequest = {
	__typename?: 'CardRequest'
	clientId: Scalars['String']['output']
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidatedPracticeId: Scalars['String']['output']
	createdAt: Scalars['DateTimeISO']['output']
	createdBy: Scalars['String']['output']
	deliveryMethod: CardRequestDeliveryMethod
	expiresAt: Scalars['DateTimeISO']['output']
	failureReason?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	paymentMethodId?: Maybe<Scalars['String']['output']>
	pimsClientId?: Maybe<Scalars['String']['output']>
	practiceId: Scalars['String']['output']
	savedAt?: Maybe<Scalars['DateTimeISO']['output']>
	sentAt?: Maybe<Scalars['DateTimeISO']['output']>
	sentTo: Scalars['String']['output']
	setupIntentId?: Maybe<Scalars['String']['output']>
	source?: Maybe<Scalars['String']['output']>
	status: CardRequestStatus
	stripeCustomerId: Scalars['String']['output']
	updatedAt: Scalars['DateTimeISO']['output']
	viewedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

/** How the card request link was delivered to the client */
export enum CardRequestDeliveryMethod {
	Email = 'EMAIL',
	Text = 'TEXT'
}

export type CardRequestDeliveryMethodFilter = {
	equals?: InputMaybe<CardRequestDeliveryMethod>
	in?: InputMaybe<Array<CardRequestDeliveryMethod>>
}

/** A page of CardRequest rows with the total matching count */
export type CardRequestListWithCount = {
	__typename?: 'CardRequestListWithCount'
	args: BaseListArgs
	items: Array<CardRequest>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A sort order for a field on CardRequest */
export type CardRequestOrderByInput = {
	clientId?: InputMaybe<SortOrder>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	createdAt?: InputMaybe<SortOrder>
	deliveryMethod?: InputMaybe<SortOrder>
	expiresAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	pimsClientId?: InputMaybe<SortOrderInput>
	savedAt?: InputMaybe<SortOrderInput>
	sentAt?: InputMaybe<SortOrderInput>
	sentTo?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
	viewedAt?: InputMaybe<SortOrderInput>
}

/** Lifecycle state of a card request */
export enum CardRequestStatus {
	Canceled = 'CANCELED',
	Expired = 'EXPIRED',
	Saved = 'SAVED',
	SendFailed = 'SEND_FAILED',
	Sent = 'SENT',
	Viewed = 'VIEWED'
}

export type CardRequestStatusFilter = {
	equals?: InputMaybe<CardRequestStatus>
	in?: InputMaybe<Array<CardRequestStatus>>
	notIn?: InputMaybe<Array<CardRequestStatus>>
}

/** A query filter for a list of CardRequest rows */
export type CardRequestWhereInput = {
	AND?: InputMaybe<Array<CardRequestWhereInput>>
	NOT?: InputMaybe<Array<CardRequestWhereInput>>
	OR?: InputMaybe<Array<CardRequestWhereInput>>
	clientId?: InputMaybe<StringFilter>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdBy?: InputMaybe<StringFilter>
	deliveryMethod?: InputMaybe<CardRequestDeliveryMethodFilter>
	expiresAt?: InputMaybe<DateTimeFilter>
	failureReason?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	pimsClientId?: InputMaybe<StringNullableFilter>
	practiceId?: InputMaybe<StringFilter>
	savedAt?: InputMaybe<DateTimeNullableFilter>
	sentAt?: InputMaybe<DateTimeNullableFilter>
	sentTo?: InputMaybe<StringFilter>
	setupIntentId?: InputMaybe<StringNullableFilter>
	status?: InputMaybe<CardRequestStatusFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	viewedAt?: InputMaybe<DateTimeNullableFilter>
}

/** Represents a physical cash deposit record for a practice, including audit details, drawer tracking, and deposit status. */
export type CashDeposit = {
	__typename?: 'CashDeposit'
	cashDrawers?: Maybe<Array<CashDrawer>>
	cashSalesDate: Scalars['DateTimeISO']['output']
	consolidatedPractice: ConsolidatedPractice
	consolidatedPracticeId: Scalars['String']['output']
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	createdBy: Scalars['String']['output']
	createdByUser: User
	dtsTrackingNumber?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	plannedDepositDate?: Maybe<Scalars['DateTimeISO']['output']>
	reportedDepositAmount: Scalars['Int']['output']
	status: CashDepositStatus
	updatedAt: Scalars['DateTimeISO']['output']
}

export type CashDepositListWithCount = {
	__typename?: 'CashDepositListWithCount'
	all?: Maybe<Scalars['Boolean']['output']>
	args: BaseListArgs
	items: Array<CashDeposit>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type CashDepositOrderByInput = {
	cashSalesDate?: InputMaybe<SortOrder>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	createdAt?: InputMaybe<SortOrder>
	createdByUser?: InputMaybe<UserOrderByInput>
	dtsTrackingNumber?: InputMaybe<SortOrder>
	plannedDepositDate?: InputMaybe<SortOrder>
	reportedCashDeposit?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** Status of a cash deposit operation, representing its workflow state (e.g., submitted, reconciled, etc). */
export enum CashDepositStatus {
	Submitted = 'SUBMITTED'
}

export type CashDepositWhereInput = {
	AND?: InputMaybe<Array<CashDepositWhereInput>>
	NOT?: InputMaybe<Array<CashDepositWhereInput>>
	OR?: InputMaybe<Array<CashDepositWhereInput>>
	cashSalesDate?: InputMaybe<DateTimeFilter>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdByUser?: InputMaybe<UserWhereInput>
	dtsTrackingNumber?: InputMaybe<StringNullableFilter>
	plannedDepositDate?: InputMaybe<DateTimeFilter>
	reportedCashDeposit?: InputMaybe<IntFilter>
	status?: InputMaybe<StringNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Represents a physical cash drawer record for a practice, including audit details, drawer tracking, links to deposit, and user information. */
export type CashDrawer = {
	__typename?: 'CashDrawer'
	/** Related cash deposit ID. */
	cashDepositId: Scalars['String']['output']
	/** Drawer identifier, e.g. "Drawer 1". */
	cashDrawerIdentifier: Scalars['String']['output']
	cashSalesDate: Scalars['DateTimeISO']['output']
	/** Associated consolidated practice. */
	consolidatedPractice: ConsolidatedPractice
	/** Identifier of the consolidated practice. */
	consolidatedPracticeId: Scalars['String']['output']
	/** Identifier of the consolidator (if any). */
	consolidatorId?: Maybe<Scalars['String']['output']>
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** User ID who created this cash drawer record. */
	createdBy: Scalars['String']['output']
	/** User who created this drawer entry. */
	createdByUser: User
	/** Unique identifier for this cash drawer. */
	id: Scalars['String']['output']
	/** Optional reconciliation note. */
	reconciliationNote?: Maybe<Scalars['String']['output']>
	/** Reported cash count (in cents). */
	reportedCashCount: Scalars['Int']['output']
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
}

export type CashDrawerListWithCount = {
	__typename?: 'CashDrawerListWithCount'
	all?: Maybe<Scalars['Boolean']['output']>
	args: BaseListArgs
	items: Array<CashDrawer>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type CashDrawerOrderByInput = {
	cashDrawerIdentifier?: InputMaybe<SortOrder>
	cashSalesDate?: InputMaybe<SortOrder>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	createdAt?: InputMaybe<SortOrder>
	createdByUser?: InputMaybe<UserOrderByInput>
	reconciliationNote?: InputMaybe<SortOrder>
	reportedCashCount?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type CashDrawerWhereInput = {
	AND?: InputMaybe<Array<CashDrawerWhereInput>>
	NOT?: InputMaybe<Array<CashDrawerWhereInput>>
	OR?: InputMaybe<Array<CashDrawerWhereInput>>
	cashDepositId?: InputMaybe<StringNullableFilter>
	cashDrawerIdentifier?: InputMaybe<StringNullableFilter>
	cashSalesDate?: InputMaybe<DateTimeFilter>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdByUser?: InputMaybe<UserWhereInput>
	reportedCashCount?: InputMaybe<IntFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Represents a category reference. */
export type CategoryReference = {
	__typename?: 'CategoryReference'
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** Unique identifier for the category reference. */
	id: Scalars['String']['output']
	/** Category name. */
	name: Scalars['String']['output']
	/** Products associated with this category */
	products?: Maybe<Array<ProductReference>>
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
}

export type CategoryReferenceListWithCount = {
	__typename?: 'CategoryReferenceListWithCount'
	args: BaseListArgs
	items: Array<CategoryReference>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type CategoryReferenceOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type CategoryReferenceWhereInput = {
	AND?: InputMaybe<Array<CategoryReferenceWhereInput>>
	NOT?: InputMaybe<Array<CategoryReferenceWhereInput>>
	OR?: InputMaybe<Array<CategoryReferenceWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

export type ConsolidatedPractice = {
	__typename?: 'ConsolidatedPractice'
	acceptsCareCredit?: Maybe<Scalars['Boolean']['output']>
	activeTerminalsCount?: Maybe<Scalars['Int']['output']>
	additionalIncludedTerminals?: Maybe<Scalars['Int']['output']>
	address?: Maybe<Scalars['String']['output']>
	address2?: Maybe<Scalars['String']['output']>
	agreementSignedAt?: Maybe<Scalars['DateTimeISO']['output']>
	city?: Maybe<Scalars['String']['output']>
	consolidator?: Maybe<Consolidator>
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorOther?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode3?: Maybe<Scalars['String']['output']>
	country?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	createdBy?: Maybe<Scalars['String']['output']>
	currency?: Maybe<Scalars['String']['output']>
	customPayoutRunAtTime?: Maybe<Scalars['DateTimeISO']['output']>
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	customPayoutStartedAt?: Maybe<Scalars['DateTimeISO']['output']>
	customPayoutTarget?: Maybe<Scalars['String']['output']>
	dashboardActivatedOn?: Maybe<Scalars['DateTimeISO']['output']>
	deletedAt?: Maybe<Scalars['DateTimeISO']['output']>
	email?: Maybe<Scalars['String']['output']>
	finalizeLoanAttemptOn?: Maybe<Scalars['DateTimeISO']['output']>
	financingStatus?: Maybe<Scalars['String']['output']>
	fingerprint?: Maybe<Scalars['String']['output']>
	firstApplicationDate?: Maybe<Scalars['DateTimeISO']['output']>
	firstFinalizedTestTransaction?: Maybe<Scalars['DateTimeISO']['output']>
	firstLoanDate?: Maybe<Scalars['DateTimeISO']['output']>
	firstPaymentDate?: Maybe<Scalars['DateTimeISO']['output']>
	goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>
	googlePlaceId?: Maybe<Scalars['String']['output']>
	hospitalManagerEmail?: Maybe<Scalars['String']['output']>
	howDidYouHearAboutUs?: Maybe<Scalars['String']['output']>
	hubspotCompanyId?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	industry?: Maybe<Scalars['String']['output']>
	industryProgramMetadata?: Maybe<Scalars['JSON']['output']>
	installmentAlertEmails?: Maybe<Array<Scalars['String']['output']>>
	integrationId?: Maybe<Scalars['String']['output']>
	isActive?: Maybe<Scalars['Boolean']['output']>
	isCustomPayoutEnabled?: Maybe<Scalars['Boolean']['output']>
	isDeleted?: Maybe<Scalars['Boolean']['output']>
	isEr?: Maybe<Scalars['Boolean']['output']>
	isLendingEnabled?: Maybe<Scalars['Boolean']['output']>
	isNetSettlement?: Maybe<Scalars['Boolean']['output']>
	isNetSettlementLending?: Maybe<Scalars['Boolean']['output']>
	isPaymentEnabled?: Maybe<Scalars['Boolean']['output']>
	isRebateEnabled?: Maybe<Scalars['Boolean']['output']>
	isUnderwritten?: Maybe<Scalars['Boolean']['output']>
	lat?: Maybe<Scalars['Float']['output']>
	legalBusinessName?: Maybe<Scalars['String']['output']>
	lendingFlags?: Maybe<Scalars['JSON']['output']>
	lendingId?: Maybe<Scalars['Int']['output']>
	lng?: Maybe<Scalars['Float']['output']>
	locale?: Maybe<Scalars['String']['output']>
	logoUrl?: Maybe<Scalars['String']['output']>
	memberUTM?: Maybe<Scalars['String']['output']>
	merchantCategoryId?: Maybe<Scalars['Int']['output']>
	name?: Maybe<Scalars['String']['output']>
	netsuiteId?: Maybe<Scalars['String']['output']>
	numJCLoans?: Maybe<Scalars['Int']['output']>
	numPetParentsLoans?: Maybe<Scalars['Int']['output']>
	numberOfExamRooms?: Maybe<Scalars['Int']['output']>
	partnerIds?: Maybe<Array<Scalars['String']['output']>>
	payerEmail?: Maybe<Scalars['String']['output']>
	paymentId?: Maybe<Scalars['String']['output']>
	paymentLogo?: Maybe<Scalars['String']['output']>
	paymentMethodTriggers?: Maybe<Array<Scalars['String']['output']>>
	phone?: Maybe<Scalars['String']['output']>
	pimsData?: Maybe<Scalars['JSON']['output']>
	pimsDataCursors?: Maybe<Scalars['JSON']['output']>
	pimsMetadata?: Maybe<Scalars['JSON']['output']>
	rateScheme?: Maybe<Scalars['String']['output']>
	referralId?: Maybe<Scalars['String']['output']>
	referralRockAccepted?: Maybe<Scalars['Boolean']['output']>
	referrer?: Maybe<Scalars['String']['output']>
	regionalManagerId?: Maybe<Scalars['String']['output']>
	settings?: Maybe<Scalars['JSON']['output']>
	settlementDays?: Maybe<Scalars['Int']['output']>
	signerEmail?: Maybe<Scalars['String']['output']>
	signerName?: Maybe<Scalars['String']['output']>
	signerPhone?: Maybe<Scalars['String']['output']>
	signerRole?: Maybe<Scalars['String']['output']>
	signupAttribution?: Maybe<Scalars['JSON']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
	socialUrl?: Maybe<Scalars['JSON']['output']>
	source?: Maybe<Scalars['String']['output']>
	state?: Maybe<Scalars['String']['output']>
	status?: Maybe<Scalars['JSON']['output']>
	stripeAccountStatus?: Maybe<Scalars['JSON']['output']>
	stripeFutureRequirements?: Maybe<Scalars['JSON']['output']>
	surchargeEnabled?: Maybe<Scalars['Boolean']['output']>
	surchargeFeePct?: Maybe<Scalars['Float']['output']>
	surchargeStartDate?: Maybe<Scalars['DateTimeISO']['output']>
	terminalConfigId?: Maybe<Scalars['String']['output']>
	terminalLocation?: Maybe<Scalars['String']['output']>
	terminalSplashScreen?: Maybe<Scalars['JSON']['output']>
	timezone?: Maybe<Scalars['String']['output']>
	totalTerminalsCount?: Maybe<Scalars['Int']['output']>
	transactionFees?: Maybe<Scalars['JSON']['output']>
	underwritingStatus?: Maybe<Scalars['String']['output']>
	underwrittenAt?: Maybe<Scalars['DateTimeISO']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	validatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	validationType?: Maybe<Scalars['String']['output']>
	website?: Maybe<Scalars['String']['output']>
	writebackBackoffTimers?: Maybe<Scalars['JSON']['output']>
	zip?: Maybe<Scalars['String']['output']>
}

export type ConsolidatedPracticeBankAccount = {
	__typename?: 'ConsolidatedPracticeBankAccount'
	accountHolderName: Scalars['String']['output']
	accountHolderType: Scalars['String']['output']
	accountNumber: Scalars['String']['output']
	bankName?: Maybe<Scalars['String']['output']>
	consolidatedPracticeId: Scalars['String']['output']
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	createdByUserId?: Maybe<Scalars['String']['output']>
	disabledAt?: Maybe<Scalars['DateTimeISO']['output']>
	disabledByUserId?: Maybe<Scalars['String']['output']>
	disabledReason?: Maybe<Scalars['String']['output']>
	enabledAt?: Maybe<Scalars['DateTimeISO']['output']>
	enabledByUserId?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
	routingNumber: Scalars['String']['output']
	status: BankAccountStatus
	stripeBankAccountId?: Maybe<Scalars['String']['output']>
	stripeCustomerId?: Maybe<Scalars['String']['output']>
	stripePaymentMethodId?: Maybe<Scalars['String']['output']>
	stripePlatformAccountId?: Maybe<Scalars['String']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	usedForProduct: Array<ScratchProduct>
}

/** List of Consolidated Practice items with a count for pagination */
export type ConsolidatedPracticeBankAccountListWithCount = {
	__typename?: 'ConsolidatedPracticeBankAccountListWithCount'
	items: Array<ConsolidatedPracticeBankAccount>
	total: Scalars['Float']['output']
}

export type ConsolidatedPracticeBankAccountOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type ConsolidatedPracticeBankAccountWhereInput = {
	AND?: InputMaybe<Array<ConsolidatedPracticeBankAccountWhereInput>>
	NOT?: InputMaybe<Array<ConsolidatedPracticeBankAccountWhereInput>>
	OR?: InputMaybe<Array<ConsolidatedPracticeBankAccountWhereInput>>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	status?: InputMaybe<BankAccountStatus>
}

/** Consolidated practice summary exposed alongside an industry program relation */
export type ConsolidatedPracticeIndustryProgramSummary = {
	__typename?: 'ConsolidatedPracticeIndustryProgramSummary'
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	industryProgramMetadata?: Maybe<Scalars['JSON']['output']>
	isDeleted?: Maybe<Scalars['Boolean']['output']>
	isLendingEnabled?: Maybe<Scalars['Boolean']['output']>
	isPaymentEnabled?: Maybe<Scalars['Boolean']['output']>
	isRebateEnabled?: Maybe<Scalars['Boolean']['output']>
	lendingId?: Maybe<Scalars['Int']['output']>
	logoUrl?: Maybe<Scalars['String']['output']>
	name?: Maybe<Scalars['String']['output']>
	netsuiteId?: Maybe<Scalars['String']['output']>
	paymentId?: Maybe<Scalars['String']['output']>
	pimsMetadata?: Maybe<Scalars['JSON']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
}

/** List of Consolidated Practice items with a count for pagination */
export type ConsolidatedPracticeListWithCount = {
	__typename?: 'ConsolidatedPracticeListWithCount'
	items: Array<ConsolidatedPractice>
	total: Scalars['Float']['output']
}

export type ConsolidatedPracticeOrderByInput = {
	activeTerminalsCount?: InputMaybe<SortOrderInput>
	address?: InputMaybe<SortOrderInput>
	city?: InputMaybe<SortOrderInput>
	consolidatorId?: InputMaybe<SortOrder>
	consolidatorReferenceCode?: InputMaybe<SortOrderInput>
	consolidatorReferenceCode2?: InputMaybe<SortOrderInput>
	consolidatorReferenceCode3?: InputMaybe<SortOrderInput>
	createdAt?: InputMaybe<SortOrder>
	customPayoutTarget?: InputMaybe<SortOrderInput>
	deletedAt?: InputMaybe<SortOrder>
	email?: InputMaybe<SortOrderInput>
	firstPaymentDate?: InputMaybe<SortOrderInput>
	goLiveDate?: InputMaybe<SortOrderInput>
	id?: InputMaybe<SortOrder>
	isActive?: InputMaybe<SortOrder>
	isCustomPayoutEnabled?: InputMaybe<SortOrderInput>
	isNetSettlement?: InputMaybe<SortOrder>
	legalBusinessName?: InputMaybe<SortOrderInput>
	lendingId?: InputMaybe<SortOrderInput>
	name?: InputMaybe<SortOrder>
	netsuiteId?: InputMaybe<SortOrderInput>
	paymentId?: InputMaybe<SortOrderInput>
	rateScheme?: InputMaybe<SortOrder>
	skyworldId?: InputMaybe<SortOrderInput>
	surchargeEnabled?: InputMaybe<SortOrderInput>
	surchargeFeePct?: InputMaybe<SortOrder>
	surchargeStartDate?: InputMaybe<SortOrderInput>
	totalTerminalsCount?: InputMaybe<SortOrderInput>
	updatedAt?: InputMaybe<SortOrder>
	zip?: InputMaybe<SortOrderInput>
}

export type ConsolidatedPracticeRelationFilter = {
	is?: InputMaybe<ConsolidatedPracticeWhereInput>
	isNot?: InputMaybe<ConsolidatedPracticeWhereInput>
}

/** Consolidated practice summary exposed alongside a practice relation */
export type ConsolidatedPracticeSummary = {
	__typename?: 'ConsolidatedPracticeSummary'
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	isDeleted?: Maybe<Scalars['Boolean']['output']>
	isLendingEnabled?: Maybe<Scalars['Boolean']['output']>
	isPaymentEnabled?: Maybe<Scalars['Boolean']['output']>
	isRebateEnabled?: Maybe<Scalars['Boolean']['output']>
	lendingId?: Maybe<Scalars['Int']['output']>
	name?: Maybe<Scalars['String']['output']>
	netsuiteId?: Maybe<Scalars['String']['output']>
	paymentId?: Maybe<Scalars['String']['output']>
	pimsMetadata?: Maybe<Scalars['JSON']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
}

/** A user membership on a consolidated practice */
export type ConsolidatedPracticeUser = {
	__typename?: 'ConsolidatedPracticeUser'
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidatedPracticeId: Scalars['String']['output']
	role?: Maybe<Scalars['String']['output']>
	showPayments?: Maybe<Scalars['Boolean']['output']>
	userId: Scalars['String']['output']
}

export type ConsolidatedPracticeWhereInput = {
	AND?: InputMaybe<Array<ConsolidatedPracticeWhereInput>>
	NOT?: InputMaybe<Array<ConsolidatedPracticeWhereInput>>
	OR?: InputMaybe<Array<ConsolidatedPracticeWhereInput>>
	address?: InputMaybe<StringNullableFilter>
	city?: InputMaybe<StringNullableFilter>
	consolidatorId?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode2?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode3?: InputMaybe<StringNullableFilter>
	country?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	customPayoutSettings?: InputMaybe<JsonNullableFilter>
	customPayoutTarget?: InputMaybe<StringNullableFilter>
	deletedAt?: InputMaybe<DateTimeFilter>
	email?: InputMaybe<StringNullableFilter>
	firstPaymentDate?: InputMaybe<DateTimeFilter>
	goLiveDate?: InputMaybe<DateTimeFilter>
	hospitalManagerEmail?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	industry?: InputMaybe<StringNullableFilter>
	isActive?: InputMaybe<BoolNullableFilter>
	isCustomPayoutEnabled?: InputMaybe<BoolNullableFilter>
	isDeleted?: InputMaybe<BoolFilter>
	isLendingEnabled?: InputMaybe<BoolNullableFilter>
	isNetSettlement?: InputMaybe<BoolFilter>
	isPaymentEnabled?: InputMaybe<BoolNullableFilter>
	isRebateEnabled?: InputMaybe<BoolNullableFilter>
	legalBusinessName?: InputMaybe<StringNullableFilter>
	lendingId?: InputMaybe<IntNullableFilter>
	name?: InputMaybe<StringNullableFilter>
	netsuiteId?: InputMaybe<StringNullableFilter>
	paymentId?: InputMaybe<StringNullableFilter>
	pimsMetadata?: InputMaybe<JsonNullableFilter>
	rateScheme?: InputMaybe<StringNullableFilter>
	regionalManagerId?: InputMaybe<StringNullableFilter>
	skyworldId?: InputMaybe<StringNullableFilter>
	status?: InputMaybe<JsonNullableFilter>
	surchargeEnabled?: InputMaybe<BoolNullableFilter>
	surchargeFeePct?: InputMaybe<FloatNullableFilter>
	surchargeStartDate?: InputMaybe<DateTimeFilter>
	terminalConfigId?: InputMaybe<StringNullableFilter>
	terminalLocation?: InputMaybe<StringNullableFilter>
	timezone?: InputMaybe<StringNullableFilter>
	transactionFees?: InputMaybe<JsonNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	zip?: InputMaybe<StringNullableFilter>
}

export type Consolidator = {
	__typename?: 'Consolidator'
	canadaAccountInfo?: Maybe<Scalars['JSON']['output']>
	customFields?: Maybe<Scalars['JSON']['output']>
	customization?: Maybe<Scalars['JSON']['output']>
	featureFlags?: Maybe<Scalars['JSON']['output']>
	financingFlags?: Maybe<Scalars['JSON']['output']>
	id: Scalars['String']['output']
	lendingFlags?: Maybe<Scalars['JSON']['output']>
	mcc?: Maybe<Scalars['String']['output']>
	name?: Maybe<Scalars['String']['output']>
	ownerLastFour?: Maybe<Scalars['String']['output']>
	timezone?: Maybe<Scalars['String']['output']>
}

export type ConsolidatorMonthlyStatement = {
	__typename?: 'ConsolidatorMonthlyStatement'
	consolidatorId: Scalars['String']['output']
	creditCount: Scalars['Float']['output']
	creditFees?: Maybe<Scalars['Decimal']['output']>
	creditVolume?: Maybe<Scalars['Decimal']['output']>
	currency: Scalars['String']['output']
	debitCount: Scalars['Float']['output']
	debitFees?: Maybe<Scalars['Decimal']['output']>
	debitVolume?: Maybe<Scalars['Decimal']['output']>
	hardwareOrders?: Maybe<Array<NetworkMonthlyStatementHardwareOrder>>
	id: Scalars['String']['output']
	locationLines?: Maybe<Array<NetworkMonthlyStatementLocationLine>>
	month: Scalars['DateTimeISO']['output']
	paymentLines?: Maybe<Array<NetworkMonthlyStatementPaymentLine>>
	paymentVolume?: Maybe<Scalars['Decimal']['output']>
	surchargeFees?: Maybe<Scalars['Decimal']['output']>
	surchargeFeesSaved?: Maybe<Scalars['Decimal']['output']>
	surchargeVolume?: Maybe<Scalars['Decimal']['output']>
	tipVolume?: Maybe<Scalars['Decimal']['output']>
	totalFees?: Maybe<Scalars['Decimal']['output']>
}

export type ConsolidatorMonthlyStatementOrderByInput = {
	consolidatorId?: InputMaybe<SortOrder>
	currency?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	month?: InputMaybe<SortOrder>
}

export type ConsolidatorMonthlyStatementWhereInput = {
	AND?: InputMaybe<Array<ConsolidatorMonthlyStatementWhereInput>>
	NOT?: InputMaybe<Array<ConsolidatorMonthlyStatementWhereInput>>
	OR?: InputMaybe<Array<ConsolidatorMonthlyStatementWhereInput>>
	consolidator?: InputMaybe<ConsolidatorRelationFilter>
	consolidatorId?: InputMaybe<StringFilter>
	currency?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	month?: InputMaybe<DateTimeFilter>
}

export type ConsolidatorOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type ConsolidatorRelationFilter = {
	is?: InputMaybe<ConsolidatorWhereInput>
	isNot?: InputMaybe<ConsolidatorWhereInput>
}

export type ConsolidatorWhereInput = {
	AND?: InputMaybe<Array<ConsolidatorWhereInput>>
	NOT?: InputMaybe<Array<ConsolidatorWhereInput>>
	OR?: InputMaybe<Array<ConsolidatorWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Arguments required to create a new cash drawler entry. */
export type CreateCashDrawerArgs = {
	/** Identifier for the cash drawer being reported. */
	cashDrawerIdentifier: Scalars['String']['input']
	/** Optional notes related to the reconciliation. */
	reconciliationNote?: InputMaybe<Scalars['String']['input']>
	/** Amount counted in the drawer (in cents). */
	reportedCashCount: Scalars['Int']['input']
}

export enum Currency {
	Cad = 'CAD',
	Usd = 'USD'
}

export enum CustomPayoutBatchStatus {
	Failed = 'FAILED',
	Processed = 'PROCESSED',
	Processing = 'PROCESSING',
	Scheduled = 'SCHEDULED'
}

export enum CustomPayoutBatchTarget {
	Consolidator = 'CONSOLIDATOR',
	Practice = 'PRACTICE'
}

export enum CustomPayoutBatchTypes {
	Card = 'CARD',
	Check = 'CHECK'
}

/** List of CustomPayoutPracticeBatch Details with pagination */
export type CustomPayoutDetailList = {
	__typename?: 'CustomPayoutDetailList'
	args: BaseListArgs
	items: Array<CustomPayoutDetails>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** CustomPayoutDetails item */
export type CustomPayoutDetails = {
	__typename?: 'CustomPayoutDetails'
	baseTransactionFee?: Maybe<Scalars['Float']['output']>
	cardBrand?: Maybe<Scalars['String']['output']>
	cardFunding?: Maybe<Scalars['String']['output']>
	cardholderName?: Maybe<Scalars['String']['output']>
	consPayoutEstimatedArrivalAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	currency: Scalars['String']['output']
	customPayoutConsolidatorBatchId?: Maybe<Scalars['String']['output']>
	customPayoutPracticeBatchId?: Maybe<Scalars['String']['output']>
	donationAmount?: Maybe<Scalars['Float']['output']>
	id: Scalars['ID']['output']
	last4?: Maybe<Scalars['String']['output']>
	lockboxId?: Maybe<Scalars['String']['output']>
	paymentIntentId?: Maybe<Scalars['String']['output']>
	paymentMethodType?: Maybe<Scalars['String']['output']>
	paymentType?: Maybe<Scalars['String']['output']>
	payoutDescription?: Maybe<Scalars['String']['output']>
	payoutEstimatedArrivalAt?: Maybe<Scalars['DateTimeISO']['output']>
	payoutReference?: Maybe<Scalars['String']['output']>
	payoutStatementDescriptor?: Maybe<Scalars['String']['output']>
	pimsClientId?: Maybe<Scalars['String']['output']>
	practiceConsolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	practiceConsolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	practiceId?: Maybe<Scalars['String']['output']>
	practiceName?: Maybe<Scalars['String']['output']>
	practiceNetsuiteId?: Maybe<Scalars['String']['output']>
	practiceSkyworldId?: Maybe<Scalars['String']['output']>
	savedPaymentMethod?: Maybe<Scalars['Boolean']['output']>
	savedPaymentMethodFee?: Maybe<Scalars['Float']['output']>
	scratchPaymentMethod?: Maybe<Scalars['String']['output']>
	scratchPaymentRequestType?: Maybe<Scalars['String']['output']>
	stripePayoutId?: Maybe<Scalars['String']['output']>
	surchargeFee?: Maybe<Scalars['Float']['output']>
	tipAmount?: Maybe<Scalars['Float']['output']>
	transactionAmount?: Maybe<Scalars['Float']['output']>
	transactionDate?: Maybe<Scalars['DateTimeISO']['output']>
	transactionFee?: Maybe<Scalars['Float']['output']>
	transactionNet?: Maybe<Scalars['Float']['output']>
	transactionType: CustomPayoutTransactionType
}

/** A sort order for a field on Custom Payout Detail */
export type CustomPayoutDetailsOrderByInput = {
	baseTransactionFee?: InputMaybe<SortOrder>
	cardBrand?: InputMaybe<SortOrder>
	cardholderName?: InputMaybe<SortOrder>
	consPayoutEstimatedArrivalAt?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	donationAmount?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	lockboxId?: InputMaybe<SortOrder>
	paymentIntentId?: InputMaybe<SortOrder>
	paymentType?: InputMaybe<SortOrder>
	payoutDescription?: InputMaybe<SortOrder>
	payoutEstimatedArrivalAt?: InputMaybe<SortOrder>
	payoutStatementDescriptor?: InputMaybe<SortOrder>
	pimsClientId?: InputMaybe<SortOrder>
	practiceConsolidatorReferenceCode?: InputMaybe<SortOrder>
	practiceId?: InputMaybe<SortOrder>
	practiceName?: InputMaybe<SortOrder>
	practiceNetsuiteId?: InputMaybe<SortOrder>
	practiceSkyworldId?: InputMaybe<SortOrder>
	savedPaymentMethod?: InputMaybe<SortOrder>
	savedPaymentMethodFee?: InputMaybe<SortOrder>
	scratchPaymentMethod?: InputMaybe<SortOrder>
	scratchPaymentRequestType?: InputMaybe<SortOrder>
	stripePayoutId?: InputMaybe<SortOrder>
	surchargeFee?: InputMaybe<SortOrder>
	tipAmount?: InputMaybe<SortOrder>
	transactionAmount?: InputMaybe<SortOrder>
	transactionDate?: InputMaybe<SortOrder>
	transactionFee?: InputMaybe<SortOrder>
	transactionNet?: InputMaybe<SortOrder>
	transactionType?: InputMaybe<SortOrder>
}

/** Sum of Custom Payout Details by Card Brand */
export type CustomPayoutDetailsSumByCardBrandList = {
	__typename?: 'CustomPayoutDetailsSumByCardBrandList'
	items: Array<CustomPayoutDetails>
}

/** A query filter for a list of customPayoutDetail rows */
export type CustomPayoutDetailsWhereInput = {
	AND?: InputMaybe<Array<CustomPayoutDetailsWhereInput>>
	OR?: InputMaybe<Array<CustomPayoutDetailsWhereInput>>
	baseTransactionFee?: InputMaybe<IntNullableFilter>
	cardBrand?: InputMaybe<StringNullableFilter>
	cardholderName?: InputMaybe<StringNullableFilter>
	consPayoutEstimatedArrivalAt?: InputMaybe<DateTimeFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	donationAmount?: InputMaybe<IntNullableFilter>
	id?: InputMaybe<StringFilter>
	lockboxId?: InputMaybe<StringNullableFilter>
	paymentIntentId?: InputMaybe<StringNullableFilter>
	paymentType?: InputMaybe<StringNullableFilter>
	payoutDescription?: InputMaybe<StringNullableFilter>
	payoutEstimatedArrivalAt?: InputMaybe<DateTimeFilter>
	payoutStatementDescriptor?: InputMaybe<StringNullableFilter>
	pimsClientId?: InputMaybe<StringNullableFilter>
	practiceConsolidatorReferenceCode?: InputMaybe<StringNullableFilter>
	practiceId?: InputMaybe<StringNullableFilter>
	practiceName?: InputMaybe<StringNullableFilter>
	practiceNetsuiteId?: InputMaybe<StringNullableFilter>
	practiceSkyworldId?: InputMaybe<StringNullableFilter>
	savedPaymentMethod?: InputMaybe<BoolNullableFilter>
	savedPaymentMethodFee?: InputMaybe<IntNullableFilter>
	scratchPaymentMethod?: InputMaybe<StringNullableFilter>
	scratchPaymentRequestType?: InputMaybe<StringNullableFilter>
	stripePayoutId?: InputMaybe<StringNullableFilter>
	surchargeFee?: InputMaybe<IntNullableFilter>
	tipAmount?: InputMaybe<IntNullableFilter>
	transactionAmount?: InputMaybe<IntNullableFilter>
	transactionDate?: InputMaybe<DateTimeFilter>
	transactionFee?: InputMaybe<IntNullableFilter>
	transactionNet?: InputMaybe<IntNullableFilter>
	transactionType?: InputMaybe<StringNullableFilter>
}

/** CustomPayout practice */
export type CustomPayoutPractice = {
	__typename?: 'CustomPayoutPractice'
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	netsuiteId?: Maybe<Scalars['String']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
}

/** CustomPayoutPracticeBatch item */
export type CustomPayoutPracticeBatch = {
	__typename?: 'CustomPayoutPracticeBatch'
	batchCriteria?: Maybe<Scalars['JSON']['output']>
	batchType: CustomPayoutBatchTypes
	completedAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidator?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	currency: Currency
	customPayoutConsolidatorBatchId?: Maybe<Scalars['String']['output']>
	customPayoutCronjobLogId: Scalars['Int']['output']
	description?: Maybe<Scalars['String']['output']>
	disputeAmount?: Maybe<Scalars['Float']['output']>
	disputeCount?: Maybe<Scalars['Int']['output']>
	failureReason?: Maybe<Scalars['String']['output']>
	id: Scalars['ID']['output']
	notes?: Maybe<Scalars['String']['output']>
	paymentAmount?: Maybe<Scalars['Float']['output']>
	paymentApplicationFee?: Maybe<Scalars['Float']['output']>
	paymentCount?: Maybe<Scalars['Int']['output']>
	payoutAmount?: Maybe<Scalars['Float']['output']>
	payoutDate?: Maybe<Scalars['DateTimeISO']['output']>
	payoutEstimatedArrivalAt?: Maybe<Scalars['DateTimeISO']['output']>
	payoutReference?: Maybe<Scalars['String']['output']>
	payoutSentAt?: Maybe<Scalars['DateTimeISO']['output']>
	practice: CustomPayoutPractice
	refundAmount?: Maybe<Scalars['Float']['output']>
	refundApplicationFee?: Maybe<Scalars['Float']['output']>
	refundCount?: Maybe<Scalars['Int']['output']>
	refundedTipAmount?: Maybe<Scalars['Float']['output']>
	retryCount: Scalars['Int']['output']
	startWindowDate?: Maybe<Scalars['DateTimeISO']['output']>
	startedAt?: Maybe<Scalars['DateTimeISO']['output']>
	statementDescriptor?: Maybe<Scalars['String']['output']>
	status: CustomPayoutBatchStatus
	stripePayoutId?: Maybe<Scalars['String']['output']>
	stripeTransferId?: Maybe<Scalars['String']['output']>
	target: CustomPayoutBatchTarget
	tipAmount?: Maybe<Scalars['Float']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

/** List of CustomPayoutPracticeBatch items with pagination */
export type CustomPayoutPracticeBatchList = {
	__typename?: 'CustomPayoutPracticeBatchList'
	args: BaseListArgs
	items: Array<CustomPayoutPracticeBatch>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A sort order for a field on Custom Payout Practice Batch */
export type CustomPayoutPracticeBatchOrderByInput = {
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	description?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	payoutAmount?: InputMaybe<SortOrder>
	payoutDate?: InputMaybe<SortOrder>
	payoutEstimatedArrivalAt?: InputMaybe<SortOrder>
	practice?: InputMaybe<PracticeOrderByInput>
	refundedTipAmount?: InputMaybe<SortOrder>
	startWindowDate?: InputMaybe<SortOrder>
	stripePayoutId?: InputMaybe<SortOrder>
	tipAmount?: InputMaybe<SortOrder>
}

/** A query filter for a list of customPayoutPracticeBatch rows */
export type CustomPayoutPracticeBatchWhereInput = {
	AND?: InputMaybe<Array<CustomPayoutPracticeBatchWhereInput>>
	OR?: InputMaybe<Array<CustomPayoutPracticeBatchWhereInput>>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	customPayoutBatchType?: InputMaybe<StringNullableFilter>
	description?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	payoutAmount?: InputMaybe<IntNullableFilter>
	payoutDate?: InputMaybe<DateTimeFilter>
	payoutEstimatedArrivalAt?: InputMaybe<DateTimeFilter>
	practice?: InputMaybe<PracticeWhereInput>
	refundedTipAmount?: InputMaybe<IntNullableFilter>
	startWindowDate?: InputMaybe<DateTimeFilter>
	stripePayoutId?: InputMaybe<StringNullableFilter>
	tipAmount?: InputMaybe<IntNullableFilter>
}

export type CustomPayoutSettingsInput = {
	delayProcessingHours?: InputMaybe<Scalars['Float']['input']>
	includeYearInDescriptor?: InputMaybe<Scalars['Boolean']['input']>
	moveToPlatform?: InputMaybe<Scalars['Boolean']['input']>
	payoutDescriptor1?: InputMaybe<Scalars['String']['input']>
	payoutDescriptor2?: InputMaybe<Scalars['String']['input']>
	startWindowHour?: InputMaybe<Scalars['Float']['input']>
	subtractedDays?: InputMaybe<Scalars['Float']['input']>
	timezone?: InputMaybe<Scalars['String']['input']>
}

export enum CustomPayoutTransactionType {
	Charge = 'Charge',
	Dispute = 'Dispute',
	Refund = 'Refund'
}

/** Daily Totals grouped by card */
export type DailyTotalsByCard = {
	__typename?: 'DailyTotalsByCard'
	/** The brand of the card used for the payment (e.g., Visa, MasterCard). */
	cardBrand: Scalars['String']['output']
	/** The Scratch payment method for non-card payments (e.g., check_payment, lockbox_check). Null for card-based rows and the total row. */
	scratchPaymentMethod?: Maybe<Scalars['String']['output']>
	/** Total sum of payments made on the day. */
	sumPayments: Scalars['BigInt']['output']
	/** Total sum of refunds made on the day. */
	sumRefunds: Scalars['BigInt']['output']
	/** Net total, considering both payments and refunds. */
	total: Scalars['BigInt']['output']
}

/** Daily totals grouped by payment type */
export type DailyTotalsByType = {
	__typename?: 'DailyTotalsByType'
	/** The payment type used (e.g., Credit Card, Pix, Boleto). */
	paymentType: Scalars['String']['output']
	/** Total sum of payments made on the day. */
	sumPayments: Scalars['BigInt']['output']
	/** Total sum of refunds made on the day. */
	sumRefunds: Scalars['BigInt']['output']
	/** Net total, considering both payments and refunds. */
	total: Scalars['BigInt']['output']
}

/** Response containing daily totals grouped by card or by payment type. */
export type DailyTotalsResponse = {
	__typename?: 'DailyTotalsResponse'
	/** Daily totals grouped by card brand. */
	byCard: Array<DailyTotalsByCard>
	/** Daily totals grouped by payment type. */
	byPaymentType: Array<DailyTotalsByType>
	practiceId: Scalars['String']['output']
}

/** A query filter for daily totals */
export type DailyTotalsWhereInput = {
	AND?: InputMaybe<Array<DailyTotalsWhereInput>>
	NOT?: InputMaybe<Array<DailyTotalsWhereInput>>
	OR?: InputMaybe<Array<DailyTotalsWhereInput>>
	dateToFilter?: InputMaybe<DateTimeNullableFilter>
	practice?: InputMaybe<PracticeWhereInput>
	practiceId?: InputMaybe<StringFilter>
}

export type DateTimeFilter = {
	equals?: InputMaybe<Scalars['DateTimeISO']['input']>
	gt?: InputMaybe<Scalars['DateTimeISO']['input']>
	gte?: InputMaybe<Scalars['DateTimeISO']['input']>
	in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
	lt?: InputMaybe<Scalars['DateTimeISO']['input']>
	lte?: InputMaybe<Scalars['DateTimeISO']['input']>
	not?: InputMaybe<NestedDateTimeFilter>
	notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type DateTimeNullableFilter = {
	equals?: InputMaybe<Scalars['DateTimeISO']['input']>
	gt?: InputMaybe<Scalars['DateTimeISO']['input']>
	gte?: InputMaybe<Scalars['DateTimeISO']['input']>
	in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
	lt?: InputMaybe<Scalars['DateTimeISO']['input']>
	lte?: InputMaybe<Scalars['DateTimeISO']['input']>
	not?: InputMaybe<NestedDateTimeNullableFilter>
	notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type DecimalFilter = {
	equals?: InputMaybe<Scalars['Decimal']['input']>
	gt?: InputMaybe<Scalars['Decimal']['input']>
	gte?: InputMaybe<Scalars['Decimal']['input']>
	in?: InputMaybe<Array<Scalars['Decimal']['input']>>
	lt?: InputMaybe<Scalars['Decimal']['input']>
	lte?: InputMaybe<Scalars['Decimal']['input']>
	not?: InputMaybe<NestedDecimalFilter>
	notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>
}

export type DonationCharityAdmin = {
	__typename?: 'DonationCharityAdmin'
	address?: Maybe<Scalars['String']['output']>
	bankLast4?: Maybe<Scalars['String']['output']>
	bankRoutingNumber?: Maybe<Scalars['String']['output']>
	city?: Maybe<Scalars['String']['output']>
	country?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	ein?: Maybe<Scalars['String']['output']>
	email?: Maybe<Scalars['String']['output']>
	id: Scalars['ID']['output']
	name: Scalars['String']['output']
	payoutsEnabled: Scalars['Boolean']['output']
	phone?: Maybe<Scalars['String']['output']>
	state?: Maybe<Scalars['String']['output']>
	stripeAccountId?: Maybe<Scalars['String']['output']>
	suggestedAmounts?: Maybe<Array<Scalars['Int']['output']>>
	updatedAt: Scalars['DateTimeISO']['output']
	website?: Maybe<Scalars['String']['output']>
	zip?: Maybe<Scalars['String']['output']>
}

export type DonationCharityListWithCount = {
	__typename?: 'DonationCharityListWithCount'
	args: BaseListArgs
	items: Array<DonationCharityAdmin>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type DonationCharityOrderByInput = {
	city?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	state?: InputMaybe<SortOrder>
}

export type DonationCharityWhereInput = {
	AND?: InputMaybe<Array<DonationCharityWhereInput>>
	OR?: InputMaybe<Array<DonationCharityWhereInput>>
	city?: InputMaybe<StringFilter>
	email?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	state?: InputMaybe<StringFilter>
	stripeAccountId?: InputMaybe<StringFilter>
}

/** Enable CustomPayoutV2 Response */
export type EnableCustomPayoutV2Response = {
	__typename?: 'EnableCustomPayoutV2Response'
	practicePayoutInfo: PracticeCustomPayoutInfo
}

/** Enterprise invoice detected rebate with practice context */
export type EnterpriseInvoiceDetectedRebate = {
	__typename?: 'EnterpriseInvoiceDetectedRebate'
	/** Client first name (from RebateInvoice) */
	clientFirstName?: Maybe<Scalars['String']['output']>
	/** Client last name (from RebateInvoice) */
	clientLastName?: Maybe<Scalars['String']['output']>
	/** Consolidated practice ID */
	consolidatedPracticeId?: Maybe<Scalars['String']['output']>
	/** Created at timestamp */
	createdAt: Scalars['DateTime']['output']
	/** Detected amount */
	detectedAmount?: Maybe<Scalars['Decimal']['output']>
	/** Detected quantity */
	detectedQuantity?: Maybe<Scalars['Int']['output']>
	/** Unique identifier for the invoice detected rebate */
	id: Scalars['String']['output']
	/** Invoice date */
	invoiceDate: Scalars['DateTime']['output']
	/** Invoice ID */
	invoiceId: Scalars['String']['output']
	/** Invoice line item ID */
	invoiceLineItemId: Scalars['String']['output']
	/** Match confidence */
	matchConfidence?: Maybe<Scalars['Decimal']['output']>
	/** Matched product name */
	matchedProductName?: Maybe<Scalars['String']['output']>
	/** Ordinal */
	ordinal?: Maybe<Scalars['Int']['output']>
	/** Original invoice ID (for multi-invoice rebate validation) */
	originalInvoiceId?: Maybe<Scalars['String']['output']>
	/** Patient name (from RebateInvoice) */
	patientName?: Maybe<Scalars['String']['output']>
	/** Rebate payout batch ID (if rebate has been paid out) */
	payoutBatchId?: Maybe<Scalars['String']['output']>
	/** Payout eligible at timestamp */
	payoutEligibleAt?: Maybe<Scalars['DateTime']['output']>
	/** Practice name */
	practiceName?: Maybe<Scalars['String']['output']>
	/** Product description */
	productDescription?: Maybe<Scalars['String']['output']>
	/** Rebate code */
	rebateCode: Scalars['String']['output']
	/** Rebate invoice ID (FK to RebateInvoice) */
	rebateInvoiceId?: Maybe<Scalars['String']['output']>
	/** Rebate program ID */
	rebateProgramId?: Maybe<Scalars['String']['output']>
	/** Rebate program name */
	rebateProgramName?: Maybe<Scalars['String']['output']>
	/** Rebate program product ID */
	rebateProgramProductId?: Maybe<Scalars['String']['output']>
	/** Rebate program product name */
	rebateProgramProductName?: Maybe<Scalars['String']['output']>
	/** Rebate program product snapshot */
	rebateProgramProductSnapshot?: Maybe<Scalars['JSON']['output']>
	/** Rebate program snapshot */
	rebateProgramSnapshot?: Maybe<Scalars['JSON']['output']>
	/** Rejection reason */
	rejectionReason?: Maybe<Scalars['String']['output']>
	/** Review notes */
	reviewNotes?: Maybe<Scalars['String']['output']>
	/** Status of the rebate */
	status?: Maybe<Scalars['String']['output']>
	/** Validated at timestamp */
	validatedAt?: Maybe<Scalars['DateTime']['output']>
	/** Validation method used to detect this rebate */
	validationMethod?: Maybe<Scalars['String']['output']>
}

/** Response containing enterprise invoice detected rebates with count */
export type EnterpriseInvoiceDetectedRebateListWithCount = {
	__typename?: 'EnterpriseInvoiceDetectedRebateListWithCount'
	args: BaseListArgs
	/** List of enterprise invoice detected rebates */
	items: Array<EnterpriseInvoiceDetectedRebate>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for invoice detected rebates */
export type EnterpriseInvoiceDetectedRebateOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	invoiceDate?: InputMaybe<SortOrder>
	invoiceId?: InputMaybe<SortOrder>
	rebateCode?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	validationMethod?: InputMaybe<SortOrder>
}

/** Filter conditions for invoice detected rebates */
export type EnterpriseInvoiceDetectedRebateWhereInput = {
	AND?: InputMaybe<Array<EnterpriseInvoiceDetectedRebateWhereInput>>
	NOT?: InputMaybe<Array<EnterpriseInvoiceDetectedRebateWhereInput>>
	OR?: InputMaybe<Array<EnterpriseInvoiceDetectedRebateWhereInput>>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	invoiceDate?: InputMaybe<DateTimeFilter>
	invoiceId?: InputMaybe<StringFilter>
	invoiceLineItemId?: InputMaybe<StringFilter>
	payoutBatchId?: InputMaybe<StringNullableFilter>
	rebateCode?: InputMaybe<StringFilter>
	rebateProgramId?: InputMaybe<StringFilter>
	rebateProgramProductId?: InputMaybe<StringFilter>
	status?: InputMaybe<StringNullableFilter>
	validatedAt?: InputMaybe<DateTimeFilter>
	validationMethod?: InputMaybe<StringNullableFilter>
}

/** Response containing enterprise rebate invoices with count */
export type EnterpriseRebateInvoiceListWithCount = {
	__typename?: 'EnterpriseRebateInvoiceListWithCount'
	args: BaseListArgs
	/** List of rebate invoices */
	items: Array<RebateInvoice>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for enterprise rebate invoices */
export type EnterpriseRebateInvoiceOrderByInput = {
	consolidatedPracticeId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	invoiceDate?: InputMaybe<SortOrder>
	invoiceId?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** Filter conditions for enterprise rebate invoices */
export type EnterpriseRebateInvoiceWhereInput = {
	AND?: InputMaybe<Array<EnterpriseRebateInvoiceWhereInput>>
	NOT?: InputMaybe<Array<EnterpriseRebateInvoiceWhereInput>>
	OR?: InputMaybe<Array<EnterpriseRebateInvoiceWhereInput>>
	clientFirstName?: InputMaybe<StringFilter>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	invoiceDate?: InputMaybe<DateTimeFilter>
	invoiceId?: InputMaybe<StringFilter>
	status?: InputMaybe<RebateInvoiceStatus>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Enterprise rebate payout batch with practice and manufacturer context */
export type EnterpriseRebatePayoutBatch = {
	__typename?: 'EnterpriseRebatePayoutBatch'
	/** Batch status (DRAFT, SCHEDULED, PROCESSING, PROCESSED, FAILED, CANCELLED) */
	batchStatus: Scalars['String']['output']
	/** Consolidated practice ID */
	consolidatedPracticeId: Scalars['String']['output']
	/** Consolidator reference code (Consolidator UID) */
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	/** Created at timestamp */
	createdAt: Scalars['DateTime']['output']
	/** Currency */
	currency?: Maybe<Scalars['String']['output']>
	/** Unique identifier for the rebate payout batch */
	id: Scalars['String']['output']
	/** Manufacturer ID */
	manufacturerId: Scalars['String']['output']
	/** Manufacturer name */
	manufacturerName?: Maybe<Scalars['String']['output']>
	/** Payment status (PENDING, PAID, FAILED, etc.) */
	paymentStatus: Scalars['String']['output']
	/** Payout date */
	payoutDate: Scalars['DateTime']['output']
	/** Estimated arrival time of the payout */
	payoutEstimatedArrivalAt?: Maybe<Scalars['DateTime']['output']>
	/** Time when payout was sent */
	payoutSentAt?: Maybe<Scalars['DateTime']['output']>
	/** Practice name */
	practiceName?: Maybe<Scalars['String']['output']>
	/** Statement descriptor used on the Stripe payout */
	statementDescriptor?: Maybe<Scalars['String']['output']>
	/** Stripe payout ID */
	stripePayoutId?: Maybe<Scalars['String']['output']>
	/** Total rebate amount (in cents) */
	totalRebateAmount: Scalars['Int']['output']
	/** Total rebate count */
	totalRebateCount: Scalars['Int']['output']
	/** Updated at timestamp */
	updatedAt: Scalars['DateTime']['output']
}

/** Generic id/name pair used to populate filter dropdowns */
export type EnterpriseRebatePayoutBatchFilterOption = {
	__typename?: 'EnterpriseRebatePayoutBatchFilterOption'
	id: Scalars['String']['output']
	name: Scalars['String']['output']
}

/** Dropdown options for the rebate payouts page filter bar, scoped to the authenticated admin's consolidator */
export type EnterpriseRebatePayoutBatchFilterOptions = {
	__typename?: 'EnterpriseRebatePayoutBatchFilterOptions'
	/** Distinct manufacturers that have at least one payout batch under the consolidator */
	manufacturers: Array<EnterpriseRebatePayoutBatchFilterOption>
	/** All consolidated practices belonging to the consolidator */
	practices: Array<EnterpriseRebatePayoutBatchFilterOption>
}

/** Response containing enterprise rebate payout batches with count */
export type EnterpriseRebatePayoutBatchListWithCount = {
	__typename?: 'EnterpriseRebatePayoutBatchListWithCount'
	args: BaseListArgs
	/** List of enterprise rebate payout batches */
	items: Array<EnterpriseRebatePayoutBatch>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for enterprise rebate payout batches */
export type EnterpriseRebatePayoutBatchOrderByInput = {
	batchStatus?: InputMaybe<SortOrder>
	consolidatedPracticeId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	manufacturerId?: InputMaybe<SortOrder>
	paymentStatus?: InputMaybe<SortOrder>
	payoutDate?: InputMaybe<SortOrder>
	payoutEstimatedArrivalAt?: InputMaybe<SortOrder>
	totalRebateAmount?: InputMaybe<SortOrder>
	totalRebateCount?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** Filter conditions for enterprise rebate payout batches */
export type EnterpriseRebatePayoutBatchWhereInput = {
	AND?: InputMaybe<Array<EnterpriseRebatePayoutBatchWhereInput>>
	NOT?: InputMaybe<Array<EnterpriseRebatePayoutBatchWhereInput>>
	OR?: InputMaybe<Array<EnterpriseRebatePayoutBatchWhereInput>>
	batchStatus?: InputMaybe<StringNullableFilter>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	manufacturerId?: InputMaybe<StringFilter>
	paymentStatus?: InputMaybe<StringNullableFilter>
	payoutDate?: InputMaybe<DateTimeFilter>
	payoutEstimatedArrivalAt?: InputMaybe<DateTimeFilter>
	stripePayoutId?: InputMaybe<StringNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

export type FloatFilter = {
	equals?: InputMaybe<Scalars['Float']['input']>
	gt?: InputMaybe<Scalars['Float']['input']>
	gte?: InputMaybe<Scalars['Float']['input']>
	in?: InputMaybe<Array<Scalars['Float']['input']>>
	lt?: InputMaybe<Scalars['Float']['input']>
	lte?: InputMaybe<Scalars['Float']['input']>
	not?: InputMaybe<NestedFloatFilter>
	notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type FloatNullableFilter = {
	equals?: InputMaybe<Scalars['Float']['input']>
	gt?: InputMaybe<Scalars['Float']['input']>
	gte?: InputMaybe<Scalars['Float']['input']>
	in?: InputMaybe<Array<Scalars['Float']['input']>>
	lt?: InputMaybe<Scalars['Float']['input']>
	lte?: InputMaybe<Scalars['Float']['input']>
	not?: InputMaybe<NestedFloatNullableFilter>
	notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

/** Industry program information */
export type IndustryProgram = {
	__typename?: 'IndustryProgram'
	/** Discount offered to clients */
	clientDiscount?: Maybe<Scalars['String']['output']>
	/** Benefits for the clinic */
	clinicBenefit?: Maybe<Scalars['String']['output']>
	/** Description of the industry program */
	description?: Maybe<Scalars['String']['output']>
	/** Display mode for the industry program */
	displayMode: IndustryProgramDisplayMode
	/** Fine print details of the industry program */
	finePrint?: Maybe<Scalars['String']['output']>
	/** Unique identifier for the industry program */
	id: Scalars['String']['output']
	/** Whether the industry program is active */
	isActive: Scalars['Boolean']['output']
	/** URL for the logo */
	logoUrl?: Maybe<Scalars['String']['output']>
	/** Name of the industry program */
	name: Scalars['String']['output']
	/** Whether the program is for online pharmacy */
	onlinePharma: Scalars['Boolean']['output']
	/** A list of URLs for online pharmacy, keyed by type */
	onlinePharmacyUrls?: Maybe<Scalars['JSON']['output']>
	/** Name of the partner */
	partnerName?: Maybe<Scalars['String']['output']>
	/** Priority of the industry program */
	priority: Scalars['Float']['output']
	/** Settings for template customization */
	rawTemplateSettings?: Maybe<Scalars['JSON']['output']>
	/** End time for the program run */
	runTimeEnd?: Maybe<Scalars['DateTime']['output']>
	/** Start time for the program run */
	runTimeStart: Scalars['DateTime']['output']
	/** Tagline of the industry program */
	tagline?: Maybe<Scalars['String']['output']>
	/** URL for the 720x1280 template */
	template720x1280Url: Scalars['String']['output']
	/** URL for the 1080x1920 template */
	template1080x1920Url: Scalars['String']['output']
	/** URL for the template sample */
	templateSampleUrl: Scalars['String']['output']
	/** Settings for template customization */
	templateSettings?: Maybe<TemplateSettings>
	/** First URL for the industry program */
	url1?: Maybe<Scalars['String']['output']>
	/** Second URL for the industry program */
	url2?: Maybe<Scalars['String']['output']>
	/** Visibility of the industry program */
	visibility: IndustryProgramVisibility
}

export enum IndustryProgramDisplayMode {
	MobileApp = 'MOBILE_APP',
	Splashscreen = 'SPLASHSCREEN'
}

/** A sort order for a field on Industry Program */
export type IndustryProgramOrderByInput = {
	priority?: InputMaybe<SortOrder>
	runTimeEnd?: InputMaybe<SortOrder>
	runTimeStart?: InputMaybe<SortOrder>
}

export enum IndustryProgramVisibility {
	Global = 'GLOBAL',
	Restricted = 'RESTRICTED'
}

/** A query filter for industry programs */
export type IndustryProgramWhereInput = {
	AND?: InputMaybe<Array<IndustryProgramWhereInput>>
	NOT?: InputMaybe<Array<IndustryProgramWhereInput>>
	OR?: InputMaybe<Array<IndustryProgramWhereInput>>
	id?: InputMaybe<StringFilter>
	isActive?: InputMaybe<Scalars['Boolean']['input']>
	name?: InputMaybe<StringFilter>
	onlinePharma?: InputMaybe<Scalars['Boolean']['input']>
	runTimeEnd?: InputMaybe<DateTimeNullableFilter>
	runTimeStart?: InputMaybe<DateTimeNullableFilter>
}

export type IntFilter = {
	equals?: InputMaybe<Scalars['Int']['input']>
	gt?: InputMaybe<Scalars['Int']['input']>
	gte?: InputMaybe<Scalars['Int']['input']>
	in?: InputMaybe<Array<Scalars['Int']['input']>>
	lt?: InputMaybe<Scalars['Int']['input']>
	lte?: InputMaybe<Scalars['Int']['input']>
	not?: InputMaybe<NestedIntFilter>
	notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type IntNullableFilter = {
	equals?: InputMaybe<Scalars['Int']['input']>
	gt?: InputMaybe<Scalars['Int']['input']>
	gte?: InputMaybe<Scalars['Int']['input']>
	in?: InputMaybe<Array<Scalars['Int']['input']>>
	lt?: InputMaybe<Scalars['Int']['input']>
	lte?: InputMaybe<Scalars['Int']['input']>
	not?: InputMaybe<NestedIntNullableFilter>
	notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Invoice detected rebate information */
export type InvoiceDetectedRebate = {
	__typename?: 'InvoiceDetectedRebate'
	auditLogs?: Maybe<Array<AuditLog>>
	/** Consolidated practice ID */
	consolidatedPracticeId: Scalars['String']['output']
	/** Created at timestamp */
	createdAt: Scalars['DateTime']['output']
	/** Detected amount */
	detectedAmount?: Maybe<Scalars['Decimal']['output']>
	/** Detected quantity */
	detectedQuantity?: Maybe<Scalars['Int']['output']>
	/** Unique identifier for the invoice detected rebate */
	id: Scalars['String']['output']
	/** Invoice date */
	invoiceDate: Scalars['DateTime']['output']
	/** Invoice ID */
	invoiceId: Scalars['String']['output']
	/** Invoice line item ID */
	invoiceLineItemId: Scalars['String']['output']
	/** Match confidence */
	matchConfidence?: Maybe<Scalars['Decimal']['output']>
	/** Matched product name */
	matchedProductName?: Maybe<Scalars['String']['output']>
	/** Ordinal */
	ordinal?: Maybe<Scalars['Int']['output']>
	/** Original invoice ID (for multi-invoice rebate validation) */
	originalInvoiceId?: Maybe<Scalars['String']['output']>
	/** Rebate payout batch ID (if rebate has been paid out) */
	payoutBatchId?: Maybe<Scalars['String']['output']>
	/** Payout eligible at timestamp */
	payoutEligibleAt?: Maybe<Scalars['DateTime']['output']>
	/** Product description */
	productDescription?: Maybe<Scalars['String']['output']>
	/** Rebate code */
	rebateCode: Scalars['String']['output']
	/** Rebate program ID */
	rebateProgramId?: Maybe<Scalars['String']['output']>
	/** Rebate program name */
	rebateProgramName?: Maybe<Scalars['String']['output']>
	/** Rebate program product ID */
	rebateProgramProductId?: Maybe<Scalars['String']['output']>
	/** Rebate program product name */
	rebateProgramProductName?: Maybe<Scalars['String']['output']>
	/** Rebate program product snapshot */
	rebateProgramProductSnapshot?: Maybe<Scalars['JSON']['output']>
	/** Rebate program snapshot */
	rebateProgramSnapshot?: Maybe<Scalars['JSON']['output']>
	/** Rejection reason */
	rejectionReason?: Maybe<Scalars['String']['output']>
	/** Review notes */
	reviewNotes?: Maybe<Scalars['String']['output']>
	/** Status of the rebate */
	status?: Maybe<Scalars['String']['output']>
	/** Validated at timestamp */
	validatedAt?: Maybe<Scalars['DateTime']['output']>
	/** Validation method used to detect this rebate */
	validationMethod?: Maybe<Scalars['String']['output']>
}

/** The action type of audit log */
export enum InvoiceDetectedRebateAuditLogActionType {
	Approve = 'APPROVE',
	Reject = 'REJECT'
}

/** Response containing invoice detected rebates with count */
export type InvoiceDetectedRebateListWithCount = {
	__typename?: 'InvoiceDetectedRebateListWithCount'
	args: BaseListArgs
	/** List of invoice detected rebates */
	items: Array<InvoiceDetectedRebate>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for invoice detected rebates */
export type InvoiceDetectedRebateOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	invoiceDate?: InputMaybe<SortOrder>
	invoiceId?: InputMaybe<SortOrder>
	rebateCode?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	validationMethod?: InputMaybe<SortOrder>
}

/** Filter conditions for invoice detected rebates */
export type InvoiceDetectedRebateWhereInput = {
	AND?: InputMaybe<Array<InvoiceDetectedRebateWhereInput>>
	NOT?: InputMaybe<Array<InvoiceDetectedRebateWhereInput>>
	OR?: InputMaybe<Array<InvoiceDetectedRebateWhereInput>>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	invoiceDate?: InputMaybe<DateTimeFilter>
	invoiceId?: InputMaybe<StringFilter>
	invoiceLineItemId?: InputMaybe<StringFilter>
	rebateCode?: InputMaybe<StringFilter>
	rebateProgramId?: InputMaybe<StringFilter>
	rebateProgramProductId?: InputMaybe<StringFilter>
	status?: InputMaybe<StringNullableFilter>
	validatedAt?: InputMaybe<DateTimeFilter>
	validationMethod?: InputMaybe<StringNullableFilter>
}

export type JsonFilter = {
	array_contains?: InputMaybe<Scalars['JSON']['input']>
	array_ends_with?: InputMaybe<Scalars['JSON']['input']>
	array_starts_with?: InputMaybe<Scalars['JSON']['input']>
	equals?: InputMaybe<Scalars['JSON']['input']>
	gt?: InputMaybe<Scalars['JSON']['input']>
	gte?: InputMaybe<Scalars['JSON']['input']>
	lt?: InputMaybe<Scalars['JSON']['input']>
	lte?: InputMaybe<Scalars['JSON']['input']>
	not?: InputMaybe<Scalars['JSON']['input']>
	path?: InputMaybe<Array<Scalars['String']['input']>>
	string_contains?: InputMaybe<Scalars['String']['input']>
	string_ends_with?: InputMaybe<Scalars['String']['input']>
	string_starts_with?: InputMaybe<Scalars['String']['input']>
}

export type JsonNullableFilter = {
	array_contains?: InputMaybe<Scalars['JSON']['input']>
	array_ends_with?: InputMaybe<Scalars['JSON']['input']>
	array_starts_with?: InputMaybe<Scalars['JSON']['input']>
	equals?: InputMaybe<Scalars['JSON']['input']>
	gt?: InputMaybe<Scalars['JSON']['input']>
	gte?: InputMaybe<Scalars['JSON']['input']>
	lt?: InputMaybe<Scalars['JSON']['input']>
	lte?: InputMaybe<Scalars['JSON']['input']>
	not?: InputMaybe<Scalars['JSON']['input']>
	path?: InputMaybe<Array<Scalars['String']['input']>>
	string_contains?: InputMaybe<Scalars['String']['input']>
	string_ends_with?: InputMaybe<Scalars['String']['input']>
	string_starts_with?: InputMaybe<Scalars['String']['input']>
}

/** A sort order for a field on Active Rebate Program */
export type ListActivePracticeRebateProgramOrderByInput = {
	disabledAt?: InputMaybe<SortOrder>
	enabledAt?: InputMaybe<SortOrder>
	priority?: InputMaybe<SortOrder>
}

/** Response containing active rebate programs */
export type ListActivePracticeRebateProgramResponse = {
	__typename?: 'ListActivePracticeRebateProgramResponse'
	/** List of active rebate programs */
	practiceRebatePrograms: Array<PracticeRebateProgram>
}

/** A query filter for active rebate programs */
export type ListActivePracticeRebateProgramWhereInput = {
	AND?: InputMaybe<Array<ListActivePracticeRebateProgramWhereInput>>
	NOT?: InputMaybe<Array<ListActivePracticeRebateProgramWhereInput>>
	OR?: InputMaybe<Array<ListActivePracticeRebateProgramWhereInput>>
	codesCreatedAt?: InputMaybe<DateTimeNullableFilter>
	disabledAt?: InputMaybe<DateTimeNullableFilter>
	enabledAt?: InputMaybe<DateTimeNullableFilter>
	id?: InputMaybe<StringFilter>
	practiceId?: InputMaybe<StringFilter>
	rebateProgramId?: InputMaybe<StringFilter>
	status?: InputMaybe<RebateProgramStatus>
}

/** Response containing industry programs */
export type ListIndustryProgramResponse = {
	__typename?: 'ListIndustryProgramResponse'
	/** Active Industry program */
	activeProgram?: Maybe<PracticeIndustryProgram>
	/** List of industry programs */
	industryPrograms: Array<IndustryProgram>
}

/** Response containing rebate programs */
export type ListRebateProgramResponse = {
	__typename?: 'ListRebateProgramResponse'
	/** List of rebate programs */
	rebatePrograms: Array<RebateProgram>
	/** Total number of rebate programs matching the query */
	total?: Maybe<Scalars['Int']['output']>
}

/** Manufacturer information */
export type Manufacturer = {
	__typename?: 'Manufacturer'
	/** Brands associated with this manufacturer */
	brands?: Maybe<Array<BrandReference>>
	/** Timestamp when the manufacturer was created */
	createdAt: Scalars['DateTime']['output']
	/** Unique identifier for the manufacturer */
	id: Scalars['String']['output']
	/** Name of the manufacturer */
	name: Scalars['String']['output']
	/** Product references associated with this manufacturer */
	productReferences?: Maybe<Array<ProductReference>>
	/** Funding status of the manufacturer */
	status: ManufacturerFundingStatus
	/** Timestamp when the manufacturer was last updated */
	updatedAt: Scalars['DateTime']['output']
}

/** The status of a Manufacturer account */
export enum ManufacturerFundingStatus {
	Active = 'ACTIVE',
	Inactive = 'INACTIVE',
	Suspended = 'SUSPENDED'
}

export type ManufacturerListWithCount = {
	__typename?: 'ManufacturerListWithCount'
	args: BaseListArgs
	items: Array<Manufacturer>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type ManufacturerOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type ManufacturerWhereInput = {
	AND?: InputMaybe<Array<ManufacturerWhereInput>>
	NOT?: InputMaybe<Array<ManufacturerWhereInput>>
	OR?: InputMaybe<Array<ManufacturerWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** MonthlyBillingRecord item */
export type MonthlyBillingRecord = {
	__typename?: 'MonthlyBillingRecord'
	card_payment_volume: Scalars['Decimal']['output']
	check_payment_volume: Scalars['Decimal']['output']
	credit_fees: Scalars['Decimal']['output']
	credit_volume: Scalars['Decimal']['output']
	currency: Scalars['String']['output']
	debit_fees: Scalars['Decimal']['output']
	debit_volume: Scalars['Decimal']['output']
	effective_rate: Scalars['Decimal']['output']
	id: Scalars['String']['output']
	month: Scalars['DateTimeISO']['output']
	num_active_terminals: Scalars['Float']['output']
	payment_volume: Scalars['Decimal']['output']
	rate_scheme?: Maybe<Scalars['String']['output']>
	status: Scalars['String']['output']
	surcharge_fees?: Maybe<Scalars['Decimal']['output']>
	surcharge_fees_saved?: Maybe<Scalars['Decimal']['output']>
	surcharge_volume?: Maybe<Scalars['Decimal']['output']>
	tier?: Maybe<Scalars['String']['output']>
	total_fees: Scalars['Decimal']['output']
	type: Scalars['String']['output']
}

export type MonthlyBillingRecordOrderByInput = {
	currency?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	month?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	tier?: InputMaybe<SortOrder>
}

export type MonthlyBillingRecordWhereInput = {
	AND?: InputMaybe<Array<MonthlyBillingRecordWhereInput>>
	NOT?: InputMaybe<Array<MonthlyBillingRecordWhereInput>>
	OR?: InputMaybe<Array<MonthlyBillingRecordWhereInput>>
	currency?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	month?: InputMaybe<DateTimeFilter>
	rate_scheme?: InputMaybe<StringFilter>
	status?: InputMaybe<StringFilter>
	tier?: InputMaybe<StringFilter>
	type?: InputMaybe<StringFilter>
}

/** List of Monthly Billing Records with pagination */
export type MonthlyBillingRecordWithCount = {
	__typename?: 'MonthlyBillingRecordWithCount'
	args: BaseListArgs
	items: Array<MonthlyBillingRecord>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type MonthlyStatement = {
	__typename?: 'MonthlyStatement'
	amountSettled: Scalars['Decimal']['output']
	currency: Scalars['String']['output']
	dayLines?: Maybe<Array<MonthlyStatementDayLine>>
	feeLines?: Maybe<Array<MonthlyStatementFeeLine>>
	feeTier: Scalars['String']['output']
	feesCollected?: Maybe<Scalars['Decimal']['output']>
	hardwareCost?: Maybe<Scalars['Decimal']['output']>
	hardwareOrders?: Maybe<Array<MonthlyStatementHardwareOrder>>
	hardwarePracticeSummary?: Maybe<MonthlyStatementHardwarePracticeSummary>
	id: Scalars['String']['output']
	month: Scalars['DateTimeISO']['output']
	numAuthorized: Scalars['Float']['output']
	numSettled: Scalars['Float']['output']
	otherFees?: Maybe<Scalars['Decimal']['output']>
	paymentLines?: Maybe<Array<MonthlyStatementPaymentLine>>
	practiceId: Scalars['String']['output']
	surchargeFees?: Maybe<Scalars['Decimal']['output']>
	surchargeFeesSaved?: Maybe<Scalars['Decimal']['output']>
	surchargeVolume?: Maybe<Scalars['Decimal']['output']>
	tipVolume?: Maybe<Scalars['Decimal']['output']>
	totalFees?: Maybe<Scalars['Decimal']['output']>
	totalRefunded?: Maybe<Scalars['Decimal']['output']>
}

export type MonthlyStatementDayLine = {
	__typename?: 'MonthlyStatementDayLine'
	amountSettled: Scalars['Decimal']['output']
	day: Scalars['DateTimeISO']['output']
	numAuthorized: Scalars['Float']['output']
	numSettled: Scalars['Float']['output']
	surchargeFees?: Maybe<Scalars['Decimal']['output']>
	surchargeFeesSaved?: Maybe<Scalars['Decimal']['output']>
	surchargeVolume?: Maybe<Scalars['Decimal']['output']>
	tipVolume?: Maybe<Scalars['Decimal']['output']>
	totalFees: Scalars['Decimal']['output']
	totalRefunded?: Maybe<Scalars['Decimal']['output']>
}

export type MonthlyStatementFeeLine = {
	__typename?: 'MonthlyStatementFeeLine'
	amount?: Maybe<Scalars['Decimal']['output']>
	feeType: Scalars['String']['output']
	rate?: Maybe<Scalars['Decimal']['output']>
	totalFees?: Maybe<Scalars['Decimal']['output']>
}

export type MonthlyStatementHardwareOrder = {
	__typename?: 'MonthlyStatementHardwareOrder'
	amountDue?: Maybe<Scalars['Decimal']['output']>
	details?: Maybe<Scalars['JSON']['output']>
	hardwareOrderId: Scalars['String']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
	shipping?: Maybe<Scalars['Decimal']['output']>
	tax?: Maybe<Scalars['Decimal']['output']>
	totalAmount?: Maybe<Scalars['Decimal']['output']>
}

export type MonthlyStatementHardwarePracticeSummary = {
	__typename?: 'MonthlyStatementHardwarePracticeSummary'
	accessoryCost: Scalars['Decimal']['output']
	accessoryCount: Scalars['Float']['output']
	availableHardwareCredit: Scalars['Decimal']['output']
	clinicReferenceCode?: Maybe<Scalars['String']['output']>
	currency: Scalars['String']['output']
	dockCost: Scalars['Decimal']['output']
	dockCount: Scalars['Float']['output']
	finalAmount: Scalars['Decimal']['output']
	hardwareCreditUsed: Scalars['Decimal']['output']
	id: Scalars['String']['output']
	includedTerminals: Scalars['Float']['output']
	monthlyStmtId: Scalars['String']['output']
	practiceId: Scalars['String']['output']
	practiceShippingCost?: Maybe<Scalars['Decimal']['output']>
	rollingAccessoryCount: Scalars['Float']['output']
	rollingAmount: Scalars['Decimal']['output']
	rollingDockCount?: Maybe<Scalars['Float']['output']>
	rollingTerminalCount: Scalars['Float']['output']
	scratchShippingCost?: Maybe<Scalars['Decimal']['output']>
	terminalCost: Scalars['Decimal']['output']
	terminalCount: Scalars['Float']['output']
	usageMonth: Scalars['DateTimeISO']['output']
}

export type MonthlyStatementOrderByInput = {
	id?: InputMaybe<SortOrder>
	month?: InputMaybe<SortOrder>
}

export type MonthlyStatementPaymentLine = {
	__typename?: 'MonthlyStatementPaymentLine'
	amountSettled: Scalars['Decimal']['output']
	numAuthorized: Scalars['Float']['output']
	numSettled: Scalars['Float']['output']
	paymentMethodType: Scalars['String']['output']
	surchargeFees?: Maybe<Scalars['Decimal']['output']>
	surchargeFeesSaved?: Maybe<Scalars['Decimal']['output']>
	surchargeVolume?: Maybe<Scalars['Decimal']['output']>
	tipVolume?: Maybe<Scalars['Decimal']['output']>
	totalFees: Scalars['Decimal']['output']
}

export type MonthlyStatementWhereInput = {
	AND?: InputMaybe<Array<MonthlyStatementWhereInput>>
	NOT?: InputMaybe<Array<MonthlyStatementWhereInput>>
	OR?: InputMaybe<Array<MonthlyStatementWhereInput>>
	id?: InputMaybe<StringFilter>
	month?: InputMaybe<DateTimeFilter>
	practice?: InputMaybe<PracticeRelationFilter>
	practiceId?: InputMaybe<StringFilter>
}

export type Mutation = {
	__typename?: 'Mutation'
	approveRebate: ApproveRebateResponse
	createCashDeposit: CashDeposit
	createDonationCharity: DonationCharityAdmin
	createDonationCharityAccountLink: Scalars['String']['output']
	/** Delete a normalized product by UUID */
	deleteNormalizedProduct: Scalars['Boolean']['output']
	/** Deletes all normalized products for a practice that haven't been manually checked. */
	deleteNormalizedProductsPerPractice: Scalars['Boolean']['output']
	/** Delete a product reference by ID */
	deleteProductReference: Scalars['Boolean']['output']
	/** Delete a product variant by ID */
	deleteProductVariant: Scalars['Boolean']['output']
	enableCustomPayoutV2: EnableCustomPayoutV2Response
	processUploadedFile: PaymentRequestFile
	rejectRebate: RejectRebateResponse
	toggleIndustryProgram: PracticeIndustryProgram
	toggleRebateProgram: PracticeRebateProgram
	triggerRefundPayout: TriggerRefundPayoutResponse
	updateConsolidatedPracticeStatus: ConsolidatedPractice
	updateDonationCharity: DonationCharityAdmin
	updatePaymentRequest: PaymentRequest
	updatePracticeRebateProgramSettings: PracticeRebateProgram
	upsertConsolidatedPractice: ConsolidatedPractice
	upsertConsolidatedPracticeBankAccount: ConsolidatedPracticeBankAccount
	upsertCustomPayoutSettings: UpsertCustomPayoutSettingsResponse
	/** Create or update a normalized product */
	upsertNormalizedProduct: NormalizedProduct
	/** Upsert a partner by ID */
	upsertPartner: Partner
	/** Create or update a product reference */
	upsertProductReference: ProductReference
	/** Create or update a product variant */
	upsertProductVariant: ProductVariantReference
	upsertRefundRequest: RefundRequest
	/** Create or update a tip recipient for the current practice */
	upsertTipRecipient: TipRecipient
	voidFile: VoidPaymentRequestFileResponse
}

export type MutationApproveRebateArgs = {
	notes?: InputMaybe<Scalars['String']['input']>
	rebateId: Scalars['String']['input']
}

export type MutationCreateCashDepositArgs = {
	cashDrawers: Array<CreateCashDrawerArgs>
	cashSalesDate: Scalars['DateTimeISO']['input']
	dtsTrackingNumber?: InputMaybe<Scalars['String']['input']>
	plannedDepositDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	reportedDepositAmount: Scalars['Int']['input']
}

export type MutationCreateDonationCharityArgs = {
	address?: InputMaybe<Scalars['String']['input']>
	bankAccountNumber?: InputMaybe<Scalars['String']['input']>
	bankRoutingNumber?: InputMaybe<Scalars['String']['input']>
	city?: InputMaybe<Scalars['String']['input']>
	country?: InputMaybe<Scalars['String']['input']>
	ein?: InputMaybe<Scalars['String']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	name: Scalars['String']['input']
	phone?: InputMaybe<Scalars['String']['input']>
	state?: InputMaybe<Scalars['String']['input']>
	suggestedAmounts?: InputMaybe<Array<Scalars['Int']['input']>>
	website?: InputMaybe<Scalars['String']['input']>
	zip?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateDonationCharityAccountLinkArgs = {
	id: Scalars['String']['input']
	refreshURL: Scalars['String']['input']
	returnURL: Scalars['String']['input']
}

export type MutationDeleteNormalizedProductArgs = {
	uuid: Scalars['String']['input']
}

export type MutationDeleteNormalizedProductsPerPracticeArgs = {
	practiceId: Scalars['String']['input']
}

export type MutationDeleteProductReferenceArgs = {
	id: Scalars['String']['input']
}

export type MutationDeleteProductVariantArgs = {
	id: Scalars['String']['input']
}

export type MutationEnableCustomPayoutV2Args = {
	practiceId: Scalars['ID']['input']
}

export type MutationProcessUploadedFileArgs = {
	fileName: Scalars['String']['input']
}

export type MutationRejectRebateArgs = {
	notes?: InputMaybe<Scalars['String']['input']>
	reason: Scalars['String']['input']
	rebateId: Scalars['String']['input']
}

export type MutationToggleIndustryProgramArgs = {
	disableReason?: InputMaybe<Scalars['String']['input']>
	enabled: Scalars['Boolean']['input']
	industryProgramId: Scalars['String']['input']
	practiceId: Scalars['String']['input']
}

export type MutationToggleRebateProgramArgs = {
	disableReason?: InputMaybe<Scalars['String']['input']>
	optIn: Scalars['Boolean']['input']
	rebateProgramId: Scalars['String']['input']
}

export type MutationTriggerRefundPayoutArgs = {
	amount: Scalars['Float']['input']
	currency?: InputMaybe<Scalars['String']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	stripeAccountId: Scalars['String']['input']
}

export type MutationUpdateConsolidatedPracticeStatusArgs = {
	id: Scalars['String']['input']
	processStatus?: InputMaybe<Scalars['String']['input']>
	processType?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateDonationCharityArgs = {
	address?: InputMaybe<Scalars['String']['input']>
	bankAccountNumber?: InputMaybe<Scalars['String']['input']>
	bankRoutingNumber?: InputMaybe<Scalars['String']['input']>
	city?: InputMaybe<Scalars['String']['input']>
	country?: InputMaybe<Scalars['String']['input']>
	ein?: InputMaybe<Scalars['String']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	id: Scalars['String']['input']
	name?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	state?: InputMaybe<Scalars['String']['input']>
	suggestedAmounts?: InputMaybe<Array<Scalars['Int']['input']>>
	website?: InputMaybe<Scalars['String']['input']>
	zip?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdatePaymentRequestArgs = {
	arDeliveryMethod?: InputMaybe<Scalars['String']['input']>
	customerEmail?: InputMaybe<Scalars['String']['input']>
	customerPhone?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdatePracticeRebateProgramSettingsArgs = {
	id: Scalars['String']['input']
	isTerminalOfferEnabled?: InputMaybe<Scalars['Boolean']['input']>
	priority?: InputMaybe<Scalars['Int']['input']>
	rebatesHandoffHoldoutPct?: InputMaybe<Scalars['Float']['input']>
	terminalSuppressionKeywords?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MutationUpsertConsolidatedPracticeArgs = {
	acceptsCareCredit?: InputMaybe<Scalars['Boolean']['input']>
	address?: InputMaybe<Scalars['String']['input']>
	address2?: InputMaybe<Scalars['String']['input']>
	agreementSignedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
	city?: InputMaybe<Scalars['String']['input']>
	consolidatorId?: InputMaybe<Scalars['String']['input']>
	consolidatorOther?: InputMaybe<Scalars['String']['input']>
	consolidatorReferenceCode?: InputMaybe<Scalars['String']['input']>
	consolidatorReferenceCode2?: InputMaybe<Scalars['String']['input']>
	consolidatorReferenceCode3?: InputMaybe<Scalars['String']['input']>
	country?: InputMaybe<Scalars['String']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	customPayoutRunAtTime?: InputMaybe<Scalars['DateTimeISO']['input']>
	customPayoutSettings?: InputMaybe<Scalars['JSON']['input']>
	customPayoutTarget?: InputMaybe<Scalars['String']['input']>
	dashboardActivatedOn?: InputMaybe<Scalars['DateTimeISO']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	finalizeLoanAttemptOn?: InputMaybe<Scalars['DateTimeISO']['input']>
	financingStatus?: InputMaybe<Scalars['String']['input']>
	fingerprint?: InputMaybe<Scalars['String']['input']>
	firstApplicationDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	firstFinalizedTestTransaction?: InputMaybe<Scalars['DateTimeISO']['input']>
	firstLoanDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	firstPaymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	goLiveDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	googlePlaceId?: InputMaybe<Scalars['String']['input']>
	hospitalManagerEmail?: InputMaybe<Scalars['String']['input']>
	howDidYouHearAboutUs?: InputMaybe<Scalars['String']['input']>
	hubspotCompanyId?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	industry?: InputMaybe<Scalars['String']['input']>
	industryProgramMetadata?: InputMaybe<Scalars['JSON']['input']>
	installmentAlertEmails?: InputMaybe<Array<Scalars['String']['input']>>
	integrationId?: InputMaybe<Scalars['String']['input']>
	isCustomPayoutEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isDeleted?: InputMaybe<Scalars['Boolean']['input']>
	isEr?: InputMaybe<Scalars['Boolean']['input']>
	isLendingEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isNetSettlementLending?: InputMaybe<Scalars['Boolean']['input']>
	isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isRebateEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isUnderwritten?: InputMaybe<Scalars['Boolean']['input']>
	legalBusinessName?: InputMaybe<Scalars['String']['input']>
	lendingId?: InputMaybe<Scalars['Int']['input']>
	locale?: InputMaybe<Scalars['String']['input']>
	logoUrl?: InputMaybe<Scalars['String']['input']>
	memberUTM?: InputMaybe<Scalars['String']['input']>
	merchantCategoryId?: InputMaybe<Scalars['Int']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	netsuiteId?: InputMaybe<Scalars['String']['input']>
	numJCLoans?: InputMaybe<Scalars['Int']['input']>
	numPetParentsLoans?: InputMaybe<Scalars['Int']['input']>
	numberOfExamRooms?: InputMaybe<Scalars['Int']['input']>
	partnerIds?: InputMaybe<Array<Scalars['String']['input']>>
	payerEmail?: InputMaybe<Scalars['String']['input']>
	paymentId?: InputMaybe<Scalars['String']['input']>
	paymentLogo?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	pimsMetadata?: InputMaybe<Scalars['JSON']['input']>
	referralId?: InputMaybe<Scalars['String']['input']>
	referralRockAccepted?: InputMaybe<Scalars['Boolean']['input']>
	referrer?: InputMaybe<Scalars['String']['input']>
	regionalManagerId?: InputMaybe<Scalars['String']['input']>
	settings?: InputMaybe<Scalars['JSON']['input']>
	settlementDays?: InputMaybe<Scalars['Int']['input']>
	signerEmail?: InputMaybe<Scalars['String']['input']>
	signerName?: InputMaybe<Scalars['String']['input']>
	signerPhone?: InputMaybe<Scalars['String']['input']>
	signerRole?: InputMaybe<Scalars['String']['input']>
	signupAttribution?: InputMaybe<Scalars['JSON']['input']>
	skyworldId?: InputMaybe<Scalars['String']['input']>
	socialUrl?: InputMaybe<Scalars['JSON']['input']>
	source?: InputMaybe<Scalars['String']['input']>
	state?: InputMaybe<Scalars['String']['input']>
	surchargeEnabled?: InputMaybe<Scalars['Boolean']['input']>
	surchargeFeePct?: InputMaybe<Scalars['Float']['input']>
	surchargeStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	terminalConfigId?: InputMaybe<Scalars['String']['input']>
	terminalLocation?: InputMaybe<Scalars['String']['input']>
	terminalSplashScreen?: InputMaybe<Scalars['JSON']['input']>
	timezone?: InputMaybe<Scalars['String']['input']>
	underwritingStatus?: InputMaybe<Scalars['String']['input']>
	underwrittenAt?: InputMaybe<Scalars['DateTimeISO']['input']>
	validatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
	validationType?: InputMaybe<Scalars['String']['input']>
	website?: InputMaybe<Scalars['String']['input']>
	zip?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpsertConsolidatedPracticeBankAccountArgs = {
	accountHolderName?: InputMaybe<Scalars['String']['input']>
	accountHolderType?: InputMaybe<Scalars['String']['input']>
	accountNumber?: InputMaybe<Scalars['String']['input']>
	bankName?: InputMaybe<Scalars['String']['input']>
	consolidatedPracticeId?: InputMaybe<Scalars['String']['input']>
	disabledReason?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	metadata?: InputMaybe<Scalars['JSON']['input']>
	routingNumber?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<BankAccountStatus>
	stripeBankAccountId?: InputMaybe<Scalars['String']['input']>
	stripeCustomerId?: InputMaybe<Scalars['String']['input']>
	stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>
	stripePlatformAccountId?: InputMaybe<Scalars['String']['input']>
	usedForProduct?: InputMaybe<Array<ScratchProduct>>
}

export type MutationUpsertCustomPayoutSettingsArgs = {
	practiceId: Scalars['String']['input']
	settings: CustomPayoutSettingsInput
}

export type MutationUpsertNormalizedProductArgs = {
	upsertArgs: UpsertNormalizedProductInput
}

export type MutationUpsertPartnerArgs = {
	upsertInput: UpsertPartnerInput
}

export type MutationUpsertProductReferenceArgs = {
	upsertArgs: UpsertProductReferenceInput
}

export type MutationUpsertProductVariantArgs = {
	upsertArgs: UpsertProductVariantInput
}

export type MutationUpsertRefundRequestArgs = {
	chargeId?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['ID']['input']>
	notes?: InputMaybe<Scalars['String']['input']>
	paymentIntentId?: InputMaybe<Scalars['String']['input']>
	pimsClientId?: InputMaybe<Scalars['String']['input']>
	requestedRefundAmount?: InputMaybe<Scalars['Float']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	writebackPimsClientId?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpsertTipRecipientArgs = {
	id?: InputMaybe<Scalars['ID']['input']>
	isActive?: InputMaybe<Scalars['Boolean']['input']>
	name: Scalars['String']['input']
}

export type MutationVoidFileArgs = {
	fileId: Scalars['String']['input']
}

export type NestedBoolFilter = {
	equals?: InputMaybe<Scalars['Boolean']['input']>
	not?: InputMaybe<NestedBoolFilter>
}

export type NestedBoolNullableFilter = {
	equals?: InputMaybe<Scalars['Boolean']['input']>
	not?: InputMaybe<NestedBoolNullableFilter>
}

export type NestedDateTimeFilter = {
	equals?: InputMaybe<Scalars['DateTimeISO']['input']>
	gt?: InputMaybe<Scalars['DateTimeISO']['input']>
	gte?: InputMaybe<Scalars['DateTimeISO']['input']>
	in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
	lt?: InputMaybe<Scalars['DateTimeISO']['input']>
	lte?: InputMaybe<Scalars['DateTimeISO']['input']>
	not?: InputMaybe<NestedDateTimeFilter>
	notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type NestedDateTimeNullableFilter = {
	equals?: InputMaybe<Scalars['DateTimeISO']['input']>
	gt?: InputMaybe<Scalars['DateTimeISO']['input']>
	gte?: InputMaybe<Scalars['DateTimeISO']['input']>
	in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
	lt?: InputMaybe<Scalars['DateTimeISO']['input']>
	lte?: InputMaybe<Scalars['DateTimeISO']['input']>
	not?: InputMaybe<NestedDateTimeNullableFilter>
	notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type NestedDecimalFilter = {
	equals?: InputMaybe<Scalars['Decimal']['input']>
	gt?: InputMaybe<Scalars['Decimal']['input']>
	gte?: InputMaybe<Scalars['Decimal']['input']>
	in?: InputMaybe<Array<Scalars['Decimal']['input']>>
	lt?: InputMaybe<Scalars['Decimal']['input']>
	lte?: InputMaybe<Scalars['Decimal']['input']>
	not?: InputMaybe<NestedDecimalFilter>
	notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>
}

export type NestedFloatFilter = {
	equals?: InputMaybe<Scalars['Float']['input']>
	gt?: InputMaybe<Scalars['Float']['input']>
	gte?: InputMaybe<Scalars['Float']['input']>
	in?: InputMaybe<Array<Scalars['Float']['input']>>
	lt?: InputMaybe<Scalars['Float']['input']>
	lte?: InputMaybe<Scalars['Float']['input']>
	not?: InputMaybe<NestedFloatFilter>
	notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type NestedFloatNullableFilter = {
	equals?: InputMaybe<Scalars['Float']['input']>
	gt?: InputMaybe<Scalars['Float']['input']>
	gte?: InputMaybe<Scalars['Float']['input']>
	in?: InputMaybe<Array<Scalars['Float']['input']>>
	lt?: InputMaybe<Scalars['Float']['input']>
	lte?: InputMaybe<Scalars['Float']['input']>
	not?: InputMaybe<NestedFloatNullableFilter>
	notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type NestedIntFilter = {
	equals?: InputMaybe<Scalars['Int']['input']>
	gt?: InputMaybe<Scalars['Int']['input']>
	gte?: InputMaybe<Scalars['Int']['input']>
	in?: InputMaybe<Array<Scalars['Int']['input']>>
	lt?: InputMaybe<Scalars['Int']['input']>
	lte?: InputMaybe<Scalars['Int']['input']>
	not?: InputMaybe<NestedIntFilter>
	notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NestedIntNullableFilter = {
	equals?: InputMaybe<Scalars['Int']['input']>
	gt?: InputMaybe<Scalars['Int']['input']>
	gte?: InputMaybe<Scalars['Int']['input']>
	in?: InputMaybe<Array<Scalars['Int']['input']>>
	lt?: InputMaybe<Scalars['Int']['input']>
	lte?: InputMaybe<Scalars['Int']['input']>
	not?: InputMaybe<NestedIntNullableFilter>
	notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NestedStringFilter = {
	contains?: InputMaybe<Scalars['String']['input']>
	endsWith?: InputMaybe<Scalars['String']['input']>
	equals?: InputMaybe<Scalars['String']['input']>
	gt?: InputMaybe<Scalars['String']['input']>
	gte?: InputMaybe<Scalars['String']['input']>
	in?: InputMaybe<Array<Scalars['String']['input']>>
	lt?: InputMaybe<Scalars['String']['input']>
	lte?: InputMaybe<Scalars['String']['input']>
	not?: InputMaybe<NestedStringFilter>
	notIn?: InputMaybe<Array<Scalars['String']['input']>>
	startsWith?: InputMaybe<Scalars['String']['input']>
}

export type NestedStringNullableFilter = {
	contains?: InputMaybe<Scalars['String']['input']>
	endsWith?: InputMaybe<Scalars['String']['input']>
	equals?: InputMaybe<Scalars['String']['input']>
	gt?: InputMaybe<Scalars['String']['input']>
	gte?: InputMaybe<Scalars['String']['input']>
	in?: InputMaybe<Array<Scalars['String']['input']>>
	lt?: InputMaybe<Scalars['String']['input']>
	lte?: InputMaybe<Scalars['String']['input']>
	not?: InputMaybe<NestedStringNullableFilter>
	notIn?: InputMaybe<Array<Scalars['String']['input']>>
	startsWith?: InputMaybe<Scalars['String']['input']>
}

export type NetworkMonthlyStatementHardwareOrder = {
	__typename?: 'NetworkMonthlyStatementHardwareOrder'
	amountDue?: Maybe<Scalars['Decimal']['output']>
	details?: Maybe<Scalars['JSON']['output']>
	hardwareOrderId: Scalars['String']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
	shipping?: Maybe<Scalars['Decimal']['output']>
	tax?: Maybe<Scalars['Decimal']['output']>
	totalAmount?: Maybe<Scalars['Decimal']['output']>
}

export type NetworkMonthlyStatementLocationLine = {
	__typename?: 'NetworkMonthlyStatementLocationLine'
	cardCount: Scalars['Float']['output']
	cardFees?: Maybe<Scalars['Decimal']['output']>
	cartVolume?: Maybe<Scalars['Decimal']['output']>
	checkCount: Scalars['Float']['output']
	checkFees?: Maybe<Scalars['Decimal']['output']>
	checkVolume?: Maybe<Scalars['Decimal']['output']>
	commsFees?: Maybe<Scalars['Decimal']['output']>
	creditCount: Scalars['Float']['output']
	creditFees?: Maybe<Scalars['Decimal']['output']>
	creditVolume?: Maybe<Scalars['Decimal']['output']>
	debitCount: Scalars['Float']['output']
	debitFees?: Maybe<Scalars['Decimal']['output']>
	debitVolume?: Maybe<Scalars['Decimal']['output']>
	financingFees?: Maybe<Scalars['Decimal']['output']>
	id: Scalars['String']['output']
	monthlyPaymentFees?: Maybe<Scalars['Decimal']['output']>
	otherFees?: Maybe<Scalars['Decimal']['output']>
	stripeAccountId: Scalars['String']['output']
	surchargeCount: Scalars['Float']['output']
	surchargeFees?: Maybe<Scalars['Decimal']['output']>
	surchargeFeesSaved?: Maybe<Scalars['Decimal']['output']>
	surchargeVolume?: Maybe<Scalars['Decimal']['output']>
	totalFees?: Maybe<Scalars['Decimal']['output']>
}

export type NetworkMonthlyStatementPaymentLine = {
	__typename?: 'NetworkMonthlyStatementPaymentLine'
	amount?: Maybe<Scalars['Decimal']['output']>
	cardFunding?: Maybe<Scalars['String']['output']>
	category: Scalars['String']['output']
	count: Scalars['Float']['output']
	description: Scalars['String']['output']
	fees?: Maybe<Scalars['Decimal']['output']>
	fixedRate?: Maybe<Scalars['Decimal']['output']>
	id: Scalars['String']['output']
	variableRate?: Maybe<Scalars['Decimal']['output']>
}

/** Represents a normalized product from a practice PIMS system. */
export type NormalizedProduct = {
	__typename?: 'NormalizedProduct'
	/** Consolidated practice identifier. */
	consolidatedPracticeId: Scalars['String']['output']
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** User or system that created this record. */
	createdBy: Scalars['String']['output']
	/** Unique identifier for the normalized product. */
	id: Scalars['BigInt']['output']
	/** Indicates if the product was checked manually. */
	isCheckedManually: Scalars['Boolean']['output']
	/** Additional metadata in JSON format. */
	metadata: Scalars['JSON']['output']
	/** Normalized/standardized product description. */
	normalizedProductDescription?: Maybe<Scalars['String']['output']>
	/** Original product description from PIMS. */
	pimsProductDescription: Scalars['String']['output']
	/** PIMS product unique identifier. */
	pimsProductUid?: Maybe<Scalars['String']['output']>
	/** Associated product reference details. */
	productReference?: Maybe<ProductReference>
	/** Associated product reference ID. */
	productReferenceId?: Maybe<Scalars['String']['output']>
	/** Associated product variant details. */
	productVariant?: Maybe<ProductVariantReference>
	/** Associated product variant ID. */
	productVariantId?: Maybe<Scalars['String']['output']>
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
	/** UUID for the normalized product. */
	uuid: Scalars['String']['output']
}

export type NormalizedProductListWithCount = {
	__typename?: 'NormalizedProductListWithCount'
	args: BaseListArgs
	items: Array<NormalizedProduct>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type NormalizedProductOrderByInput = {
	consolidatedPracticeId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	normalizedProductDescription?: InputMaybe<SortOrder>
	pimsProductDescription?: InputMaybe<SortOrder>
	pimsProductUid?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type NormalizedProductWhereInput = {
	AND?: InputMaybe<Array<NormalizedProductWhereInput>>
	NOT?: InputMaybe<Array<NormalizedProductWhereInput>>
	OR?: InputMaybe<Array<NormalizedProductWhereInput>>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdBy?: InputMaybe<StringFilter>
	id?: InputMaybe<IntFilter>
	metadata?: InputMaybe<JsonFilter>
	normalizedProductDescription?: InputMaybe<StringNullableFilter>
	pimsProductDescription?: InputMaybe<StringFilter>
	pimsProductUid?: InputMaybe<StringNullableFilter>
	productReferenceId?: InputMaybe<StringNullableFilter>
	productVariantId?: InputMaybe<StringNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	uuid?: InputMaybe<StringFilter>
}

export enum NullsOrder {
	First = 'first',
	Last = 'last'
}

/** Partner entity representing a business partner */
export type Partner = {
	__typename?: 'Partner'
	/** Bank account number */
	accountNumber?: Maybe<Scalars['String']['output']>
	/** API ID for partner authentication */
	apiId?: Maybe<Scalars['String']['output']>
	/** API key for partner authentication */
	apiKey?: Maybe<Scalars['String']['output']>
	/** Associated consolidator ID */
	consolidatorId?: Maybe<Scalars['String']['output']>
	/** Custom fields */
	customFields?: Maybe<Scalars['JSON']['output']>
	/** Custom payout run time */
	customPayoutRunAtTime?: Maybe<Scalars['DateTimeISO']['output']>
	/** Custom payout settings */
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	/** Custom payout target */
	customPayoutTarget?: Maybe<CustomPayoutBatchTarget>
	/** Customization settings */
	customization?: Maybe<Scalars['JSON']['output']>
	/** Feature flags configuration */
	featureFlags?: Maybe<Scalars['JSON']['output']>
	/** Webhook events to forward */
	forwardWebhookEvents?: Maybe<Array<Scalars['String']['output']>>
	/** Webhook URL for forwarding events */
	forwardWebhookUrl?: Maybe<Scalars['String']['output']>
	/** Unique identifier for this partner */
	id: Scalars['String']['output']
	/** Whether custom payout is enabled */
	isCustomPayoutEnabled?: Maybe<Scalars['Boolean']['output']>
	/** Whether this partner is used for payments */
	isPaymentPartner: Scalars['Boolean']['output']
	/** Merchant category code */
	mcc: Scalars['String']['output']
	/** Partner name */
	name: Scalars['String']['output']
	/** Product description */
	productDescription?: Maybe<Scalars['String']['output']>
	/** Bank routing number */
	routingNumber?: Maybe<Scalars['String']['output']>
	/** Tax ID */
	taxId?: Maybe<Scalars['String']['output']>
	/** Timezone */
	timezone?: Maybe<Scalars['String']['output']>
}

export type PartnerList = {
	__typename?: 'PartnerList'
	args: BaseListArgs
	items: Array<Partner>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type PartnerMonthlyStatement = {
	__typename?: 'PartnerMonthlyStatement'
	creditCount: Scalars['Float']['output']
	creditFees?: Maybe<Scalars['Decimal']['output']>
	creditVolume?: Maybe<Scalars['Decimal']['output']>
	currency: Scalars['String']['output']
	debitCount: Scalars['Float']['output']
	debitFees?: Maybe<Scalars['Decimal']['output']>
	debitVolume?: Maybe<Scalars['Decimal']['output']>
	id: Scalars['String']['output']
	locationLines?: Maybe<Array<NetworkMonthlyStatementLocationLine>>
	month: Scalars['DateTimeISO']['output']
	partnerId: Scalars['String']['output']
	paymentLines?: Maybe<Array<NetworkMonthlyStatementPaymentLine>>
	paymentVolume?: Maybe<Scalars['Decimal']['output']>
	surchargeFees?: Maybe<Scalars['Decimal']['output']>
	surchargeFeesSaved?: Maybe<Scalars['Decimal']['output']>
	surchargeVolume?: Maybe<Scalars['Decimal']['output']>
	tipVolume?: Maybe<Scalars['Decimal']['output']>
	totalFees?: Maybe<Scalars['Decimal']['output']>
}

export type PartnerMonthlyStatementOrderByInput = {
	currency?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	month?: InputMaybe<SortOrder>
	partnerId?: InputMaybe<SortOrder>
}

export type PartnerMonthlyStatementWhereInput = {
	AND?: InputMaybe<Array<PartnerMonthlyStatementWhereInput>>
	NOT?: InputMaybe<Array<PartnerMonthlyStatementWhereInput>>
	OR?: InputMaybe<Array<PartnerMonthlyStatementWhereInput>>
	currency?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	month?: InputMaybe<DateTimeFilter>
	partnerId?: InputMaybe<StringFilter>
}

export type PartnerOrderByInput = {
	consolidatorId?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	isPaymentPartner?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
}

export type PartnerWhereInput = {
	AND?: InputMaybe<Array<PartnerWhereInput>>
	NOT?: InputMaybe<Array<PartnerWhereInput>>
	OR?: InputMaybe<Array<PartnerWhereInput>>
	apiId?: InputMaybe<StringNullableFilter>
	consolidatorId?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringNullableFilter>
	isCustomPayoutEnabled?: InputMaybe<BoolNullableFilter>
	isPaymentPartner?: InputMaybe<BoolNullableFilter>
	name?: InputMaybe<StringNullableFilter>
}

/** How to handle invoices while collection is paused */
export enum PauseCollectionBehaviorTypes {
	KeepAsDraft = 'KEEP_AS_DRAFT',
	MarkUncollectible = 'MARK_UNCOLLECTIBLE',
	Void = 'VOID'
}

/** A payment history row, including charges, refunds, checks, and disputes. */
export type PaymentHistory = {
	__typename?: 'PaymentHistory'
	additionalNotes?: Maybe<Scalars['String']['output']>
	/** The total amount paid or refunded in cents */
	amount?: Maybe<Scalars['Int']['output']>
	amountCapturable?: Maybe<Scalars['Int']['output']>
	amountCaptured?: Maybe<Scalars['Int']['output']>
	/** The total amount due to or from the customer without surcharge, refunds negative */
	amountDue?: Maybe<Scalars['Int']['output']>
	/** The total amount due to or from the customer without surcharge, refunds positive */
	amountDueAbs?: Maybe<Scalars['Int']['output']>
	amountReceived?: Maybe<Scalars['Int']['output']>
	amountRefunded?: Maybe<Scalars['Int']['output']>
	amountRefundedSurchargeFee?: Maybe<Scalars['Int']['output']>
	amountRefundedWithoutSurcharge?: Maybe<Scalars['Int']['output']>
	amountWithoutSurcharge?: Maybe<Scalars['Int']['output']>
	applicationFeeAmount?: Maybe<Scalars['Int']['output']>
	applicationId?: Maybe<Scalars['String']['output']>
	/** The base amount before donation in cents */
	baseAmount?: Maybe<Scalars['Int']['output']>
	/** The base application fee amount before donation in cents */
	baseApplicationFeeAmount?: Maybe<Scalars['Int']['output']>
	canceledAt?: Maybe<Scalars['DateTimeISO']['output']>
	cancellationReason?: Maybe<Scalars['String']['output']>
	captureMethod?: Maybe<Scalars['String']['output']>
	cardBrand?: Maybe<Scalars['String']['output']>
	cardType?: Maybe<Scalars['String']['output']>
	cardholderName?: Maybe<Scalars['String']['output']>
	chargeId?: Maybe<Scalars['String']['output']>
	charges?: Maybe<Scalars['JSON']['output']>
	/** Charity EIN */
	charityEin?: Maybe<Scalars['String']['output']>
	/** Charity metadata snapshot from donation time */
	charityMetadata?: Maybe<Scalars['JSON']['output']>
	clinicName?: Maybe<Scalars['String']['output']>
	confirmationMethod?: Maybe<Scalars['String']['output']>
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	createdByEmail?: Maybe<Scalars['String']['output']>
	createdByUser?: Maybe<Scalars['String']['output']>
	currency: Scalars['String']['output']
	customerId?: Maybe<Scalars['String']['output']>
	customerName?: Maybe<Scalars['String']['output']>
	dateAdjustedInPims?: Maybe<Scalars['DateTimeISO']['output']>
	dateToFilter?: Maybe<Scalars['DateTimeISO']['output']>
	description?: Maybe<Scalars['String']['output']>
	disputeId?: Maybe<Scalars['String']['output']>
	disputeStatus?: Maybe<Scalars['String']['output']>
	disputed?: Maybe<Scalars['Boolean']['output']>
	/** The donation amount in cents (0 when no donation) */
	donationAmount: Scalars['Int']['output']
	failureCode?: Maybe<Scalars['String']['output']>
	failureReason?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	invoiceId?: Maybe<Scalars['String']['output']>
	last4?: Maybe<Scalars['String']['output']>
	latestChargeCreatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	lockboxId?: Maybe<Scalars['String']['output']>
	metadata?: Maybe<Scalars['JSON']['output']>
	notes?: Maybe<Scalars['JSON']['output']>
	/** The type of object of this payment: charge, refund, lockbox, or dispute */
	object?: Maybe<Scalars['String']['output']>
	originalChargeAmount?: Maybe<Scalars['Int']['output']>
	originalChargeAmountDue?: Maybe<Scalars['Int']['output']>
	originalChargeDate?: Maybe<Scalars['DateTimeISO']['output']>
	originalChargeSurcharge?: Maybe<Scalars['Boolean']['output']>
	originalChargeSurchargeFee?: Maybe<Scalars['Int']['output']>
	paymentIntentId?: Maybe<Scalars['String']['output']>
	paymentMethodId?: Maybe<Scalars['String']['output']>
	paymentMethodOptions?: Maybe<Scalars['JSON']['output']>
	paymentMethodType?: Maybe<Scalars['String']['output']>
	payoutDate?: Maybe<Scalars['DateTimeISO']['output']>
	payoutDescription?: Maybe<Scalars['String']['output']>
	payoutEstimatedArrivalAt?: Maybe<Scalars['DateTimeISO']['output']>
	/** The payout reference token from the practice payout batch, falling back to the consolidator payout batch when unset */
	payoutReference?: Maybe<Scalars['String']['output']>
	payoutSentAt?: Maybe<Scalars['DateTimeISO']['output']>
	payoutStatus?: Maybe<Scalars['String']['output']>
	pimsClientId?: Maybe<Scalars['String']['output']>
	pimsInvoiceId?: Maybe<Scalars['String']['output']>
	practice: Practice
	practiceId: Scalars['String']['output']
	refundReason?: Maybe<Scalars['String']['output']>
	refundType?: Maybe<Scalars['String']['output']>
	/** The tip amount refunded in cents */
	refundedTipAmount?: Maybe<Scalars['Int']['output']>
	scratchPaymentMethod?: Maybe<Scalars['String']['output']>
	scratchPaymentRequestType?: Maybe<Scalars['String']['output']>
	statementDescriptor?: Maybe<Scalars['String']['output']>
	/** The stripe status of the underlying transaction */
	status: Scalars['String']['output']
	stripePayoutiD?: Maybe<Scalars['String']['output']>
	subscriptionId?: Maybe<Scalars['String']['output']>
	subscriptionScheduleId?: Maybe<Scalars['String']['output']>
	succeededAt?: Maybe<Scalars['DateTimeISO']['output']>
	surcharge?: Maybe<Scalars['Boolean']['output']>
	surchargeFee?: Maybe<Scalars['Int']['output']>
	/** The tip amount in cents */
	tipAmount?: Maybe<Scalars['Int']['output']>
	/** The overall status of the transaction, possibly 'refunded-transactions', 'uncaptured' or 'partially_captured'. */
	transactionStatus: Scalars['String']['output']
	updatedAt: Scalars['DateTimeISO']['output']
}

/** List of PaymentHistory items with a count for pagination */
export type PaymentHistoryListWithCount = {
	__typename?: 'PaymentHistoryListWithCount'
	items: Array<PaymentHistory>
	total: Scalars['Float']['output']
}

/** List of PaymentHistory items with a summaries all at once */
export type PaymentHistoryListWithSummary = {
	__typename?: 'PaymentHistoryListWithSummary'
	items: Array<PaymentHistory>
	summary: PaymentHistorySummary
}

/** A sort order for a field on PaymentHistory */
export type PaymentHistoryOrderByInput = {
	amount?: InputMaybe<SortOrder>
	amountCapturable?: InputMaybe<SortOrder>
	amountDue?: InputMaybe<SortOrder>
	amountDueAbs?: InputMaybe<SortOrder>
	amountReceived?: InputMaybe<SortOrderInput>
	amountRefunded?: InputMaybe<SortOrderInput>
	amountWithoutSurcharge?: InputMaybe<SortOrderInput>
	applicationFeeAmount?: InputMaybe<SortOrder>
	applicationId?: InputMaybe<SortOrderInput>
	canceledAt?: InputMaybe<SortOrderInput>
	cancellationReason?: InputMaybe<SortOrderInput>
	captureMethod?: InputMaybe<SortOrder>
	cardBrand?: InputMaybe<SortOrderInput>
	cardType?: InputMaybe<SortOrderInput>
	cardholderName?: InputMaybe<SortOrderInput>
	charges?: InputMaybe<SortOrderInput>
	confirmationMethod?: InputMaybe<SortOrderInput>
	consolidatorId?: InputMaybe<SortOrderInput>
	createdAt?: InputMaybe<SortOrder>
	createdByEmail?: InputMaybe<SortOrderInput>
	createdByUser?: InputMaybe<SortOrderInput>
	currency?: InputMaybe<SortOrder>
	customerId?: InputMaybe<SortOrderInput>
	customerName?: InputMaybe<SortOrderInput>
	dateToFilter?: InputMaybe<SortOrder>
	description?: InputMaybe<SortOrderInput>
	failureCode?: InputMaybe<SortOrderInput>
	failureReason?: InputMaybe<SortOrderInput>
	id?: InputMaybe<SortOrder>
	invoiceId?: InputMaybe<SortOrderInput>
	last4?: InputMaybe<SortOrderInput>
	metadata?: InputMaybe<SortOrderInput>
	notes?: InputMaybe<SortOrderInput>
	paymentMethodId?: InputMaybe<SortOrderInput>
	paymentMethodOptions?: InputMaybe<SortOrderInput>
	paymentMethodType?: InputMaybe<SortOrderInput>
	pimsClientId?: InputMaybe<SortOrderInput>
	pimsInvoiceId?: InputMaybe<SortOrderInput>
	practice?: InputMaybe<PracticeOrderByInput>
	practiceId?: InputMaybe<SortOrder>
	scratchPaymentMethod?: InputMaybe<SortOrderInput>
	scratchPaymentRequestType?: InputMaybe<SortOrderInput>
	status?: InputMaybe<SortOrder>
	subscriptionId?: InputMaybe<SortOrderInput>
	subscriptionScheduleId?: InputMaybe<SortOrderInput>
	succeededAt?: InputMaybe<SortOrderInput>
	surchargeFee?: InputMaybe<SortOrderInput>
	updatedAt?: InputMaybe<SortOrder>
}

/** Payment History Summary for a set of rows, including count and aggregation of amounts. */
export type PaymentHistorySummary = {
	__typename?: 'PaymentHistorySummary'
	/** Total number of payments */
	count: Scalars['Int']['output']
	/** Total amount of the list in cents */
	totalAmount?: Maybe<Scalars['BigInt']['output']>
	/** Total amount failed for the list in cents */
	totalFailed?: Maybe<Scalars['BigInt']['output']>
	/** Total amount for failed echecks for the list in cents */
	totalFailedECheck?: Maybe<Scalars['BigInt']['output']>
	/** Total amount paid for the list in cents */
	totalPaid?: Maybe<Scalars['BigInt']['output']>
	/** Total amount pending for the list in cents */
	totalPending?: Maybe<Scalars['BigInt']['output']>
	/** Total amount refunded for the list in cents */
	totalRefunded?: Maybe<Scalars['BigInt']['output']>
	/** Total amount for returned echecks for the list in cents */
	totalReturnedECheck?: Maybe<Scalars['BigInt']['output']>
	/** Total tip amount of the list in cents */
	totalTip?: Maybe<Scalars['BigInt']['output']>
	/** Total amount uncaptured for the list in cents */
	totalUncaptured?: Maybe<Scalars['BigInt']['output']>
}

/** A query filter for a list of PaymentHistory rows */
export type PaymentHistoryWhereInput = {
	AND?: InputMaybe<Array<PaymentHistoryWhereInput>>
	NOT?: InputMaybe<Array<PaymentHistoryWhereInput>>
	OR?: InputMaybe<Array<PaymentHistoryWhereInput>>
	amount?: InputMaybe<IntNullableFilter>
	amountCapturable?: InputMaybe<IntFilter>
	amountReceived?: InputMaybe<IntNullableFilter>
	amountRefunded?: InputMaybe<IntNullableFilter>
	amountWithoutSurcharge?: InputMaybe<IntNullableFilter>
	applicationFeeAmount?: InputMaybe<IntFilter>
	applicationId?: InputMaybe<StringNullableFilter>
	canceledAt?: InputMaybe<DateTimeNullableFilter>
	cancellationReason?: InputMaybe<StringNullableFilter>
	captureMethod?: InputMaybe<StringFilter>
	cardBrand?: InputMaybe<StringNullableFilter>
	cardType?: InputMaybe<StringNullableFilter>
	cardholderName?: InputMaybe<StringNullableFilter>
	charges?: InputMaybe<JsonNullableFilter>
	clinicName?: InputMaybe<StringNullableFilter>
	confirmationMethod?: InputMaybe<StringNullableFilter>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	consolidatorId?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode2?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdByEmail?: InputMaybe<StringNullableFilter>
	createdByUser?: InputMaybe<StringNullableFilter>
	currency?: InputMaybe<StringFilter>
	customerId?: InputMaybe<StringNullableFilter>
	customerName?: InputMaybe<StringNullableFilter>
	dateToFilter?: InputMaybe<DateTimeNullableFilter>
	description?: InputMaybe<StringNullableFilter>
	failureCode?: InputMaybe<StringNullableFilter>
	failureReason?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	invoiceId?: InputMaybe<StringNullableFilter>
	last4?: InputMaybe<StringNullableFilter>
	metadata?: InputMaybe<JsonNullableFilter>
	notes?: InputMaybe<JsonNullableFilter>
	object?: InputMaybe<StringFilter>
	paymentMethodId?: InputMaybe<StringNullableFilter>
	paymentMethodOptions?: InputMaybe<JsonNullableFilter>
	paymentMethodType?: InputMaybe<StringNullableFilter>
	payoutDescription?: InputMaybe<StringNullableFilter>
	payoutEstimatedArrivalAt?: InputMaybe<DateTimeNullableFilter>
	pimsClientId?: InputMaybe<StringNullableFilter>
	pimsInvoiceId?: InputMaybe<StringNullableFilter>
	practice?: InputMaybe<PracticeRelationFilter>
	practiceId?: InputMaybe<StringFilter>
	scratchPaymentMethod?: InputMaybe<StringNullableFilter>
	scratchPaymentRequestType?: InputMaybe<StringNullableFilter>
	statementDescriptor?: InputMaybe<StringNullableFilter>
	status?: InputMaybe<StringFilter>
	subscriptionId?: InputMaybe<StringNullableFilter>
	subscriptionScheduleId?: InputMaybe<StringNullableFilter>
	succeededAt?: InputMaybe<DateTimeNullableFilter>
	transactionStatus?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Payment Intent item */
export type PaymentIntent = {
	__typename?: 'PaymentIntent'
	amount: Scalars['Float']['output']
	amountCapturable: Scalars['Float']['output']
	amountReceived?: Maybe<Scalars['Float']['output']>
	amountRefunded?: Maybe<Scalars['Float']['output']>
	amountWithoutSurcharge?: Maybe<Scalars['Float']['output']>
	id: Scalars['ID']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
}

/** A payment request row */
export type PaymentRequest = {
	__typename?: 'PaymentRequest'
	amount: Scalars['Int']['output']
	amountWithoutSurcharge?: Maybe<Scalars['Int']['output']>
	canceledAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	customerId?: Maybe<Scalars['String']['output']>
	customerName?: Maybe<Scalars['String']['output']>
	description?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
	paidSeparately?: Maybe<Scalars['Boolean']['output']>
	pimsClientId?: Maybe<Scalars['String']['output']>
	practice: PaymentRequestPractice
	practiceId: Scalars['String']['output']
	scratchPaymentMethod?: Maybe<Scalars['String']['output']>
	status: Scalars['String']['output']
	succeededAt?: Maybe<Scalars['DateTimeISO']['output']>
	surchargeFee?: Maybe<Scalars['Int']['output']>
	updatedAt: Scalars['DateTimeISO']['output']
}

/** A payment request file record */
export type PaymentRequestFile = {
	__typename?: 'PaymentRequestFile'
	completedAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	createdBy: Scalars['String']['output']
	createdByUser: User
	failedRecordsCount: Scalars['Float']['output']
	failureReason?: Maybe<Scalars['String']['output']>
	fileName: Scalars['String']['output']
	id: Scalars['String']['output']
	recordsCount: Scalars['Float']['output']
	startedAt?: Maybe<Scalars['DateTimeISO']['output']>
	status: Scalars['String']['output']
	succeededRecordsCount: Scalars['Float']['output']
	updatedAt: Scalars['DateTimeISO']['output']
}

/** List of PaymentRequestFile items with total count */
export type PaymentRequestFileList = {
	__typename?: 'PaymentRequestFileList'
	items: Array<PaymentRequestFile>
	total: Scalars['Float']['output']
}

/** A sort order for a field on PaymentRequestFile */
export type PaymentRequestFileOrderByInput = {
	consolidatorId?: InputMaybe<SortOrderInput>
	createdAt?: InputMaybe<SortOrder>
	createdBy?: InputMaybe<SortOrderInput>
	createdByUser?: InputMaybe<UserOrderByInput>
	id?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** A query filter for a list of PaymentRequestFile rows */
export type PaymentRequestFileWhereInput = {
	AND?: InputMaybe<Array<PaymentRequestFileWhereInput>>
	NOT?: InputMaybe<Array<PaymentRequestFileWhereInput>>
	OR?: InputMaybe<Array<PaymentRequestFileWhereInput>>
	consolidatorId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdBy?: InputMaybe<StringNullableFilter>
	createdByUser?: InputMaybe<UserWhereInput>
	id?: InputMaybe<StringFilter>
	status?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** List of PaymentRequest items with a amount all at once */
export type PaymentRequestListWithSummary = {
	__typename?: 'PaymentRequestListWithSummary'
	amountWithoutSurcharge?: Maybe<Scalars['BigInt']['output']>
	items: Array<PaymentRequest>
	total: Scalars['Float']['output']
}

/** A sort order for a field on PaymentRequest */
export type PaymentRequestOrderByInput = {
	amount?: InputMaybe<SortOrder>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	consolidatorId?: InputMaybe<SortOrderInput>
	createdAt?: InputMaybe<SortOrder>
	customerId?: InputMaybe<SortOrder>
	customerName?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	metadata?: InputMaybe<SortOrderInput>
	pimsClientId?: InputMaybe<SortOrder>
	practice?: InputMaybe<PracticeOrderByInput>
	practiceId?: InputMaybe<SortOrder>
	scratchPaymentMethod?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	succeededAt?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** PaymentRequest practice */
export type PaymentRequestPractice = {
	__typename?: 'PaymentRequestPractice'
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	netsuiteId?: Maybe<Scalars['String']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
}

/** A query filter for a list of PaymentRequest rows */
export type PaymentRequestWhereInput = {
	AND?: InputMaybe<Array<PaymentRequestWhereInput>>
	NOT?: InputMaybe<Array<PaymentRequestWhereInput>>
	OR?: InputMaybe<Array<PaymentRequestWhereInput>>
	amount?: InputMaybe<IntFilter>
	canceledAt?: InputMaybe<DateTimeNullableFilter>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeRelationFilter>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	consolidatorId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	customerId?: InputMaybe<StringNullableFilter>
	customerName?: InputMaybe<StringNullableFilter>
	description?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	metadata?: InputMaybe<JsonNullableFilter>
	paidSeparately?: InputMaybe<Scalars['Boolean']['input']>
	pimsClientId?: InputMaybe<StringNullableFilter>
	practice?: InputMaybe<PracticeRelationFilter>
	practiceId?: InputMaybe<StringFilter>
	scratchPaymentMethod?: InputMaybe<StringNullableFilter>
	status?: InputMaybe<StringFilter>
	succeededAt?: InputMaybe<DateTimeNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Payout item */
export type Payout = {
	__typename?: 'Payout'
	batchCriteria?: Maybe<Scalars['JSON']['output']>
	batchType: CustomPayoutBatchTypes
	completedAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidator?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	currency: Currency
	custom: Scalars['Boolean']['output']
	customPayoutConsolidatorBatchId?: Maybe<Scalars['String']['output']>
	customPayoutCronjobLogId: Scalars['Int']['output']
	description?: Maybe<Scalars['String']['output']>
	disputeAmount?: Maybe<Scalars['Float']['output']>
	disputeCount?: Maybe<Scalars['Int']['output']>
	disputeFee?: Maybe<Scalars['Float']['output']>
	donationAmount?: Maybe<Scalars['Float']['output']>
	failureReason?: Maybe<Scalars['String']['output']>
	id: Scalars['ID']['output']
	notes?: Maybe<Scalars['String']['output']>
	paymentAmount?: Maybe<Scalars['Float']['output']>
	paymentApplicationFee?: Maybe<Scalars['Float']['output']>
	paymentCount?: Maybe<Scalars['Int']['output']>
	payoutAmount?: Maybe<Scalars['Float']['output']>
	payoutDate?: Maybe<Scalars['DateTimeISO']['output']>
	payoutEstimatedArrivalAt?: Maybe<Scalars['DateTimeISO']['output']>
	payoutReference?: Maybe<Scalars['String']['output']>
	payoutSentAt?: Maybe<Scalars['DateTimeISO']['output']>
	practice: CustomPayoutPractice
	refundAmount?: Maybe<Scalars['Float']['output']>
	refundApplicationFee?: Maybe<Scalars['Float']['output']>
	refundCount?: Maybe<Scalars['Int']['output']>
	refundedTipAmount?: Maybe<Scalars['Float']['output']>
	retryCount: Scalars['Int']['output']
	startWindowDate?: Maybe<Scalars['DateTimeISO']['output']>
	startedAt?: Maybe<Scalars['DateTimeISO']['output']>
	statementDescriptor?: Maybe<Scalars['String']['output']>
	status: CustomPayoutBatchStatus
	stripePayoutId?: Maybe<Scalars['String']['output']>
	stripeTransferId?: Maybe<Scalars['String']['output']>
	surchargeFee: Scalars['Int']['output']
	target: CustomPayoutBatchTarget
	tipAmount?: Maybe<Scalars['Float']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

/** List of Payout items with pagination */
export type PayoutList = {
	__typename?: 'PayoutList'
	args: BaseListArgs
	items: Array<Payout>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A PIMS option */
export type Pims = {
	__typename?: 'Pims'
	/** Timestamp when the PIMS option was created */
	createdAt: Scalars['DateTimeISO']['output']
	/** Current value associated with this PIMS option */
	currentPimsValue: Scalars['String']['output']
	/** Unique identifier for the PIMS option */
	id: Scalars['ID']['output']
	/** Industry category that this PIMS option belongs to */
	industry: PimsIndustry
	/** Indicates if the PIMS option is currently active */
	isActive: Scalars['Boolean']['output']
	/** Visibility flag on the sign-up form for end users */
	isVisibleOnSignUpForm: Scalars['Boolean']['output']
	/** Visibility flag for consolidator admin users */
	isVisibleToConsolidatorAdmins: Scalars['Boolean']['output']
	/** Optional MCC (Merchant Category Code) associated with this PIMS option */
	mcc?: Maybe<Scalars['String']['output']>
	/** Display name of the PIMS option */
	name: Scalars['String']['output']
	/** Timestamp when the PIMS option was last updated */
	updatedAt: Scalars['DateTimeISO']['output']
}

/** Industry types for PIMS */
export enum PimsIndustry {
	All = 'ALL',
	Dental = 'DENTAL',
	Veterinary = 'VETERINARY'
}

/** List of PIMS options with count */
export type PimsListWithCount = {
	__typename?: 'PimsListWithCount'
	/** Array of PIMS options */
	items: Array<Pims>
	/** Total number of PIMS matching the query */
	total: Scalars['Float']['output']
}

export type PimsOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	currentPimsValue?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	industry?: InputMaybe<SortOrder>
	isActive?: InputMaybe<SortOrder>
	isVisibleOnSignUpForm?: InputMaybe<SortOrder>
	isVisibleToConsolidatorAdmins?: InputMaybe<SortOrder>
	mcc?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type PimsWhereInput = {
	AND?: InputMaybe<Array<PimsWhereInput>>
	NOT?: InputMaybe<Array<PimsWhereInput>>
	OR?: InputMaybe<Array<PimsWhereInput>>
	currentPimsValue?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	industry?: InputMaybe<PimsIndustry>
	isActive?: InputMaybe<BoolFilter>
	isVisibleOnSignUpForm?: InputMaybe<BoolFilter>
	isVisibleToConsolidatorAdmins?: InputMaybe<BoolFilter>
	mcc?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
}

export type Practice = {
	__typename?: 'Practice'
	accountNumber?: Maybe<Scalars['String']['output']>
	activeTerminalsCount?: Maybe<Scalars['Int']['output']>
	address?: Maybe<Scalars['String']['output']>
	city?: Maybe<Scalars['String']['output']>
	consolidator?: Maybe<Consolidator>
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode3?: Maybe<Scalars['String']['output']>
	country?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	currentPims?: Maybe<Scalars['String']['output']>
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	customPayoutTarget?: Maybe<Scalars['String']['output']>
	deleted: Scalars['Boolean']['output']
	email?: Maybe<Scalars['String']['output']>
	financingStatus?: Maybe<Scalars['String']['output']>
	hospitalManagerEmail?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	industryProgramMetadata?: Maybe<Scalars['JSON']['output']>
	integrationId?: Maybe<Scalars['String']['output']>
	isCustomPayoutEnabled?: Maybe<Scalars['Boolean']['output']>
	isDashboardEnabled?: Maybe<Scalars['Boolean']['output']>
	isLendingEnabled?: Maybe<Scalars['Boolean']['output']>
	isPaymentEnabled?: Maybe<Scalars['Boolean']['output']>
	isRebateEnabled?: Maybe<Scalars['Boolean']['output']>
	isUnderwritten?: Maybe<Scalars['Boolean']['output']>
	locale?: Maybe<Scalars['String']['output']>
	logoUrl?: Maybe<Scalars['String']['output']>
	name?: Maybe<Scalars['String']['output']>
	netsuiteId?: Maybe<Scalars['String']['output']>
	originationFlags?: Maybe<Scalars['JSON']['output']>
	products?: Maybe<Scalars['JSON']['output']>
	regionalManagerId?: Maybe<Scalars['String']['output']>
	routingNumber?: Maybe<Scalars['String']['output']>
	settings?: Maybe<Scalars['JSON']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
	socialUrl?: Maybe<Scalars['JSON']['output']>
	state?: Maybe<Scalars['String']['output']>
	stripeAccountId?: Maybe<Scalars['String']['output']>
	surchargeEnabled?: Maybe<Scalars['Boolean']['output']>
	surchargeFeePct?: Maybe<Scalars['Float']['output']>
	terminalLocation?: Maybe<Scalars['String']['output']>
	timezone?: Maybe<Scalars['String']['output']>
	totalTerminalsCount?: Maybe<Scalars['Int']['output']>
	underwrittingStatus?: Maybe<Scalars['String']['output']>
	uniqueId?: Maybe<Scalars['String']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	users?: Maybe<Array<PracticeUser>>
	vetClinicId?: Maybe<Scalars['Int']['output']>
	website?: Maybe<Scalars['String']['output']>
	zip?: Maybe<Scalars['String']['output']>
}

export type PracticeCustomPayoutInfo = {
	__typename?: 'PracticeCustomPayoutInfo'
	consolidatorId?: Maybe<Scalars['String']['output']>
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	customPayoutTarget?: Maybe<CustomPayoutBatchTarget>
	id: Scalars['ID']['output']
	isCustomPayoutEnabled?: Maybe<Scalars['Boolean']['output']>
	name?: Maybe<Scalars['String']['output']>
	stripeAccountId?: Maybe<Scalars['String']['output']>
}

/** PracticeFeeLog item */
export type PracticeFeeLog = {
	__typename?: 'PracticeFeeLog'
	changeLog: Scalars['JSON']['output']
	createdAt: Scalars['DateTimeISO']['output']
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	id: Scalars['String']['output']
	isNetSettlement?: Maybe<Scalars['Boolean']['output']>
	practiceId: Scalars['String']['output']
	rateScheme?: Maybe<Scalars['String']['output']>
	source?: Maybe<Scalars['String']['output']>
	surchargeEnabled?: Maybe<Scalars['Boolean']['output']>
	surchargeFeePct?: Maybe<Scalars['Float']['output']>
	surchargeStartDate?: Maybe<Scalars['DateTimeISO']['output']>
	transactionFees?: Maybe<Scalars['JSON']['output']>
	updatedAt: Scalars['DateTimeISO']['output']
	updatedBy?: Maybe<Scalars['String']['output']>
}

export type PracticeFeeLogOrderByInput = {
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	isNetSettlement?: InputMaybe<SortOrder>
	practiceId?: InputMaybe<SortOrder>
	rateScheme?: InputMaybe<SortOrder>
	source?: InputMaybe<SortOrder>
	surchargeEnabled?: InputMaybe<SortOrder>
	surchargeFeePct?: InputMaybe<SortOrder>
	surchargeStartDate?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
	updatedBy?: InputMaybe<SortOrder>
}

export type PracticeFeeLogWhereInput = {
	AND?: InputMaybe<Array<PracticeFeeLogWhereInput>>
	NOT?: InputMaybe<Array<PracticeFeeLogWhereInput>>
	OR?: InputMaybe<Array<PracticeFeeLogWhereInput>>
	changeLog?: InputMaybe<JsonNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	customPayoutSettings?: InputMaybe<JsonNullableFilter>
	id?: InputMaybe<StringFilter>
	isNetSettlement?: InputMaybe<Scalars['Boolean']['input']>
	practiceId?: InputMaybe<StringFilter>
	rateScheme?: InputMaybe<StringFilter>
	source?: InputMaybe<StringFilter>
	surchargeEnabled?: InputMaybe<Scalars['Boolean']['input']>
	surchargeFeePct?: InputMaybe<StringFilter>
	surchargeStartDate?: InputMaybe<DateTimeFilter>
	transactionFees?: InputMaybe<JsonNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	updatedBy?: InputMaybe<StringFilter>
}

/** List of Practice Fee Log records with pagination */
export type PracticeFeeLogWithCount = {
	__typename?: 'PracticeFeeLogWithCount'
	args: BaseListArgs
	items: Array<PracticeFeeLog>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Practice Industry Program */
export type PracticeIndustryProgram = {
	__typename?: 'PracticeIndustryProgram'
	/** Details of the associated consolidated practice */
	consolidatedPractice?: Maybe<ConsolidatedPracticeIndustryProgramSummary>
	/** Timestamp when the program was created */
	createdAt: Scalars['DateTimeISO']['output']
	/** Disabled by user or program ended */
	disabledBy?: Maybe<Scalars['String']['output']>
	/** Details of the user who disabled the program, if applicable */
	disabledByUser?: Maybe<User>
	/** Unique identifier for the user who disabled the program */
	disabledByUserId?: Maybe<Scalars['String']['output']>
	/** Details of the user who enabled the program */
	enabledByUser: User
	/** Unique identifier for the user who enabled the program */
	enabledByUserId: Scalars['String']['output']
	/** Generated QR code details */
	generatedQrCode?: Maybe<QrCode>
	/** Generated splash screen details */
	generatedSplashScreen?: Maybe<SplashScreen>
	/** Timestamp when the splash screen was set */
	generatedSplashScreenSetAt?: Maybe<Scalars['DateTimeISO']['output']>
	/** Unique identifier for the practice industry program */
	id: Scalars['String']['output']
	/** Details of the associated industry program */
	industryProgram: IndustryProgram
	/** Unique identifier for the industry program */
	industryProgramId: Scalars['String']['output']
	/** Snapshot of the industry program details */
	industryProgramSnapshot?: Maybe<IndustryProgram>
	/** Details of the associated practice */
	practice: Practice
	/** Unique identifier for the practice */
	practiceId: Scalars['String']['output']
	/** End date of the program, if applicable */
	programEndAt?: Maybe<Scalars['DateTimeISO']['output']>
	/** Start date of the program */
	programStartAt: Scalars['DateTimeISO']['output']
	/** Current status of the practice industry program */
	status: PracticeIndustryProgramStatus
	/** Timestamp when the program was last updated */
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

/** Enumeration of possible statuses for a practice industry program */
export enum PracticeIndustryProgramStatus {
	Active = 'ACTIVE',
	Inactive = 'INACTIVE'
}

/** List of Practice items with a count for pagination */
export type PracticeListWithCount = {
	__typename?: 'PracticeListWithCount'
	items: Array<Practice>
	total: Scalars['Float']['output']
}

export type PracticeOrderByInput = {
	activeTerminalsCount?: InputMaybe<SortOrder>
	address?: InputMaybe<SortOrder>
	consolidatorId?: InputMaybe<SortOrder>
	consolidatorReferenceCode?: InputMaybe<SortOrder>
	consolidatorReferenceCode2?: InputMaybe<SortOrder>
	consolidatorReferenceCode3?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	createdBy?: InputMaybe<SortOrder>
	customPayoutTarget?: InputMaybe<SortOrder>
	email?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	isCustomPayoutEnabled?: InputMaybe<SortOrder>
	legalBusinessName?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	netsuiteId?: InputMaybe<SortOrder>
	skyworldId?: InputMaybe<SortOrder>
	stripeAccountId?: InputMaybe<SortOrder>
	totalTerminalsCount?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
	vetClinicId?: InputMaybe<SortOrder>
	zip?: InputMaybe<SortOrder>
}

/** Practice Rebate Program relationship */
export type PracticeRebateProgram = {
	__typename?: 'PracticeRebateProgram'
	/** Timestamp when the program was created */
	createdAt: Scalars['DateTime']['output']
	/** Reason for disabling the program */
	disableReason?: Maybe<Scalars['String']['output']>
	/** Timestamp when the program was disabled */
	disabledAt?: Maybe<Scalars['DateTime']['output']>
	/** Unique identifier for the user who disabled the program */
	disabledBy?: Maybe<Scalars['String']['output']>
	/** Timestamp when the program was enabled */
	enabledAt: Scalars['DateTime']['output']
	/** Unique identifier for the user who enabled the program */
	enabledBy: Scalars['String']['output']
	/** Unique identifier for the practice rebate program */
	id: Scalars['String']['output']
	/** Practice-level metadata overrides for this rebate program */
	metadata?: Maybe<Scalars['JSONObject']['output']>
	/** Unique identifier for the practice */
	practiceId: Scalars['String']['output']
	/** Priority of the practice rebate program */
	priority?: Maybe<Scalars['Int']['output']>
	/** Details of the associated rebate program */
	rebateProgram?: Maybe<RebateProgram>
	/** Unique identifier for the rebate program */
	rebateProgramId: Scalars['String']['output']
	/** Snapshot of the rebate program details at time of enrollment */
	rebateProgramSnapshot: Scalars['JSON']['output']
	/** Current status of the practice rebate program */
	status: RebateProgramStatus
	/** Timestamp when the program was last updated */
	updatedAt: Scalars['DateTime']['output']
}

/** Paginated response for practice rebate search */
export type PracticeRebateSearchResponse = {
	__typename?: 'PracticeRebateSearchResponse'
	args: BaseListArgs
	/** List of matching practices */
	practices: Array<PracticeRebateSearchResult>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A practice with its rebate terminal enabled status */
export type PracticeRebateSearchResult = {
	__typename?: 'PracticeRebateSearchResult'
	acceptsCareCredit?: Maybe<Scalars['Boolean']['output']>
	activeTerminalsCount?: Maybe<Scalars['Int']['output']>
	additionalIncludedTerminals?: Maybe<Scalars['Int']['output']>
	address?: Maybe<Scalars['String']['output']>
	address2?: Maybe<Scalars['String']['output']>
	agreementSignedAt?: Maybe<Scalars['DateTimeISO']['output']>
	city?: Maybe<Scalars['String']['output']>
	consolidator?: Maybe<Consolidator>
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorOther?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode3?: Maybe<Scalars['String']['output']>
	country?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	createdBy?: Maybe<Scalars['String']['output']>
	currency?: Maybe<Scalars['String']['output']>
	customPayoutRunAtTime?: Maybe<Scalars['DateTimeISO']['output']>
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	customPayoutStartedAt?: Maybe<Scalars['DateTimeISO']['output']>
	customPayoutTarget?: Maybe<Scalars['String']['output']>
	dashboardActivatedOn?: Maybe<Scalars['DateTimeISO']['output']>
	deletedAt?: Maybe<Scalars['DateTimeISO']['output']>
	email?: Maybe<Scalars['String']['output']>
	finalizeLoanAttemptOn?: Maybe<Scalars['DateTimeISO']['output']>
	financingStatus?: Maybe<Scalars['String']['output']>
	fingerprint?: Maybe<Scalars['String']['output']>
	firstApplicationDate?: Maybe<Scalars['DateTimeISO']['output']>
	firstFinalizedTestTransaction?: Maybe<Scalars['DateTimeISO']['output']>
	firstLoanDate?: Maybe<Scalars['DateTimeISO']['output']>
	firstPaymentDate?: Maybe<Scalars['DateTimeISO']['output']>
	goLiveDate?: Maybe<Scalars['DateTimeISO']['output']>
	googlePlaceId?: Maybe<Scalars['String']['output']>
	hospitalManagerEmail?: Maybe<Scalars['String']['output']>
	howDidYouHearAboutUs?: Maybe<Scalars['String']['output']>
	hubspotCompanyId?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	industry?: Maybe<Scalars['String']['output']>
	industryProgramMetadata?: Maybe<Scalars['JSON']['output']>
	installmentAlertEmails?: Maybe<Array<Scalars['String']['output']>>
	integrationId?: Maybe<Scalars['String']['output']>
	isActive?: Maybe<Scalars['Boolean']['output']>
	isCustomPayoutEnabled?: Maybe<Scalars['Boolean']['output']>
	isDeleted?: Maybe<Scalars['Boolean']['output']>
	isEr?: Maybe<Scalars['Boolean']['output']>
	isLendingEnabled?: Maybe<Scalars['Boolean']['output']>
	isNetSettlement?: Maybe<Scalars['Boolean']['output']>
	isNetSettlementLending?: Maybe<Scalars['Boolean']['output']>
	isPaymentEnabled?: Maybe<Scalars['Boolean']['output']>
	isRebateEnabled?: Maybe<Scalars['Boolean']['output']>
	isUnderwritten?: Maybe<Scalars['Boolean']['output']>
	lat?: Maybe<Scalars['Float']['output']>
	legalBusinessName?: Maybe<Scalars['String']['output']>
	lendingFlags?: Maybe<Scalars['JSON']['output']>
	lendingId?: Maybe<Scalars['Int']['output']>
	lng?: Maybe<Scalars['Float']['output']>
	locale?: Maybe<Scalars['String']['output']>
	logoUrl?: Maybe<Scalars['String']['output']>
	memberUTM?: Maybe<Scalars['String']['output']>
	merchantCategoryId?: Maybe<Scalars['Int']['output']>
	name?: Maybe<Scalars['String']['output']>
	netsuiteId?: Maybe<Scalars['String']['output']>
	numJCLoans?: Maybe<Scalars['Int']['output']>
	numPetParentsLoans?: Maybe<Scalars['Int']['output']>
	numberOfExamRooms?: Maybe<Scalars['Int']['output']>
	partnerIds?: Maybe<Array<Scalars['String']['output']>>
	payerEmail?: Maybe<Scalars['String']['output']>
	paymentId?: Maybe<Scalars['String']['output']>
	paymentLogo?: Maybe<Scalars['String']['output']>
	paymentMethodTriggers?: Maybe<Array<Scalars['String']['output']>>
	phone?: Maybe<Scalars['String']['output']>
	pimsData?: Maybe<Scalars['JSON']['output']>
	pimsDataCursors?: Maybe<Scalars['JSON']['output']>
	pimsMetadata?: Maybe<Scalars['JSON']['output']>
	rateScheme?: Maybe<Scalars['String']['output']>
	referralId?: Maybe<Scalars['String']['output']>
	referralRockAccepted?: Maybe<Scalars['Boolean']['output']>
	referrer?: Maybe<Scalars['String']['output']>
	regionalManagerId?: Maybe<Scalars['String']['output']>
	settings?: Maybe<Scalars['JSON']['output']>
	settlementDays?: Maybe<Scalars['Int']['output']>
	signerEmail?: Maybe<Scalars['String']['output']>
	signerName?: Maybe<Scalars['String']['output']>
	signerPhone?: Maybe<Scalars['String']['output']>
	signerRole?: Maybe<Scalars['String']['output']>
	signupAttribution?: Maybe<Scalars['JSON']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
	socialUrl?: Maybe<Scalars['JSON']['output']>
	source?: Maybe<Scalars['String']['output']>
	state?: Maybe<Scalars['String']['output']>
	status?: Maybe<Scalars['JSON']['output']>
	stripeAccountStatus?: Maybe<Scalars['JSON']['output']>
	stripeFutureRequirements?: Maybe<Scalars['JSON']['output']>
	surchargeEnabled?: Maybe<Scalars['Boolean']['output']>
	surchargeFeePct?: Maybe<Scalars['Float']['output']>
	surchargeStartDate?: Maybe<Scalars['DateTimeISO']['output']>
	terminalConfigId?: Maybe<Scalars['String']['output']>
	/** Terminal offer enabled status across all programs */
	terminalEnabledStatus: TerminalRebateEnabledStatus
	terminalLocation?: Maybe<Scalars['String']['output']>
	terminalSplashScreen?: Maybe<Scalars['JSON']['output']>
	timezone?: Maybe<Scalars['String']['output']>
	totalTerminalsCount?: Maybe<Scalars['Int']['output']>
	transactionFees?: Maybe<Scalars['JSON']['output']>
	underwritingStatus?: Maybe<Scalars['String']['output']>
	underwrittenAt?: Maybe<Scalars['DateTimeISO']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	validatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	validationType?: Maybe<Scalars['String']['output']>
	website?: Maybe<Scalars['String']['output']>
	writebackBackoffTimers?: Maybe<Scalars['JSON']['output']>
	zip?: Maybe<Scalars['String']['output']>
}

export type PracticeRelationFilter = {
	is?: InputMaybe<PracticeWhereInput>
	isNot?: InputMaybe<PracticeWhereInput>
}

export type PracticeUser = {
	__typename?: 'PracticeUser'
	isHospitalManager: Scalars['Boolean']['output']
	isRegionalManager: Scalars['Boolean']['output']
	isStaff?: Maybe<Scalars['Boolean']['output']>
	practice: Practice
	practiceId: Scalars['String']['output']
	user?: Maybe<User>
	userId: Scalars['String']['output']
}

export type PracticeUserListWhereInput = {
	every?: InputMaybe<PracticeUserWhereInput>
	none?: InputMaybe<PracticeUserWhereInput>
	some?: InputMaybe<PracticeUserWhereInput>
}

export type PracticeUserWhereInput = {
	AND?: InputMaybe<Array<PracticeUserWhereInput>>
	NOT?: InputMaybe<Array<PracticeUserWhereInput>>
	OR?: InputMaybe<Array<PracticeUserWhereInput>>
	fromFinancing?: InputMaybe<Scalars['Boolean']['input']>
	fromPayments?: InputMaybe<Scalars['Boolean']['input']>
	isHospitalManager?: InputMaybe<Scalars['Boolean']['input']>
	isRegionalManager?: InputMaybe<Scalars['Boolean']['input']>
	isStaff?: InputMaybe<Scalars['Boolean']['input']>
	practice?: InputMaybe<PracticeWhereInput>
	practiceId?: InputMaybe<StringNullableFilter>
	userId?: InputMaybe<StringNullableFilter>
}

export type PracticeWhereInput = {
	AND?: InputMaybe<Array<PracticeWhereInput>>
	NOT?: InputMaybe<Array<PracticeWhereInput>>
	OR?: InputMaybe<Array<PracticeWhereInput>>
	city?: InputMaybe<StringNullableFilter>
	consolidator?: InputMaybe<ConsolidatorRelationFilter>
	consolidatorId?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode2?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode3?: InputMaybe<StringNullableFilter>
	country?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdBy?: InputMaybe<StringNullableFilter>
	customPayoutSettings?: InputMaybe<JsonNullableFilter>
	customPayoutTarget?: InputMaybe<StringNullableFilter>
	deleted?: InputMaybe<BoolFilter>
	email?: InputMaybe<StringNullableFilter>
	hospitalManagerEmail?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	isCustomPayoutEnabled?: InputMaybe<BoolFilter>
	name?: InputMaybe<StringNullableFilter>
	netsuiteId?: InputMaybe<StringNullableFilter>
	products?: InputMaybe<JsonNullableFilter>
	regionalManagerId?: InputMaybe<StringNullableFilter>
	settings?: InputMaybe<JsonNullableFilter>
	skyworldId?: InputMaybe<StringNullableFilter>
	stripeAccountId?: InputMaybe<StringNullableFilter>
	surchargeEnabled?: InputMaybe<BoolNullableFilter>
	timezone?: InputMaybe<StringNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	users?: InputMaybe<PracticeUserListWhereInput>
	vetClinicId?: InputMaybe<IntNullableFilter>
	zip?: InputMaybe<StringNullableFilter>
}

/** Represents a standardized product reference. */
export type ProductReference = {
	__typename?: 'ProductReference'
	/** Associated brand entity. */
	brand?: Maybe<BrandReference>
	/** Brand identifier. */
	brandId?: Maybe<Scalars['String']['output']>
	/** Associated category entity. */
	category?: Maybe<CategoryReference>
	/** Category identifier. */
	categoryId?: Maybe<Scalars['String']['output']>
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** Days on therapy. */
	daysOnTherapy?: Maybe<Scalars['Int']['output']>
	/** Unique identifier for the product reference. */
	id: Scalars['String']['output']
	/** Associated manufacturer entity. */
	manufacturer?: Maybe<Manufacturer>
	/** Manufacturer identifier. */
	manufacturerId?: Maybe<Scalars['String']['output']>
	/** Product name. */
	name: Scalars['String']['output']
	/** Normalized products using this reference. */
	normalizedProducts?: Maybe<Array<NormalizedProduct>>
	/** Additional notes. */
	notes?: Maybe<Scalars['String']['output']>
	/** Associated product variants. */
	productVariants?: Maybe<Array<ProductVariantReference>>
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
}

export type ProductReferenceListWithCount = {
	__typename?: 'ProductReferenceListWithCount'
	args: BaseListArgs
	items: Array<ProductReference>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type ProductReferenceOrderByInput = {
	brandId?: InputMaybe<SortOrder>
	categoryId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	daysOnTherapy?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	manufacturerId?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export type ProductReferenceWhereInput = {
	AND?: InputMaybe<Array<ProductReferenceWhereInput>>
	NOT?: InputMaybe<Array<ProductReferenceWhereInput>>
	OR?: InputMaybe<Array<ProductReferenceWhereInput>>
	brandId?: InputMaybe<StringNullableFilter>
	categoryId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	daysOnTherapy?: InputMaybe<IntFilter>
	id?: InputMaybe<StringFilter>
	manufacturerId?: InputMaybe<StringNullableFilter>
	name?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

export type ProductVariantListWithCount = {
	__typename?: 'ProductVariantListWithCount'
	args: BaseListArgs
	items: Array<ProductVariantReference>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type ProductVariantOrderByInput = {
	color?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	doseOrPackSize?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	maxWeight?: InputMaybe<SortOrder>
	minWeight?: InputMaybe<SortOrder>
	productReferenceId?: InputMaybe<SortOrder>
	species?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
	weightUnit?: InputMaybe<SortOrder>
}

/** Represents a variant of a product reference. */
export type ProductVariantReference = {
	__typename?: 'ProductVariantReference'
	/** Variant color. */
	color?: Maybe<Scalars['String']['output']>
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** Dose or pack size. */
	doseOrPackSize?: Maybe<Scalars['String']['output']>
	/** Unique identifier for the product variant. */
	id: Scalars['String']['output']
	/** Maximum weight. */
	maxWeight?: Maybe<Scalars['Float']['output']>
	/** Minimum weight. */
	minWeight?: Maybe<Scalars['Float']['output']>
	/** Normalized products using this variant. */
	normalizedProducts?: Maybe<Array<NormalizedProduct>>
	/** Additional notes. */
	notes?: Maybe<Scalars['String']['output']>
	/** Associated product reference. */
	productReference: ProductReference
	/** Associated product reference ID. */
	productReferenceId: Scalars['String']['output']
	/** Species (e.g., Dog, Cat). */
	species?: Maybe<Scalars['String']['output']>
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
	/** Weight unit. */
	weightUnit?: Maybe<Scalars['String']['output']>
}

export type ProductVariantWhereInput = {
	AND?: InputMaybe<Array<ProductVariantWhereInput>>
	NOT?: InputMaybe<Array<ProductVariantWhereInput>>
	OR?: InputMaybe<Array<ProductVariantWhereInput>>
	color?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	doseOrPackSize?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	maxWeight?: InputMaybe<DecimalFilter>
	minWeight?: InputMaybe<DecimalFilter>
	productReferenceId?: InputMaybe<StringFilter>
	species?: InputMaybe<StringNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	weightUnit?: InputMaybe<StringNullableFilter>
}

/** QrCode */
export type QrCode = {
	__typename?: 'QrCode'
	/** URL for the QR code image */
	imageUrl: Scalars['String']['output']
	/** Unique identifier for the QR code in the provider (e.g., Bitly or QR.io) */
	qrCodeId: Scalars['String']['output']
	/** URL for accessing the QR code */
	qrCodeUrl: Scalars['String']['output']
}

export type Query = {
	__typename?: 'Query'
	activePracticeRebatePrograms: ListActivePracticeRebateProgramResponse
	allPracticesWithCount: ScratchAdminPracticeListWithCount
	allRebatePrograms: ListRebateProgramResponse
	b2bRebatePayoutFiles: B2bRebatePayoutFileListWithCount
	b2bRebatePayoutRecords: B2bRebatePayoutRecordListWithCount
	billingTask: BillingTaskListWithCount
	/** Get a brand reference by ID */
	brandReference?: Maybe<BrandReference>
	/** List brand references with filters */
	brandReferences: Array<BrandReference>
	/** List brand references with total count */
	brandReferencesWithCount: BrandReferenceListWithCount
	bulkPracticeImport?: Maybe<BulkPracticeImport>
	bulkPracticeImports: BulkPracticeImportListWithCount
	/** One business verification submission with its full decrypted EIN, for the reviewer detail view. Access is audit-logged. */
	businessVerificationSubmission: BusinessVerificationSubmissionDetail
	/** Business verification submissions awaiting or past admin review. */
	businessVerificationSubmissions: BusinessVerificationSubmissionListWithCount
	/** Get a category reference by ID */
	categoryReference?: Maybe<CategoryReference>
	/** List category references with filters */
	categoryReferences: Array<CategoryReference>
	/** List category references with total count */
	categoryReferencesWithCount: CategoryReferenceListWithCount
	cardRequests: Array<CardRequest>
	cardRequestsWithCount: CardRequestListWithCount
	consolidatedPractices: ConsolidatedPracticeListWithCount
	consolidatorFeatureFlag: Scalars['Boolean']['output']
	consolidatorMonthlyStatements: Array<ConsolidatorMonthlyStatement>
	consolidators: Array<Consolidator>
	dailyTotals: DailyTotalsResponse
	donationCharities: Array<DonationCharityAdmin>
	donationCharitiesWithCount: DonationCharityListWithCount
	enterpriseInvoiceDetectedRebate: EnterpriseInvoiceDetectedRebateListWithCount
	enterpriseRebateInvoices: EnterpriseRebateInvoiceListWithCount
	enterpriseRebatePayoutBatchFilterOptions: EnterpriseRebatePayoutBatchFilterOptions
	enterpriseRebatePayoutBatches: EnterpriseRebatePayoutBatchListWithCount
	industryPrograms: ListIndustryProgramResponse
	invoiceDetectedRebate: InvoiceDetectedRebateListWithCount
	listActionNeeded: ActionNeededList
	/** List cash counts filtered by practice and date */
	listCashDeposits: Array<CashDeposit>
	/** List cash counts with total count */
	listCashDepositsWithCount: CashDepositListWithCount
	/** List cash counts filtered by practice and date */
	listCashDrawers: Array<CashDrawer>
	/** List cash counts with total count */
	listCashDrawersWithCount: CashDrawerListWithCount
	listCustomPayoutDetails: CustomPayoutDetailList
	listCustomPayoutPracticeBatch: CustomPayoutPracticeBatchList
	/** List partners with optional filters */
	listPartners: PartnerList
	listPayouts: PayoutList
	/** List of active PIMS records filtered by MCC and industry */
	listPims: PimsListWithCount
	listRefundRequests: RefundRequestList
	/** List individual tipped transactions for the current practice, with total count */
	listTerminalTips: TerminalTipListWithCount
	/** List active tip recipients for the current practice */
	listTipRecipients: Array<TipRecipient>
	listUsers: UserList
	listUsersWithCount: UserListWithCount
	/** Get a manufacturer by ID */
	manufacturer?: Maybe<Manufacturer>
	/** List manufacturers with filters */
	manufacturers: Array<Manufacturer>
	/** List manufacturers with total count */
	manufacturersWithCount: ManufacturerListWithCount
	monthlyBillingRecords: MonthlyBillingRecordWithCount
	monthlyStatements: Array<MonthlyStatement>
	/** List normalized products with filters */
	normalizedProducts: Array<NormalizedProduct>
	/** List normalized products with total count */
	normalizedProductsWithCount: NormalizedProductListWithCount
	partnerMonthlyStatements: Array<PartnerMonthlyStatement>
	paymentHistories: Array<PaymentHistory>
	paymentHistoriesWithCount: PaymentHistoryListWithCount
	paymentHistoriesWithSummary: PaymentHistoryListWithSummary
	paymentHistorySummary: PaymentHistorySummary
	paymentRequestFiles: PaymentRequestFileList
	paymentRequests: Array<PaymentRequest>
	paymentRequestsWithSummary: PaymentRequestListWithSummary
	practiceBankAccounts: ConsolidatedPracticeBankAccountListWithCount
	practiceFeeLog: PracticeFeeLogWithCount
	practices: Array<Practice>
	practicesWithCount: PracticeListWithCount
	/** List product references with filters */
	productReferences: Array<ProductReference>
	/** List product references with total count */
	productReferencesWithCount: ProductReferenceListWithCount
	/** List product variants with filters */
	productVariants: Array<ProductVariantReference>
	/** List product variants with total count */
	productVariantsWithCount: ProductVariantListWithCount
	rebateInvoices: RebateInvoiceListWithCount
	rebatePrograms: ListRebateProgramResponse
	refundPayouts: RefundPayoutListWithCount
	refundVisibility: Scalars['Boolean']['output']
	searchPracticesWithRebates: PracticeRebateSearchResponse
	storedPaymentMethods: Array<StoredPaymentMethod>
	stripeDisputeDetails: StripeDisputeDetails
	stripeDisputes: StripeDisputeWithCount
	subscriptionSchedules: Array<SubscriptionSchedule>
	subscriptionSchedulesWithCount: SubscriptionScheduleListWithCount
	sumCustomPayoutDetailsByCardBrand: CustomPayoutDetailsSumByCardBrandList
	/** Tip totals per recipient for the current practice over the selected range */
	terminalTipSummary: Array<TerminalTipSummary>
}

export type QueryActivePracticeRebateProgramsArgs = {
	orderBy?: InputMaybe<Array<ListActivePracticeRebateProgramOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ListActivePracticeRebateProgramWhereInput>
}

export type QueryAllPracticesWithCountArgs = {
	orderBy?: InputMaybe<Array<ScratchAdminPracticeOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ScratchAdminPracticeWhereInput>
}

export type QueryAllRebateProgramsArgs = {
	orderBy?: InputMaybe<Array<RebateProgramOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<RebateProgramWhereInput>
}

export type QueryB2bRebatePayoutFilesArgs = {
	orderBy?: InputMaybe<Array<B2bRebatePayoutFileOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<B2bRebatePayoutFileWhereInput>
}

export type QueryB2bRebatePayoutRecordsArgs = {
	orderBy?: InputMaybe<Array<B2bRebatePayoutRecordOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<B2bRebatePayoutRecordWhereInput>
}

export type QueryBillingTaskArgs = {
	orderBy?: InputMaybe<Array<BillingTaskOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<BillingTaskWhereInput>
}

export type QueryBrandReferenceArgs = {
	id: Scalars['String']['input']
}

export type QueryBrandReferencesArgs = {
	orderBy?: InputMaybe<Array<BrandReferenceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<BrandReferenceWhereInput>
}

export type QueryBrandReferencesWithCountArgs = {
	orderBy?: InputMaybe<Array<BrandReferenceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<BrandReferenceWhereInput>
}

export type QueryBulkPracticeImportArgs = {
	id: Scalars['String']['input']
}

export type QueryBulkPracticeImportsArgs = {
	orderBy?: InputMaybe<Array<BulkPracticeImportOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<BulkPracticeImportWhereInput>
}

export type QueryBusinessVerificationSubmissionArgs = {
	id: Scalars['String']['input']
}

export type QueryBusinessVerificationSubmissionsArgs = {
	consolidatedPracticeId?: InputMaybe<Scalars['String']['input']>
	skip?: Scalars['Int']['input']
	sortDirection?: InputMaybe<SortOrder>
	statuses?: InputMaybe<Array<BusinessVerificationStatus>>
	submittedFrom?: InputMaybe<Scalars['DateTime']['input']>
	submittedTo?: InputMaybe<Scalars['DateTime']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCardRequestsArgs = {
	orderBy?: InputMaybe<Array<CardRequestOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CardRequestWhereInput>
}

export type QueryCardRequestsWithCountArgs = {
	orderBy?: InputMaybe<Array<CardRequestOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CardRequestWhereInput>
}

export type QueryCategoryReferenceArgs = {
	id: Scalars['String']['input']
}

export type QueryCategoryReferencesArgs = {
	orderBy?: InputMaybe<Array<CategoryReferenceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CategoryReferenceWhereInput>
}

export type QueryCategoryReferencesWithCountArgs = {
	orderBy?: InputMaybe<Array<CategoryReferenceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CategoryReferenceWhereInput>
}

export type QueryConsolidatedPracticesArgs = {
	orderBy?: InputMaybe<Array<ConsolidatedPracticeOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
}

export type QueryConsolidatorFeatureFlagArgs = {
	name: Scalars['String']['input']
}

export type QueryConsolidatorMonthlyStatementsArgs = {
	orderBy?: InputMaybe<Array<ConsolidatorMonthlyStatementOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ConsolidatorMonthlyStatementWhereInput>
}

export type QueryConsolidatorsArgs = {
	orderBy?: InputMaybe<Array<ConsolidatorOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ConsolidatorWhereInput>
}

export type QueryDailyTotalsArgs = {
	includePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>
	where?: InputMaybe<DailyTotalsWhereInput>
}

export type QueryDonationCharitiesWithCountArgs = {
	orderBy?: InputMaybe<Array<DonationCharityOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<DonationCharityWhereInput>
}

export type QueryEnterpriseInvoiceDetectedRebateArgs = {
	orderBy?: InputMaybe<Array<EnterpriseInvoiceDetectedRebateOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<EnterpriseInvoiceDetectedRebateWhereInput>
}

export type QueryEnterpriseRebateInvoicesArgs = {
	orderBy?: InputMaybe<Array<EnterpriseRebateInvoiceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<EnterpriseRebateInvoiceWhereInput>
}

export type QueryEnterpriseRebatePayoutBatchesArgs = {
	orderBy?: InputMaybe<Array<EnterpriseRebatePayoutBatchOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<EnterpriseRebatePayoutBatchWhereInput>
}

export type QueryIndustryProgramsArgs = {
	orderBy?: InputMaybe<Array<IndustryProgramOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<IndustryProgramWhereInput>
}

export type QueryInvoiceDetectedRebateArgs = {
	orderBy?: InputMaybe<Array<InvoiceDetectedRebateOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<InvoiceDetectedRebateWhereInput>
}

export type QueryListActionNeededArgs = {
	orderBy?: InputMaybe<Array<ActionNeededOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ActionNeededWhereInput>
}

export type QueryListCashDepositsArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<CashDepositOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CashDepositWhereInput>
}

export type QueryListCashDepositsWithCountArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<CashDepositOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CashDepositWhereInput>
}

export type QueryListCashDrawersArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<CashDrawerOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CashDrawerWhereInput>
}

export type QueryListCashDrawersWithCountArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<CashDrawerOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CashDrawerWhereInput>
}

export type QueryListCustomPayoutDetailsArgs = {
	orderBy?: InputMaybe<Array<CustomPayoutDetailsOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CustomPayoutDetailsWhereInput>
}

export type QueryListCustomPayoutPracticeBatchArgs = {
	orderBy?: InputMaybe<Array<CustomPayoutPracticeBatchOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CustomPayoutPracticeBatchWhereInput>
}

export type QueryListPartnersArgs = {
	orderBy?: InputMaybe<Array<PartnerOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PartnerWhereInput>
}

export type QueryListPayoutsArgs = {
	orderBy?: InputMaybe<Array<CustomPayoutPracticeBatchOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CustomPayoutPracticeBatchWhereInput>
}

export type QueryListPimsArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<PimsOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PimsWhereInput>
}

export type QueryListRefundRequestsArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<RefundRequestOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<RefundRequestWhereInput>
}

export type QueryListTerminalTipsArgs = {
	consolidatedPracticeId?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	recipientId?: InputMaybe<Scalars['String']['input']>
	skip?: Scalars['Int']['input']
	startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}

export type QueryListTipRecipientsArgs = {
	orderBy?: InputMaybe<Array<TipRecipientOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<TipRecipientWhereInput>
}

export type QueryListUsersArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<UserOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<UserWhereInput>
}

export type QueryListUsersWithCountArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<UserOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<UserWhereInput>
}

export type QueryManufacturerArgs = {
	id: Scalars['String']['input']
}

export type QueryManufacturersArgs = {
	orderBy?: InputMaybe<Array<ManufacturerOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ManufacturerWhereInput>
}

export type QueryManufacturersWithCountArgs = {
	orderBy?: InputMaybe<Array<ManufacturerOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ManufacturerWhereInput>
}

export type QueryMonthlyBillingRecordsArgs = {
	orderBy?: InputMaybe<Array<MonthlyBillingRecordOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<MonthlyBillingRecordWhereInput>
}

export type QueryMonthlyStatementsArgs = {
	orderBy?: InputMaybe<Array<MonthlyStatementOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<MonthlyStatementWhereInput>
}

export type QueryNormalizedProductsArgs = {
	orderBy?: InputMaybe<Array<NormalizedProductOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<NormalizedProductWhereInput>
}

export type QueryNormalizedProductsWithCountArgs = {
	orderBy?: InputMaybe<Array<NormalizedProductOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<NormalizedProductWhereInput>
}

export type QueryPartnerMonthlyStatementsArgs = {
	orderBy?: InputMaybe<Array<PartnerMonthlyStatementOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PartnerMonthlyStatementWhereInput>
}

export type QueryPaymentHistoriesArgs = {
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PaymentHistoryWhereInput>
}

export type QueryPaymentHistoriesWithCountArgs = {
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PaymentHistoryWhereInput>
}

export type QueryPaymentHistoriesWithSummaryArgs = {
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PaymentHistoryWhereInput>
}

export type QueryPaymentHistorySummaryArgs = {
	where: PaymentHistoryWhereInput
}

export type QueryPaymentRequestFilesArgs = {
	orderBy?: InputMaybe<Array<PaymentRequestFileOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PaymentRequestFileWhereInput>
}

export type QueryPaymentRequestsArgs = {
	orderBy?: InputMaybe<Array<PaymentRequestOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PaymentRequestWhereInput>
}

export type QueryPaymentRequestsWithSummaryArgs = {
	orderBy?: InputMaybe<Array<PaymentRequestOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PaymentRequestWhereInput>
}

export type QueryPracticeBankAccountsArgs = {
	consolidatedPracticeId: Scalars['String']['input']
	orderBy?: InputMaybe<ConsolidatedPracticeBankAccountOrderByInput>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ConsolidatedPracticeBankAccountWhereInput>
}

export type QueryPracticeFeeLogArgs = {
	orderBy?: InputMaybe<Array<PracticeFeeLogOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PracticeFeeLogWhereInput>
}

export type QueryPracticesArgs = {
	orderBy?: InputMaybe<Array<PracticeOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PracticeWhereInput>
}

export type QueryPracticesWithCountArgs = {
	orderBy?: InputMaybe<Array<PracticeOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<PracticeWhereInput>
}

export type QueryProductReferencesArgs = {
	orderBy?: InputMaybe<Array<ProductReferenceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ProductReferenceWhereInput>
}

export type QueryProductReferencesWithCountArgs = {
	orderBy?: InputMaybe<Array<ProductReferenceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ProductReferenceWhereInput>
}

export type QueryProductVariantsArgs = {
	orderBy?: InputMaybe<Array<ProductVariantOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ProductVariantWhereInput>
}

export type QueryProductVariantsWithCountArgs = {
	orderBy?: InputMaybe<Array<ProductVariantOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ProductVariantWhereInput>
}

export type QueryRebateInvoicesArgs = {
	orderBy?: InputMaybe<Array<RebateInvoiceOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<RebateInvoiceWhereInput>
}

export type QueryRebateProgramsArgs = {
	orderBy?: InputMaybe<Array<RebateProgramOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<RebateProgramWhereInput>
}

export type QueryRefundPayoutsArgs = {
	orderBy?: InputMaybe<Array<RefundPayoutOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<RefundPayoutWhereInput>
}

export type QueryRefundVisibilityArgs = {
	amountRefundedBefore?: InputMaybe<Scalars['Int']['input']>
	paymentIntentId?: InputMaybe<Scalars['String']['input']>
	refundId?: InputMaybe<Scalars['String']['input']>
}

export type QuerySearchPracticesWithRebatesArgs = {
	orderBy?: InputMaybe<Array<ConsolidatedPracticeOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
}

export type QueryStoredPaymentMethodsArgs = {
	orderBy?: InputMaybe<Array<StoredPaymentMethodOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<StoredPaymentMethodWhereInput>
}

export type QueryStripeDisputeDetailsArgs = {
	id: Scalars['String']['input']
}

export type QueryStripeDisputesArgs = {
	orderBy?: InputMaybe<Array<StripeDisputeOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<StripeDisputeWhereInput>
}

export type QuerySubscriptionSchedulesArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<SubscriptionScheduleOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<SubscriptionScheduleWhereInput>
}

export type QuerySubscriptionSchedulesWithCountArgs = {
	all?: InputMaybe<Scalars['Boolean']['input']>
	orderBy?: InputMaybe<Array<SubscriptionScheduleOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<SubscriptionScheduleWhereInput>
}

export type QuerySumCustomPayoutDetailsByCardBrandArgs = {
	orderBy?: InputMaybe<Array<CustomPayoutDetailsOrderByInput>>
	skip?: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<CustomPayoutDetailsWhereInput>
}

export type QueryTerminalTipSummaryArgs = {
	endDate: Scalars['DateTimeISO']['input']
	startDate: Scalars['DateTimeISO']['input']
}

export enum QueryMode {
	Default = 'default',
	Insensitive = 'insensitive'
}

/** Rebate invoice item */
export type RebateInvoice = {
	__typename?: 'RebateInvoice'
	clientFirstName?: Maybe<Scalars['String']['output']>
	clientLastName?: Maybe<Scalars['String']['output']>
	consolidatedPracticeId: Scalars['String']['output']
	createdAt: Scalars['DateTime']['output']
	id: Scalars['String']['output']
	invoiceDate: Scalars['DateTime']['output']
	invoiceDetectedRebates?: Maybe<Array<InvoiceDetectedRebate>>
	invoiceId: Scalars['String']['output']
	invoiceSnapshot: Scalars['JSON']['output']
	patientName?: Maybe<Scalars['String']['output']>
	status: RebateInvoiceStatus
	updatedAt: Scalars['DateTime']['output']
}

/** Response containing rebate invoices with count */
export type RebateInvoiceListWithCount = {
	__typename?: 'RebateInvoiceListWithCount'
	args: BaseListArgs
	/** List of rebate invoices */
	items: Array<RebateInvoice>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** Sort order for rebate invoices */
export type RebateInvoiceOrderByInput = {
	consolidatedPracticeId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	invoiceDate?: InputMaybe<SortOrder>
	invoiceId?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** The status of a rebate invoice */
export enum RebateInvoiceStatus {
	Completed = 'COMPLETED',
	Failed = 'FAILED',
	Processing = 'PROCESSING'
}

/** Filter conditions for rebate invoices */
export type RebateInvoiceWhereInput = {
	AND?: InputMaybe<Array<RebateInvoiceWhereInput>>
	NOT?: InputMaybe<Array<RebateInvoiceWhereInput>>
	OR?: InputMaybe<Array<RebateInvoiceWhereInput>>
	clientFirstName?: InputMaybe<StringFilter>
	consolidatedPracticeId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	invoiceDate?: InputMaybe<DateTimeFilter>
	invoiceId?: InputMaybe<StringFilter>
	status?: InputMaybe<RebateInvoiceStatus>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Rebate program information */
export type RebateProgram = {
	__typename?: 'RebateProgram'
	/** Bundles associated with this rebate program */
	bundles: Array<RebateProgramBundle>
	/** Timestamp when the rebate program was created */
	createdAt: Scalars['DateTime']['output']
	/** Description of the rebate program */
	description?: Maybe<Scalars['String']['output']>
	/** End date of the rebate program */
	endAt?: Maybe<Scalars['DateTime']['output']>
	/** Unique identifier for the rebate program */
	id: Scalars['String']['output']
	/** Learn more URL for the rebate program */
	learnMoreUrl?: Maybe<Scalars['String']['output']>
	/** URL for the logo */
	logoUrl?: Maybe<Scalars['String']['output']>
	/** Manufacturer of the Rebate Program */
	manufacturer?: Maybe<Manufacturer>
	/** Unique identifier for the manufacturer */
	manufacturerId?: Maybe<Scalars['String']['output']>
	/** Rebate program metadata for extensibility */
	metadata?: Maybe<Scalars['JSONObject']['output']>
	/** Name of the rebate program */
	name: Scalars['String']['output']
	/** Name of the partner organization associated with the rebate program */
	partnerName?: Maybe<Scalars['String']['output']>
	/** Priority of the rebate program */
	priority: Scalars['Int']['output']
	/** Products associated with this rebate program */
	products: Array<RebateProgramProduct>
	/** Start date of the rebate program */
	startAt: Scalars['DateTime']['output']
	/** Status of the rebate program */
	status: RebateProgramStatus
	/** Display title for the rebate program, used in marketing copy */
	title?: Maybe<Scalars['String']['output']>
	/** Timestamp when the rebate program was last updated */
	updatedAt: Scalars['DateTime']['output']
	/** Visibility of the rebate program */
	visibility: RebateProgramVisibility
}

/** Rebate program bundle information */
export type RebateProgramBundle = {
	__typename?: 'RebateProgramBundle'
	/** Bundle code */
	bundleCode?: Maybe<Scalars['String']['output']>
	/** Timestamp when the bundle was created */
	createdAt: Scalars['DateTime']['output']
	/** Description of the bundle */
	description?: Maybe<Scalars['String']['output']>
	/** Unique identifier for the rebate program bundle */
	id: Scalars['String']['output']
	/** Name of the bundle */
	name: Scalars['String']['output']
	/** Products included in this bundle */
	products: Array<RebateProgramProduct>
	/** Rebate amount for this bundle */
	rebateAmount: Scalars['Int']['output']
	/** Rebate code for this bundle */
	rebateCode: Scalars['String']['output']
	/** Rebate program ID this bundle belongs to */
	rebateProgramId: Scalars['String']['output']
	/** Validation rule for this bundle */
	rebateProgramRule?: Maybe<RebateProgramRule>
	/** Rebate program rule ID for validation instructions */
	rebateProgramRuleId?: Maybe<Scalars['String']['output']>
	/** Status of the rebate program bundle */
	status: RebateProgramStatus
	/** Timestamp when the bundle was last updated */
	updatedAt: Scalars['DateTime']['output']
}

/** A sort order for a field on Rebate Program */
export type RebateProgramOrderByInput = {
	endAt?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	priority?: InputMaybe<SortOrder>
	startAt?: InputMaybe<SortOrder>
}

/** Rebate program product information */
export type RebateProgramProduct = {
	__typename?: 'RebateProgramProduct'
	/** Timestamp when the product was created */
	createdAt: Scalars['DateTime']['output']
	/** Description of the product */
	description?: Maybe<Scalars['String']['output']>
	/** Unique identifier for the rebate program product */
	id: Scalars['String']['output']
	/** Name of the product */
	name: Scalars['String']['output']
	/** Product references linked to this rebate program product */
	productReferences?: Maybe<Array<RebateProgramProductReference>>
	/** Rebate amount for this product */
	rebateAmount: Scalars['Int']['output']
	/** Rebate code for this product */
	rebateCode: Scalars['String']['output']
	/** Bundle ID if this product is part of a bundle */
	rebateProgramBundleId?: Maybe<Scalars['String']['output']>
	/** Rebate program ID this product belongs to */
	rebateProgramId: Scalars['String']['output']
	/** Required quantity to qualify for rebate */
	requiredQuantity: Scalars['Int']['output']
	/** SKU of the product */
	sku: Scalars['String']['output']
	/** Status of the rebate program product */
	status: RebateProgramStatus
	/** Unit of the product */
	unit?: Maybe<Scalars['String']['output']>
	/** Timestamp when the product was last updated */
	updatedAt: Scalars['DateTime']['output']
}

/** Junction record linking a rebate program product to a product reference */
export type RebateProgramProductReference = {
	__typename?: 'RebateProgramProductReference'
	/** Timestamp when the record was created */
	createdAt: Scalars['DateTime']['output']
	/** Unique identifier for the rebate program product reference */
	id: Scalars['String']['output']
	/** Metadata about how this product reference was matched */
	matchMetadata: Scalars['JSONObject']['output']
	/** The linked product reference */
	productReference: ProductReference
	/** Product reference ID linked to the rebate program product */
	productReferenceId: Scalars['String']['output']
	/** Rebate program product ID this reference belongs to */
	rebateProgramProductId: Scalars['String']['output']
	/** Timestamp when the record was last updated */
	updatedAt: Scalars['DateTime']['output']
}

/** Rebate program validation rule information */
export type RebateProgramRule = {
	__typename?: 'RebateProgramRule'
	/** Timestamp when the rule was created */
	createdAt: Scalars['DateTime']['output']
	/** Unique identifier for the rebate program rule */
	id: Scalars['String']['output']
	/** Validation instructions in JSON format */
	instructions: Scalars['JSONObject']['output']
	/** Timestamp when the rule was last updated */
	updatedAt: Scalars['DateTime']['output']
}

export enum RebateProgramStatus {
	Active = 'ACTIVE',
	Inactive = 'INACTIVE'
}

export enum RebateProgramVisibility {
	Global = 'GLOBAL',
	Restricted = 'RESTRICTED'
}

/** A query filter for rebate programs */
export type RebateProgramWhereInput = {
	AND?: InputMaybe<Array<RebateProgramWhereInput>>
	NOT?: InputMaybe<Array<RebateProgramWhereInput>>
	OR?: InputMaybe<Array<RebateProgramWhereInput>>
	endAt?: InputMaybe<DateTimeNullableFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	startAt?: InputMaybe<DateTimeNullableFilter>
	status?: InputMaybe<RebateProgramStatus>
	visibility?: InputMaybe<RebateProgramVisibility>
}

/** Response containing refund payout records with a total count */
export type RefundPayoutListWithCount = {
	__typename?: 'RefundPayoutListWithCount'
	args: BaseListArgs
	/** List of refund payout records */
	items: Array<RefundPayoutLog>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** An immutable audit record for a single Refund Payout attempt. */
export type RefundPayoutLog = {
	__typename?: 'RefundPayoutLog'
	/** Amount sent from the connected account to the practice's bank, in cents */
	amountPaidOut: Scalars['Int']['output']
	/** Amount moved from the platform account to the connected account, in cents */
	amountTransferred: Scalars['Int']['output']
	/** When the attempt was recorded */
	createdAt: Scalars['DateTime']['output']
	/** ISO 4217 currency code */
	currency: Scalars['String']['output']
	/** Free-text note on the payout */
	description?: Maybe<Scalars['String']['output']>
	/** Stripe or application error message captured on failure */
	errorReason?: Maybe<Scalars['String']['output']>
	/** Unique identifier for the refund payout record */
	id: Scalars['ID']['output']
	/** Email of the Scratch admin who triggered the payout */
	issuedBy: Scalars['String']['output']
	/** The connected account's practice ID */
	practiceId: Scalars['String']['output']
	/** Name of the practice */
	practiceName?: Maybe<Scalars['String']['output']>
	/** Outcome of the attempt */
	status: ScratchRefundPayoutStatus
	/** Stripe payout ID */
	stripePayoutId?: Maybe<Scalars['String']['output']>
	/** Stripe transfer ID */
	stripeTransferId?: Maybe<Scalars['String']['output']>
}

/** Sort order for refund payout records */
export type RefundPayoutOrderByInput = {
	amountPaidOut?: InputMaybe<SortOrder>
	amountTransferred?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	issuedBy?: InputMaybe<SortOrder>
	practiceId?: InputMaybe<SortOrder>
	status?: InputMaybe<SortOrder>
}

/** Filter conditions for refund payout records */
export type RefundPayoutWhereInput = {
	AND?: InputMaybe<Array<RefundPayoutWhereInput>>
	NOT?: InputMaybe<Array<RefundPayoutWhereInput>>
	OR?: InputMaybe<Array<RefundPayoutWhereInput>>
	createdAt?: InputMaybe<DateTimeFilter>
	id?: InputMaybe<StringFilter>
	issuedBy?: InputMaybe<StringFilter>
	practiceId?: InputMaybe<StringFilter>
	/** Filters by payout status (CREATED or FAILED) */
	status?: InputMaybe<ScratchRefundPayoutStatus>
	stripePayoutId?: InputMaybe<StringNullableFilter>
	stripeTransferId?: InputMaybe<StringNullableFilter>
}

/** Refund Request item */
export type RefundRequest = {
	__typename?: 'RefundRequest'
	/** User role required to approve the request */
	approverRole: Scalars['String']['output']
	charge?: Maybe<StripeCharge>
	chargeId?: Maybe<Scalars['String']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidatorId: Scalars['String']['output']
	/** Date when the Refund Request was created */
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	id: Scalars['ID']['output']
	/** Note left by the approver */
	notesApprover?: Maybe<Scalars['String']['output']>
	/** Note left by the requestor */
	notesRequestor?: Maybe<Scalars['String']['output']>
	/** Original Payment Amonut */
	originalPaymentAmount: Scalars['Float']['output']
	/** Date when payment was processed */
	originalPaymentProcessedAt: Scalars['DateTimeISO']['output']
	paymentIntent: PaymentIntent
	paymentIntentId: Scalars['String']['output']
	/** Client Id on PIMS */
	pimsClientId?: Maybe<Scalars['String']['output']>
	practice: Practice
	practiceId: Scalars['String']['output']
	requestedBy: User
	/** User email that requested the refund */
	requestedByEmail: Scalars['String']['output']
	/** User id that requested the refund */
	requestedById: Scalars['String']['output']
	/** Amount requested to refund */
	requestedRefundAmount: Scalars['Float']['output']
	/** Date when the request was resolved */
	resolvedAt?: Maybe<Scalars['DateTimeISO']['output']>
	/** User who resolved the request */
	resolvedById?: Maybe<Scalars['String']['output']>
	/** Refund Request Status */
	status: RefundRequestStatuses
	/** Date when the Refund Request was last updated */
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	writebackPimsClientId?: Maybe<Scalars['String']['output']>
}

/** List of Refund Request items with pagination */
export type RefundRequestList = {
	__typename?: 'RefundRequestList'
	all?: Maybe<Scalars['Boolean']['output']>
	args: BaseListArgs
	items: Array<RefundRequest>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A sort order for a field on Request Refund */
export type RefundRequestOrderByInput = {
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	originalPaymentAmount?: InputMaybe<SortOrder>
	originalPaymentProcessedAt?: InputMaybe<SortOrder>
	practice?: InputMaybe<PracticeOrderByInput>
	practiceId?: InputMaybe<SortOrder>
	requestedRefundAmount?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

export enum RefundRequestStatuses {
	Approved = 'APPROVED',
	Denied = 'DENIED',
	Open = 'OPEN'
}

/** A query filter for a list of refundRequest rows */
export type RefundRequestWhereInput = {
	AND?: InputMaybe<Array<RefundRequestWhereInput>>
	OR?: InputMaybe<Array<RefundRequestWhereInput>>
	approverRole?: InputMaybe<StringFilter>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	consolidatorId?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	pimsClientId?: InputMaybe<StringFilter>
	practice?: InputMaybe<PracticeWhereInput>
	practiceId?: InputMaybe<StringFilter>
	requestedById?: InputMaybe<StringFilter>
	status?: InputMaybe<StringNullableFilter>
}

/** Response for rebate rejection */
export type RejectRebateResponse = {
	__typename?: 'RejectRebateResponse'
	/** Error message if rejection failed */
	error?: Maybe<Scalars['String']['output']>
	/** The updated rebate */
	rebate?: Maybe<InvoiceDetectedRebate>
	/** Whether the rejection was successful */
	success: Scalars['Boolean']['output']
}

export type ScratchAdminPractice = {
	__typename?: 'ScratchAdminPractice'
	accountNumber?: Maybe<Scalars['String']['output']>
	activeTerminalsCount?: Maybe<Scalars['Int']['output']>
	address?: Maybe<Scalars['String']['output']>
	city?: Maybe<Scalars['String']['output']>
	consolidator?: Maybe<Consolidator>
	consolidatorId?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode2?: Maybe<Scalars['String']['output']>
	consolidatorReferenceCode3?: Maybe<Scalars['String']['output']>
	country?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	currentPims?: Maybe<Scalars['String']['output']>
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	customPayoutTarget?: Maybe<Scalars['String']['output']>
	deleted: Scalars['Boolean']['output']
	email?: Maybe<Scalars['String']['output']>
	financingStatus?: Maybe<Scalars['String']['output']>
	firstPaymentDate?: Maybe<Scalars['DateTimeISO']['output']>
	hospitalManagerEmail?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	industryProgramMetadata?: Maybe<Scalars['JSON']['output']>
	integrationId?: Maybe<Scalars['String']['output']>
	isCustomPayoutEnabled?: Maybe<Scalars['Boolean']['output']>
	isDashboardEnabled?: Maybe<Scalars['Boolean']['output']>
	isLendingEnabled?: Maybe<Scalars['Boolean']['output']>
	isNetSettlement?: Maybe<Scalars['Boolean']['output']>
	isPaymentEnabled?: Maybe<Scalars['Boolean']['output']>
	isRebateEnabled?: Maybe<Scalars['Boolean']['output']>
	isUnderwritten?: Maybe<Scalars['Boolean']['output']>
	locale?: Maybe<Scalars['String']['output']>
	logoUrl?: Maybe<Scalars['String']['output']>
	name?: Maybe<Scalars['String']['output']>
	netsuiteId?: Maybe<Scalars['String']['output']>
	originationFlags?: Maybe<Scalars['JSON']['output']>
	products?: Maybe<Scalars['JSON']['output']>
	rateScheme?: Maybe<Scalars['String']['output']>
	regionalManagerId?: Maybe<Scalars['String']['output']>
	routingNumber?: Maybe<Scalars['String']['output']>
	settings?: Maybe<Scalars['JSON']['output']>
	skyworldId?: Maybe<Scalars['String']['output']>
	socialUrl?: Maybe<Scalars['JSON']['output']>
	state?: Maybe<Scalars['String']['output']>
	stripeAccountId?: Maybe<Scalars['String']['output']>
	surchargeEnabled?: Maybe<Scalars['Boolean']['output']>
	surchargeFeePct?: Maybe<Scalars['Float']['output']>
	surchargeStartDate?: Maybe<Scalars['DateTimeISO']['output']>
	terminalLocation?: Maybe<Scalars['String']['output']>
	timezone?: Maybe<Scalars['String']['output']>
	totalTerminalsCount?: Maybe<Scalars['Int']['output']>
	transactionFees?: Maybe<Scalars['JSON']['output']>
	underwrittingStatus?: Maybe<Scalars['String']['output']>
	uniqueId?: Maybe<Scalars['String']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	users?: Maybe<Array<PracticeUser>>
	vetClinicId?: Maybe<Scalars['Int']['output']>
	website?: Maybe<Scalars['String']['output']>
	zip?: Maybe<Scalars['String']['output']>
}

/** List of Practice items with pagination */
export type ScratchAdminPracticeListWithCount = {
	__typename?: 'ScratchAdminPracticeListWithCount'
	args: BaseListArgs
	items: Array<ScratchAdminPractice>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

export type ScratchAdminPracticeOrderByInput = {
	activeTerminalsCount?: InputMaybe<SortOrder>
	address?: InputMaybe<SortOrder>
	consolidatorId?: InputMaybe<SortOrder>
	consolidatorReferenceCode?: InputMaybe<SortOrder>
	consolidatorReferenceCode2?: InputMaybe<SortOrder>
	consolidatorReferenceCode3?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	createdBy?: InputMaybe<SortOrder>
	customPayoutTarget?: InputMaybe<SortOrder>
	email?: InputMaybe<SortOrder>
	firstPaymentDate?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	isCustomPayoutEnabled?: InputMaybe<SortOrder>
	isNetSettlement?: InputMaybe<SortOrder>
	legalBusinessName?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	netsuiteId?: InputMaybe<SortOrder>
	rateScheme?: InputMaybe<SortOrder>
	skyworldId?: InputMaybe<SortOrder>
	stripeAccountId?: InputMaybe<SortOrder>
	surchargeEnabled?: InputMaybe<SortOrder>
	surchargeFeePct?: InputMaybe<SortOrder>
	surchargeStartDate?: InputMaybe<SortOrder>
	totalTerminalsCount?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
	vetClinicId?: InputMaybe<SortOrder>
	zip?: InputMaybe<SortOrder>
}

export type ScratchAdminPracticeWhereInput = {
	AND?: InputMaybe<Array<PracticeWhereInput>>
	NOT?: InputMaybe<Array<PracticeWhereInput>>
	OR?: InputMaybe<Array<PracticeWhereInput>>
	city?: InputMaybe<StringNullableFilter>
	consolidator?: InputMaybe<ConsolidatorRelationFilter>
	consolidatorId?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode2?: InputMaybe<StringNullableFilter>
	consolidatorReferenceCode3?: InputMaybe<StringNullableFilter>
	country?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	createdBy?: InputMaybe<StringNullableFilter>
	customPayoutSettings?: InputMaybe<JsonNullableFilter>
	customPayoutTarget?: InputMaybe<StringNullableFilter>
	deleted?: InputMaybe<BoolFilter>
	email?: InputMaybe<StringNullableFilter>
	firstPaymentDate?: InputMaybe<StringNullableFilter>
	hospitalManagerEmail?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	isCustomPayoutEnabled?: InputMaybe<BoolFilter>
	isNetSettlement?: InputMaybe<StringNullableFilter>
	name?: InputMaybe<StringNullableFilter>
	netsuiteId?: InputMaybe<StringNullableFilter>
	products?: InputMaybe<JsonNullableFilter>
	rateScheme?: InputMaybe<StringNullableFilter>
	regionalManagerId?: InputMaybe<StringNullableFilter>
	settings?: InputMaybe<JsonNullableFilter>
	skyworldId?: InputMaybe<StringNullableFilter>
	stripeAccountId?: InputMaybe<StringNullableFilter>
	surchargeEnabled?: InputMaybe<BoolNullableFilter>
	surchargeFeePct?: InputMaybe<StringNullableFilter>
	surchargeStartDate?: InputMaybe<DateTimeFilter>
	timezone?: InputMaybe<StringNullableFilter>
	transactionFees?: InputMaybe<JsonNullableFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
	users?: InputMaybe<PracticeUserListWhereInput>
	vetClinicId?: InputMaybe<IntNullableFilter>
	zip?: InputMaybe<StringNullableFilter>
}

export enum ScratchProduct {
	Financing = 'FINANCING',
	Payments = 'PAYMENTS',
	Rebates = 'REBATES'
}

/** Outcome of a refund payout attempt (CREATED = success, FAILED = error). */
export enum ScratchRefundPayoutStatus {
	Created = 'CREATED',
	Failed = 'FAILED'
}

/** The status of the e-signature for a stored card */
export enum SignatureStatus {
	Available = 'available',
	NotApplicable = 'not_applicable',
	Pending = 'pending'
}

export enum SortOrder {
	Asc = 'asc',
	Desc = 'desc'
}

export type SortOrderInput = {
	nulls?: InputMaybe<NullsOrder>
	sort: SortOrder
}

/** SplashScreen */
export type SplashScreen = {
	__typename?: 'SplashScreen'
	/** URL for the 720x1280 splash screen image */
	image720x1280Url: Scalars['String']['output']
	/** URL for the 1080x1920 splash screen image */
	image1080x1920Url: Scalars['String']['output']
}

/** A stored payment method (card on file) */
export type StoredPaymentMethod = {
	__typename?: 'StoredPaymentMethod'
	acknowledgedAt?: Maybe<Scalars['DateTimeISO']['output']>
	acknowledgementMode?: Maybe<AcknowledgementMode>
	addressLine1?: Maybe<Scalars['String']['output']>
	addressLine2?: Maybe<Scalars['String']['output']>
	cardBrand: Scalars['String']['output']
	cardLast4: Scalars['String']['output']
	cardName: Scalars['String']['output']
	cardType: Scalars['String']['output']
	city?: Maybe<Scalars['String']['output']>
	country?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	customerId: Scalars['String']['output']
	email?: Maybe<Scalars['String']['output']>
	expiresMonth: Scalars['Int']['output']
	expiresYear: Scalars['Int']['output']
	hasAcknowledgement: Scalars['Boolean']['output']
	id: Scalars['String']['output']
	origin?: Maybe<Scalars['String']['output']>
	paymentIntentId?: Maybe<Scalars['String']['output']>
	phone?: Maybe<Scalars['String']['output']>
	postalCode?: Maybe<Scalars['String']['output']>
	readMethod: Scalars['String']['output']
	setupIntentId?: Maybe<Scalars['String']['output']>
	signatureStatus: SignatureStatus
	signatureUrl?: Maybe<Scalars['String']['output']>
	state?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['DateTimeISO']['output']
}

/** A sort order for a field on StoredPaymentMethod */
export type StoredPaymentMethodOrderByInput = {
	addressLine1?: InputMaybe<SortOrder>
	addressLine2?: InputMaybe<SortOrder>
	cardBrand?: InputMaybe<SortOrder>
	cardLast4?: InputMaybe<SortOrder>
	cardName?: InputMaybe<SortOrder>
	cardType?: InputMaybe<SortOrder>
	city?: InputMaybe<SortOrder>
	country?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	customerId?: InputMaybe<SortOrder>
	email?: InputMaybe<SortOrder>
	expiresMonth?: InputMaybe<SortOrder>
	expiresYear?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	origin?: InputMaybe<SortOrder>
	paymentIntentId?: InputMaybe<SortOrder>
	phone?: InputMaybe<SortOrder>
	postalCode?: InputMaybe<SortOrder>
	readMethod?: InputMaybe<SortOrder>
	setupIntentId?: InputMaybe<SortOrder>
	state?: InputMaybe<SortOrder>
	updatedAt?: InputMaybe<SortOrder>
}

/** A query filter for a list of StoredPaymentMethod rows */
export type StoredPaymentMethodWhereInput = {
	customerId?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
}

export type StringFilter = {
	contains?: InputMaybe<Scalars['String']['input']>
	endsWith?: InputMaybe<Scalars['String']['input']>
	equals?: InputMaybe<Scalars['String']['input']>
	gt?: InputMaybe<Scalars['String']['input']>
	gte?: InputMaybe<Scalars['String']['input']>
	in?: InputMaybe<Array<Scalars['String']['input']>>
	lt?: InputMaybe<Scalars['String']['input']>
	lte?: InputMaybe<Scalars['String']['input']>
	mode?: InputMaybe<QueryMode>
	not?: InputMaybe<NestedStringFilter>
	notIn?: InputMaybe<Array<Scalars['String']['input']>>
	startsWith?: InputMaybe<Scalars['String']['input']>
}

export type StringNullableFilter = {
	contains?: InputMaybe<Scalars['String']['input']>
	endsWith?: InputMaybe<Scalars['String']['input']>
	equals?: InputMaybe<Scalars['String']['input']>
	gt?: InputMaybe<Scalars['String']['input']>
	gte?: InputMaybe<Scalars['String']['input']>
	in?: InputMaybe<Array<Scalars['String']['input']>>
	lt?: InputMaybe<Scalars['String']['input']>
	lte?: InputMaybe<Scalars['String']['input']>
	mode?: InputMaybe<QueryMode>
	not?: InputMaybe<NestedStringNullableFilter>
	notIn?: InputMaybe<Array<Scalars['String']['input']>>
	startsWith?: InputMaybe<Scalars['String']['input']>
}

/** Stripe Charge item */
export type StripeCharge = {
	__typename?: 'StripeCharge'
	amount: Scalars['Float']['output']
	amountCaptured: Scalars['Float']['output']
	amountRefunded?: Maybe<Scalars['Float']['output']>
	amountWithoutSurcharge?: Maybe<Scalars['Float']['output']>
	capturedAt?: Maybe<Scalars['DateTimeISO']['output']>
	id: Scalars['ID']['output']
	metadata?: Maybe<Scalars['JSON']['output']>
	/** Stripe destination payment ID from the transfer */
	transferDestinationPaymentId?: Maybe<Scalars['String']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

/** Stripe Dispute item */
export type StripeDispute = {
	__typename?: 'StripeDispute'
	amount: Scalars['Float']['output']
	balanceTransactions: Array<Scalars['JSON']['output']>
	cardBrand?: Maybe<Scalars['String']['output']>
	cardType?: Maybe<Scalars['String']['output']>
	cardholderName?: Maybe<Scalars['String']['output']>
	charge?: Maybe<StripeCharge>
	chargeId?: Maybe<Scalars['String']['output']>
	closedAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	currency?: Maybe<Scalars['String']['output']>
	customPayoutBatchStatus?: Maybe<Scalars['String']['output']>
	customPayoutConsolidatorBatchId?: Maybe<Scalars['String']['output']>
	customPayoutPracticeBatchId?: Maybe<Scalars['String']['output']>
	disputeFee?: Maybe<Scalars['Float']['output']>
	disputeTotal?: Maybe<Scalars['Float']['output']>
	evidence?: Maybe<Scalars['JSON']['output']>
	evidenceDetails?: Maybe<Scalars['JSON']['output']>
	fundsStatus?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	isChargeRefundable?: Maybe<Scalars['Boolean']['output']>
	last4?: Maybe<Scalars['String']['output']>
	lostAt?: Maybe<Scalars['DateTimeISO']['output']>
	metadata?: Maybe<Scalars['JSON']['output']>
	partnerId?: Maybe<Scalars['String']['output']>
	paymentIntentId?: Maybe<Scalars['String']['output']>
	paymentMethodType?: Maybe<Scalars['String']['output']>
	practice?: Maybe<Practice>
	practiceFundsWithdrawalAt?: Maybe<Scalars['DateTimeISO']['output']>
	practiceFundsWithdrawalETA?: Maybe<Scalars['DateTimeISO']['output']>
	practiceId: Scalars['String']['output']
	reason?: Maybe<Scalars['String']['output']>
	status?: Maybe<Scalars['String']['output']>
	stripePayoutId?: Maybe<Scalars['String']['output']>
	stripeWonPayoutId?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['DateTimeISO']['output']
}

/** Everything the lost-dispute panel shows */
export type StripeDisputeDetails = {
	__typename?: 'StripeDisputeDetails'
	bankResponse?: Maybe<StripeDisputeIssuerEvidence>
	cardholderEmail?: Maybe<Scalars['String']['output']>
	cardholderName?: Maybe<Scalars['String']['output']>
	chargebackClaim?: Maybe<StripeDisputeIssuerEvidence>
	consolidatedPracticeId?: Maybe<Scalars['String']['output']>
	currency: Scalars['String']['output']
	decidedAt?: Maybe<Scalars['DateTimeISO']['output']>
	/** Disputed amount, in cents */
	disputedAmount: Scalars['Int']['output']
	/** When the practice submitted evidence; null if submitted before we recorded it */
	evidenceSubmittedAt?: Maybe<Scalars['DateTimeISO']['output']>
	id: Scalars['String']['output']
	/** Lost dispute fee, in cents */
	lostDisputeFee?: Maybe<Scalars['Int']['output']>
	networkReasonCode?: Maybe<Scalars['String']['output']>
	/** Charge amount, in cents */
	paymentAmount?: Maybe<Scalars['Int']['output']>
	paymentMethod?: Maybe<StripeDisputePaymentMethod>
	paymentSucceededAt?: Maybe<Scalars['DateTimeISO']['output']>
	reason: Scalars['String']['output']
	receivedAt: Scalars['DateTimeISO']['output']
	/** Our status */
	status?: Maybe<Scalars['String']['output']>
	/** Stripe's own status, e.g. appeal_needs_response */
	stripeStatus: Scalars['String']['output']
	submittedEvidence: Array<StripeDisputeEvidenceFile>
}

export type StripeDisputeEvidenceFile = {
	__typename?: 'StripeDisputeEvidenceFile'
	categoryLabel: Scalars['String']['output']
	fileId: Scalars['String']['output']
	fileName?: Maybe<Scalars['String']['output']>
}

export type StripeDisputeFile = {
	__typename?: 'StripeDisputeFile'
	fileId: Scalars['String']['output']
}

/** A document or statement from the card issuer */
export type StripeDisputeIssuerEvidence = {
	__typename?: 'StripeDisputeIssuerEvidence'
	files: Array<StripeDisputeFile>
	text?: Maybe<Scalars['String']['output']>
}

export type StripeDisputeOrderByInput = {
	amount?: InputMaybe<Scalars['String']['input']>
	cardBrand?: InputMaybe<Scalars['String']['input']>
	cardType?: InputMaybe<Scalars['String']['input']>
	cardholderName?: InputMaybe<Scalars['String']['input']>
	chargeId?: InputMaybe<Scalars['String']['input']>
	closedAt?: InputMaybe<Scalars['String']['input']>
	consolidatorId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['String']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	customPayoutBatchStatus?: InputMaybe<Scalars['String']['input']>
	customPayoutConsolidatorBatchId?: InputMaybe<Scalars['String']['input']>
	customPayoutPracticeBatchId?: InputMaybe<Scalars['String']['input']>
	disputeFee?: InputMaybe<Scalars['String']['input']>
	disputeTotal?: InputMaybe<Scalars['String']['input']>
	fundsStatus?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	last4?: InputMaybe<Scalars['String']['input']>
	lostAt?: InputMaybe<Scalars['String']['input']>
	partnerId?: InputMaybe<Scalars['String']['input']>
	paymentIntentId?: InputMaybe<Scalars['String']['input']>
	paymentMethodType?: InputMaybe<Scalars['String']['input']>
	practiceFundsWithdrawalAt?: InputMaybe<Scalars['String']['input']>
	practiceFundsWithdrawalETA?: InputMaybe<Scalars['String']['input']>
	practiceId?: InputMaybe<Scalars['String']['input']>
	reason?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	stripePayoutId?: InputMaybe<Scalars['String']['input']>
	stripeWonPayoutId?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['String']['input']>
}

/** Card of the disputed charge */
export type StripeDisputePaymentMethod = {
	__typename?: 'StripeDisputePaymentMethod'
	/** Billing address on one line */
	billingAddress?: Maybe<Scalars['String']['output']>
	brand?: Maybe<Scalars['String']['output']>
	/** Issuing country, ISO code */
	country?: Maybe<Scalars['String']['output']>
	/** Card not present only, e.g. pass */
	cvcCheck?: Maybe<Scalars['String']['output']>
	expMonth?: Maybe<Scalars['Int']['output']>
	expYear?: Maybe<Scalars['Int']['output']>
	funding?: Maybe<Scalars['String']['output']>
	last4?: Maybe<Scalars['String']['output']>
	/** Card not present only, e.g. fail */
	postalCodeCheck?: Maybe<Scalars['String']['output']>
	/** Card present only, e.g. contactless_emv */
	readMethod?: Maybe<Scalars['String']['output']>
	type?: Maybe<Scalars['String']['output']>
}

export type StripeDisputeWhereInput = {
	AND?: InputMaybe<Array<StripeDisputeWhereInput>>
	NOT?: InputMaybe<Array<StripeDisputeWhereInput>>
	OR?: InputMaybe<Array<StripeDisputeWhereInput>>
	amount?: InputMaybe<IntFilter>
	cardBrand?: InputMaybe<StringFilter>
	cardType?: InputMaybe<StringFilter>
	cardholderName?: InputMaybe<StringFilter>
	chargeId?: InputMaybe<StringFilter>
	closedAt?: InputMaybe<DateTimeFilter>
	consolidatorId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	currency?: InputMaybe<StringFilter>
	customPayoutBatchStatus?: InputMaybe<StringFilter>
	customPayoutConsolidatorBatchId?: InputMaybe<StringFilter>
	customPayoutPracticeBatchId?: InputMaybe<StringFilter>
	disputeFee?: InputMaybe<IntFilter>
	disputeTotal?: InputMaybe<IntFilter>
	fundsStatus?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	last4?: InputMaybe<StringFilter>
	lostAt?: InputMaybe<DateTimeFilter>
	partnerId?: InputMaybe<StringFilter>
	paymentIntentId?: InputMaybe<StringFilter>
	paymentMethodType?: InputMaybe<StringFilter>
	practiceFundsWithdrawalAt?: InputMaybe<DateTimeFilter>
	practiceFundsWithdrawalETA?: InputMaybe<DateTimeFilter>
	practiceId?: InputMaybe<StringFilter>
	reason?: InputMaybe<StringFilter>
	search?: InputMaybe<StringFilter>
	status?: InputMaybe<StringFilter>
	stripePayoutId?: InputMaybe<StringFilter>
	stripeWonPayoutId?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** List of Stripe Dispute records with pagination */
export type StripeDisputeWithCount = {
	__typename?: 'StripeDisputeWithCount'
	args: BaseListArgs
	items: Array<StripeDispute>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A subscription schedule row */
export type SubscriptionSchedule = {
	__typename?: 'SubscriptionSchedule'
	applicationFeePercent?: Maybe<Scalars['Decimal']['output']>
	attemptCount?: Maybe<Scalars['Int']['output']>
	canceledAt?: Maybe<Scalars['DateTimeISO']['output']>
	completedAt?: Maybe<Scalars['DateTimeISO']['output']>
	consolidatedPractice?: Maybe<ConsolidatedPracticeSummary>
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['DateTimeISO']['output']
	customerId: Scalars['String']['output']
	description?: Maybe<Scalars['String']['output']>
	finalPaymentOn?: Maybe<Scalars['DateTimeISO']['output']>
	firstPaymentOn?: Maybe<Scalars['DateTimeISO']['output']>
	id: Scalars['String']['output']
	latestInvoiceAmountPaid?: Maybe<Scalars['Int']['output']>
	latestInvoiceAttemptCount?: Maybe<Scalars['Int']['output']>
	latestInvoiceAttempted?: Maybe<Scalars['Boolean']['output']>
	latestInvoiceCreatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	latestInvoiceId?: Maybe<Scalars['String']['output']>
	latestInvoiceNumber?: Maybe<Scalars['String']['output']>
	latestInvoicePaid?: Maybe<Scalars['Boolean']['output']>
	latestInvoicePaymentIntentId?: Maybe<Scalars['String']['output']>
	latestInvoiceStatus?: Maybe<Scalars['String']['output']>
	latestInvoiceStatusTransitionPaidAt?: Maybe<Scalars['DateTimeISO']['output']>
	metadata?: Maybe<Scalars['JSON']['output']>
	metadataClientFirstName?: Maybe<Scalars['String']['output']>
	metadataClientId?: Maybe<Scalars['String']['output']>
	metadataClientLastName?: Maybe<Scalars['String']['output']>
	metadataClientName?: Maybe<Scalars['String']['output']>
	nextPaymentOn?: Maybe<Scalars['DateTimeISO']['output']>
	nextRetryDate?: Maybe<Scalars['DateTimeISO']['output']>
	onBehalfOfAccountId?: Maybe<Scalars['String']['output']>
	pauseCollectionBehavior?: Maybe<PauseCollectionBehaviorTypes>
	pauseCollectionResumesAt?: Maybe<Scalars['DateTimeISO']['output']>
	paymentAmount?: Maybe<Scalars['Int']['output']>
	paymentMethodBankAccountBankName?: Maybe<Scalars['String']['output']>
	paymentMethodBankAccountLast4?: Maybe<Scalars['String']['output']>
	paymentMethodCardBrand?: Maybe<Scalars['String']['output']>
	paymentMethodCardExpMonth?: Maybe<Scalars['Int']['output']>
	paymentMethodCardExpYear?: Maybe<Scalars['Int']['output']>
	paymentMethodCardLast4?: Maybe<Scalars['String']['output']>
	paymentMethodId?: Maybe<Scalars['String']['output']>
	paymentMethodMetadata?: Maybe<Scalars['JSON']['output']>
	paymentMethodType?: Maybe<Scalars['String']['output']>
	paymentsAttempted?: Maybe<Scalars['Int']['output']>
	paymentsFailed?: Maybe<Scalars['Int']['output']>
	paymentsRemaining?: Maybe<Scalars['Int']['output']>
	paymentsSkipped?: Maybe<Scalars['Int']['output']>
	paymentsSucceeded?: Maybe<Scalars['Int']['output']>
	paymentsTotal?: Maybe<Scalars['Int']['output']>
	petName?: Maybe<Scalars['String']['output']>
	phases?: Maybe<Scalars['JSON']['output']>
	practice?: Maybe<Practice>
	practiceId: Scalars['String']['output']
	releasedAt?: Maybe<Scalars['DateTimeISO']['output']>
	renewalInterval?: Maybe<Scalars['String']['output']>
	stripeCreatedAt: Scalars['DateTimeISO']['output']
	subscriptionId?: Maybe<Scalars['String']['output']>
	subscriptionScheduleStatus?: Maybe<Scalars['String']['output']>
	subscriptionStatus?: Maybe<Scalars['String']['output']>
	transferDataDestinationAccountId?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['DateTimeISO']['output']
}

/** List of SubscriptionSchedule items with count */
export type SubscriptionScheduleListWithCount = {
	__typename?: 'SubscriptionScheduleListWithCount'
	items: Array<SubscriptionSchedule>
	total: Scalars['Float']['output']
}

export type SubscriptionScheduleOrderByInput = {
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeOrderByInput>
	createdAt?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	metadataClientFirstName?: InputMaybe<SortOrder>
	metadataClientId?: InputMaybe<SortOrder>
	metadataClientLastName?: InputMaybe<SortOrder>
	practice?: InputMaybe<PracticeOrderByInput>
}

export type SubscriptionScheduleWhereInput = {
	AND?: InputMaybe<Array<SubscriptionScheduleWhereInput>>
	NOT?: InputMaybe<Array<SubscriptionScheduleWhereInput>>
	OR?: InputMaybe<Array<SubscriptionScheduleWhereInput>>
	canceledAt?: InputMaybe<DateTimeNullableFilter>
	completedAt?: InputMaybe<DateTimeNullableFilter>
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeWhereInput>
	consolidatedPracticeId?: InputMaybe<StringNullableFilter>
	createdAt?: InputMaybe<DateTimeFilter>
	customerId?: InputMaybe<StringNullableFilter>
	id?: InputMaybe<StringFilter>
	metadataClientFirstName?: InputMaybe<StringNullableFilter>
	metadataClientId?: InputMaybe<StringNullableFilter>
	metadataClientLastName?: InputMaybe<StringNullableFilter>
	metadataClientName?: InputMaybe<StringNullableFilter>
	nextPaymentOnEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	nextPaymentOnStartDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	practice?: InputMaybe<PracticeWhereInput>
	search?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<DateTimeFilter>
}

/** Shared configuration for elements in the template */
export type TemplateElementConfig = {
	__typename?: 'TemplateElementConfig'
	/** Maximum height of the element */
	maxHeight?: Maybe<Scalars['Float']['output']>
	/** Maximum width of the element */
	maxWidth?: Maybe<Scalars['Float']['output']>
	/** Position of the element */
	position?: Maybe<TemplatePosition>
	/** Whether the element is required */
	required?: Maybe<Scalars['Boolean']['output']>
}

/** Position settings for elements in the template */
export type TemplatePosition = {
	__typename?: 'TemplatePosition'
	/** Horizontal Alignment */
	hAlign?: Maybe<Scalars['String']['output']>
	/** Padding when vAlign or hAlign is used */
	padding?: Maybe<Scalars['Float']['output']>
	/** Vertical Alignment */
	vAlign?: Maybe<Scalars['String']['output']>
	/** X-coordinate of the position */
	x?: Maybe<Scalars['Float']['output']>
	/** Y-coordinate of the position */
	y?: Maybe<Scalars['Float']['output']>
}

/** Settings for template customization */
export type TemplateSettings = {
	__typename?: 'TemplateSettings'
	/** Settings for the logo */
	logo?: Maybe<TemplateElementConfig>
	/** Settings for the QR code */
	qrcode?: Maybe<TemplateElementConfig>
}

/** Whether terminal offer is enabled for all, some, or none of a practice programs */
export enum TerminalRebateEnabledStatus {
	None = 'NONE',
	Partial = 'PARTIAL',
	Yes = 'YES'
}

/** A single row for the Tip Report detail table -- either a tip collected or a single refund event against a tip collected in an earlier (or the same) row, told apart by `rowType`. A refunded tip therefore appears as two rows: the original collection and, dated by when the refund happened, its own refund row pointing back to the same `paymentIntentId`. */
export type TerminalTip = {
	__typename?: 'TerminalTip'
	/** Consolidated practice this tip belongs to. */
	consolidatedPracticeId: Scalars['String']['output']
	/** When this row happened: the tip collection time on a collected row, or the refund's own event time on a refund row. */
	createdAt: Scalars['DateTimeISO']['output']
	/** Unique identifier for this row. */
	id: Scalars['ID']['output']
	/** The PaymentIntent the tip was collected on. */
	paymentIntent: TerminalTipPaymentIntent
	/** Stripe PaymentIntent id the tip was collected on. */
	paymentIntentId: Scalars['String']['output']
	/** Display name of the tip recipient. */
	recipientName: Scalars['String']['output']
	/** This row's own refunded tip amount, in cents. Always 0 on a collected row -- refunds never mutate the original row, they get their own. */
	refundedTipAmount: Scalars['Int']['output']
	/** Whether this row is the tip collected or a refund event against it. */
	rowType: TerminalTipRowType
	/** Stripe refund id this row represents. Null on the tip-collected row (rowType TIP); set on a refund row (rowType REFUND), identifying which refund it is. */
	stripeRefundId?: Maybe<Scalars['String']['output']>
	/** Tip amount collected, in cents. Always 0 on a refund row. */
	tipAmount: Scalars['Int']['output']
}

/** Paginated Tip Report detail rows with total matching count. */
export type TerminalTipListWithCount = {
	__typename?: 'TerminalTipListWithCount'
	args: BaseListArgs
	items: Array<TerminalTip>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A tip's PaymentIntent details for the Tip Report detail table. */
export type TerminalTipPaymentIntent = {
	__typename?: 'TerminalTipPaymentIntent'
	/** Payment amount before tip, in cents. */
	baseAmount?: Maybe<Scalars['Int']['output']>
	/** The PaymentIntent's Stripe capture method, e.g. automatic or manual. */
	captureMethod?: Maybe<Scalars['String']['output']>
	/** Card brand used for the payment, e.g. visa. */
	cardBrand?: Maybe<Scalars['String']['output']>
	/** Card funding type, e.g. credit or debit. */
	cardType?: Maybe<Scalars['String']['output']>
	/** Name on the card used for the payment. */
	cardholderName?: Maybe<Scalars['String']['output']>
	/** PIMS client data captured on the PaymentIntent. */
	clientData?: Maybe<Scalars['JSON']['output']>
	/** Payer's display name. */
	customerName?: Maybe<Scalars['String']['output']>
	/** Last 4 digits of the card used for the payment. */
	last4?: Maybe<Scalars['String']['output']>
	/** Raw Stripe metadata on the PaymentIntent. */
	metadata?: Maybe<Scalars['JSON']['output']>
	/** PIMS client id for the payer. */
	pimsClientId?: Maybe<Scalars['String']['output']>
	/** PIMS invoice number the payment was applied to. */
	pimsInvoiceId?: Maybe<Scalars['String']['output']>
}

/** Which kind of event a Tip Report detail row represents: TIP (a tip was collected) or REFUND (a tip-bearing refund happened, dated by its own event time). */
export enum TerminalTipRowType {
	Refund = 'REFUND',
	Tip = 'TIP'
}

/** Tip totals for a single recipient over the selected range. */
export type TerminalTipSummary = {
	__typename?: 'TerminalTipSummary'
	/** Unique identifier of the tip recipient. */
	recipientId: Scalars['ID']['output']
	/** Display name of the tip recipient. */
	recipientName: Scalars['String']['output']
	/** Tip amount refunded for this recipient in the window, in cents. Dated by each refund, not the tip it refunds, so it can exceed tipVolume when it refunds a tip collected in an earlier window. */
	refundedTipVolume: Scalars['Int']['output']
	/** Number of tips collected for this recipient in the window. */
	tipCount: Scalars['Int']['output']
	/** Total tip amount collected for this recipient in the window, in cents. */
	tipVolume: Scalars['Int']['output']
}

/** A tip recipient configured for a practice. */
export type TipRecipient = {
	__typename?: 'TipRecipient'
	/** Record creation timestamp. */
	createdAt: Scalars['DateTimeISO']['output']
	/** Unique identifier for this tip recipient. */
	id: Scalars['ID']['output']
	/** Whether this recipient is active. */
	isActive: Scalars['Boolean']['output']
	/** Display name of the tip recipient. */
	name: Scalars['String']['output']
	/** Record last update timestamp. */
	updatedAt: Scalars['DateTimeISO']['output']
}

export type TipRecipientOrderByInput = {
	name?: InputMaybe<SortOrder>
}

export type TipRecipientWhereInput = {
	/** Consolidated practice relation filter. */
	consolidatedPractice?: InputMaybe<ConsolidatedPracticeRelationFilter>
	/** Consolidated practice ID to scope recipients. */
	consolidatedPracticeId?: InputMaybe<Scalars['String']['input']>
	/** Recipient Name */
	name?: InputMaybe<StringFilter>
}

/** Result of a Trigger Refund Payout mutation */
export type TriggerRefundPayoutResponse = {
	__typename?: 'TriggerRefundPayoutResponse'
	amount: Scalars['Float']['output']
	currency: Scalars['String']['output']
	practiceId: Scalars['ID']['output']
	status?: Maybe<Scalars['String']['output']>
	stripeAccountId: Scalars['String']['output']
	stripePayoutId: Scalars['String']['output']
	stripeTransferId: Scalars['String']['output']
}

export type UpsertCustomPayoutSettingsResponse = {
	__typename?: 'UpsertCustomPayoutSettingsResponse'
	customPayoutSettings?: Maybe<Scalars['JSON']['output']>
	success: Scalars['Boolean']['output']
}

/** Input for creating or updating a normalized product. */
export type UpsertNormalizedProductInput = {
	/** Consolidated practice identifier. */
	consolidatedPracticeId: Scalars['String']['input']
	/** User or system that created this record. */
	createdBy?: InputMaybe<Scalars['String']['input']>
	/** Indicates if the product was checked manually. */
	isCheckedManually?: InputMaybe<Scalars['Boolean']['input']>
	/** Additional metadata in JSON format. */
	metadata?: InputMaybe<Scalars['JSON']['input']>
	/** Normalized/standardized product description. */
	normalizedProductDescription?: InputMaybe<Scalars['String']['input']>
	/** Original product description from PIMS. */
	pimsProductDescription: Scalars['String']['input']
	/** PIMS product unique identifier. */
	pimsProductUid?: InputMaybe<Scalars['String']['input']>
	/** Associated product reference ID. */
	productReferenceId?: InputMaybe<Scalars['String']['input']>
	/** Associated product variant ID. */
	productVariantId?: InputMaybe<Scalars['String']['input']>
	/** UUID for updating existing product. */
	uuid?: InputMaybe<Scalars['String']['input']>
}

export type UpsertPartnerInput = {
	accountNumber?: InputMaybe<Scalars['String']['input']>
	apiId?: InputMaybe<Scalars['String']['input']>
	apiKey?: InputMaybe<Scalars['String']['input']>
	consolidatorId?: InputMaybe<Scalars['String']['input']>
	customFields?: InputMaybe<Scalars['JSON']['input']>
	customPayoutRunAtTime?: InputMaybe<Scalars['DateTimeISO']['input']>
	customPayoutSettings?: InputMaybe<Scalars['JSON']['input']>
	customPayoutTarget?: InputMaybe<CustomPayoutBatchTarget>
	customization?: InputMaybe<Scalars['JSON']['input']>
	featureFlags?: InputMaybe<Scalars['JSON']['input']>
	forwardWebhookAPIKey?: InputMaybe<Scalars['String']['input']>
	forwardWebhookEvents?: InputMaybe<Array<Scalars['String']['input']>>
	forwardWebhookUrl?: InputMaybe<Scalars['String']['input']>
	/** Partner ID - required for both create and update */
	id: Scalars['String']['input']
	isCustomPayoutEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isPaymentPartner?: InputMaybe<Scalars['Boolean']['input']>
	mcc?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	productDescription?: InputMaybe<Scalars['String']['input']>
	routingNumber?: InputMaybe<Scalars['String']['input']>
	taxId?: InputMaybe<Scalars['String']['input']>
	timezone?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating or updating a product reference. */
export type UpsertProductReferenceInput = {
	/** Brand identifier. */
	brandId?: InputMaybe<Scalars['String']['input']>
	/** Category identifier. */
	categoryId?: InputMaybe<Scalars['String']['input']>
	/** Days on therapy. */
	daysOnTherapy?: InputMaybe<Scalars['Int']['input']>
	/** ID for updating existing product reference. */
	id?: InputMaybe<Scalars['String']['input']>
	/** Manufacturer identifier. */
	manufacturerId?: InputMaybe<Scalars['String']['input']>
	/** Product name. */
	name: Scalars['String']['input']
	/** Additional notes. */
	notes?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating or updating a product variant reference. */
export type UpsertProductVariantInput = {
	/** Variant color. */
	color?: InputMaybe<Scalars['String']['input']>
	/** Dose or pack size. */
	doseOrPackSize?: InputMaybe<Scalars['String']['input']>
	/** ID for updating existing variant. */
	id?: InputMaybe<Scalars['String']['input']>
	/** Maximum weight. */
	maxWeight?: InputMaybe<Scalars['Float']['input']>
	/** Minimum weight. */
	minWeight?: InputMaybe<Scalars['Float']['input']>
	/** Additional notes. */
	notes?: InputMaybe<Scalars['String']['input']>
	/** Associated product reference ID. */
	productReferenceId: Scalars['String']['input']
	/** Species (e.g., Dog, Cat). */
	species?: InputMaybe<Scalars['String']['input']>
	/** Weight unit. */
	weightUnit?: InputMaybe<Scalars['String']['input']>
}

/** User item */
export type User = {
	__typename?: 'User'
	consolidatedPractices?: Maybe<Array<ConsolidatedPracticeUser>>
	consolidatorId?: Maybe<Scalars['String']['output']>
	createdAt?: Maybe<Scalars['DateTimeISO']['output']>
	createdBy?: Maybe<Scalars['String']['output']>
	dashboardUserId?: Maybe<Scalars['Float']['output']>
	disabled?: Maybe<Scalars['Boolean']['output']>
	displayName?: Maybe<Scalars['String']['output']>
	email?: Maybe<Scalars['String']['output']>
	emailMapped?: Maybe<Scalars['Boolean']['output']>
	extraEmailForNotifications?: Maybe<Scalars['String']['output']>
	firstName?: Maybe<Scalars['String']['output']>
	id: Scalars['ID']['output']
	initialRole?: Maybe<Scalars['String']['output']>
	isAdmin?: Maybe<Scalars['Boolean']['output']>
	isRegionalManager?: Maybe<Scalars['Boolean']['output']>
	isScratchAdmin?: Maybe<Scalars['Boolean']['output']>
	isUserNameLogin?: Maybe<Scalars['Boolean']['output']>
	lastLoginDate?: Maybe<Scalars['DateTimeISO']['output']>
	lastName?: Maybe<Scalars['String']['output']>
	name?: Maybe<Scalars['String']['output']>
	passwordLastUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	practices: Array<PracticeUser>
	primaryClinic?: Maybe<Practice>
	primaryClinicId?: Maybe<Scalars['String']['output']>
	primaryStripeAccountId?: Maybe<Scalars['String']['output']>
	uid?: Maybe<Scalars['String']['output']>
	updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
	username?: Maybe<Scalars['String']['output']>
}

/** List of Users items with pagination */
export type UserList = {
	__typename?: 'UserList'
	all?: Maybe<Scalars['Boolean']['output']>
	args: BaseListArgs
	items: Array<User>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** List of Users items with pagination */
export type UserListWithCount = {
	__typename?: 'UserListWithCount'
	all?: Maybe<Scalars['Boolean']['output']>
	args: BaseListArgs
	items: Array<User>
	skip: Scalars['Float']['output']
	take?: Maybe<Scalars['Float']['output']>
	total: Scalars['Float']['output']
}

/** A sort order for a field on User */
export type UserOrderByInput = {
	consolidatorId?: InputMaybe<SortOrder>
	createdAt?: InputMaybe<SortOrder>
	disabled?: InputMaybe<SortOrder>
	email?: InputMaybe<SortOrder>
	id?: InputMaybe<SortOrder>
	initialRole?: InputMaybe<SortOrder>
	lastLoginDate?: InputMaybe<SortOrder>
	name?: InputMaybe<SortOrder>
	primaryClinic?: InputMaybe<PracticeOrderByInput>
	updatedAt?: InputMaybe<SortOrder>
	username?: InputMaybe<SortOrder>
}

/** A query filter for a list of User Practices rows */
export type UserPracticesWhereInput = {
	some?: InputMaybe<PracticeUserWhereInput>
}

/** A query filter for a list of User rows */
export type UserWhereInput = {
	AND?: InputMaybe<Array<UserWhereInput>>
	OR?: InputMaybe<Array<UserWhereInput>>
	consolidatorId?: InputMaybe<StringFilter>
	disabled?: InputMaybe<BoolFilter>
	displayName?: InputMaybe<StringFilter>
	email?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	initialRole?: InputMaybe<StringFilter>
	lastLoginDate?: InputMaybe<DateTimeFilter>
	name?: InputMaybe<StringFilter>
	practices?: InputMaybe<UserPracticesWhereInput>
	primaryClinic?: InputMaybe<PracticeWhereInput>
	uid?: InputMaybe<StringFilter>
	username?: InputMaybe<StringFilter>
}

/** Response for voiding payment requests */
export type VoidPaymentRequestFileResponse = {
	__typename?: 'VoidPaymentRequestFileResponse'
	message: Scalars['String']['output']
	success: Scalars['Boolean']['output']
}

export type ListActionNeededQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ActionNeededOrderByInput> | ActionNeededOrderByInput>
	where?: InputMaybe<ActionNeededWhereInput>
}>

export type ListActionNeededQuery = {
	__typename?: 'Query'
	listActionNeeded: {
		__typename?: 'ActionNeededList'
		skip: number
		take?: number | null
		total: number
		items: Array<{
			__typename?: 'ActionNeeded'
			id: string
			isComplete: boolean
			amount: number
			clientId?: string | null
			clientName?: string | null
			actionItemType: ActionItemTypes
			paid?: boolean | null
			chargeId?: string | null
			paymentIntentId?: string | null
			invoiceId?: string | null
			metadata?: any | null
			failureCode?: string | null
			failureMessage?: string | null
			scratchPaymentMethod?: string | null
			createdAt?: any | null
			updatedAt?: any | null
			dateAdjustedInPims?: any | null
			resolution?: ActionItemResoltionTypes | null
			resolutionNote?: string | null
			completedBy?: string | null
			completedAt?: any | null
			notes?: string | null
			stripeCreatedDate?: any | null
			practice: {
				__typename?: 'ActionNeededPractice'
				name: string
				id: string
				consolidatorReferenceCode?: string | null
				consolidatorReferenceCode2?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
			}
		}>
	}
}

export type B2bRebatePayoutFilesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<B2bRebatePayoutFileOrderByInput> | B2bRebatePayoutFileOrderByInput>
	where?: InputMaybe<B2bRebatePayoutFileWhereInput>
}>

export type B2bRebatePayoutFilesQuery = {
	__typename?: 'Query'
	b2bRebatePayoutFiles: {
		__typename?: 'B2bRebatePayoutFileListWithCount'
		total: number
		items: Array<{
			__typename?: 'B2bRebatePayoutFile'
			id: string
			fileName: string
			uploadedBy: string
			uploadedByName?: string | null
			status: string
			notes?: any | null
			startedAt?: any | null
			completedAt?: any | null
			recordsCount?: number | null
			validRecordsCount?: number | null
			createdAt: any
			updatedAt: any
		}>
	}
}

export type B2bRebatePayoutRecordsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<B2bRebatePayoutRecordOrderByInput> | B2bRebatePayoutRecordOrderByInput>
	where?: InputMaybe<B2bRebatePayoutRecordWhereInput>
}>

export type B2bRebatePayoutRecordsQuery = {
	__typename?: 'Query'
	b2bRebatePayoutRecords: {
		__typename?: 'B2bRebatePayoutRecordListWithCount'
		total: number
		items: Array<{
			__typename?: 'B2bRebatePayoutRecord'
			id: string
			uploadId: string
			consolidatedPracticeId?: string | null
			practiceName?: string | null
			manufacturerId: string
			manufacturerName?: string | null
			reimbursementAmount: number
			rebateCount?: number | null
			payoutDate: any
			statementDescriptor?: string | null
			status: string
			rebatePayoutBatchId?: string | null
			createdAt: any
			updatedAt: any
		}>
	}
}

export type BillingTaskQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<BillingTaskOrderByInput> | BillingTaskOrderByInput>
	where?: InputMaybe<BillingTaskWhereInput>
}>

export type BillingTaskQuery = {
	__typename?: 'Query'
	billingTask: {
		__typename?: 'BillingTaskListWithCount'
		total: number
		items: Array<{
			__typename?: 'BillingTask'
			id: string
			identifier: string
			target: string
			isAutomatedRun: boolean
			monthlyBillingLogId: string
			status: string
			requestedBy?: string | null
			request?: any | null
			responseSnapshot?: any | null
			createdAt: any
			updatedAt: any
		}>
	}
}

export type CardRequestsQueryVariables = Exact<{
	skip: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CardRequestOrderByInput> | CardRequestOrderByInput>
	where?: InputMaybe<CardRequestWhereInput>
}>

export type CardRequestsQuery = {
	__typename?: 'Query'
	cardRequests: Array<{
		__typename?: 'CardRequest'
		id: string
		status: CardRequestStatus
		deliveryMethod: CardRequestDeliveryMethod
		sentTo: string
		sentAt?: any | null
		viewedAt?: any | null
		savedAt?: any | null
		expiresAt: any
		failureReason?: string | null
		paymentMethodId?: string | null
		clientId: string
		pimsClientId?: string | null
		createdAt: any
		consolidatedPractice?: {
			__typename?: 'ConsolidatedPracticeSummary'
			id: string
			name?: string | null
			consolidatorReferenceCode?: string | null
		} | null
	}>
}

export type CardRequestsWithCountQueryVariables = Exact<{
	skip: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CardRequestOrderByInput> | CardRequestOrderByInput>
	where?: InputMaybe<CardRequestWhereInput>
}>

export type CardRequestsWithCountQuery = {
	__typename?: 'Query'
	cardRequestsWithCount: {
		__typename?: 'CardRequestListWithCount'
		total: number
		items: Array<{
			__typename?: 'CardRequest'
			id: string
			status: CardRequestStatus
			deliveryMethod: CardRequestDeliveryMethod
			sentTo: string
			sentAt?: any | null
			viewedAt?: any | null
			savedAt?: any | null
			expiresAt: any
			failureReason?: string | null
			paymentMethodId?: string | null
			clientId: string
			pimsClientId?: string | null
			createdAt: any
			consolidatedPractice?: {
				__typename?: 'ConsolidatedPracticeSummary'
				id: string
				name?: string | null
				consolidatorReferenceCode?: string | null
			} | null
		}>
	}
}

export type BulkPracticeImportsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<BulkPracticeImportOrderByInput> | BulkPracticeImportOrderByInput>
	where?: InputMaybe<BulkPracticeImportWhereInput>
}>

export type BulkPracticeImportsQuery = {
	__typename?: 'Query'
	bulkPracticeImports: {
		__typename?: 'BulkPracticeImportListWithCount'
		total: number
		items: Array<{
			__typename?: 'BulkPracticeImport'
			id: string
			status: string
			fileName: string
			importedBy: string
			totalRows: number
			summary?: any | null
			createdAt: any
			completedAt?: any | null
		}>
	}
}

export type BulkPracticeImportQueryVariables = Exact<{
	id: Scalars['String']['input']
}>

export type BulkPracticeImportQuery = {
	__typename?: 'Query'
	bulkPracticeImport?: {
		__typename?: 'BulkPracticeImport'
		id: string
		status: string
		fileName: string
		importedBy: string
		totalRows: number
		preview?: any | null
		results?: any | null
		summary?: any | null
		createdAt: any
		completedAt?: any | null
	} | null
}

export type BusinessVerificationSubmissionsQueryVariables = Exact<{
	statuses?: InputMaybe<Array<BusinessVerificationStatus> | BusinessVerificationStatus>
	consolidatedPracticeId?: InputMaybe<Scalars['String']['input']>
	submittedFrom?: InputMaybe<Scalars['DateTime']['input']>
	submittedTo?: InputMaybe<Scalars['DateTime']['input']>
	sortDirection?: InputMaybe<SortOrder>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type BusinessVerificationSubmissionsQuery = {
	__typename?: 'Query'
	businessVerificationSubmissions: {
		__typename?: 'BusinessVerificationSubmissionListWithCount'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'BusinessVerificationSubmission'
			id: string
			consolidatedPracticeId: string
			status: BusinessVerificationStatus
			source: BusinessVerificationSource
			verificationMethod: BusinessVerificationMethod
			legalBusinessName?: string | null
			einLast4?: string | null
			irsDocUrl?: string | null
			irsDocName?: string | null
			w9Url?: string | null
			w9Name?: string | null
			submittedAt: any
			reviewedAt?: any | null
			reviewedBy?: string | null
			failureReason?: string | null
			reviewerNotes?: string | null
			consolidatedPractice: {
				__typename?: 'BusinessVerificationSubmissionPractice'
				id: string
				name?: string | null
				paymentId?: string | null
				lendingId?: number | null
			}
		}>
	}
}

export type BusinessVerificationSubmissionQueryVariables = Exact<{
	id: Scalars['String']['input']
}>

export type BusinessVerificationSubmissionQuery = {
	__typename?: 'Query'
	businessVerificationSubmission: {
		__typename?: 'BusinessVerificationSubmissionDetail'
		id: string
		consolidatedPracticeId: string
		status: BusinessVerificationStatus
		source: BusinessVerificationSource
		verificationMethod: BusinessVerificationMethod
		legalBusinessName?: string | null
		ein?: string | null
		einLast4?: string | null
		irsDocUrl?: string | null
		irsDocName?: string | null
		w9Url?: string | null
		w9Name?: string | null
		submittedAt: any
		reviewedAt?: any | null
		reviewedBy?: string | null
		failureReason?: string | null
		reviewerNotes?: string | null
		consolidatedPractice: {
			__typename?: 'BusinessVerificationSubmissionPractice'
			id: string
			name?: string | null
			paymentId?: string | null
			lendingId?: number | null
			email?: string | null
			legalBusinessName?: string | null
			businessVerificationStatus?: BusinessVerificationStatus | null
		}
	}
}

export type CreateCashDepositMutationVariables = Exact<{
	reportedDepositAmount: Scalars['Int']['input']
	plannedDepositDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	dtsTrackingNumber?: InputMaybe<Scalars['String']['input']>
	cashSalesDate: Scalars['DateTimeISO']['input']
	cashDrawers: Array<CreateCashDrawerArgs> | CreateCashDrawerArgs
}>

export type CreateCashDepositMutation = {
	__typename?: 'Mutation'
	createCashDeposit: {
		__typename?: 'CashDeposit'
		id: string
		consolidatedPracticeId: string
		reportedDepositAmount: number
		dtsTrackingNumber?: string | null
		cashSalesDate: any
		cashDrawers?: Array<{
			__typename?: 'CashDrawer'
			cashDrawerIdentifier: string
			reportedCashCount: number
			reconciliationNote?: string | null
		}> | null
	}
}

export type ListCashDepositsQueryVariables = Exact<{
	where?: InputMaybe<CashDepositWhereInput>
	orderBy?: InputMaybe<Array<CashDepositOrderByInput> | CashDepositOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListCashDepositsQuery = {
	__typename?: 'Query'
	listCashDeposits: Array<{
		__typename?: 'CashDeposit'
		id: string
		reportedDepositAmount: number
		plannedDepositDate?: any | null
		dtsTrackingNumber?: string | null
		cashSalesDate: any
		consolidatedPracticeId: string
		consolidatorId?: string | null
		createdAt: any
		consolidatedPractice: {
			__typename?: 'ConsolidatedPractice'
			name?: string | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			consolidatorReferenceCode3?: string | null
		}
		createdByUser: { __typename?: 'User'; email?: string | null }
		cashDrawers?: Array<{
			__typename?: 'CashDrawer'
			cashDrawerIdentifier: string
			reportedCashCount: number
			reconciliationNote?: string | null
		}> | null
	}>
}

export type ListCashDepositsWithCountQueryVariables = Exact<{
	where?: InputMaybe<CashDepositWhereInput>
	orderBy?: InputMaybe<Array<CashDepositOrderByInput> | CashDepositOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListCashDepositsWithCountQuery = {
	__typename?: 'Query'
	listCashDepositsWithCount: {
		__typename?: 'CashDepositListWithCount'
		total: number
		items: Array<{
			__typename?: 'CashDeposit'
			id: string
			reportedDepositAmount: number
			plannedDepositDate?: any | null
			dtsTrackingNumber?: string | null
			cashSalesDate: any
			consolidatedPracticeId: string
			createdAt: any
			consolidatorId?: string | null
			consolidatedPractice: {
				__typename?: 'ConsolidatedPractice'
				name?: string | null
				consolidatorReferenceCode?: string | null
				consolidatorReferenceCode2?: string | null
				consolidatorReferenceCode3?: string | null
			}
			createdByUser: { __typename?: 'User'; email?: string | null }
			cashDrawers?: Array<{
				__typename?: 'CashDrawer'
				cashDrawerIdentifier: string
				reportedCashCount: number
				reconciliationNote?: string | null
			}> | null
		}>
	}
}

export type ListCashDrawersQueryVariables = Exact<{
	where?: InputMaybe<CashDrawerWhereInput>
	orderBy?: InputMaybe<Array<CashDrawerOrderByInput> | CashDrawerOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListCashDrawersQuery = {
	__typename?: 'Query'
	listCashDrawers: Array<{
		__typename?: 'CashDrawer'
		id: string
		cashDrawerIdentifier: string
		reportedCashCount: number
		reconciliationNote?: string | null
		cashDepositId: string
		cashSalesDate: any
		consolidatedPracticeId: string
		createdAt: any
		consolidatedPractice: {
			__typename?: 'ConsolidatedPractice'
			name?: string | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			consolidatorReferenceCode3?: string | null
		}
		createdByUser: { __typename?: 'User'; email?: string | null }
	}>
}

export type ListCashDrawersWithCountQueryVariables = Exact<{
	where?: InputMaybe<CashDrawerWhereInput>
	orderBy?: InputMaybe<Array<CashDrawerOrderByInput> | CashDrawerOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListCashDrawersWithCountQuery = {
	__typename?: 'Query'
	listCashDrawersWithCount: {
		__typename?: 'CashDrawerListWithCount'
		total: number
		items: Array<{
			__typename?: 'CashDrawer'
			id: string
			cashDrawerIdentifier: string
			reportedCashCount: number
			reconciliationNote?: string | null
			cashDepositId: string
			cashSalesDate: any
			consolidatedPracticeId: string
			createdAt: any
			consolidatedPractice: {
				__typename?: 'ConsolidatedPractice'
				name?: string | null
				consolidatorReferenceCode?: string | null
				consolidatorReferenceCode2?: string | null
				consolidatorReferenceCode3?: string | null
			}
			createdByUser: { __typename?: 'User'; email?: string | null }
		}>
	}
}

export type UpdateConsolidatedPracticeStatusMutationVariables = Exact<{
	id: Scalars['String']['input']
	processType?: InputMaybe<Scalars['String']['input']>
	processStatus?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateConsolidatedPracticeStatusMutation = {
	__typename?: 'Mutation'
	updateConsolidatedPracticeStatus: {
		__typename?: 'ConsolidatedPractice'
		id: string
		status?: any | null
	}
}

export type GetConsolidatedPracticesSlimQueryVariables = Exact<{
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
	orderBy?: InputMaybe<Array<ConsolidatedPracticeOrderByInput> | ConsolidatedPracticeOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetConsolidatedPracticesSlimQuery = {
	__typename?: 'Query'
	consolidatedPractices: {
		__typename?: 'ConsolidatedPracticeListWithCount'
		total: number
		items: Array<{
			__typename?: 'ConsolidatedPractice'
			id: string
			paymentId?: string | null
			lendingId?: number | null
			name?: string | null
			consolidatorId?: string | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			regionalManagerId?: string | null
			logoUrl?: string | null
			city?: string | null
			state?: string | null
			country?: string | null
			isActive?: boolean | null
			terminalLocation?: string | null
		}>
	}
}

export type GetConsolidatedPracticesQueryVariables = Exact<{
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
	orderBy?: InputMaybe<Array<ConsolidatedPracticeOrderByInput> | ConsolidatedPracticeOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetConsolidatedPracticesQuery = {
	__typename?: 'Query'
	consolidatedPractices: {
		__typename?: 'ConsolidatedPracticeListWithCount'
		total: number
		items: Array<{
			__typename?: 'ConsolidatedPractice'
			id: string
			paymentId?: string | null
			lendingId?: number | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			consolidatorReferenceCode3?: string | null
			isPaymentEnabled?: boolean | null
			isLendingEnabled?: boolean | null
			isRebateEnabled?: boolean | null
			isActive?: boolean | null
			isDeleted?: boolean | null
			name?: string | null
			legalBusinessName?: string | null
			consolidatorId?: string | null
			address?: string | null
			address2?: string | null
			email?: string | null
			signerEmail?: string | null
			signerName?: string | null
			phone?: string | null
			city?: string | null
			state?: string | null
			zip?: string | null
			country?: string | null
			currency?: string | null
			timezone?: string | null
			settings?: any | null
			pimsMetadata?: any | null
			activeTerminalsCount?: number | null
			totalTerminalsCount?: number | null
			terminalLocation?: string | null
			hospitalManagerEmail?: string | null
			website?: string | null
			regionalManagerId?: string | null
			surchargeEnabled?: boolean | null
			surchargeFeePct?: number | null
			surchargeStartDate?: any | null
			transactionFees?: any | null
			integrationId?: string | null
			netsuiteId?: string | null
			skyworldId?: string | null
			logoUrl?: string | null
			isCustomPayoutEnabled?: boolean | null
			customPayoutTarget?: string | null
			customPayoutSettings?: any | null
			customPayoutRunAtTime?: any | null
			customPayoutStartedAt?: any | null
			createdAt?: any | null
			updatedAt?: any | null
			consolidator?: { __typename?: 'Consolidator'; id: string; featureFlags?: any | null } | null
		}>
	}
}

export type UpsertConsolidatedPracticeMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	legalBusinessName?: InputMaybe<Scalars['String']['input']>
	address?: InputMaybe<Scalars['String']['input']>
	address2?: InputMaybe<Scalars['String']['input']>
	city?: InputMaybe<Scalars['String']['input']>
	state?: InputMaybe<Scalars['String']['input']>
	zip?: InputMaybe<Scalars['String']['input']>
	country?: InputMaybe<Scalars['String']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	paymentId?: InputMaybe<Scalars['String']['input']>
	lendingId?: InputMaybe<Scalars['Int']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	signerName?: InputMaybe<Scalars['String']['input']>
	signerEmail?: InputMaybe<Scalars['String']['input']>
	isDeleted?: InputMaybe<Scalars['Boolean']['input']>
	isLendingEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>
	isRebateEnabled?: InputMaybe<Scalars['Boolean']['input']>
	consolidatorId?: InputMaybe<Scalars['String']['input']>
	timezone?: InputMaybe<Scalars['String']['input']>
	pimsMetadata?: InputMaybe<Scalars['JSON']['input']>
	settings?: InputMaybe<Scalars['JSON']['input']>
}>

export type UpsertConsolidatedPracticeMutation = {
	__typename?: 'Mutation'
	upsertConsolidatedPractice: {
		__typename?: 'ConsolidatedPractice'
		id: string
		name?: string | null
		legalBusinessName?: string | null
		city?: string | null
		state?: string | null
		country?: string | null
		isLendingEnabled?: boolean | null
		isPaymentEnabled?: boolean | null
		isRebateEnabled?: boolean | null
		createdAt?: any | null
		updatedAt?: any | null
	}
}

export type UpsertConsolidatedPracticeBankAccountMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	consolidatedPracticeId?: InputMaybe<Scalars['String']['input']>
	accountNumber?: InputMaybe<Scalars['String']['input']>
	routingNumber?: InputMaybe<Scalars['String']['input']>
	accountHolderName?: InputMaybe<Scalars['String']['input']>
	accountHolderType?: InputMaybe<Scalars['String']['input']>
	bankName?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<BankAccountStatus>
	usedForProduct?: InputMaybe<Array<ScratchProduct> | ScratchProduct>
	stripeBankAccountId?: InputMaybe<Scalars['String']['input']>
	stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>
	stripeCustomerId?: InputMaybe<Scalars['String']['input']>
	stripePlatformAccountId?: InputMaybe<Scalars['String']['input']>
	metadata?: InputMaybe<Scalars['JSON']['input']>
	disabledReason?: InputMaybe<Scalars['String']['input']>
}>

export type UpsertConsolidatedPracticeBankAccountMutation = {
	__typename?: 'Mutation'
	upsertConsolidatedPracticeBankAccount: {
		__typename?: 'ConsolidatedPracticeBankAccount'
		id: string
		consolidatedPracticeId: string
		accountNumber: string
		routingNumber: string
		accountHolderName: string
		accountHolderType: string
		bankName?: string | null
		status: BankAccountStatus
		usedForProduct: Array<ScratchProduct>
		stripeBankAccountId?: string | null
		stripePaymentMethodId?: string | null
		stripeCustomerId?: string | null
		stripePlatformAccountId?: string | null
		metadata?: any | null
		enabledAt?: any | null
		enabledByUserId?: string | null
		disabledAt?: any | null
		disabledByUserId?: string | null
		disabledReason?: string | null
		createdAt?: any | null
		updatedAt?: any | null
	}
}

export type GetConsolidatedPracticesAndBankAccountsQueryVariables = Exact<{
	wherePractices?: InputMaybe<ConsolidatedPracticeWhereInput>
	orderByPractices?: InputMaybe<
		Array<ConsolidatedPracticeOrderByInput> | ConsolidatedPracticeOrderByInput
	>
	skipPractices?: InputMaybe<Scalars['Int']['input']>
	takePractices?: InputMaybe<Scalars['Int']['input']>
	consolidatedPracticeId: Scalars['String']['input']
	whereBankAccounts?: InputMaybe<ConsolidatedPracticeBankAccountWhereInput>
	orderByBankAccounts?: InputMaybe<ConsolidatedPracticeBankAccountOrderByInput>
	skipBankAccounts?: InputMaybe<Scalars['Int']['input']>
	takeBankAccounts?: InputMaybe<Scalars['Int']['input']>
}>

export type GetConsolidatedPracticesAndBankAccountsQuery = {
	__typename?: 'Query'
	consolidatedPractices: {
		__typename?: 'ConsolidatedPracticeListWithCount'
		total: number
		items: Array<{
			__typename?: 'ConsolidatedPractice'
			id: string
			paymentId?: string | null
			lendingId?: number | null
			isPaymentEnabled?: boolean | null
			isLendingEnabled?: boolean | null
			isRebateEnabled?: boolean | null
			isDeleted?: boolean | null
			name?: string | null
			legalBusinessName?: string | null
			consolidatorId?: string | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			consolidatorReferenceCode3?: string | null
			address?: string | null
			address2?: string | null
			email?: string | null
			signerEmail?: string | null
			signerName?: string | null
			phone?: string | null
			city?: string | null
			state?: string | null
			zip?: string | null
			country?: string | null
			currency?: string | null
			timezone?: string | null
			website?: string | null
			hospitalManagerEmail?: string | null
			regionalManagerId?: string | null
			createdAt?: any | null
			updatedAt?: any | null
			pimsMetadata?: any | null
		}>
	}
	practiceBankAccounts: {
		__typename?: 'ConsolidatedPracticeBankAccountListWithCount'
		total: number
		items: Array<{
			__typename?: 'ConsolidatedPracticeBankAccount'
			id: string
			consolidatedPracticeId: string
			accountNumber: string
			routingNumber: string
			accountHolderName: string
			accountHolderType: string
		}>
	}
}

export type GetPracticeBankAccountsQueryVariables = Exact<{
	consolidatedPracticeId: Scalars['String']['input']
	whereBankAccounts?: InputMaybe<ConsolidatedPracticeBankAccountWhereInput>
	orderByBankAccounts?: InputMaybe<ConsolidatedPracticeBankAccountOrderByInput>
	skipBankAccounts?: InputMaybe<Scalars['Int']['input']>
	takeBankAccounts?: InputMaybe<Scalars['Int']['input']>
}>

export type GetPracticeBankAccountsQuery = {
	__typename?: 'Query'
	practiceBankAccounts: {
		__typename?: 'ConsolidatedPracticeBankAccountListWithCount'
		total: number
		items: Array<{
			__typename?: 'ConsolidatedPracticeBankAccount'
			id: string
			consolidatedPracticeId: string
			accountNumber: string
			routingNumber: string
			accountHolderName: string
			accountHolderType: string
		}>
	}
}

export type SearchConsolidatedPracticesForPayoutQueryVariables = Exact<{
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchConsolidatedPracticesForPayoutQuery = {
	__typename?: 'Query'
	consolidatedPractices: {
		__typename?: 'ConsolidatedPracticeListWithCount'
		items: Array<{
			__typename?: 'ConsolidatedPractice'
			id: string
			paymentId?: string | null
			lendingId?: number | null
			name?: string | null
			consolidatorId?: string | null
			timezone?: string | null
			isCustomPayoutEnabled?: boolean | null
			customPayoutTarget?: string | null
			customPayoutSettings?: any | null
		}>
	}
}

export type ListConsolidatedPracticesDirectoryQueryVariables = Exact<{
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type ListConsolidatedPracticesDirectoryQuery = {
	__typename?: 'Query'
	consolidatedPractices: {
		__typename?: 'ConsolidatedPracticeListWithCount'
		total: number
		items: Array<{
			__typename?: 'ConsolidatedPractice'
			id: string
			paymentId?: string | null
			name?: string | null
			consolidatorId?: string | null
			pimsMetadata?: any | null
		}>
	}
}

export type GetConsolidatorsQueryVariables = Exact<{
	skip: Scalars['Int']['input']
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ConsolidatorOrderByInput> | ConsolidatorOrderByInput>
	where?: InputMaybe<ConsolidatorWhereInput>
}>

export type GetConsolidatorsQuery = {
	__typename?: 'Query'
	consolidators: Array<{
		__typename?: 'Consolidator'
		id: string
		name?: string | null
		mcc?: string | null
		timezone?: string | null
		ownerLastFour?: string | null
		customFields?: any | null
		customization?: any | null
		featureFlags?: any | null
		financingFlags?: any | null
		canadaAccountInfo?: any | null
	}>
}

export type ConsolidatorFeatureFlagQueryVariables = Exact<{
	name: Scalars['String']['input']
}>

export type ConsolidatorFeatureFlagQuery = {
	__typename?: 'Query'
	consolidatorFeatureFlag: boolean
}

export type ListCustomPayoutDetailsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CustomPayoutDetailsOrderByInput> | CustomPayoutDetailsOrderByInput>
	where?: InputMaybe<CustomPayoutDetailsWhereInput>
}>

export type ListCustomPayoutDetailsQuery = {
	__typename?: 'Query'
	listCustomPayoutDetails: {
		__typename?: 'CustomPayoutDetailList'
		skip: number
		take?: number | null
		total: number
		items: Array<{
			__typename?: 'CustomPayoutDetails'
			id: string
			payoutEstimatedArrivalAt?: any | null
			practiceConsolidatorReferenceCode?: string | null
			practiceConsolidatorReferenceCode2?: string | null
			practiceName?: string | null
			transactionAmount?: number | null
			transactionFee?: number | null
			baseTransactionFee?: number | null
			savedPaymentMethodFee?: number | null
			transactionNet?: number | null
			paymentIntentId?: string | null
			transactionDate?: any | null
			transactionType: CustomPayoutTransactionType
			paymentType?: string | null
			cardBrand?: string | null
			cardFunding?: string | null
			cardholderName?: string | null
			payoutDescription?: string | null
			payoutStatementDescriptor?: string | null
			payoutReference?: string | null
			stripePayoutId?: string | null
			practiceId?: string | null
			customPayoutPracticeBatchId?: string | null
			customPayoutConsolidatorBatchId?: string | null
			consolidatorId?: string | null
			pimsClientId?: string | null
			currency: string
			lockboxId?: string | null
			createdAt?: any | null
			surchargeFee?: number | null
			tipAmount?: number | null
			practiceNetsuiteId?: string | null
			practiceSkyworldId?: string | null
			scratchPaymentMethod?: string | null
			scratchPaymentRequestType?: string | null
			savedPaymentMethod?: boolean | null
		}>
	}
}

export type SumCustomPayoutDetailsByCardBrandQueryVariables = Exact<{
	where?: InputMaybe<CustomPayoutDetailsWhereInput>
}>

export type SumCustomPayoutDetailsByCardBrandQuery = {
	__typename?: 'Query'
	sumCustomPayoutDetailsByCardBrand: {
		__typename?: 'CustomPayoutDetailsSumByCardBrandList'
		items: Array<{
			__typename?: 'CustomPayoutDetails'
			cardBrand?: string | null
			transactionAmount?: number | null
			transactionFee?: number | null
			transactionNet?: number | null
			tipAmount?: number | null
		}>
	}
}

export type ListPayoutsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<
		Array<CustomPayoutPracticeBatchOrderByInput> | CustomPayoutPracticeBatchOrderByInput
	>
	where?: InputMaybe<CustomPayoutPracticeBatchWhereInput>
}>

export type ListPayoutsQuery = {
	__typename?: 'Query'
	listPayouts: {
		__typename?: 'PayoutList'
		skip: number
		take?: number | null
		total: number
		items: Array<{
			__typename?: 'Payout'
			id: string
			paymentAmount?: number | null
			paymentApplicationFee?: number | null
			refundAmount?: number | null
			disputeAmount?: number | null
			disputeFee?: number | null
			refundApplicationFee?: number | null
			payoutAmount?: number | null
			payoutEstimatedArrivalAt?: any | null
			startWindowDate?: any | null
			stripePayoutId?: string | null
			description?: string | null
			statementDescriptor?: string | null
			payoutReference?: string | null
			surchargeFee: number
			tipAmount?: number | null
			refundedTipAmount?: number | null
			donationAmount?: number | null
			notes?: string | null
			practice: {
				__typename?: 'CustomPayoutPractice'
				id: string
				name: string
				consolidatorReferenceCode?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
			}
			consolidatedPractice?: {
				__typename?: 'ConsolidatedPracticeSummary'
				id: string
				name?: string | null
				consolidatorReferenceCode?: string | null
				consolidatorReferenceCode2?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
				pimsMetadata?: any | null
				paymentId?: string | null
			} | null
		}>
	}
}

export type GetDailyTotalsQueryVariables = Exact<{
	where?: InputMaybe<DailyTotalsWhereInput>
	includePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetDailyTotalsQuery = {
	__typename?: 'Query'
	dailyTotals: {
		__typename?: 'DailyTotalsResponse'
		byCard: Array<{
			__typename?: 'DailyTotalsByCard'
			cardBrand: string
			scratchPaymentMethod?: string | null
			sumPayments: any
			sumRefunds: any
			total: any
		}>
		byPaymentType: Array<{
			__typename?: 'DailyTotalsByType'
			paymentType: string
			sumPayments: any
			sumRefunds: any
			total: any
		}>
	}
}

export type GetStripeDisputesQueryVariables = Exact<{
	take?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<StripeDisputeWhereInput>
}>

export type GetStripeDisputesQuery = {
	__typename?: 'Query'
	stripeDisputes: {
		__typename?: 'StripeDisputeWithCount'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'StripeDispute'
			id: string
			practiceId: string
			amount: number
			last4?: string | null
			evidenceDetails?: any | null
			cardholderName?: string | null
			disputeFee?: number | null
			disputeTotal?: number | null
			lostAt?: any | null
			reason?: string | null
			practiceFundsWithdrawalAt?: any | null
			currency?: string | null
			status?: string | null
			stripeStatus?: string | null
			createdAt: any
			charge?: {
				__typename?: 'StripeCharge'
				amount: number
				capturedAt?: any | null
				transferDestinationPaymentId?: string | null
			} | null
		}>
	}
}

export type GetStripeDisputeDetailsQueryVariables = Exact<{
	id: Scalars['String']['input']
}>

export type GetStripeDisputeDetailsQuery = {
	__typename?: 'Query'
	stripeDisputeDetails: {
		__typename?: 'StripeDisputeDetails'
		id: string
		consolidatedPracticeId?: string | null
		currency: string
		paymentAmount?: number | null
		paymentSucceededAt?: any | null
		disputedAmount: number
		cardholderName?: string | null
		cardholderEmail?: string | null
		reason: string
		networkReasonCode?: string | null
		stripeStatus: string
		status?: string | null
		receivedAt: any
		decidedAt?: any | null
		evidenceSubmittedAt?: any | null
		lostDisputeFee?: number | null
		paymentMethod?: {
			__typename?: 'StripeDisputePaymentMethod'
			type?: string | null
			brand?: string | null
			last4?: string | null
			funding?: string | null
			expMonth?: number | null
			expYear?: number | null
			country?: string | null
			cvcCheck?: string | null
			postalCodeCheck?: string | null
			readMethod?: string | null
			billingAddress?: string | null
		} | null
		chargebackClaim?: {
			__typename?: 'StripeDisputeIssuerEvidence'
			text?: string | null
			files: Array<{ __typename?: 'StripeDisputeFile'; fileId: string }>
		} | null
		bankResponse?: {
			__typename?: 'StripeDisputeIssuerEvidence'
			text?: string | null
			files: Array<{ __typename?: 'StripeDisputeFile'; fileId: string }>
		} | null
		submittedEvidence: Array<{
			__typename?: 'StripeDisputeEvidenceFile'
			fileId: string
			fileName?: string | null
			categoryLabel: string
		}>
	}
}

export type GridConsolidatedPracticeFragment = {
	__typename?: 'ConsolidatedPractice'
	id: string
	name?: string | null
	consolidatorReferenceCode?: string | null
	consolidatorReferenceCode2?: string | null
	consolidatorReferenceCode3?: string | null
	netsuiteId?: string | null
	skyworldId?: string | null
	pimsMetadata?: any | null
	logoUrl?: string | null
	paymentId?: string | null
	lendingId?: number | null
	industryProgramMetadata?: any | null
}

export type GridConsolidatedPracticeSummaryFragment = {
	__typename?: 'ConsolidatedPracticeSummary'
	id: string
	name?: string | null
	consolidatorReferenceCode?: string | null
	consolidatorReferenceCode2?: string | null
	netsuiteId?: string | null
	skyworldId?: string | null
	pimsMetadata?: any | null
	paymentId?: string | null
}

export type GridConsolidatedPracticeIndustryProgramFragment = {
	__typename?: 'ConsolidatedPracticeIndustryProgramSummary'
	id: string
	logoUrl?: string | null
	industryProgramMetadata?: any | null
}

export type ListPartnersQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PartnerOrderByInput> | PartnerOrderByInput>
	where?: InputMaybe<PartnerWhereInput>
}>

export type ListPartnersQuery = {
	__typename?: 'Query'
	listPartners: {
		__typename?: 'PartnerList'
		total: number
		items: Array<{
			__typename?: 'Partner'
			id: string
			name: string
			consolidatorId?: string | null
		}>
	}
}

export type PaymentHistoryQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput> | PaymentHistoryOrderByInput>
	where?: InputMaybe<PaymentHistoryWhereInput>
}>

export type PaymentHistoryQuery = {
	__typename?: 'Query'
	paymentHistories: Array<{
		__typename?: 'PaymentHistory'
		amount?: number | null
		amountDue?: number | null
		amountCaptured?: number | null
		amountCapturable?: number | null
		amountReceived?: number | null
		amountRefunded?: number | null
		amountWithoutSurcharge?: number | null
		applicationId?: string | null
		canceledAt?: any | null
		cancellationReason?: string | null
		captureMethod?: string | null
		cardBrand?: string | null
		cardType?: string | null
		cardholderName?: string | null
		charges?: any | null
		chargeId?: string | null
		clinicName?: string | null
		confirmationMethod?: string | null
		consolidatorReferenceCode?: string | null
		consolidatorReferenceCode2?: string | null
		createdAt: any
		createdByEmail?: string | null
		createdByUser?: string | null
		currency: string
		customerId?: string | null
		customerName?: string | null
		dateToFilter?: any | null
		description?: string | null
		failureCode?: string | null
		failureReason?: string | null
		id: string
		invoiceId?: string | null
		lockboxId?: string | null
		last4?: string | null
		metadata?: any | null
		notes?: any | null
		object?: string | null
		originalChargeAmountDue?: number | null
		originalChargeDate?: any | null
		paymentMethodId?: string | null
		paymentMethodOptions?: any | null
		paymentMethodType?: string | null
		pimsClientId?: string | null
		pimsInvoiceId?: string | null
		practiceId: string
		scratchPaymentMethod?: string | null
		scratchPaymentRequestType?: string | null
		status: string
		transactionStatus: string
		subscriptionId?: string | null
		subscriptionScheduleId?: string | null
		succeededAt?: any | null
		surcharge?: boolean | null
		surchargeFee?: number | null
		donationAmount: number
		baseAmount?: number | null
		tipAmount?: number | null
		refundedTipAmount?: number | null
		updatedAt: any
		disputed?: boolean | null
		disputeId?: string | null
		disputeStatus?: string | null
	}>
}

export type PaymentHistoryWithCountQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput> | PaymentHistoryOrderByInput>
	where?: InputMaybe<PaymentHistoryWhereInput>
}>

export type PaymentHistoryWithCountQuery = {
	__typename?: 'Query'
	paymentHistoriesWithCount: {
		__typename?: 'PaymentHistoryListWithCount'
		total: number
		items: Array<{
			__typename?: 'PaymentHistory'
			amount?: number | null
			amountDue?: number | null
			amountCaptured?: number | null
			amountCapturable?: number | null
			amountReceived?: number | null
			amountRefunded?: number | null
			amountWithoutSurcharge?: number | null
			applicationId?: string | null
			canceledAt?: any | null
			cancellationReason?: string | null
			captureMethod?: string | null
			cardBrand?: string | null
			cardType?: string | null
			cardholderName?: string | null
			charges?: any | null
			chargeId?: string | null
			clinicName?: string | null
			confirmationMethod?: string | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			createdAt: any
			createdByEmail?: string | null
			createdByUser?: string | null
			currency: string
			customerId?: string | null
			customerName?: string | null
			dateToFilter?: any | null
			description?: string | null
			failureCode?: string | null
			failureReason?: string | null
			id: string
			invoiceId?: string | null
			lockboxId?: string | null
			last4?: string | null
			metadata?: any | null
			notes?: any | null
			object?: string | null
			originalChargeAmountDue?: number | null
			originalChargeDate?: any | null
			paymentMethodId?: string | null
			paymentMethodOptions?: any | null
			paymentMethodType?: string | null
			pimsClientId?: string | null
			pimsInvoiceId?: string | null
			practiceId: string
			scratchPaymentMethod?: string | null
			scratchPaymentRequestType?: string | null
			status: string
			transactionStatus: string
			subscriptionId?: string | null
			subscriptionScheduleId?: string | null
			succeededAt?: any | null
			surcharge?: boolean | null
			surchargeFee?: number | null
			donationAmount: number
			baseAmount?: number | null
			tipAmount?: number | null
			refundedTipAmount?: number | null
			updatedAt: any
			disputed?: boolean | null
			disputeId?: string | null
			disputeStatus?: string | null
		}>
	}
}

export type PaymentHistoryForManualPayoutQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput> | PaymentHistoryOrderByInput>
	where?: InputMaybe<PaymentHistoryWhereInput>
}>

export type PaymentHistoryForManualPayoutQuery = {
	__typename?: 'Query'
	paymentHistoriesWithCount: {
		__typename?: 'PaymentHistoryListWithCount'
		total: number
		items: Array<{
			__typename?: 'PaymentHistory'
			id: string
			object?: string | null
			chargeId?: string | null
			dateToFilter?: any | null
			customerName?: string | null
			amountCaptured?: number | null
			paymentMethodType?: string | null
			cardBrand?: string | null
			last4?: string | null
			status: string
			transactionStatus: string
			invoiceId?: string | null
			payoutDescription?: string | null
			stripePayoutiD?: string | null
		}>
	}
}

export type PaymentHistoryListWithSummaryQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput> | PaymentHistoryOrderByInput>
	where?: InputMaybe<PaymentHistoryWhereInput>
}>

export type PaymentHistoryListWithSummaryQuery = {
	__typename?: 'Query'
	paymentHistoriesWithSummary: {
		__typename?: 'PaymentHistoryListWithSummary'
		items: Array<{
			__typename?: 'PaymentHistory'
			amount?: number | null
			amountDue?: number | null
			amountCaptured?: number | null
			amountCapturable?: number | null
			amountReceived?: number | null
			amountRefunded?: number | null
			amountWithoutSurcharge?: number | null
			applicationId?: string | null
			canceledAt?: any | null
			cancellationReason?: string | null
			captureMethod?: string | null
			cardBrand?: string | null
			cardType?: string | null
			cardholderName?: string | null
			charges?: any | null
			chargeId?: string | null
			clinicName?: string | null
			confirmationMethod?: string | null
			consolidatorReferenceCode?: string | null
			consolidatorReferenceCode2?: string | null
			createdAt: any
			createdByEmail?: string | null
			createdByUser?: string | null
			currency: string
			customerId?: string | null
			customerName?: string | null
			dateToFilter?: any | null
			description?: string | null
			failureCode?: string | null
			failureReason?: string | null
			id: string
			invoiceId?: string | null
			lockboxId?: string | null
			last4?: string | null
			metadata?: any | null
			notes?: any | null
			object?: string | null
			originalChargeAmountDue?: number | null
			originalChargeDate?: any | null
			paymentMethodId?: string | null
			paymentMethodOptions?: any | null
			paymentMethodType?: string | null
			pimsClientId?: string | null
			pimsInvoiceId?: string | null
			practiceId: string
			scratchPaymentMethod?: string | null
			scratchPaymentRequestType?: string | null
			status: string
			transactionStatus: string
			subscriptionId?: string | null
			subscriptionScheduleId?: string | null
			succeededAt?: any | null
			surcharge?: boolean | null
			surchargeFee?: number | null
			donationAmount: number
			baseAmount?: number | null
			tipAmount?: number | null
			refundedTipAmount?: number | null
			updatedAt: any
			disputed?: boolean | null
			disputeId?: string | null
			disputeStatus?: string | null
		}>
		summary: {
			__typename?: 'PaymentHistorySummary'
			count: number
			totalAmount?: any | null
			totalRefunded?: any | null
			totalFailed?: any | null
			totalPaid?: any | null
			totalPending?: any | null
			totalUncaptured?: any | null
			totalFailedECheck?: any | null
			totalReturnedECheck?: any | null
		}
	}
}

export type PaymentHistoryWithoutChargesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentHistoryOrderByInput> | PaymentHistoryOrderByInput>
	where?: InputMaybe<PaymentHistoryWhereInput>
}>

export type PaymentHistoryWithoutChargesQuery = {
	__typename?: 'Query'
	paymentHistories: Array<{
		__typename?: 'PaymentHistory'
		amount?: number | null
		amountDue?: number | null
		amountCaptured?: number | null
		amountCapturable?: number | null
		amountReceived?: number | null
		amountRefunded?: number | null
		amountWithoutSurcharge?: number | null
		applicationId?: string | null
		canceledAt?: any | null
		cancellationReason?: string | null
		captureMethod?: string | null
		cardBrand?: string | null
		cardType?: string | null
		cardholderName?: string | null
		clinicName?: string | null
		confirmationMethod?: string | null
		consolidatorReferenceCode?: string | null
		consolidatorReferenceCode2?: string | null
		createdAt: any
		createdByEmail?: string | null
		createdByUser?: string | null
		currency: string
		customerId?: string | null
		customerName?: string | null
		dateToFilter?: any | null
		description?: string | null
		failureCode?: string | null
		failureReason?: string | null
		id: string
		invoiceId?: string | null
		lockboxId?: string | null
		last4?: string | null
		metadata?: any | null
		notes?: any | null
		object?: string | null
		originalChargeAmountDue?: number | null
		originalChargeDate?: any | null
		paymentMethodId?: string | null
		paymentMethodOptions?: any | null
		paymentMethodType?: string | null
		pimsClientId?: string | null
		pimsInvoiceId?: string | null
		practiceId: string
		scratchPaymentMethod?: string | null
		scratchPaymentRequestType?: string | null
		status: string
		transactionStatus: string
		subscriptionId?: string | null
		subscriptionScheduleId?: string | null
		succeededAt?: any | null
		surcharge?: boolean | null
		surchargeFee?: number | null
		donationAmount: number
		baseAmount?: number | null
		tipAmount?: number | null
		refundedTipAmount?: number | null
		updatedAt: any
		disputed?: boolean | null
		disputeId?: string | null
		disputeStatus?: string | null
	}>
}

export type PaymentHistorySummaryQueryVariables = Exact<{
	where: PaymentHistoryWhereInput
}>

export type PaymentHistorySummaryQuery = {
	__typename?: 'Query'
	paymentHistorySummary: {
		__typename?: 'PaymentHistorySummary'
		count: number
		totalAmount?: any | null
		totalRefunded?: any | null
		totalFailed?: any | null
		totalPaid?: any | null
		totalPending?: any | null
		totalUncaptured?: any | null
		totalFailedECheck?: any | null
		totalReturnedECheck?: any | null
	}
}

export type RefundVisibilityQueryVariables = Exact<{
	refundId?: InputMaybe<Scalars['String']['input']>
	paymentIntentId?: InputMaybe<Scalars['String']['input']>
	amountRefundedBefore?: InputMaybe<Scalars['Int']['input']>
}>

export type RefundVisibilityQuery = { __typename?: 'Query'; refundVisibility: boolean }

export type PaymentRequestQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentRequestOrderByInput> | PaymentRequestOrderByInput>
	where?: InputMaybe<PaymentRequestWhereInput>
}>

export type PaymentRequestQuery = {
	__typename?: 'Query'
	paymentRequests: Array<{
		__typename?: 'PaymentRequest'
		amount: number
		consolidatorId?: string | null
		createdAt: any
		customerId?: string | null
		customerName?: string | null
		description?: string | null
		id: string
		metadata?: any | null
		pimsClientId?: string | null
		practiceId: string
		scratchPaymentMethod?: string | null
		status: string
		succeededAt?: any | null
		updatedAt: any
		canceledAt?: any | null
		paidSeparately?: boolean | null
		surchargeFee?: number | null
		amountWithoutSurcharge?: number | null
		practice: {
			__typename?: 'PaymentRequestPractice'
			id: string
			name: string
			consolidatorReferenceCode?: string | null
			netsuiteId?: string | null
			skyworldId?: string | null
		}
	}>
}

export type PaymentRequestWithSummaryQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentRequestOrderByInput> | PaymentRequestOrderByInput>
	where?: InputMaybe<PaymentRequestWhereInput>
}>

export type PaymentRequestWithSummaryQuery = {
	__typename?: 'Query'
	paymentRequestsWithSummary: {
		__typename?: 'PaymentRequestListWithSummary'
		total: number
		amountWithoutSurcharge?: any | null
		items: Array<{
			__typename?: 'PaymentRequest'
			amount: number
			consolidatorId?: string | null
			createdAt: any
			customerId?: string | null
			customerName?: string | null
			description?: string | null
			id: string
			metadata?: any | null
			pimsClientId?: string | null
			practiceId: string
			scratchPaymentMethod?: string | null
			status: string
			succeededAt?: any | null
			updatedAt: any
			canceledAt?: any | null
			paidSeparately?: boolean | null
			surchargeFee?: number | null
			amountWithoutSurcharge?: number | null
			practice: {
				__typename?: 'PaymentRequestPractice'
				id: string
				name: string
				consolidatorReferenceCode?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
			}
		}>
	}
}

export type UpdatePaymentRequestMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	arDeliveryMethod?: InputMaybe<Scalars['String']['input']>
	customerEmail?: InputMaybe<Scalars['String']['input']>
	customerPhone?: InputMaybe<Scalars['String']['input']>
}>

export type UpdatePaymentRequestMutation = {
	__typename?: 'Mutation'
	updatePaymentRequest: { __typename?: 'PaymentRequest'; id: string; metadata?: any | null }
}

export type ProcessUploadFileMutationVariables = Exact<{
	fileName: Scalars['String']['input']
}>

export type ProcessUploadFileMutation = {
	__typename?: 'Mutation'
	processUploadedFile: {
		__typename?: 'PaymentRequestFile'
		id: string
		fileName: string
		createdBy: string
		consolidatorId?: string | null
	}
}

export type VoidFileMutationVariables = Exact<{
	fileId: Scalars['String']['input']
}>

export type VoidFileMutation = {
	__typename?: 'Mutation'
	voidFile: { __typename?: 'VoidPaymentRequestFileResponse'; message: string; success: boolean }
}

export type PaymentRequestFileListQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PaymentRequestFileOrderByInput> | PaymentRequestFileOrderByInput>
	where?: InputMaybe<PaymentRequestFileWhereInput>
}>

export type PaymentRequestFileListQuery = {
	__typename?: 'Query'
	paymentRequestFiles: {
		__typename?: 'PaymentRequestFileList'
		total: number
		items: Array<{
			__typename?: 'PaymentRequestFile'
			id: string
			createdAt: any
			createdBy: string
			recordsCount: number
			succeededRecordsCount: number
			failureReason?: string | null
			failedRecordsCount: number
			fileName: string
			status: string
			createdByUser: { __typename?: 'User'; name?: string | null; displayName?: string | null }
		}>
	}
}

export type ListPimsQueryVariables = Exact<{
	where?: InputMaybe<PimsWhereInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PimsOrderByInput> | PimsOrderByInput>
}>

export type ListPimsQuery = {
	__typename?: 'Query'
	listPims: {
		__typename?: 'PimsListWithCount'
		total: number
		items: Array<{
			__typename?: 'Pims'
			id: string
			name: string
			currentPimsValue: string
			industry: PimsIndustry
			mcc?: string | null
			isActive: boolean
			isVisibleToConsolidatorAdmins: boolean
			isVisibleOnSignUpForm: boolean
			createdAt: any
			updatedAt: any
		}>
	}
}

export type GetPracticesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PracticeOrderByInput> | PracticeOrderByInput>
	where?: InputMaybe<PracticeWhereInput>
}>

export type GetPracticesQuery = {
	__typename?: 'Query'
	practices: Array<{
		__typename?: 'Practice'
		id: string
		stripeAccountId?: string | null
		name?: string | null
		city?: string | null
		state?: string | null
		address?: string | null
		zip?: string | null
	}>
}

export type GetAllPracticesCountQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PracticeOrderByInput> | PracticeOrderByInput>
	where?: InputMaybe<PracticeWhereInput>
}>

export type GetAllPracticesCountQuery = {
	__typename?: 'Query'
	practicesWithCount: {
		__typename?: 'PracticeListWithCount'
		total: number
		items: Array<{
			__typename?: 'Practice'
			id: string
			stripeAccountId?: string | null
			consolidatorId?: string | null
			name?: string | null
			country?: string | null
			city?: string | null
			state?: string | null
			address?: string | null
			zip?: string | null
			vetClinicId?: number | null
			settings?: any | null
			integrationId?: string | null
			hospitalManagerEmail?: string | null
			products?: any | null
			routingNumber?: string | null
			accountNumber?: string | null
			logoUrl?: string | null
			activeTerminalsCount?: number | null
			totalTerminalsCount?: number | null
			currentPims?: string | null
			timezone?: string | null
			isCustomPayoutEnabled?: boolean | null
			netsuiteId?: string | null
			skyworldId?: string | null
			consolidator?: { __typename?: 'Consolidator'; id: string; featureFlags?: any | null } | null
		}>
	}
}

export type GetAllPracticesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PracticeOrderByInput> | PracticeOrderByInput>
	where?: InputMaybe<PracticeWhereInput>
}>

export type GetAllPracticesQuery = {
	__typename?: 'Query'
	practices: Array<{
		__typename?: 'Practice'
		id: string
		stripeAccountId?: string | null
		consolidatorId?: string | null
		name?: string | null
		country?: string | null
		city?: string | null
		state?: string | null
		address?: string | null
		zip?: string | null
		vetClinicId?: number | null
		settings?: any | null
		integrationId?: string | null
		hospitalManagerEmail?: string | null
		products?: any | null
		routingNumber?: string | null
		accountNumber?: string | null
		logoUrl?: string | null
		activeTerminalsCount?: number | null
		totalTerminalsCount?: number | null
		currentPims?: string | null
		timezone?: string | null
		isCustomPayoutEnabled?: boolean | null
		customPayoutTarget?: string | null
		customPayoutSettings?: any | null
		netsuiteId?: string | null
		skyworldId?: string | null
		consolidator?: { __typename?: 'Consolidator'; id: string; featureFlags?: any | null } | null
	}>
}

export type UpsertCustomPayoutSettingsMutationVariables = Exact<{
	practiceId: Scalars['String']['input']
	settings: CustomPayoutSettingsInput
}>

export type UpsertCustomPayoutSettingsMutation = {
	__typename?: 'Mutation'
	upsertCustomPayoutSettings: {
		__typename?: 'UpsertCustomPayoutSettingsResponse'
		success: boolean
		customPayoutSettings?: any | null
	}
}

export type EnableCustomPayoutV2MutationVariables = Exact<{
	practiceId: Scalars['ID']['input']
}>

export type EnableCustomPayoutV2Mutation = {
	__typename?: 'Mutation'
	enableCustomPayoutV2: {
		__typename?: 'EnableCustomPayoutV2Response'
		practicePayoutInfo: {
			__typename?: 'PracticeCustomPayoutInfo'
			id: string
			stripeAccountId?: string | null
			name?: string | null
			consolidatorId?: string | null
			customPayoutTarget?: CustomPayoutBatchTarget | null
			customPayoutSettings?: any | null
			isCustomPayoutEnabled?: boolean | null
		}
	}
}

export type PracticeFeeLogsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<PracticeFeeLogOrderByInput> | PracticeFeeLogOrderByInput>
	where?: InputMaybe<PracticeFeeLogWhereInput>
}>

export type PracticeFeeLogsQuery = {
	__typename?: 'Query'
	practiceFeeLog: {
		__typename?: 'PracticeFeeLogWithCount'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'PracticeFeeLog'
			id: string
			practiceId: string
			surchargeEnabled?: boolean | null
			isNetSettlement?: boolean | null
			surchargeFeePct?: number | null
			transactionFees?: any | null
			customPayoutSettings?: any | null
			changeLog: any
			rateScheme?: string | null
			surchargeStartDate?: any | null
			source?: string | null
			updatedBy?: string | null
			createdAt: any
			updatedAt: any
		}>
	}
}

export type EnterpriseRebatePayoutBatchesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<
		Array<EnterpriseRebatePayoutBatchOrderByInput> | EnterpriseRebatePayoutBatchOrderByInput
	>
	where?: InputMaybe<EnterpriseRebatePayoutBatchWhereInput>
}>

export type EnterpriseRebatePayoutBatchesQuery = {
	__typename?: 'Query'
	enterpriseRebatePayoutBatches: {
		__typename?: 'EnterpriseRebatePayoutBatchListWithCount'
		total: number
		items: Array<{
			__typename?: 'EnterpriseRebatePayoutBatch'
			id: string
			consolidatedPracticeId: string
			practiceName?: string | null
			consolidatorReferenceCode?: string | null
			manufacturerId: string
			manufacturerName?: string | null
			payoutDate: any
			totalRebateAmount: number
			totalRebateCount: number
			batchStatus: string
			paymentStatus: string
			stripePayoutId?: string | null
			statementDescriptor?: string | null
			payoutEstimatedArrivalAt?: any | null
			payoutSentAt?: any | null
			currency?: string | null
			createdAt: any
			updatedAt: any
		}>
	}
}

export type EnterpriseRebatePayoutBatchFilterOptionsQueryVariables = Exact<{ [key: string]: never }>

export type EnterpriseRebatePayoutBatchFilterOptionsQuery = {
	__typename?: 'Query'
	enterpriseRebatePayoutBatchFilterOptions: {
		__typename?: 'EnterpriseRebatePayoutBatchFilterOptions'
		practices: Array<{
			__typename?: 'EnterpriseRebatePayoutBatchFilterOption'
			id: string
			name: string
		}>
		manufacturers: Array<{
			__typename?: 'EnterpriseRebatePayoutBatchFilterOption'
			id: string
			name: string
		}>
	}
}

export type EnterpriseRebatePayoutDetailsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<
		Array<EnterpriseInvoiceDetectedRebateOrderByInput> | EnterpriseInvoiceDetectedRebateOrderByInput
	>
	where?: InputMaybe<EnterpriseInvoiceDetectedRebateWhereInput>
}>

export type EnterpriseRebatePayoutDetailsQuery = {
	__typename?: 'Query'
	enterpriseInvoiceDetectedRebate: {
		__typename?: 'EnterpriseInvoiceDetectedRebateListWithCount'
		total: number
		items: Array<{
			__typename?: 'EnterpriseInvoiceDetectedRebate'
			id: string
			invoiceId: string
			invoiceLineItemId: string
			invoiceDate: any
			rebateCode: string
			detectedAmount?: any | null
			rebateProgramName?: string | null
			rebateProgramProductName?: string | null
			consolidatedPracticeId?: string | null
			practiceName?: string | null
			rebateInvoiceId?: string | null
			clientFirstName?: string | null
			clientLastName?: string | null
			patientName?: string | null
			payoutBatchId?: string | null
			status?: string | null
			createdAt: any
		}>
	}
}

export type AllProgramsQueryVariables = Exact<{
	orderBy?: InputMaybe<
		Array<ListActivePracticeRebateProgramOrderByInput> | ListActivePracticeRebateProgramOrderByInput
	>
	where?: InputMaybe<ListActivePracticeRebateProgramWhereInput>
}>

export type AllProgramsQuery = {
	__typename?: 'Query'
	rebatePrograms: {
		__typename?: 'ListRebateProgramResponse'
		rebatePrograms: Array<{
			__typename?: 'RebateProgram'
			id: string
			name: string
			description?: string | null
			startAt: any
			endAt?: any | null
			status: RebateProgramStatus
			partnerName?: string | null
			title?: string | null
			priority: number
			visibility: RebateProgramVisibility
			logoUrl?: string | null
			learnMoreUrl?: string | null
			products: Array<{
				__typename?: 'RebateProgramProduct'
				id: string
				name: string
				sku: string
				rebateAmount: number
				rebateCode: string
				requiredQuantity: number
				unit?: string | null
				status: RebateProgramStatus
				description?: string | null
				createdAt: any
				updatedAt: any
				productReferences?: Array<{
					__typename?: 'RebateProgramProductReference'
					productReferenceId: string
					productReference: { __typename?: 'ProductReference'; id: string; name: string }
				}> | null
			}>
			bundles: Array<{
				__typename?: 'RebateProgramBundle'
				id: string
				name: string
				description?: string | null
				rebateAmount: number
				rebateCode: string
				bundleCode?: string | null
				rebateProgramId: string
				status: RebateProgramStatus
				createdAt: any
				updatedAt: any
				products: Array<{
					__typename?: 'RebateProgramProduct'
					id: string
					name: string
					sku: string
					rebateAmount: number
					rebateCode: string
					requiredQuantity: number
					status: RebateProgramStatus
					description?: string | null
					createdAt: any
					updatedAt: any
					productReferences?: Array<{
						__typename?: 'RebateProgramProductReference'
						productReferenceId: string
						productReference: { __typename?: 'ProductReference'; id: string; name: string }
					}> | null
				}>
			}>
		}>
	}
	activePracticeRebatePrograms: {
		__typename?: 'ListActivePracticeRebateProgramResponse'
		practiceRebatePrograms: Array<{
			__typename?: 'PracticeRebateProgram'
			id: string
			practiceId: string
			rebateProgramId: string
			enabledBy: string
			disabledBy?: string | null
			disableReason?: string | null
			enabledAt: any
			disabledAt?: any | null
			status: RebateProgramStatus
			createdAt: any
			updatedAt: any
		}>
	}
}

export type ToggleRebateProgramMutationVariables = Exact<{
	rebateProgramId: Scalars['String']['input']
	optIn: Scalars['Boolean']['input']
	disableReason?: InputMaybe<Scalars['String']['input']>
}>

export type ToggleRebateProgramMutation = {
	__typename?: 'Mutation'
	toggleRebateProgram: {
		__typename?: 'PracticeRebateProgram'
		id: string
		practiceId: string
		rebateProgramId: string
		status: RebateProgramStatus
		enabledAt: any
		disabledAt?: any | null
		disableReason?: string | null
	}
}

export type AllRebateProgramsQueryVariables = Exact<{
	orderBy?: InputMaybe<Array<RebateProgramOrderByInput> | RebateProgramOrderByInput>
	where?: InputMaybe<RebateProgramWhereInput>
}>

export type AllRebateProgramsQuery = {
	__typename?: 'Query'
	allRebatePrograms: {
		__typename?: 'ListRebateProgramResponse'
		rebatePrograms: Array<{
			__typename?: 'RebateProgram'
			id: string
			name: string
			description?: string | null
			products: Array<{
				__typename?: 'RebateProgramProduct'
				id: string
				name: string
				sku: string
				description?: string | null
			}>
			bundles: Array<{
				__typename?: 'RebateProgramBundle'
				id: string
				name: string
				description?: string | null
				products: Array<{
					__typename?: 'RebateProgramProduct'
					id: string
					name: string
					sku: string
					description?: string | null
				}>
			}>
		}>
	}
}

export type AdminRebateProgramsListQueryVariables = Exact<{
	where?: InputMaybe<RebateProgramWhereInput>
	orderBy?: InputMaybe<Array<RebateProgramOrderByInput> | RebateProgramOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type AdminRebateProgramsListQuery = {
	__typename?: 'Query'
	allRebatePrograms: {
		__typename?: 'ListRebateProgramResponse'
		total?: number | null
		rebatePrograms: Array<{
			__typename?: 'RebateProgram'
			id: string
			name: string
			partnerName?: string | null
			status: RebateProgramStatus
			visibility: RebateProgramVisibility
			startAt: any
			endAt?: any | null
			products: Array<{ __typename?: 'RebateProgramProduct'; id: string }>
		}>
	}
}

export type RebateProgramsForAdminQueryVariables = Exact<{
	orderBy?: InputMaybe<Array<RebateProgramOrderByInput> | RebateProgramOrderByInput>
	where?: InputMaybe<RebateProgramWhereInput>
}>

export type RebateProgramsForAdminQuery = {
	__typename?: 'Query'
	rebatePrograms: {
		__typename?: 'ListRebateProgramResponse'
		rebatePrograms: Array<{
			__typename?: 'RebateProgram'
			id: string
			name: string
			description?: string | null
			products: Array<{
				__typename?: 'RebateProgramProduct'
				id: string
				name: string
				sku: string
				description?: string | null
			}>
			bundles: Array<{
				__typename?: 'RebateProgramBundle'
				id: string
				name: string
				description?: string | null
				products: Array<{
					__typename?: 'RebateProgramProduct'
					id: string
					name: string
					sku: string
					description?: string | null
				}>
			}>
		}>
	}
}

export type InvoiceDetectedRebateQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<InvoiceDetectedRebateOrderByInput> | InvoiceDetectedRebateOrderByInput>
	where?: InputMaybe<InvoiceDetectedRebateWhereInput>
}>

export type InvoiceDetectedRebateQuery = {
	__typename?: 'Query'
	invoiceDetectedRebate: {
		__typename?: 'InvoiceDetectedRebateListWithCount'
		total: number
		items: Array<{
			__typename?: 'InvoiceDetectedRebate'
			id: string
			invoiceId: string
			originalInvoiceId?: string | null
			invoiceLineItemId: string
			invoiceDate: any
			rebateCode: string
			detectedAmount?: any | null
			detectedQuantity?: number | null
			productDescription?: string | null
			matchedProductName?: string | null
			matchConfidence?: any | null
			status?: string | null
			rejectionReason?: string | null
			rebateProgramId?: string | null
			rebateProgramProductId?: string | null
			rebateProgramName?: string | null
			rebateProgramProductName?: string | null
			createdAt: any
			validatedAt?: any | null
			payoutBatchId?: string | null
		}>
	}
}

export type EnterpriseInvoiceDetectedRebateQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<
		Array<EnterpriseInvoiceDetectedRebateOrderByInput> | EnterpriseInvoiceDetectedRebateOrderByInput
	>
	where?: InputMaybe<EnterpriseInvoiceDetectedRebateWhereInput>
}>

export type EnterpriseInvoiceDetectedRebateQuery = {
	__typename?: 'Query'
	enterpriseInvoiceDetectedRebate: {
		__typename?: 'EnterpriseInvoiceDetectedRebateListWithCount'
		total: number
		items: Array<{
			__typename?: 'EnterpriseInvoiceDetectedRebate'
			id: string
			invoiceId: string
			originalInvoiceId?: string | null
			invoiceLineItemId: string
			invoiceDate: any
			rebateCode: string
			detectedAmount?: any | null
			detectedQuantity?: number | null
			productDescription?: string | null
			matchedProductName?: string | null
			matchConfidence?: any | null
			status?: string | null
			rejectionReason?: string | null
			rebateProgramId?: string | null
			rebateProgramProductId?: string | null
			rebateProgramName?: string | null
			rebateProgramProductName?: string | null
			createdAt: any
			validatedAt?: any | null
			payoutBatchId?: string | null
			consolidatedPracticeId?: string | null
			practiceName?: string | null
		}>
	}
}

export type RebateInvoicesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<RebateInvoiceOrderByInput> | RebateInvoiceOrderByInput>
	where?: InputMaybe<RebateInvoiceWhereInput>
}>

export type RebateInvoicesQuery = {
	__typename?: 'Query'
	rebateInvoices: {
		__typename?: 'RebateInvoiceListWithCount'
		items: Array<{
			__typename?: 'RebateInvoice'
			id: string
			invoiceId: string
			consolidatedPracticeId: string
			invoiceDate: any
			clientFirstName?: string | null
			clientLastName?: string | null
			patientName?: string | null
			invoiceSnapshot: any
			status: RebateInvoiceStatus
			createdAt: any
			updatedAt: any
			invoiceDetectedRebates?: Array<{
				__typename?: 'InvoiceDetectedRebate'
				id: string
				invoiceId: string
				originalInvoiceId?: string | null
				status?: string | null
				productDescription?: string | null
				rebateCode: string
				rebateProgramName?: string | null
				rejectionReason?: string | null
				invoiceLineItemId: string
				ordinal?: number | null
				payoutBatchId?: string | null
			}> | null
		}>
	}
}

export type EnterpriseRebateInvoicesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<
		Array<EnterpriseRebateInvoiceOrderByInput> | EnterpriseRebateInvoiceOrderByInput
	>
	where?: InputMaybe<EnterpriseRebateInvoiceWhereInput>
}>

export type EnterpriseRebateInvoicesQuery = {
	__typename?: 'Query'
	enterpriseRebateInvoices: {
		__typename?: 'EnterpriseRebateInvoiceListWithCount'
		items: Array<{
			__typename?: 'RebateInvoice'
			id: string
			invoiceId: string
			consolidatedPracticeId: string
			invoiceDate: any
			clientFirstName?: string | null
			clientLastName?: string | null
			patientName?: string | null
			invoiceSnapshot: any
			status: RebateInvoiceStatus
			createdAt: any
			updatedAt: any
			invoiceDetectedRebates?: Array<{
				__typename?: 'InvoiceDetectedRebate'
				id: string
				invoiceId: string
				originalInvoiceId?: string | null
				status?: string | null
				productDescription?: string | null
				rebateCode: string
				rebateProgramName?: string | null
				rejectionReason?: string | null
				invoiceLineItemId: string
				ordinal?: number | null
				payoutBatchId?: string | null
			}> | null
		}>
	}
}

export type ApproveRebateMutationVariables = Exact<{
	rebateId: Scalars['String']['input']
	notes?: InputMaybe<Scalars['String']['input']>
}>

export type ApproveRebateMutation = {
	__typename?: 'Mutation'
	approveRebate: {
		__typename?: 'ApproveRebateResponse'
		success: boolean
		error?: string | null
		rebate?: {
			__typename?: 'InvoiceDetectedRebate'
			id: string
			status?: string | null
			validatedAt?: any | null
			reviewNotes?: string | null
		} | null
	}
}

export type RejectRebateMutationVariables = Exact<{
	rebateId: Scalars['String']['input']
	reason: Scalars['String']['input']
	notes?: InputMaybe<Scalars['String']['input']>
}>

export type RejectRebateMutation = {
	__typename?: 'Mutation'
	rejectRebate: {
		__typename?: 'RejectRebateResponse'
		success: boolean
		error?: string | null
		rebate?: {
			__typename?: 'InvoiceDetectedRebate'
			id: string
			status?: string | null
			rejectionReason?: string | null
			reviewNotes?: string | null
			validatedAt?: any | null
			rebateProgramName?: string | null
			detectedAmount?: any | null
			invoiceId: string
		} | null
	}
}

export type GetNormalizedProductsWithCountQueryVariables = Exact<{
	where?: InputMaybe<NormalizedProductWhereInput>
	orderBy?: InputMaybe<Array<NormalizedProductOrderByInput> | NormalizedProductOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetNormalizedProductsWithCountQuery = {
	__typename?: 'Query'
	normalizedProductsWithCount: {
		__typename?: 'NormalizedProductListWithCount'
		total: number
		items: Array<{
			__typename?: 'NormalizedProduct'
			id: any
			uuid: string
			consolidatedPracticeId: string
			pimsProductDescription: string
			normalizedProductDescription?: string | null
			pimsProductUid?: string | null
			productReferenceId?: string | null
			productVariantId?: string | null
			metadata: any
			createdBy: string
			createdAt: any
			updatedAt: any
			isCheckedManually: boolean
			productReference?: {
				__typename?: 'ProductReference'
				id: string
				name: string
				manufacturerId?: string | null
				brandId?: string | null
				categoryId?: string | null
				daysOnTherapy?: number | null
				notes?: string | null
				createdAt: any
				updatedAt: any
			} | null
			productVariant?: {
				__typename?: 'ProductVariantReference'
				id: string
				productReferenceId: string
				species?: string | null
				color?: string | null
				minWeight?: number | null
				maxWeight?: number | null
				weightUnit?: string | null
				doseOrPackSize?: string | null
				notes?: string | null
				createdAt: any
				updatedAt: any
			} | null
		}>
	}
}

export type GetNormalizedProductsQueryVariables = Exact<{
	where?: InputMaybe<NormalizedProductWhereInput>
	orderBy?: InputMaybe<Array<NormalizedProductOrderByInput> | NormalizedProductOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetNormalizedProductsQuery = {
	__typename?: 'Query'
	normalizedProducts: Array<{
		__typename?: 'NormalizedProduct'
		id: any
		uuid: string
		consolidatedPracticeId: string
		pimsProductDescription: string
		normalizedProductDescription?: string | null
		pimsProductUid?: string | null
		productReferenceId?: string | null
		productVariantId?: string | null
		metadata: any
		createdBy: string
		createdAt: any
		updatedAt: any
		isCheckedManually: boolean
		productReference?: {
			__typename?: 'ProductReference'
			id: string
			name: string
			manufacturerId?: string | null
			brandId?: string | null
			categoryId?: string | null
			daysOnTherapy?: number | null
			notes?: string | null
			createdAt: any
			updatedAt: any
			manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null
			brand?: { __typename?: 'BrandReference'; id: string; name: string } | null
			category?: { __typename?: 'CategoryReference'; id: string; name: string } | null
		} | null
		productVariant?: {
			__typename?: 'ProductVariantReference'
			id: string
			productReferenceId: string
			species?: string | null
			color?: string | null
			minWeight?: number | null
			maxWeight?: number | null
			weightUnit?: string | null
			doseOrPackSize?: string | null
			notes?: string | null
			createdAt: any
			updatedAt: any
		} | null
	}>
}

export type GetProductReferencesQueryVariables = Exact<{
	where?: InputMaybe<ProductReferenceWhereInput>
	orderBy?: InputMaybe<Array<ProductReferenceOrderByInput> | ProductReferenceOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetProductReferencesQuery = {
	__typename?: 'Query'
	productReferences: Array<{
		__typename?: 'ProductReference'
		id: string
		name: string
		manufacturerId?: string | null
		brandId?: string | null
		categoryId?: string | null
		daysOnTherapy?: number | null
		notes?: string | null
		createdAt: any
		updatedAt: any
		manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null
		brand?: { __typename?: 'BrandReference'; id: string; name: string } | null
		category?: { __typename?: 'CategoryReference'; id: string; name: string } | null
	}>
}

export type GetProductReferencesWithCountQueryVariables = Exact<{
	where?: InputMaybe<ProductReferenceWhereInput>
	orderBy?: InputMaybe<Array<ProductReferenceOrderByInput> | ProductReferenceOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetProductReferencesWithCountQuery = {
	__typename?: 'Query'
	productReferencesWithCount: {
		__typename?: 'ProductReferenceListWithCount'
		total: number
		items: Array<{
			__typename?: 'ProductReference'
			id: string
			name: string
			manufacturerId?: string | null
			brandId?: string | null
			categoryId?: string | null
			daysOnTherapy?: number | null
			notes?: string | null
			createdAt: any
			updatedAt: any
			manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null
			brand?: { __typename?: 'BrandReference'; id: string; name: string } | null
			category?: { __typename?: 'CategoryReference'; id: string; name: string } | null
		}>
	}
}

export type UpsertNormalizedProductMutationVariables = Exact<{
	upsertArgs: UpsertNormalizedProductInput
}>

export type UpsertNormalizedProductMutation = {
	__typename?: 'Mutation'
	upsertNormalizedProduct: {
		__typename?: 'NormalizedProduct'
		id: any
		uuid: string
		consolidatedPracticeId: string
		pimsProductDescription: string
		normalizedProductDescription?: string | null
		pimsProductUid?: string | null
		productReferenceId?: string | null
		productVariantId?: string | null
		metadata: any
		createdBy: string
		createdAt: any
		updatedAt: any
		productReference?: {
			__typename?: 'ProductReference'
			id: string
			name: string
			manufacturerId?: string | null
			brandId?: string | null
			categoryId?: string | null
			daysOnTherapy?: number | null
			notes?: string | null
			createdAt: any
			updatedAt: any
		} | null
		productVariant?: {
			__typename?: 'ProductVariantReference'
			id: string
			productReferenceId: string
			species?: string | null
			color?: string | null
			minWeight?: number | null
			maxWeight?: number | null
			weightUnit?: string | null
			doseOrPackSize?: string | null
			notes?: string | null
			createdAt: any
			updatedAt: any
		} | null
	}
}

export type GetProductVariantsQueryVariables = Exact<{
	where?: InputMaybe<ProductVariantWhereInput>
	orderBy?: InputMaybe<Array<ProductVariantOrderByInput> | ProductVariantOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetProductVariantsQuery = {
	__typename?: 'Query'
	productVariants: Array<{
		__typename?: 'ProductVariantReference'
		id: string
		productReferenceId: string
		species?: string | null
		color?: string | null
		minWeight?: number | null
		maxWeight?: number | null
		weightUnit?: string | null
		doseOrPackSize?: string | null
		notes?: string | null
		createdAt: any
		updatedAt: any
		productReference: {
			__typename?: 'ProductReference'
			id: string
			name: string
			daysOnTherapy?: number | null
			notes?: string | null
			createdAt: any
			updatedAt: any
			manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null
			brand?: { __typename?: 'BrandReference'; id: string; name: string } | null
			category?: { __typename?: 'CategoryReference'; id: string; name: string } | null
		}
	}>
}

export type GetProductVariantsWithCountQueryVariables = Exact<{
	where?: InputMaybe<ProductVariantWhereInput>
	orderBy?: InputMaybe<Array<ProductVariantOrderByInput> | ProductVariantOrderByInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type GetProductVariantsWithCountQuery = {
	__typename?: 'Query'
	productVariantsWithCount: {
		__typename?: 'ProductVariantListWithCount'
		total: number
		items: Array<{
			__typename?: 'ProductVariantReference'
			id: string
			productReferenceId: string
			species?: string | null
			color?: string | null
			minWeight?: number | null
			maxWeight?: number | null
			weightUnit?: string | null
			doseOrPackSize?: string | null
			notes?: string | null
			createdAt: any
			updatedAt: any
			productReference: {
				__typename?: 'ProductReference'
				id: string
				name: string
				manufacturerId?: string | null
				brandId?: string | null
				categoryId?: string | null
				daysOnTherapy?: number | null
				notes?: string | null
				createdAt: any
				updatedAt: any
			}
		}>
	}
}

export type UpsertProductVariantMutationVariables = Exact<{
	upsertArgs: UpsertProductVariantInput
}>

export type UpsertProductVariantMutation = {
	__typename?: 'Mutation'
	upsertProductVariant: {
		__typename?: 'ProductVariantReference'
		id: string
		productReferenceId: string
		species?: string | null
		color?: string | null
		minWeight?: number | null
		maxWeight?: number | null
		weightUnit?: string | null
		doseOrPackSize?: string | null
		notes?: string | null
	}
}

export type UpsertProductReferenceMutationVariables = Exact<{
	upsertArgs: UpsertProductReferenceInput
}>

export type UpsertProductReferenceMutation = {
	__typename?: 'Mutation'
	upsertProductReference: {
		__typename?: 'ProductReference'
		id: string
		name: string
		manufacturerId?: string | null
		brandId?: string | null
		categoryId?: string | null
		daysOnTherapy?: number | null
		notes?: string | null
		createdAt: any
		updatedAt: any
		manufacturer?: { __typename?: 'Manufacturer'; id: string; name: string } | null
		brand?: { __typename?: 'BrandReference'; id: string; name: string } | null
		category?: { __typename?: 'CategoryReference'; id: string; name: string } | null
	}
}

export type DeleteProductVariantMutationVariables = Exact<{
	id: Scalars['String']['input']
}>

export type DeleteProductVariantMutation = {
	__typename?: 'Mutation'
	deleteProductVariant: boolean
}

export type DeleteProductReferenceMutationVariables = Exact<{
	id: Scalars['String']['input']
}>

export type DeleteProductReferenceMutation = {
	__typename?: 'Mutation'
	deleteProductReference: boolean
}

export type DeleteNormalizedProductMutationVariables = Exact<{
	uuid: Scalars['String']['input']
}>

export type DeleteNormalizedProductMutation = {
	__typename?: 'Mutation'
	deleteNormalizedProduct: boolean
}

export type PracticeTerminalRebateProgramsQueryVariables = Exact<{
	where?: InputMaybe<ListActivePracticeRebateProgramWhereInput>
	orderBy?: InputMaybe<
		Array<ListActivePracticeRebateProgramOrderByInput> | ListActivePracticeRebateProgramOrderByInput
	>
}>

export type PracticeTerminalRebateProgramsQuery = {
	__typename?: 'Query'
	activePracticeRebatePrograms: {
		__typename?: 'ListActivePracticeRebateProgramResponse'
		practiceRebatePrograms: Array<{
			__typename?: 'PracticeRebateProgram'
			id: string
			practiceMetadata?: any | null
			practicePriority?: number | null
			rebateProgram?: {
				__typename?: 'RebateProgram'
				id: string
				name: string
				description?: string | null
				metadata?: any | null
			} | null
		}>
	}
}

export type SearchPracticesWithRebatesQueryVariables = Exact<{
	where?: InputMaybe<ConsolidatedPracticeWhereInput>
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchPracticesWithRebatesQuery = {
	__typename?: 'Query'
	searchPracticesWithRebates: {
		__typename?: 'PracticeRebateSearchResponse'
		total: number
		skip: number
		take?: number | null
		practices: Array<{
			__typename?: 'PracticeRebateSearchResult'
			id: string
			name?: string | null
			isRebateEnabled?: boolean | null
			terminalEnabledStatus: TerminalRebateEnabledStatus
		}>
	}
}

export type DeleteNormalizedProductsPerPracticeMutationVariables = Exact<{
	practiceId: Scalars['String']['input']
}>

export type DeleteNormalizedProductsPerPracticeMutation = {
	__typename?: 'Mutation'
	deleteNormalizedProductsPerPractice: boolean
}

export type UpdatePracticeRebateProgramSettingsMutationVariables = Exact<{
	id: Scalars['String']['input']
	priority?: InputMaybe<Scalars['Int']['input']>
	isTerminalOfferEnabled?: InputMaybe<Scalars['Boolean']['input']>
	rebatesHandoffHoldoutPct?: InputMaybe<Scalars['Float']['input']>
	terminalSuppressionKeywords?: InputMaybe<
		Array<Scalars['String']['input']> | Scalars['String']['input']
	>
}>

export type UpdatePracticeRebateProgramSettingsMutation = {
	__typename?: 'Mutation'
	updatePracticeRebateProgramSettings: {
		__typename?: 'PracticeRebateProgram'
		id: string
		practiceId: string
		rebateProgramId: string
		metadata?: any | null
	}
}

export type GetBrandsManufacturersCategoriesQueryVariables = Exact<{
	brandWhere?: InputMaybe<BrandReferenceWhereInput>
	brandOrderBy?: InputMaybe<Array<BrandReferenceOrderByInput> | BrandReferenceOrderByInput>
	brandSkip?: InputMaybe<Scalars['Int']['input']>
	brandTake?: InputMaybe<Scalars['Int']['input']>
	manufacturerWhere?: InputMaybe<ManufacturerWhereInput>
	manufacturerOrderBy?: InputMaybe<Array<ManufacturerOrderByInput> | ManufacturerOrderByInput>
	manufacturerSkip?: InputMaybe<Scalars['Int']['input']>
	manufacturerTake?: InputMaybe<Scalars['Int']['input']>
	categoryWhere?: InputMaybe<CategoryReferenceWhereInput>
	categoryOrderBy?: InputMaybe<Array<CategoryReferenceOrderByInput> | CategoryReferenceOrderByInput>
	categorySkip?: InputMaybe<Scalars['Int']['input']>
	categoryTake?: InputMaybe<Scalars['Int']['input']>
}>

export type GetBrandsManufacturersCategoriesQuery = {
	__typename?: 'Query'
	brandReferences: Array<{
		__typename?: 'BrandReference'
		id: string
		name: string
		createdAt: any
		updatedAt: any
	}>
	manufacturers: Array<{
		__typename?: 'Manufacturer'
		id: string
		name: string
		status: ManufacturerFundingStatus
		createdAt: any
		updatedAt: any
	}>
	categoryReferences: Array<{
		__typename?: 'CategoryReference'
		id: string
		name: string
		createdAt: any
		updatedAt: any
	}>
}

export type GetPracticeForRefundPayoutQueryVariables = Exact<{
	where?: InputMaybe<PracticeWhereInput>
}>

export type GetPracticeForRefundPayoutQuery = {
	__typename?: 'Query'
	practices: Array<{
		__typename?: 'Practice'
		id: string
		stripeAccountId?: string | null
		name?: string | null
		consolidatorId?: string | null
		country?: string | null
		state?: string | null
	}>
}

export type TriggerRefundPayoutMutationVariables = Exact<{
	stripeAccountId: Scalars['String']['input']
	amount: Scalars['Float']['input']
	currency: Scalars['String']['input']
	description?: InputMaybe<Scalars['String']['input']>
}>

export type TriggerRefundPayoutMutation = {
	__typename?: 'Mutation'
	triggerRefundPayout: {
		__typename?: 'TriggerRefundPayoutResponse'
		practiceId: string
		stripeAccountId: string
		stripeTransferId: string
		stripePayoutId: string
		amount: number
		currency: string
		status?: string | null
	}
}

export type RefundPayoutsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<RefundPayoutOrderByInput> | RefundPayoutOrderByInput>
	where?: InputMaybe<RefundPayoutWhereInput>
}>

export type RefundPayoutsQuery = {
	__typename?: 'Query'
	refundPayouts: {
		__typename?: 'RefundPayoutListWithCount'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'RefundPayoutLog'
			id: string
			issuedBy: string
			practiceId: string
			practiceName?: string | null
			amountTransferred: number
			amountPaidOut: number
			currency: string
			description?: string | null
			stripeTransferId?: string | null
			stripePayoutId?: string | null
			status: ScratchRefundPayoutStatus
			errorReason?: string | null
			createdAt: any
		}>
	}
}

export type ListRefundRequestsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<RefundRequestOrderByInput> | RefundRequestOrderByInput>
	where?: InputMaybe<RefundRequestWhereInput>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListRefundRequestsQuery = {
	__typename?: 'Query'
	listRefundRequests: {
		__typename?: 'RefundRequestList'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'RefundRequest'
			id: string
			consolidatorId: string
			paymentIntentId: string
			originalPaymentAmount: number
			originalPaymentProcessedAt: any
			requestedRefundAmount: number
			requestedById: string
			requestedByEmail: string
			approverRole: string
			notesRequestor?: string | null
			status: RefundRequestStatuses
			pimsClientId?: string | null
			writebackPimsClientId?: string | null
			createdAt?: any | null
			updatedAt?: any | null
			chargeId?: string | null
			notesApprover?: string | null
			resolvedAt?: any | null
			resolvedById?: string | null
			paymentIntent: { __typename?: 'PaymentIntent'; metadata?: any | null }
			requestedBy: { __typename?: 'User'; name?: string | null; displayName?: string | null }
			practice: {
				__typename?: 'Practice'
				id: string
				name?: string | null
				currentPims?: string | null
			}
		}>
	}
}

export type CreateRefundRequestMutationVariables = Exact<{
	paymentIntentId: Scalars['String']['input']
	pimsClientId?: InputMaybe<Scalars['String']['input']>
	notes?: InputMaybe<Scalars['String']['input']>
	requestedRefundAmount: Scalars['Float']['input']
	chargeId?: InputMaybe<Scalars['String']['input']>
	writebackPimsClientId?: InputMaybe<Scalars['String']['input']>
}>

export type CreateRefundRequestMutation = {
	__typename?: 'Mutation'
	upsertRefundRequest: {
		__typename?: 'RefundRequest'
		id: string
		status: RefundRequestStatuses
		requestedRefundAmount: number
	}
}

export type UpdateRefundRequestMutationVariables = Exact<{
	id: Scalars['ID']['input']
	status: Scalars['String']['input']
	notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateRefundRequestMutation = {
	__typename?: 'Mutation'
	upsertRefundRequest: {
		__typename?: 'RefundRequest'
		id: string
		consolidatorId: string
		paymentIntentId: string
		originalPaymentAmount: number
		originalPaymentProcessedAt: any
		requestedRefundAmount: number
		requestedById: string
		requestedByEmail: string
		approverRole: string
		notesRequestor?: string | null
		notesApprover?: string | null
		status: RefundRequestStatuses
		pimsClientId?: string | null
		writebackPimsClientId?: string | null
		createdAt?: any | null
		updatedAt?: any | null
		chargeId?: string | null
		resolvedAt?: any | null
		resolvedById?: string | null
	}
}

export type ListMonthlyStatementsQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<MonthlyStatementOrderByInput> | MonthlyStatementOrderByInput>
	where?: InputMaybe<MonthlyStatementWhereInput>
}>

export type ListMonthlyStatementsQuery = {
	__typename?: 'Query'
	monthlyStatements: Array<{
		__typename?: 'MonthlyStatement'
		id: string
		month: any
		feeTier: string
		currency: string
		numAuthorized: number
		numSettled: number
		amountSettled: any
		surchargeVolume?: any | null
		tipVolume?: any | null
		totalFees?: any | null
		otherFees?: any | null
		practiceId: string
		feesCollected?: any | null
		totalRefunded?: any | null
		dayLines?: Array<{
			__typename?: 'MonthlyStatementDayLine'
			day: any
			numAuthorized: number
			numSettled: number
			amountSettled: any
			totalFees: any
			surchargeVolume?: any | null
			tipVolume?: any | null
			totalRefunded?: any | null
		}> | null
		feeLines?: Array<{
			__typename?: 'MonthlyStatementFeeLine'
			feeType: string
			rate?: any | null
			amount?: any | null
			totalFees?: any | null
		}> | null
		paymentLines?: Array<{
			__typename?: 'MonthlyStatementPaymentLine'
			paymentMethodType: string
			numAuthorized: number
			numSettled: number
			amountSettled: any
			totalFees: any
			surchargeVolume?: any | null
			tipVolume?: any | null
		}> | null
	}>
}

export type StoredPaymentMethodsQueryVariables = Exact<{
	where?: InputMaybe<StoredPaymentMethodWhereInput>
	orderBy?: InputMaybe<Array<StoredPaymentMethodOrderByInput> | StoredPaymentMethodOrderByInput>
}>

export type StoredPaymentMethodsQuery = {
	__typename?: 'Query'
	storedPaymentMethods: Array<{
		__typename?: 'StoredPaymentMethod'
		id: string
		customerId: string
		cardName: string
		cardBrand: string
		cardLast4: string
		cardType: string
		expiresMonth: number
		expiresYear: number
		postalCode?: string | null
		city?: string | null
		state?: string | null
		addressLine1?: string | null
		addressLine2?: string | null
		country?: string | null
		readMethod: string
		createdAt: any
		hasAcknowledgement: boolean
		acknowledgementMode?: AcknowledgementMode | null
		acknowledgedAt?: any | null
		signatureStatus: SignatureStatus
		signatureUrl?: string | null
	}>
}

export type SubscriptionSchedulesQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SubscriptionScheduleOrderByInput> | SubscriptionScheduleOrderByInput>
	where?: InputMaybe<SubscriptionScheduleWhereInput>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SubscriptionSchedulesQuery = {
	__typename?: 'Query'
	subscriptionSchedules: Array<{
		__typename?: 'SubscriptionSchedule'
		id: string
		applicationFeePercent?: any | null
		canceledAt?: any | null
		completedAt?: any | null
		customerId: string
		paymentMethodId?: string | null
		paymentMethodType?: string | null
		paymentMethodCardBrand?: string | null
		paymentMethodCardLast4?: string | null
		paymentMethodCardExpMonth?: number | null
		paymentMethodCardExpYear?: number | null
		paymentMethodBankAccountBankName?: string | null
		paymentMethodBankAccountLast4?: string | null
		paymentMethodMetadata?: any | null
		description?: string | null
		latestInvoiceId?: string | null
		latestInvoicePaymentIntentId?: string | null
		latestInvoiceStatus?: string | null
		latestInvoiceAttemptCount?: number | null
		latestInvoiceAmountPaid?: number | null
		latestInvoiceAttempted?: boolean | null
		latestInvoiceCreatedAt?: any | null
		latestInvoiceNumber?: string | null
		latestInvoicePaid?: boolean | null
		latestInvoiceStatusTransitionPaidAt?: any | null
		onBehalfOfAccountId?: string | null
		transferDataDestinationAccountId?: string | null
		metadata?: any | null
		practiceId: string
		metadataClientId?: string | null
		metadataClientName?: string | null
		metadataClientFirstName?: string | null
		metadataClientLastName?: string | null
		consolidatorId?: string | null
		petName?: string | null
		phases?: any | null
		releasedAt?: any | null
		renewalInterval?: string | null
		subscriptionId?: string | null
		subscriptionScheduleStatus?: string | null
		subscriptionStatus?: string | null
		firstPaymentOn?: any | null
		nextPaymentOn?: any | null
		paymentAmount?: number | null
		paymentsTotal?: number | null
		paymentsRemaining?: number | null
		stripeCreatedAt: any
		createdAt: any
		updatedAt: any
		pauseCollectionBehavior?: PauseCollectionBehaviorTypes | null
		pauseCollectionResumesAt?: any | null
		paymentsAttempted?: number | null
		paymentsSkipped?: number | null
		paymentsSucceeded?: number | null
		paymentsFailed?: number | null
		nextRetryDate?: any | null
		attemptCount?: number | null
		finalPaymentOn?: any | null
		practice?: {
			__typename?: 'Practice'
			id: string
			name?: string | null
			consolidatorReferenceCode?: string | null
			netsuiteId?: string | null
			skyworldId?: string | null
		} | null
	}>
}

export type SubscriptionSchedulesWithCountQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SubscriptionScheduleOrderByInput> | SubscriptionScheduleOrderByInput>
	where?: InputMaybe<SubscriptionScheduleWhereInput>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SubscriptionSchedulesWithCountQuery = {
	__typename?: 'Query'
	subscriptionSchedulesWithCount: {
		__typename?: 'SubscriptionScheduleListWithCount'
		total: number
		items: Array<{
			__typename?: 'SubscriptionSchedule'
			id: string
			applicationFeePercent?: any | null
			canceledAt?: any | null
			completedAt?: any | null
			customerId: string
			paymentMethodId?: string | null
			paymentMethodType?: string | null
			paymentMethodCardBrand?: string | null
			paymentMethodCardLast4?: string | null
			paymentMethodCardExpMonth?: number | null
			paymentMethodCardExpYear?: number | null
			paymentMethodBankAccountBankName?: string | null
			paymentMethodBankAccountLast4?: string | null
			paymentMethodMetadata?: any | null
			description?: string | null
			latestInvoiceId?: string | null
			latestInvoicePaymentIntentId?: string | null
			latestInvoiceStatus?: string | null
			latestInvoiceAttemptCount?: number | null
			latestInvoiceAmountPaid?: number | null
			latestInvoiceAttempted?: boolean | null
			latestInvoiceCreatedAt?: any | null
			latestInvoiceNumber?: string | null
			latestInvoicePaid?: boolean | null
			latestInvoiceStatusTransitionPaidAt?: any | null
			onBehalfOfAccountId?: string | null
			transferDataDestinationAccountId?: string | null
			metadata?: any | null
			practiceId: string
			metadataClientId?: string | null
			metadataClientName?: string | null
			metadataClientFirstName?: string | null
			metadataClientLastName?: string | null
			consolidatorId?: string | null
			petName?: string | null
			phases?: any | null
			releasedAt?: any | null
			renewalInterval?: string | null
			subscriptionId?: string | null
			subscriptionScheduleStatus?: string | null
			subscriptionStatus?: string | null
			firstPaymentOn?: any | null
			nextPaymentOn?: any | null
			paymentAmount?: number | null
			paymentsTotal?: number | null
			paymentsRemaining?: number | null
			stripeCreatedAt: any
			createdAt: any
			updatedAt: any
			pauseCollectionBehavior?: PauseCollectionBehaviorTypes | null
			pauseCollectionResumesAt?: any | null
			paymentsAttempted?: number | null
			paymentsSkipped?: number | null
			paymentsSucceeded?: number | null
			paymentsFailed?: number | null
			nextRetryDate?: any | null
			attemptCount?: number | null
			finalPaymentOn?: any | null
			practice?: {
				__typename?: 'Practice'
				id: string
				name?: string | null
				consolidatorReferenceCode?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
			} | null
		}>
	}
}

export type ListTerminalTipsQueryVariables = Exact<{
	take?: InputMaybe<Scalars['Int']['input']>
	skip?: InputMaybe<Scalars['Int']['input']>
	startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
	recipientId?: InputMaybe<Scalars['String']['input']>
}>

export type ListTerminalTipsQuery = {
	__typename?: 'Query'
	listTerminalTips: {
		__typename?: 'TerminalTipListWithCount'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'TerminalTip'
			id: string
			createdAt: any
			tipAmount: number
			refundedTipAmount: number
			recipientName: string
			paymentIntentId: string
			paymentIntent: {
				__typename?: 'TerminalTipPaymentIntent'
				customerName?: string | null
				cardholderName?: string | null
				pimsClientId?: string | null
				pimsInvoiceId?: string | null
				baseAmount?: number | null
				cardBrand?: string | null
				last4?: string | null
			}
		}>
	}
}

export type ListTipRecipientsQueryVariables = Exact<{
	take?: InputMaybe<Scalars['Int']['input']>
	where?: InputMaybe<TipRecipientWhereInput>
	orderBy?: InputMaybe<Array<TipRecipientOrderByInput> | TipRecipientOrderByInput>
}>

export type ListTipRecipientsQuery = {
	__typename?: 'Query'
	listTipRecipients: Array<{
		__typename?: 'TipRecipient'
		id: string
		name: string
		isActive: boolean
	}>
}

export type UpsertTipRecipientMutationVariables = Exact<{
	id?: InputMaybe<Scalars['ID']['input']>
	name: Scalars['String']['input']
	isActive?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpsertTipRecipientMutation = {
	__typename?: 'Mutation'
	upsertTipRecipient: { __typename?: 'TipRecipient'; id: string; name: string; isActive: boolean }
}

export type TerminalTipSummaryQueryVariables = Exact<{
	startDate: Scalars['DateTimeISO']['input']
	endDate: Scalars['DateTimeISO']['input']
}>

export type TerminalTipSummaryQuery = {
	__typename?: 'Query'
	terminalTipSummary: Array<{
		__typename?: 'TerminalTipSummary'
		recipientId: string
		recipientName: string
		tipCount: number
		tipVolume: number
		refundedTipVolume: number
	}>
}

export type ListUsersQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<UserOrderByInput> | UserOrderByInput>
	where?: InputMaybe<UserWhereInput>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListUsersQuery = {
	__typename?: 'Query'
	listUsers: {
		__typename?: 'UserList'
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'User'
			consolidatorId?: string | null
			createdAt?: any | null
			createdBy?: string | null
			dashboardUserId?: number | null
			disabled?: boolean | null
			displayName?: string | null
			email?: string | null
			emailMapped?: boolean | null
			extraEmailForNotifications?: string | null
			firstName?: string | null
			id: string
			initialRole?: string | null
			isAdmin?: boolean | null
			isRegionalManager?: boolean | null
			isScratchAdmin?: boolean | null
			isUserNameLogin?: boolean | null
			lastLoginDate?: any | null
			lastName?: string | null
			name?: string | null
			passwordLastUpdatedAt?: any | null
			primaryClinicId?: string | null
			primaryStripeAccountId?: string | null
			uid?: string | null
			updatedAt?: any | null
			username?: string | null
			practices: Array<{
				__typename?: 'PracticeUser'
				isRegionalManager: boolean
				isHospitalManager: boolean
				isStaff?: boolean | null
				practice: { __typename?: 'Practice'; id: string; stripeAccountId?: string | null }
			}>
			primaryClinic?: {
				__typename?: 'Practice'
				id: string
				name?: string | null
				consolidatorReferenceCode2?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
			} | null
		}>
	}
}

export type ListUsersWithCountQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<UserOrderByInput> | UserOrderByInput>
	where?: InputMaybe<UserWhereInput>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListUsersWithCountQuery = {
	__typename?: 'Query'
	listUsersWithCount: {
		__typename?: 'UserListWithCount'
		total: number
		skip: number
		take?: number | null
		items: Array<{
			__typename?: 'User'
			consolidatorId?: string | null
			createdAt?: any | null
			createdBy?: string | null
			dashboardUserId?: number | null
			disabled?: boolean | null
			displayName?: string | null
			email?: string | null
			emailMapped?: boolean | null
			extraEmailForNotifications?: string | null
			firstName?: string | null
			id: string
			initialRole?: string | null
			isAdmin?: boolean | null
			isRegionalManager?: boolean | null
			isScratchAdmin?: boolean | null
			isUserNameLogin?: boolean | null
			lastLoginDate?: any | null
			lastName?: string | null
			name?: string | null
			passwordLastUpdatedAt?: any | null
			primaryClinicId?: string | null
			primaryStripeAccountId?: string | null
			uid?: string | null
			updatedAt?: any | null
			username?: string | null
			practices: Array<{
				__typename?: 'PracticeUser'
				isRegionalManager: boolean
				isHospitalManager: boolean
				isStaff?: boolean | null
				practice: { __typename?: 'Practice'; id: string; stripeAccountId?: string | null }
			}>
			primaryClinic?: {
				__typename?: 'Practice'
				id: string
				name?: string | null
				consolidatorReferenceCode2?: string | null
				netsuiteId?: string | null
				skyworldId?: string | null
			} | null
		}>
	}
}

export type ListUserQueryVariables = Exact<{
	skip?: InputMaybe<Scalars['Int']['input']>
	take?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<UserOrderByInput> | UserOrderByInput>
	where?: InputMaybe<UserWhereInput>
	all?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListUserQuery = {
	__typename?: 'Query'
	listUsers: {
		__typename?: 'UserList'
		items: Array<{
			__typename?: 'User'
			consolidatorId?: string | null
			createdAt?: any | null
			createdBy?: string | null
			dashboardUserId?: number | null
			disabled?: boolean | null
			displayName?: string | null
			email?: string | null
			emailMapped?: boolean | null
			extraEmailForNotifications?: string | null
			firstName?: string | null
			id: string
			initialRole?: string | null
			isAdmin?: boolean | null
			isRegionalManager?: boolean | null
			isScratchAdmin?: boolean | null
			isUserNameLogin?: boolean | null
			lastLoginDate?: any | null
			lastName?: string | null
			name?: string | null
			passwordLastUpdatedAt?: any | null
			uid?: string | null
			updatedAt?: any | null
			username?: string | null
			practices: Array<{
				__typename?: 'PracticeUser'
				isHospitalManager: boolean
				isRegionalManager: boolean
				isStaff?: boolean | null
				practice: {
					__typename?: 'Practice'
					id: string
					stripeAccountId?: string | null
					consolidatorReferenceCode?: string | null
					consolidatorReferenceCode2?: string | null
					name?: string | null
					isRebateEnabled?: boolean | null
					isPaymentEnabled?: boolean | null
					isLendingEnabled?: boolean | null
				}
			}>
			primaryClinic?: { __typename?: 'Practice'; id: string; name?: string | null } | null
		}>
	}
}

export const GridConsolidatedPracticeFragmentDoc = gql`
	fragment GridConsolidatedPractice on ConsolidatedPractice {
		id
		name
		consolidatorReferenceCode
		consolidatorReferenceCode2
		consolidatorReferenceCode3
		netsuiteId
		skyworldId
		pimsMetadata
		logoUrl
		paymentId
		lendingId
		industryProgramMetadata
	}
`
export const GridConsolidatedPracticeSummaryFragmentDoc = gql`
	fragment GridConsolidatedPracticeSummary on ConsolidatedPracticeSummary {
		id
		name
		consolidatorReferenceCode
		consolidatorReferenceCode2
		netsuiteId
		skyworldId
		pimsMetadata
		paymentId
	}
`
export const GridConsolidatedPracticeIndustryProgramFragmentDoc = gql`
	fragment GridConsolidatedPracticeIndustryProgram on ConsolidatedPracticeIndustryProgramSummary {
		id
		logoUrl
		industryProgramMetadata
	}
`
export const ListActionNeededDocument = gql`
	query ListActionNeeded(
		$skip: Int
		$take: Int
		$orderBy: [ActionNeededOrderByInput!]
		$where: ActionNeededWhereInput
	) {
		listActionNeeded(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				isComplete
				amount
				clientId
				clientName
				actionItemType
				paid
				chargeId
				paymentIntentId
				invoiceId
				metadata
				failureCode
				failureMessage
				scratchPaymentMethod
				createdAt
				updatedAt
				dateAdjustedInPims
				resolution
				resolutionNote
				completedBy
				completedAt
				notes
				stripeCreatedDate
				practice {
					name
					id
					consolidatorReferenceCode
					consolidatorReferenceCode2
					netsuiteId
					skyworldId
				}
			}
			skip
			take
			total
		}
	}
`

export function useListActionNeededQuery(
	options?: Omit<Urql.UseQueryArgs<ListActionNeededQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListActionNeededQuery, ListActionNeededQueryVariables>({
		query: ListActionNeededDocument,
		...options
	})
}
export const B2bRebatePayoutFilesDocument = gql`
	query b2bRebatePayoutFiles(
		$skip: Int
		$take: Int
		$orderBy: [B2bRebatePayoutFileOrderByInput!]
		$where: B2bRebatePayoutFileWhereInput
	) {
		b2bRebatePayoutFiles(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				fileName
				uploadedBy
				uploadedByName
				status
				notes
				startedAt
				completedAt
				recordsCount
				validRecordsCount
				createdAt
				updatedAt
			}
			total
		}
	}
`

export function useB2bRebatePayoutFilesQuery(
	options?: Omit<Urql.UseQueryArgs<B2bRebatePayoutFilesQueryVariables>, 'query'>
) {
	return Urql.useQuery<B2bRebatePayoutFilesQuery, B2bRebatePayoutFilesQueryVariables>({
		query: B2bRebatePayoutFilesDocument,
		...options
	})
}
export const B2bRebatePayoutRecordsDocument = gql`
	query b2bRebatePayoutRecords(
		$skip: Int
		$take: Int
		$orderBy: [B2bRebatePayoutRecordOrderByInput!]
		$where: B2bRebatePayoutRecordWhereInput
	) {
		b2bRebatePayoutRecords(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				uploadId
				consolidatedPracticeId
				practiceName
				manufacturerId
				manufacturerName
				reimbursementAmount
				rebateCount
				payoutDate
				statementDescriptor
				status
				rebatePayoutBatchId
				createdAt
				updatedAt
			}
			total
		}
	}
`

export function useB2bRebatePayoutRecordsQuery(
	options?: Omit<Urql.UseQueryArgs<B2bRebatePayoutRecordsQueryVariables>, 'query'>
) {
	return Urql.useQuery<B2bRebatePayoutRecordsQuery, B2bRebatePayoutRecordsQueryVariables>({
		query: B2bRebatePayoutRecordsDocument,
		...options
	})
}
export const BillingTaskDocument = gql`
	query billingTask(
		$skip: Int
		$take: Int
		$orderBy: [BillingTaskOrderByInput!]
		$where: BillingTaskWhereInput
	) {
		billingTask(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				identifier
				target
				isAutomatedRun
				monthlyBillingLogId
				status
				requestedBy
				request
				responseSnapshot
				createdAt
				updatedAt
			}
			total
		}
	}
`

export function useBillingTaskQuery(
	options?: Omit<Urql.UseQueryArgs<BillingTaskQueryVariables>, 'query'>
) {
	return Urql.useQuery<BillingTaskQuery, BillingTaskQueryVariables>({
		query: BillingTaskDocument,
		...options
	})
}

export const CardRequestsDocument = gql`
	query CardRequests(
		$skip: Int!
		$take: Int
		$orderBy: [CardRequestOrderByInput!]
		$where: CardRequestWhereInput
	) {
		cardRequests(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			id
			status
			deliveryMethod
			sentTo
			sentAt
			viewedAt
			savedAt
			expiresAt
			failureReason
			paymentMethodId
			clientId
			pimsClientId
			createdAt
			consolidatedPractice {
				id
				name
				consolidatorReferenceCode
			}
		}
	}
`

export function useCardRequestsQuery(
	options: Omit<Urql.UseQueryArgs<CardRequestsQueryVariables>, 'query'>
) {
	return Urql.useQuery<CardRequestsQuery, CardRequestsQueryVariables>({
		query: CardRequestsDocument,
		...options
	})
}
export const CardRequestsWithCountDocument = gql`
	query CardRequestsWithCount(
		$skip: Int!
		$take: Int
		$orderBy: [CardRequestOrderByInput!]
		$where: CardRequestWhereInput
	) {
		cardRequestsWithCount(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				status
				deliveryMethod
				sentTo
				sentAt
				viewedAt
				savedAt
				expiresAt
				failureReason
				paymentMethodId
				clientId
				pimsClientId
				createdAt
				consolidatedPractice {
					id
					name
					consolidatorReferenceCode
				}
			}
			total
		}
	}
`

export function useCardRequestsWithCountQuery(
	options: Omit<Urql.UseQueryArgs<CardRequestsWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<CardRequestsWithCountQuery, CardRequestsWithCountQueryVariables>({
		query: CardRequestsWithCountDocument,
		...options
	})
}
export const BulkPracticeImportsDocument = gql`
	query bulkPracticeImports(
		$skip: Int
		$take: Int
		$orderBy: [BulkPracticeImportOrderByInput!]
		$where: BulkPracticeImportWhereInput
	) {
		bulkPracticeImports(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				status
				fileName
				importedBy
				totalRows
				summary
				createdAt
				completedAt
			}
			total
		}
	}
`

export function useBulkPracticeImportsQuery(
	options?: Omit<Urql.UseQueryArgs<BulkPracticeImportsQueryVariables>, 'query'>
) {
	return Urql.useQuery<BulkPracticeImportsQuery, BulkPracticeImportsQueryVariables>({
		query: BulkPracticeImportsDocument,
		...options
	})
}
export const BulkPracticeImportDocument = gql`
	query bulkPracticeImport($id: String!) {
		bulkPracticeImport(id: $id) {
			id
			status
			fileName
			importedBy
			totalRows
			preview
			results
			summary
			createdAt
			completedAt
		}
	}
`

export function useBulkPracticeImportQuery(
	options: Omit<Urql.UseQueryArgs<BulkPracticeImportQueryVariables>, 'query'>
) {
	return Urql.useQuery<BulkPracticeImportQuery, BulkPracticeImportQueryVariables>({
		query: BulkPracticeImportDocument,
		...options
	})
}
export const BusinessVerificationSubmissionsDocument = gql`
	query BusinessVerificationSubmissions(
		$statuses: [BusinessVerificationStatus!]
		$consolidatedPracticeId: String
		$submittedFrom: DateTime
		$submittedTo: DateTime
		$sortDirection: SortOrder
		$skip: Int
		$take: Int
	) {
		businessVerificationSubmissions(
			statuses: $statuses
			consolidatedPracticeId: $consolidatedPracticeId
			submittedFrom: $submittedFrom
			submittedTo: $submittedTo
			sortDirection: $sortDirection
			skip: $skip
			take: $take
		) {
			items {
				id
				consolidatedPracticeId
				status
				source
				verificationMethod
				legalBusinessName
				einLast4
				irsDocUrl
				irsDocName
				w9Url
				w9Name
				submittedAt
				reviewedAt
				reviewedBy
				failureReason
				reviewerNotes
				consolidatedPractice {
					id
					name
					paymentId
					lendingId
				}
			}
			total
			skip
			take
		}
	}
`

export function useBusinessVerificationSubmissionsQuery(
	options?: Omit<Urql.UseQueryArgs<BusinessVerificationSubmissionsQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		BusinessVerificationSubmissionsQuery,
		BusinessVerificationSubmissionsQueryVariables
	>({ query: BusinessVerificationSubmissionsDocument, ...options })
}
export const BusinessVerificationSubmissionDocument = gql`
	query BusinessVerificationSubmission($id: String!) {
		businessVerificationSubmission(id: $id) {
			id
			consolidatedPracticeId
			status
			source
			verificationMethod
			legalBusinessName
			ein
			einLast4
			irsDocUrl
			irsDocName
			w9Url
			w9Name
			submittedAt
			reviewedAt
			reviewedBy
			failureReason
			reviewerNotes
			consolidatedPractice {
				id
				name
				paymentId
				lendingId
				email
				legalBusinessName
				businessVerificationStatus
			}
		}
	}
`

export function useBusinessVerificationSubmissionQuery(
	options: Omit<Urql.UseQueryArgs<BusinessVerificationSubmissionQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		BusinessVerificationSubmissionQuery,
		BusinessVerificationSubmissionQueryVariables
	>({ query: BusinessVerificationSubmissionDocument, ...options })
}
export const CreateCashDepositDocument = gql`
	mutation CreateCashDeposit(
		$reportedDepositAmount: Int!
		$plannedDepositDate: DateTimeISO
		$dtsTrackingNumber: String
		$cashSalesDate: DateTimeISO!
		$cashDrawers: [CreateCashDrawerArgs!]!
	) {
		createCashDeposit(
			reportedDepositAmount: $reportedDepositAmount
			plannedDepositDate: $plannedDepositDate
			dtsTrackingNumber: $dtsTrackingNumber
			cashSalesDate: $cashSalesDate
			cashDrawers: $cashDrawers
		) {
			id
			consolidatedPracticeId
			reportedDepositAmount
			dtsTrackingNumber
			cashSalesDate
			cashDrawers {
				cashDrawerIdentifier
				reportedCashCount
				reconciliationNote
			}
		}
	}
`

export function useCreateCashDepositMutation() {
	return Urql.useMutation<CreateCashDepositMutation, CreateCashDepositMutationVariables>(
		CreateCashDepositDocument
	)
}
export const ListCashDepositsDocument = gql`
	query ListCashDeposits(
		$where: CashDepositWhereInput
		$orderBy: [CashDepositOrderByInput!]
		$skip: Int
		$take: Int
		$all: Boolean
	) {
		listCashDeposits(where: $where, orderBy: $orderBy, skip: $skip, take: $take, all: $all) {
			id
			reportedDepositAmount
			plannedDepositDate
			dtsTrackingNumber
			cashSalesDate
			consolidatedPracticeId
			consolidatorId
			createdAt
			consolidatedPractice {
				name
				consolidatorReferenceCode
				consolidatorReferenceCode2
				consolidatorReferenceCode3
			}
			consolidatorId
			createdByUser {
				email
			}
			cashDrawers {
				cashDrawerIdentifier
				reportedCashCount
				reconciliationNote
			}
		}
	}
`

export function useListCashDepositsQuery(
	options?: Omit<Urql.UseQueryArgs<ListCashDepositsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListCashDepositsQuery, ListCashDepositsQueryVariables>({
		query: ListCashDepositsDocument,
		...options
	})
}
export const ListCashDepositsWithCountDocument = gql`
	query ListCashDepositsWithCount(
		$where: CashDepositWhereInput
		$orderBy: [CashDepositOrderByInput!]
		$skip: Int
		$take: Int
		$all: Boolean
	) {
		listCashDepositsWithCount(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
			all: $all
		) {
			total
			items {
				id
				reportedDepositAmount
				plannedDepositDate
				dtsTrackingNumber
				cashSalesDate
				consolidatedPracticeId
				createdAt
				consolidatedPractice {
					name
					consolidatorReferenceCode
					consolidatorReferenceCode2
					consolidatorReferenceCode3
				}
				consolidatorId
				createdByUser {
					email
				}
				cashDrawers {
					cashDrawerIdentifier
					reportedCashCount
					reconciliationNote
				}
			}
		}
	}
`

export function useListCashDepositsWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<ListCashDepositsWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListCashDepositsWithCountQuery, ListCashDepositsWithCountQueryVariables>({
		query: ListCashDepositsWithCountDocument,
		...options
	})
}
export const ListCashDrawersDocument = gql`
	query ListCashDrawers(
		$where: CashDrawerWhereInput
		$orderBy: [CashDrawerOrderByInput!]
		$skip: Int
		$take: Int
		$all: Boolean
	) {
		listCashDrawers(where: $where, orderBy: $orderBy, skip: $skip, take: $take, all: $all) {
			id
			cashDrawerIdentifier
			reportedCashCount
			reconciliationNote
			cashDepositId
			cashSalesDate
			consolidatedPracticeId
			createdAt
			consolidatedPractice {
				name
				consolidatorReferenceCode
				consolidatorReferenceCode2
				consolidatorReferenceCode3
			}
			createdByUser {
				email
			}
		}
	}
`

export function useListCashDrawersQuery(
	options?: Omit<Urql.UseQueryArgs<ListCashDrawersQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListCashDrawersQuery, ListCashDrawersQueryVariables>({
		query: ListCashDrawersDocument,
		...options
	})
}
export const ListCashDrawersWithCountDocument = gql`
	query ListCashDrawersWithCount(
		$where: CashDrawerWhereInput
		$orderBy: [CashDrawerOrderByInput!]
		$skip: Int
		$take: Int
		$all: Boolean
	) {
		listCashDrawersWithCount(
			where: $where
			orderBy: $orderBy
			skip: $skip
			take: $take
			all: $all
		) {
			total
			items {
				id
				cashDrawerIdentifier
				reportedCashCount
				reconciliationNote
				cashDepositId
				cashSalesDate
				consolidatedPracticeId
				createdAt
				consolidatedPractice {
					name
					consolidatorReferenceCode
					consolidatorReferenceCode2
					consolidatorReferenceCode3
				}
				createdByUser {
					email
				}
			}
		}
	}
`

export function useListCashDrawersWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<ListCashDrawersWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListCashDrawersWithCountQuery, ListCashDrawersWithCountQueryVariables>({
		query: ListCashDrawersWithCountDocument,
		...options
	})
}
export const UpdateConsolidatedPracticeStatusDocument = gql`
	mutation updateConsolidatedPracticeStatus(
		$id: String!
		$processType: String
		$processStatus: String
	) {
		updateConsolidatedPracticeStatus(
			id: $id
			processType: $processType
			processStatus: $processStatus
		) {
			id
			status
		}
	}
`

export function useUpdateConsolidatedPracticeStatusMutation() {
	return Urql.useMutation<
		UpdateConsolidatedPracticeStatusMutation,
		UpdateConsolidatedPracticeStatusMutationVariables
	>(UpdateConsolidatedPracticeStatusDocument)
}
export const GetConsolidatedPracticesSlimDocument = gql`
	query GetConsolidatedPracticesSlim(
		$where: ConsolidatedPracticeWhereInput
		$orderBy: [ConsolidatedPracticeOrderByInput!]
		$skip: Int
		$take: Int
	) {
		consolidatedPractices(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			total
			items {
				id
				paymentId
				lendingId
				name
				consolidatorId
				consolidatorReferenceCode
				consolidatorReferenceCode2
				regionalManagerId
				logoUrl
				city
				state
				country
				isActive
				terminalLocation
			}
		}
	}
`

export function useGetConsolidatedPracticesSlimQuery(
	options?: Omit<Urql.UseQueryArgs<GetConsolidatedPracticesSlimQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		GetConsolidatedPracticesSlimQuery,
		GetConsolidatedPracticesSlimQueryVariables
	>({ query: GetConsolidatedPracticesSlimDocument, ...options })
}
export const GetConsolidatedPracticesDocument = gql`
	query GetConsolidatedPractices(
		$where: ConsolidatedPracticeWhereInput
		$orderBy: [ConsolidatedPracticeOrderByInput!]
		$skip: Int
		$take: Int
	) {
		consolidatedPractices(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			total
			items {
				id
				paymentId
				lendingId
				consolidatorReferenceCode
				consolidatorReferenceCode2
				consolidatorReferenceCode3
				isPaymentEnabled
				isLendingEnabled
				isRebateEnabled
				isActive
				isDeleted
				name
				legalBusinessName
				consolidatorId
				consolidator {
					id
					featureFlags
				}
				address
				address2
				email
				signerEmail
				signerName
				phone
				city
				state
				zip
				country
				currency
				timezone
				settings
				pimsMetadata
				activeTerminalsCount
				totalTerminalsCount
				terminalLocation
				hospitalManagerEmail
				website
				regionalManagerId
				surchargeEnabled
				surchargeFeePct
				surchargeStartDate
				transactionFees
				integrationId
				netsuiteId
				skyworldId
				logoUrl
				isCustomPayoutEnabled
				customPayoutTarget
				customPayoutSettings
				customPayoutRunAtTime
				customPayoutStartedAt
				createdAt
				updatedAt
			}
		}
	}
`

export function useGetConsolidatedPracticesQuery(
	options?: Omit<Urql.UseQueryArgs<GetConsolidatedPracticesQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetConsolidatedPracticesQuery, GetConsolidatedPracticesQueryVariables>({
		query: GetConsolidatedPracticesDocument,
		...options
	})
}
export const UpsertConsolidatedPracticeDocument = gql`
	mutation upsertConsolidatedPractice(
		$id: String
		$name: String
		$legalBusinessName: String
		$address: String
		$address2: String
		$city: String
		$state: String
		$zip: String
		$country: String
		$currency: String
		$paymentId: String
		$lendingId: Int
		$email: String
		$phone: String
		$signerName: String
		$signerEmail: String
		$isDeleted: Boolean
		$isLendingEnabled: Boolean
		$isPaymentEnabled: Boolean
		$isRebateEnabled: Boolean
		$consolidatorId: String
		$timezone: String
		$pimsMetadata: JSON
		$settings: JSON
	) {
		upsertConsolidatedPractice(
			id: $id
			name: $name
			legalBusinessName: $legalBusinessName
			address: $address
			address2: $address2
			city: $city
			state: $state
			zip: $zip
			country: $country
			currency: $currency
			paymentId: $paymentId
			lendingId: $lendingId
			email: $email
			phone: $phone
			signerName: $signerName
			signerEmail: $signerEmail
			isDeleted: $isDeleted
			isLendingEnabled: $isLendingEnabled
			isPaymentEnabled: $isPaymentEnabled
			isRebateEnabled: $isRebateEnabled
			consolidatorId: $consolidatorId
			timezone: $timezone
			pimsMetadata: $pimsMetadata
			settings: $settings
		) {
			id
			name
			legalBusinessName
			city
			state
			country
			isLendingEnabled
			isPaymentEnabled
			isRebateEnabled
			createdAt
			updatedAt
		}
	}
`

export function useUpsertConsolidatedPracticeMutation() {
	return Urql.useMutation<
		UpsertConsolidatedPracticeMutation,
		UpsertConsolidatedPracticeMutationVariables
	>(UpsertConsolidatedPracticeDocument)
}
export const UpsertConsolidatedPracticeBankAccountDocument = gql`
	mutation UpsertConsolidatedPracticeBankAccount(
		$id: String
		$consolidatedPracticeId: String
		$accountNumber: String
		$routingNumber: String
		$accountHolderName: String
		$accountHolderType: String
		$bankName: String
		$status: BankAccountStatus
		$usedForProduct: [ScratchProduct!]
		$stripeBankAccountId: String
		$stripePaymentMethodId: String
		$stripeCustomerId: String
		$stripePlatformAccountId: String
		$metadata: JSON
		$disabledReason: String
	) {
		upsertConsolidatedPracticeBankAccount(
			id: $id
			consolidatedPracticeId: $consolidatedPracticeId
			accountNumber: $accountNumber
			routingNumber: $routingNumber
			accountHolderName: $accountHolderName
			accountHolderType: $accountHolderType
			bankName: $bankName
			status: $status
			usedForProduct: $usedForProduct
			stripeBankAccountId: $stripeBankAccountId
			stripePaymentMethodId: $stripePaymentMethodId
			stripeCustomerId: $stripeCustomerId
			stripePlatformAccountId: $stripePlatformAccountId
			metadata: $metadata
			disabledReason: $disabledReason
		) {
			id
			consolidatedPracticeId
			accountNumber
			routingNumber
			accountHolderName
			accountHolderType
			bankName
			status
			usedForProduct
			stripeBankAccountId
			stripePaymentMethodId
			stripeCustomerId
			stripePlatformAccountId
			metadata
			enabledAt
			enabledByUserId
			disabledAt
			disabledByUserId
			disabledReason
			createdAt
			updatedAt
		}
	}
`

export function useUpsertConsolidatedPracticeBankAccountMutation() {
	return Urql.useMutation<
		UpsertConsolidatedPracticeBankAccountMutation,
		UpsertConsolidatedPracticeBankAccountMutationVariables
	>(UpsertConsolidatedPracticeBankAccountDocument)
}
export const GetConsolidatedPracticesAndBankAccountsDocument = gql`
	query GetConsolidatedPracticesAndBankAccounts(
		$wherePractices: ConsolidatedPracticeWhereInput
		$orderByPractices: [ConsolidatedPracticeOrderByInput!]
		$skipPractices: Int
		$takePractices: Int
		$consolidatedPracticeId: String!
		$whereBankAccounts: ConsolidatedPracticeBankAccountWhereInput
		$orderByBankAccounts: ConsolidatedPracticeBankAccountOrderByInput
		$skipBankAccounts: Int
		$takeBankAccounts: Int
	) {
		consolidatedPractices(
			where: $wherePractices
			orderBy: $orderByPractices
			skip: $skipPractices
			take: $takePractices
		) {
			total
			items {
				id
				paymentId
				lendingId
				isPaymentEnabled
				isLendingEnabled
				isRebateEnabled
				isDeleted
				name
				legalBusinessName
				consolidatorId
				consolidatorReferenceCode
				consolidatorReferenceCode2
				consolidatorReferenceCode3
				address
				address2
				email
				signerEmail
				signerName
				phone
				city
				state
				zip
				country
				currency
				timezone
				website
				hospitalManagerEmail
				regionalManagerId
				createdAt
				updatedAt
				pimsMetadata
			}
		}
		practiceBankAccounts(
			consolidatedPracticeId: $consolidatedPracticeId
			where: $whereBankAccounts
			orderBy: $orderByBankAccounts
			skip: $skipBankAccounts
			take: $takeBankAccounts
		) {
			total
			items {
				id
				consolidatedPracticeId
				accountNumber
				routingNumber
				accountHolderName
				accountHolderType
			}
		}
	}
`

export function useGetConsolidatedPracticesAndBankAccountsQuery(
	options: Omit<Urql.UseQueryArgs<GetConsolidatedPracticesAndBankAccountsQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		GetConsolidatedPracticesAndBankAccountsQuery,
		GetConsolidatedPracticesAndBankAccountsQueryVariables
	>({ query: GetConsolidatedPracticesAndBankAccountsDocument, ...options })
}
export const GetPracticeBankAccountsDocument = gql`
	query GetPracticeBankAccounts(
		$consolidatedPracticeId: String!
		$whereBankAccounts: ConsolidatedPracticeBankAccountWhereInput
		$orderByBankAccounts: ConsolidatedPracticeBankAccountOrderByInput
		$skipBankAccounts: Int
		$takeBankAccounts: Int
	) {
		practiceBankAccounts(
			consolidatedPracticeId: $consolidatedPracticeId
			where: $whereBankAccounts
			orderBy: $orderByBankAccounts
			skip: $skipBankAccounts
			take: $takeBankAccounts
		) {
			total
			items {
				id
				consolidatedPracticeId
				accountNumber
				routingNumber
				accountHolderName
				accountHolderType
			}
		}
	}
`

export function useGetPracticeBankAccountsQuery(
	options: Omit<Urql.UseQueryArgs<GetPracticeBankAccountsQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetPracticeBankAccountsQuery, GetPracticeBankAccountsQueryVariables>({
		query: GetPracticeBankAccountsDocument,
		...options
	})
}
export const SearchConsolidatedPracticesForPayoutDocument = gql`
	query SearchConsolidatedPracticesForPayout($where: ConsolidatedPracticeWhereInput, $take: Int) {
		consolidatedPractices(where: $where, take: $take, orderBy: { name: asc }) {
			items {
				id
				paymentId
				lendingId
				name
				consolidatorId
				timezone
				isCustomPayoutEnabled
				customPayoutTarget
				customPayoutSettings
			}
		}
	}
`

export function useSearchConsolidatedPracticesForPayoutQuery(
	options?: Omit<Urql.UseQueryArgs<SearchConsolidatedPracticesForPayoutQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		SearchConsolidatedPracticesForPayoutQuery,
		SearchConsolidatedPracticesForPayoutQueryVariables
	>({ query: SearchConsolidatedPracticesForPayoutDocument, ...options })
}
export const ListConsolidatedPracticesDirectoryDocument = gql`
	query ListConsolidatedPracticesDirectory(
		$where: ConsolidatedPracticeWhereInput
		$skip: Int
		$take: Int
	) {
		consolidatedPractices(where: $where, orderBy: { name: asc }, skip: $skip, take: $take) {
			total
			items {
				id
				paymentId
				name
				consolidatorId
				pimsMetadata
			}
		}
	}
`

export function useListConsolidatedPracticesDirectoryQuery(
	options?: Omit<Urql.UseQueryArgs<ListConsolidatedPracticesDirectoryQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		ListConsolidatedPracticesDirectoryQuery,
		ListConsolidatedPracticesDirectoryQueryVariables
	>({ query: ListConsolidatedPracticesDirectoryDocument, ...options })
}
export const GetConsolidatorsDocument = gql`
	query GetConsolidators(
		$skip: Int!
		$take: Int
		$orderBy: [ConsolidatorOrderByInput!]
		$where: ConsolidatorWhereInput
	) {
		consolidators(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			id
			name
			mcc
			timezone
			ownerLastFour
			customFields
			customization
			featureFlags
			financingFlags
			canadaAccountInfo
		}
	}
`

export function useGetConsolidatorsQuery(
	options: Omit<Urql.UseQueryArgs<GetConsolidatorsQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetConsolidatorsQuery, GetConsolidatorsQueryVariables>({
		query: GetConsolidatorsDocument,
		...options
	})
}
export const ConsolidatorFeatureFlagDocument = gql`
	query ConsolidatorFeatureFlag($name: String!) {
		consolidatorFeatureFlag(name: $name)
	}
`

export function useConsolidatorFeatureFlagQuery(
	options: Omit<Urql.UseQueryArgs<ConsolidatorFeatureFlagQueryVariables>, 'query'>
) {
	return Urql.useQuery<ConsolidatorFeatureFlagQuery, ConsolidatorFeatureFlagQueryVariables>({
		query: ConsolidatorFeatureFlagDocument,
		...options
	})
}
export const ListCustomPayoutDetailsDocument = gql`
	query listCustomPayoutDetails(
		$skip: Int
		$take: Int
		$orderBy: [CustomPayoutDetailsOrderByInput!]
		$where: CustomPayoutDetailsWhereInput
	) {
		listCustomPayoutDetails(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				payoutEstimatedArrivalAt
				practiceConsolidatorReferenceCode
				practiceConsolidatorReferenceCode2
				practiceName
				transactionAmount
				transactionFee
				baseTransactionFee
				savedPaymentMethodFee
				transactionNet
				paymentIntentId
				transactionDate
				transactionType
				paymentType
				cardBrand
				cardFunding
				cardholderName
				payoutDescription
				payoutStatementDescriptor
				payoutReference
				stripePayoutId
				practiceId
				customPayoutPracticeBatchId
				customPayoutConsolidatorBatchId
				consolidatorId
				pimsClientId
				currency
				lockboxId
				createdAt
				surchargeFee
				tipAmount
				practiceNetsuiteId
				practiceSkyworldId
				scratchPaymentMethod
				scratchPaymentRequestType
				savedPaymentMethod
			}
			skip
			take
			total
		}
	}
`

export function useListCustomPayoutDetailsQuery(
	options?: Omit<Urql.UseQueryArgs<ListCustomPayoutDetailsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListCustomPayoutDetailsQuery, ListCustomPayoutDetailsQueryVariables>({
		query: ListCustomPayoutDetailsDocument,
		...options
	})
}
export const SumCustomPayoutDetailsByCardBrandDocument = gql`
	query sumCustomPayoutDetailsByCardBrand($where: CustomPayoutDetailsWhereInput) {
		sumCustomPayoutDetailsByCardBrand(where: $where) {
			items {
				cardBrand
				transactionAmount
				transactionFee
				transactionNet
				tipAmount
			}
		}
	}
`

export function useSumCustomPayoutDetailsByCardBrandQuery(
	options?: Omit<Urql.UseQueryArgs<SumCustomPayoutDetailsByCardBrandQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		SumCustomPayoutDetailsByCardBrandQuery,
		SumCustomPayoutDetailsByCardBrandQueryVariables
	>({ query: SumCustomPayoutDetailsByCardBrandDocument, ...options })
}
export const ListPayoutsDocument = gql`
	query ListPayouts(
		$skip: Int
		$take: Int
		$orderBy: [CustomPayoutPracticeBatchOrderByInput!]
		$where: CustomPayoutPracticeBatchWhereInput
	) {
		listPayouts(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				paymentAmount
				paymentApplicationFee
				refundAmount
				disputeAmount
				disputeFee
				refundApplicationFee
				payoutAmount
				payoutEstimatedArrivalAt
				startWindowDate
				stripePayoutId
				description
				statementDescriptor
				payoutReference
				surchargeFee
				tipAmount
				refundedTipAmount
				donationAmount
				notes
				practice {
					id
					name
					consolidatorReferenceCode
					netsuiteId
					skyworldId
				}
				consolidatedPractice {
					...GridConsolidatedPracticeSummary
				}
			}
			skip
			take
			total
		}
	}
	${GridConsolidatedPracticeSummaryFragmentDoc}
`

export function useListPayoutsQuery(
	options?: Omit<Urql.UseQueryArgs<ListPayoutsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListPayoutsQuery, ListPayoutsQueryVariables>({
		query: ListPayoutsDocument,
		...options
	})
}
export const GetDailyTotalsDocument = gql`
	query GetDailyTotals($where: DailyTotalsWhereInput, $includePaymentMethod: Boolean) {
		dailyTotals(where: $where, includePaymentMethod: $includePaymentMethod) {
			byCard {
				cardBrand
				scratchPaymentMethod
				sumPayments
				sumRefunds
				total
			}
			byPaymentType {
				paymentType
				sumPayments
				sumRefunds
				total
			}
		}
	}
`

export function useGetDailyTotalsQuery(
	options?: Omit<Urql.UseQueryArgs<GetDailyTotalsQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetDailyTotalsQuery, GetDailyTotalsQueryVariables>({
		query: GetDailyTotalsDocument,
		...options
	})
}
export const GetStripeDisputesDocument = gql`
	query GetStripeDisputes($take: Int, $skip: Int, $where: StripeDisputeWhereInput) {
		stripeDisputes(take: $take, skip: $skip, where: $where) {
			items {
				id
				practiceId
				amount
				last4
				evidenceDetails
				cardholderName
				disputeFee
				disputeTotal
				lostAt
				reason
				practiceFundsWithdrawalAt
				currency
				status
				stripeStatus
				createdAt
				charge {
					amount
					capturedAt
					transferDestinationPaymentId
				}
			}
			total
			skip
			take
		}
	}
`

export function useGetStripeDisputesQuery(
	options?: Omit<Urql.UseQueryArgs<GetStripeDisputesQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetStripeDisputesQuery, GetStripeDisputesQueryVariables>({
		query: GetStripeDisputesDocument,
		...options
	})
}
export const GetStripeDisputeDetailsDocument = gql`
	query GetStripeDisputeDetails($id: String!) {
		stripeDisputeDetails(id: $id) {
			id
			consolidatedPracticeId
			currency
			paymentAmount
			paymentSucceededAt
			disputedAmount
			cardholderName
			cardholderEmail
			reason
			networkReasonCode
			stripeStatus
			status
			receivedAt
			decidedAt
			evidenceSubmittedAt
			lostDisputeFee
			paymentMethod {
				type
				brand
				last4
				funding
				expMonth
				expYear
				country
				cvcCheck
				postalCodeCheck
				readMethod
				billingAddress
			}
			chargebackClaim {
				text
				files {
					fileId
				}
			}
			bankResponse {
				text
				files {
					fileId
				}
			}
			submittedEvidence {
				fileId
				fileName
				categoryLabel
			}
		}
	}
`

export function useGetStripeDisputeDetailsQuery(
	options: Omit<Urql.UseQueryArgs<GetStripeDisputeDetailsQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetStripeDisputeDetailsQuery, GetStripeDisputeDetailsQueryVariables>({
		query: GetStripeDisputeDetailsDocument,
		...options
	})
}
export const ListPartnersDocument = gql`
	query ListPartners(
		$skip: Int
		$take: Int
		$orderBy: [PartnerOrderByInput!]
		$where: PartnerWhereInput
	) {
		listPartners(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				name
				consolidatorId
			}
			total
		}
	}
`

export function useListPartnersQuery(
	options?: Omit<Urql.UseQueryArgs<ListPartnersQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListPartnersQuery, ListPartnersQueryVariables>({
		query: ListPartnersDocument,
		...options
	})
}
export const PaymentHistoryDocument = gql`
	query PaymentHistory(
		$skip: Int
		$take: Int
		$orderBy: [PaymentHistoryOrderByInput!]
		$where: PaymentHistoryWhereInput
	) {
		paymentHistories(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			amount
			amountDue
			amountCaptured
			amountCapturable
			amountReceived
			amountRefunded
			amountWithoutSurcharge
			applicationId
			canceledAt
			cancellationReason
			captureMethod
			cardBrand
			cardType
			cardholderName
			charges
			chargeId
			clinicName
			confirmationMethod
			consolidatorReferenceCode
			consolidatorReferenceCode2
			createdAt
			createdByEmail
			createdByUser
			currency
			customerId
			customerName
			dateToFilter
			description
			failureCode
			failureReason
			id
			invoiceId
			lockboxId
			last4
			metadata
			notes
			object
			originalChargeAmountDue
			originalChargeDate
			paymentMethodId
			paymentMethodOptions
			paymentMethodType
			pimsClientId
			pimsInvoiceId
			practiceId
			scratchPaymentMethod
			scratchPaymentRequestType
			status
			transactionStatus
			subscriptionId
			subscriptionScheduleId
			succeededAt
			surcharge
			surchargeFee
			donationAmount
			baseAmount
			tipAmount
			refundedTipAmount
			updatedAt
			disputed
			disputeId
			disputeStatus
		}
	}
`

export function usePaymentHistoryQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentHistoryQueryVariables>, 'query'>
) {
	return Urql.useQuery<PaymentHistoryQuery, PaymentHistoryQueryVariables>({
		query: PaymentHistoryDocument,
		...options
	})
}
export const PaymentHistoryWithCountDocument = gql`
	query PaymentHistoryWithCount(
		$skip: Int
		$take: Int
		$orderBy: [PaymentHistoryOrderByInput!]
		$where: PaymentHistoryWhereInput
	) {
		paymentHistoriesWithCount(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				amount
				amountDue
				amountCaptured
				amountCapturable
				amountReceived
				amountRefunded
				amountWithoutSurcharge
				applicationId
				canceledAt
				cancellationReason
				captureMethod
				cardBrand
				cardType
				cardholderName
				charges
				chargeId
				clinicName
				confirmationMethod
				consolidatorReferenceCode
				consolidatorReferenceCode2
				createdAt
				createdByEmail
				createdByUser
				currency
				customerId
				customerName
				dateToFilter
				description
				failureCode
				failureReason
				id
				invoiceId
				lockboxId
				last4
				metadata
				notes
				object
				originalChargeAmountDue
				originalChargeDate
				paymentMethodId
				paymentMethodOptions
				paymentMethodType
				pimsClientId
				pimsInvoiceId
				practiceId
				scratchPaymentMethod
				scratchPaymentRequestType
				status
				transactionStatus
				subscriptionId
				subscriptionScheduleId
				succeededAt
				surcharge
				surchargeFee
				donationAmount
				baseAmount
				tipAmount
				refundedTipAmount
				updatedAt
				disputed
				disputeId
				disputeStatus
			}
			total
		}
	}
`

export function usePaymentHistoryWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentHistoryWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<PaymentHistoryWithCountQuery, PaymentHistoryWithCountQueryVariables>({
		query: PaymentHistoryWithCountDocument,
		...options
	})
}
export const PaymentHistoryForManualPayoutDocument = gql`
	query PaymentHistoryForManualPayout(
		$skip: Int
		$take: Int
		$orderBy: [PaymentHistoryOrderByInput!]
		$where: PaymentHistoryWhereInput
	) {
		paymentHistoriesWithCount(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				object
				chargeId
				dateToFilter
				customerName
				amountCaptured
				paymentMethodType
				cardBrand
				last4
				status
				transactionStatus
				invoiceId
				payoutDescription
				stripePayoutiD
			}
			total
		}
	}
`

export function usePaymentHistoryForManualPayoutQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentHistoryForManualPayoutQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		PaymentHistoryForManualPayoutQuery,
		PaymentHistoryForManualPayoutQueryVariables
	>({ query: PaymentHistoryForManualPayoutDocument, ...options })
}
export const PaymentHistoryListWithSummaryDocument = gql`
	query PaymentHistoryListWithSummary(
		$skip: Int
		$take: Int
		$orderBy: [PaymentHistoryOrderByInput!]
		$where: PaymentHistoryWhereInput
	) {
		paymentHistoriesWithSummary(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				amount
				amountDue
				amountCaptured
				amountCapturable
				amountReceived
				amountRefunded
				amountWithoutSurcharge
				applicationId
				canceledAt
				cancellationReason
				captureMethod
				cardBrand
				cardType
				cardholderName
				charges
				chargeId
				clinicName
				confirmationMethod
				consolidatorReferenceCode
				consolidatorReferenceCode2
				createdAt
				createdByEmail
				createdByUser
				currency
				customerId
				customerName
				dateToFilter
				description
				failureCode
				failureReason
				id
				invoiceId
				lockboxId
				last4
				metadata
				notes
				object
				originalChargeAmountDue
				originalChargeDate
				paymentMethodId
				paymentMethodOptions
				paymentMethodType
				pimsClientId
				pimsInvoiceId
				practiceId
				scratchPaymentMethod
				scratchPaymentRequestType
				status
				transactionStatus
				subscriptionId
				subscriptionScheduleId
				succeededAt
				surcharge
				surchargeFee
				donationAmount
				baseAmount
				tipAmount
				refundedTipAmount
				updatedAt
				disputed
				disputeId
				disputeStatus
			}
			summary {
				count
				totalAmount
				totalRefunded
				totalFailed
				totalPaid
				totalPending
				totalUncaptured
				totalFailedECheck
				totalReturnedECheck
			}
		}
	}
`

export function usePaymentHistoryListWithSummaryQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentHistoryListWithSummaryQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		PaymentHistoryListWithSummaryQuery,
		PaymentHistoryListWithSummaryQueryVariables
	>({ query: PaymentHistoryListWithSummaryDocument, ...options })
}
export const PaymentHistoryWithoutChargesDocument = gql`
	query PaymentHistoryWithoutCharges(
		$skip: Int
		$take: Int
		$orderBy: [PaymentHistoryOrderByInput!]
		$where: PaymentHistoryWhereInput
	) {
		paymentHistories(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			amount
			amountDue
			amountCaptured
			amountCapturable
			amountReceived
			amountRefunded
			amountWithoutSurcharge
			applicationId
			canceledAt
			cancellationReason
			captureMethod
			cardBrand
			cardType
			cardholderName
			clinicName
			confirmationMethod
			consolidatorReferenceCode
			consolidatorReferenceCode2
			createdAt
			createdByEmail
			createdByUser
			currency
			customerId
			customerName
			dateToFilter
			description
			failureCode
			failureReason
			id
			invoiceId
			lockboxId
			last4
			metadata
			notes
			object
			originalChargeAmountDue
			originalChargeDate
			paymentMethodId
			paymentMethodOptions
			paymentMethodType
			pimsClientId
			pimsInvoiceId
			practiceId
			scratchPaymentMethod
			scratchPaymentRequestType
			status
			transactionStatus
			subscriptionId
			subscriptionScheduleId
			succeededAt
			surcharge
			surchargeFee
			donationAmount
			baseAmount
			tipAmount
			refundedTipAmount
			updatedAt
			disputed
			disputeId
			disputeStatus
		}
	}
`

export function usePaymentHistoryWithoutChargesQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentHistoryWithoutChargesQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		PaymentHistoryWithoutChargesQuery,
		PaymentHistoryWithoutChargesQueryVariables
	>({ query: PaymentHistoryWithoutChargesDocument, ...options })
}
export const PaymentHistorySummaryDocument = gql`
	query PaymentHistorySummary($where: PaymentHistoryWhereInput!) {
		paymentHistorySummary(where: $where) {
			count
			totalAmount
			totalRefunded
			totalFailed
			totalPaid
			totalPending
			totalUncaptured
			totalFailedECheck
			totalReturnedECheck
		}
	}
`

export function usePaymentHistorySummaryQuery(
	options: Omit<Urql.UseQueryArgs<PaymentHistorySummaryQueryVariables>, 'query'>
) {
	return Urql.useQuery<PaymentHistorySummaryQuery, PaymentHistorySummaryQueryVariables>({
		query: PaymentHistorySummaryDocument,
		...options
	})
}
export const RefundVisibilityDocument = gql`
	query RefundVisibility($refundId: String, $paymentIntentId: String, $amountRefundedBefore: Int) {
		refundVisibility(
			refundId: $refundId
			paymentIntentId: $paymentIntentId
			amountRefundedBefore: $amountRefundedBefore
		)
	}
`

export function useRefundVisibilityQuery(
	options?: Omit<Urql.UseQueryArgs<RefundVisibilityQueryVariables>, 'query'>
) {
	return Urql.useQuery<RefundVisibilityQuery, RefundVisibilityQueryVariables>({
		query: RefundVisibilityDocument,
		...options
	})
}
export const PaymentRequestDocument = gql`
	query PaymentRequest(
		$skip: Int
		$take: Int
		$orderBy: [PaymentRequestOrderByInput!]
		$where: PaymentRequestWhereInput
	) {
		paymentRequests(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			amount
			consolidatorId
			createdAt
			customerId
			customerName
			description
			id
			metadata
			pimsClientId
			practiceId
			scratchPaymentMethod
			status
			succeededAt
			updatedAt
			canceledAt
			paidSeparately
			surchargeFee
			amountWithoutSurcharge
			practice {
				id
				name
				consolidatorReferenceCode
				netsuiteId
				skyworldId
			}
		}
	}
`

export function usePaymentRequestQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentRequestQueryVariables>, 'query'>
) {
	return Urql.useQuery<PaymentRequestQuery, PaymentRequestQueryVariables>({
		query: PaymentRequestDocument,
		...options
	})
}
export const PaymentRequestWithSummaryDocument = gql`
	query PaymentRequestWithSummary(
		$skip: Int
		$take: Int
		$orderBy: [PaymentRequestOrderByInput!]
		$where: PaymentRequestWhereInput
	) {
		paymentRequestsWithSummary(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				amount
				consolidatorId
				createdAt
				customerId
				customerName
				description
				id
				metadata
				pimsClientId
				practiceId
				scratchPaymentMethod
				status
				succeededAt
				updatedAt
				canceledAt
				paidSeparately
				surchargeFee
				amountWithoutSurcharge
				practice {
					id
					name
					consolidatorReferenceCode
					netsuiteId
					skyworldId
				}
			}
			total
			amountWithoutSurcharge
		}
	}
`

export function usePaymentRequestWithSummaryQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentRequestWithSummaryQueryVariables>, 'query'>
) {
	return Urql.useQuery<PaymentRequestWithSummaryQuery, PaymentRequestWithSummaryQueryVariables>({
		query: PaymentRequestWithSummaryDocument,
		...options
	})
}
export const UpdatePaymentRequestDocument = gql`
	mutation UpdatePaymentRequest(
		$id: String
		$arDeliveryMethod: String
		$customerEmail: String
		$customerPhone: String
	) {
		updatePaymentRequest(
			id: $id
			arDeliveryMethod: $arDeliveryMethod
			customerEmail: $customerEmail
			customerPhone: $customerPhone
		) {
			id
			metadata
		}
	}
`

export function useUpdatePaymentRequestMutation() {
	return Urql.useMutation<UpdatePaymentRequestMutation, UpdatePaymentRequestMutationVariables>(
		UpdatePaymentRequestDocument
	)
}
export const ProcessUploadFileDocument = gql`
	mutation ProcessUploadFile($fileName: String!) {
		processUploadedFile(fileName: $fileName) {
			id
			fileName
			createdBy
			consolidatorId
		}
	}
`

export function useProcessUploadFileMutation() {
	return Urql.useMutation<ProcessUploadFileMutation, ProcessUploadFileMutationVariables>(
		ProcessUploadFileDocument
	)
}
export const VoidFileDocument = gql`
	mutation VoidFile($fileId: String!) {
		voidFile(fileId: $fileId) {
			message
			success
		}
	}
`

export function useVoidFileMutation() {
	return Urql.useMutation<VoidFileMutation, VoidFileMutationVariables>(VoidFileDocument)
}
export const PaymentRequestFileListDocument = gql`
	query PaymentRequestFileList(
		$skip: Int
		$take: Int
		$orderBy: [PaymentRequestFileOrderByInput!]
		$where: PaymentRequestFileWhereInput
	) {
		paymentRequestFiles(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				createdAt
				createdBy
				recordsCount
				succeededRecordsCount
				failureReason
				failedRecordsCount
				fileName
				status
				createdByUser {
					name
					displayName
				}
			}
			total
		}
	}
`

export function usePaymentRequestFileListQuery(
	options?: Omit<Urql.UseQueryArgs<PaymentRequestFileListQueryVariables>, 'query'>
) {
	return Urql.useQuery<PaymentRequestFileListQuery, PaymentRequestFileListQueryVariables>({
		query: PaymentRequestFileListDocument,
		...options
	})
}
export const ListPimsDocument = gql`
	query ListPims($where: PimsWhereInput, $skip: Int, $take: Int, $orderBy: [PimsOrderByInput!]) {
		listPims(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
			total
			items {
				id
				name
				currentPimsValue
				industry
				mcc
				isActive
				isVisibleToConsolidatorAdmins
				isVisibleOnSignUpForm
				createdAt
				updatedAt
			}
		}
	}
`

export function useListPimsQuery(
	options?: Omit<Urql.UseQueryArgs<ListPimsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListPimsQuery, ListPimsQueryVariables>({
		query: ListPimsDocument,
		...options
	})
}
export const GetPracticesDocument = gql`
	query GetPractices(
		$skip: Int
		$take: Int
		$orderBy: [PracticeOrderByInput!]
		$where: PracticeWhereInput
	) {
		practices(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			id
			stripeAccountId
			name
			city
			state
			address
			zip
		}
	}
`

export function useGetPracticesQuery(
	options?: Omit<Urql.UseQueryArgs<GetPracticesQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetPracticesQuery, GetPracticesQueryVariables>({
		query: GetPracticesDocument,
		...options
	})
}
export const GetAllPracticesCountDocument = gql`
	query GetAllPracticesCount(
		$skip: Int
		$take: Int
		$orderBy: [PracticeOrderByInput!]
		$where: PracticeWhereInput
	) {
		practicesWithCount(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				stripeAccountId
				consolidatorId
				name
				country
				city
				state
				address
				zip
				vetClinicId
				settings
				integrationId
				hospitalManagerEmail
				products
				routingNumber
				accountNumber
				logoUrl
				activeTerminalsCount
				totalTerminalsCount
				currentPims
				timezone
				isCustomPayoutEnabled
				consolidator {
					id
					featureFlags
				}
				netsuiteId
				skyworldId
			}
			total
		}
	}
`

export function useGetAllPracticesCountQuery(
	options?: Omit<Urql.UseQueryArgs<GetAllPracticesCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetAllPracticesCountQuery, GetAllPracticesCountQueryVariables>({
		query: GetAllPracticesCountDocument,
		...options
	})
}
export const GetAllPracticesDocument = gql`
	query GetAllPractices(
		$skip: Int
		$take: Int
		$orderBy: [PracticeOrderByInput!]
		$where: PracticeWhereInput
	) {
		practices(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			id
			stripeAccountId
			consolidatorId
			name
			country
			city
			state
			address
			zip
			vetClinicId
			settings
			integrationId
			hospitalManagerEmail
			products
			routingNumber
			accountNumber
			logoUrl
			activeTerminalsCount
			totalTerminalsCount
			currentPims
			timezone
			isCustomPayoutEnabled
			customPayoutTarget
			customPayoutSettings
			consolidator {
				id
				featureFlags
			}
			netsuiteId
			skyworldId
		}
	}
`

export function useGetAllPracticesQuery(
	options?: Omit<Urql.UseQueryArgs<GetAllPracticesQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetAllPracticesQuery, GetAllPracticesQueryVariables>({
		query: GetAllPracticesDocument,
		...options
	})
}
export const UpsertCustomPayoutSettingsDocument = gql`
	mutation UpsertCustomPayoutSettings($practiceId: String!, $settings: CustomPayoutSettingsInput!) {
		upsertCustomPayoutSettings(practiceId: $practiceId, settings: $settings) {
			success
			customPayoutSettings
		}
	}
`

export function useUpsertCustomPayoutSettingsMutation() {
	return Urql.useMutation<
		UpsertCustomPayoutSettingsMutation,
		UpsertCustomPayoutSettingsMutationVariables
	>(UpsertCustomPayoutSettingsDocument)
}
export const EnableCustomPayoutV2Document = gql`
	mutation EnableCustomPayoutV2($practiceId: ID!) {
		enableCustomPayoutV2(practiceId: $practiceId) {
			practicePayoutInfo {
				id
				stripeAccountId
				name
				consolidatorId
				customPayoutTarget
				customPayoutSettings
				isCustomPayoutEnabled
			}
		}
	}
`

export function useEnableCustomPayoutV2Mutation() {
	return Urql.useMutation<EnableCustomPayoutV2Mutation, EnableCustomPayoutV2MutationVariables>(
		EnableCustomPayoutV2Document
	)
}
export const PracticeFeeLogsDocument = gql`
	query PracticeFeeLogs(
		$skip: Int
		$take: Int
		$orderBy: [PracticeFeeLogOrderByInput!]
		$where: PracticeFeeLogWhereInput
	) {
		practiceFeeLog(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				practiceId
				surchargeEnabled
				isNetSettlement
				surchargeFeePct
				transactionFees
				customPayoutSettings
				changeLog
				rateScheme
				surchargeStartDate
				source
				updatedBy
				createdAt
				updatedAt
			}
			total
			skip
			take
		}
	}
`

export function usePracticeFeeLogsQuery(
	options?: Omit<Urql.UseQueryArgs<PracticeFeeLogsQueryVariables>, 'query'>
) {
	return Urql.useQuery<PracticeFeeLogsQuery, PracticeFeeLogsQueryVariables>({
		query: PracticeFeeLogsDocument,
		...options
	})
}
export const EnterpriseRebatePayoutBatchesDocument = gql`
	query enterpriseRebatePayoutBatches(
		$skip: Int
		$take: Int
		$orderBy: [EnterpriseRebatePayoutBatchOrderByInput!]
		$where: EnterpriseRebatePayoutBatchWhereInput
	) {
		enterpriseRebatePayoutBatches(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				consolidatedPracticeId
				practiceName
				consolidatorReferenceCode
				manufacturerId
				manufacturerName
				payoutDate
				totalRebateAmount
				totalRebateCount
				batchStatus
				paymentStatus
				stripePayoutId
				statementDescriptor
				payoutEstimatedArrivalAt
				payoutSentAt
				currency
				createdAt
				updatedAt
			}
			total
		}
	}
`

export function useEnterpriseRebatePayoutBatchesQuery(
	options?: Omit<Urql.UseQueryArgs<EnterpriseRebatePayoutBatchesQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		EnterpriseRebatePayoutBatchesQuery,
		EnterpriseRebatePayoutBatchesQueryVariables
	>({ query: EnterpriseRebatePayoutBatchesDocument, ...options })
}
export const EnterpriseRebatePayoutBatchFilterOptionsDocument = gql`
	query enterpriseRebatePayoutBatchFilterOptions {
		enterpriseRebatePayoutBatchFilterOptions {
			practices {
				id
				name
			}
			manufacturers {
				id
				name
			}
		}
	}
`

export function useEnterpriseRebatePayoutBatchFilterOptionsQuery(
	options?: Omit<Urql.UseQueryArgs<EnterpriseRebatePayoutBatchFilterOptionsQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		EnterpriseRebatePayoutBatchFilterOptionsQuery,
		EnterpriseRebatePayoutBatchFilterOptionsQueryVariables
	>({ query: EnterpriseRebatePayoutBatchFilterOptionsDocument, ...options })
}
export const EnterpriseRebatePayoutDetailsDocument = gql`
	query enterpriseRebatePayoutDetails(
		$skip: Int
		$take: Int
		$orderBy: [EnterpriseInvoiceDetectedRebateOrderByInput!]
		$where: EnterpriseInvoiceDetectedRebateWhereInput
	) {
		enterpriseInvoiceDetectedRebate(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				invoiceId
				invoiceLineItemId
				invoiceDate
				rebateCode
				detectedAmount
				rebateProgramName
				rebateProgramProductName
				consolidatedPracticeId
				practiceName
				rebateInvoiceId
				clientFirstName
				clientLastName
				patientName
				payoutBatchId
				status
				createdAt
			}
			total
		}
	}
`

export function useEnterpriseRebatePayoutDetailsQuery(
	options?: Omit<Urql.UseQueryArgs<EnterpriseRebatePayoutDetailsQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		EnterpriseRebatePayoutDetailsQuery,
		EnterpriseRebatePayoutDetailsQueryVariables
	>({ query: EnterpriseRebatePayoutDetailsDocument, ...options })
}
export const AllProgramsDocument = gql`
	query AllPrograms(
		$orderBy: [ListActivePracticeRebateProgramOrderByInput!]
		$where: ListActivePracticeRebateProgramWhereInput
	) {
		rebatePrograms {
			rebatePrograms {
				id
				name
				description
				startAt
				endAt
				status
				partnerName
				title
				priority
				visibility
				logoUrl
				learnMoreUrl
				products {
					id
					name
					sku
					rebateAmount
					rebateCode
					requiredQuantity
					unit
					status
					description
					createdAt
					updatedAt
					productReferences {
						productReferenceId
						productReference {
							id
							name
						}
					}
				}
				bundles {
					id
					name
					description
					rebateAmount
					rebateCode
					bundleCode
					rebateProgramId
					status
					createdAt
					updatedAt
					products {
						id
						name
						sku
						rebateAmount
						rebateCode
						requiredQuantity
						status
						description
						createdAt
						updatedAt
						productReferences {
							productReferenceId
							productReference {
								id
								name
							}
						}
					}
				}
			}
		}
		activePracticeRebatePrograms(orderBy: $orderBy, where: $where) {
			practiceRebatePrograms {
				id
				practiceId
				rebateProgramId
				enabledBy
				disabledBy
				disableReason
				enabledAt
				disabledAt
				status
				createdAt
				updatedAt
			}
		}
	}
`

export function useAllProgramsQuery(
	options?: Omit<Urql.UseQueryArgs<AllProgramsQueryVariables>, 'query'>
) {
	return Urql.useQuery<AllProgramsQuery, AllProgramsQueryVariables>({
		query: AllProgramsDocument,
		...options
	})
}
export const ToggleRebateProgramDocument = gql`
	mutation ToggleRebateProgram(
		$rebateProgramId: String!
		$optIn: Boolean!
		$disableReason: String
	) {
		toggleRebateProgram(
			rebateProgramId: $rebateProgramId
			optIn: $optIn
			disableReason: $disableReason
		) {
			id
			practiceId
			rebateProgramId
			status
			enabledAt
			disabledAt
			disableReason
		}
	}
`

export function useToggleRebateProgramMutation() {
	return Urql.useMutation<ToggleRebateProgramMutation, ToggleRebateProgramMutationVariables>(
		ToggleRebateProgramDocument
	)
}
export const AllRebateProgramsDocument = gql`
	query allRebatePrograms($orderBy: [RebateProgramOrderByInput!], $where: RebateProgramWhereInput) {
		allRebatePrograms(where: $where, orderBy: $orderBy) {
			rebatePrograms {
				id
				name
				description
				products {
					id
					name
					sku
					description
				}
				bundles {
					id
					name
					description
					products {
						id
						name
						sku
						description
					}
				}
			}
		}
	}
`

export function useAllRebateProgramsQuery(
	options?: Omit<Urql.UseQueryArgs<AllRebateProgramsQueryVariables>, 'query'>
) {
	return Urql.useQuery<AllRebateProgramsQuery, AllRebateProgramsQueryVariables>({
		query: AllRebateProgramsDocument,
		...options
	})
}
export const AdminRebateProgramsListDocument = gql`
	query AdminRebateProgramsList(
		$where: RebateProgramWhereInput
		$orderBy: [RebateProgramOrderByInput!]
		$skip: Int
		$take: Int
	) {
		allRebatePrograms(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			total
			rebatePrograms {
				id
				name
				partnerName
				status
				visibility
				startAt
				endAt
				products {
					id
				}
			}
		}
	}
`

export function useAdminRebateProgramsListQuery(
	options?: Omit<Urql.UseQueryArgs<AdminRebateProgramsListQueryVariables>, 'query'>
) {
	return Urql.useQuery<AdminRebateProgramsListQuery, AdminRebateProgramsListQueryVariables>({
		query: AdminRebateProgramsListDocument,
		...options
	})
}
export const RebateProgramsForAdminDocument = gql`
	query rebateProgramsForAdmin(
		$orderBy: [RebateProgramOrderByInput!]
		$where: RebateProgramWhereInput
	) {
		rebatePrograms(where: $where, orderBy: $orderBy) {
			rebatePrograms {
				id
				name
				description
				products {
					id
					name
					sku
					description
				}
				bundles {
					id
					name
					description
					products {
						id
						name
						sku
						description
					}
				}
			}
		}
	}
`

export function useRebateProgramsForAdminQuery(
	options?: Omit<Urql.UseQueryArgs<RebateProgramsForAdminQueryVariables>, 'query'>
) {
	return Urql.useQuery<RebateProgramsForAdminQuery, RebateProgramsForAdminQueryVariables>({
		query: RebateProgramsForAdminDocument,
		...options
	})
}
export const InvoiceDetectedRebateDocument = gql`
	query invoiceDetectedRebate(
		$skip: Int
		$take: Int
		$orderBy: [InvoiceDetectedRebateOrderByInput!]
		$where: InvoiceDetectedRebateWhereInput
	) {
		invoiceDetectedRebate(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				invoiceId
				originalInvoiceId
				invoiceLineItemId
				invoiceDate
				rebateCode
				detectedAmount
				detectedQuantity
				productDescription
				matchedProductName
				matchConfidence
				status
				rejectionReason
				rebateProgramId
				rebateProgramProductId
				rebateProgramName
				rebateProgramProductName
				createdAt
				validatedAt
				payoutBatchId
			}
			total
		}
	}
`

export function useInvoiceDetectedRebateQuery(
	options?: Omit<Urql.UseQueryArgs<InvoiceDetectedRebateQueryVariables>, 'query'>
) {
	return Urql.useQuery<InvoiceDetectedRebateQuery, InvoiceDetectedRebateQueryVariables>({
		query: InvoiceDetectedRebateDocument,
		...options
	})
}
export const EnterpriseInvoiceDetectedRebateDocument = gql`
	query enterpriseInvoiceDetectedRebate(
		$skip: Int
		$take: Int
		$orderBy: [EnterpriseInvoiceDetectedRebateOrderByInput!]
		$where: EnterpriseInvoiceDetectedRebateWhereInput
	) {
		enterpriseInvoiceDetectedRebate(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				invoiceId
				originalInvoiceId
				invoiceLineItemId
				invoiceDate
				rebateCode
				detectedAmount
				detectedQuantity
				productDescription
				matchedProductName
				matchConfidence
				status
				rejectionReason
				rebateProgramId
				rebateProgramProductId
				rebateProgramName
				rebateProgramProductName
				createdAt
				validatedAt
				payoutBatchId
				consolidatedPracticeId
				practiceName
			}
			total
		}
	}
`

export function useEnterpriseInvoiceDetectedRebateQuery(
	options?: Omit<Urql.UseQueryArgs<EnterpriseInvoiceDetectedRebateQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		EnterpriseInvoiceDetectedRebateQuery,
		EnterpriseInvoiceDetectedRebateQueryVariables
	>({ query: EnterpriseInvoiceDetectedRebateDocument, ...options })
}
export const RebateInvoicesDocument = gql`
	query rebateInvoices(
		$skip: Int
		$take: Int
		$orderBy: [RebateInvoiceOrderByInput!]
		$where: RebateInvoiceWhereInput
	) {
		rebateInvoices(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				invoiceId
				consolidatedPracticeId
				invoiceDate
				clientFirstName
				clientLastName
				patientName
				invoiceSnapshot
				status
				createdAt
				updatedAt
				invoiceDetectedRebates {
					id
					invoiceId
					originalInvoiceId
					status
					productDescription
					rebateCode
					rebateProgramName
					rejectionReason
					invoiceLineItemId
					ordinal
					payoutBatchId
				}
			}
		}
	}
`

export function useRebateInvoicesQuery(
	options?: Omit<Urql.UseQueryArgs<RebateInvoicesQueryVariables>, 'query'>
) {
	return Urql.useQuery<RebateInvoicesQuery, RebateInvoicesQueryVariables>({
		query: RebateInvoicesDocument,
		...options
	})
}
export const EnterpriseRebateInvoicesDocument = gql`
	query enterpriseRebateInvoices(
		$skip: Int
		$take: Int
		$orderBy: [EnterpriseRebateInvoiceOrderByInput!]
		$where: EnterpriseRebateInvoiceWhereInput
	) {
		enterpriseRebateInvoices(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
			items {
				id
				invoiceId
				consolidatedPracticeId
				invoiceDate
				clientFirstName
				clientLastName
				patientName
				invoiceSnapshot
				status
				createdAt
				updatedAt
				invoiceDetectedRebates {
					id
					invoiceId
					originalInvoiceId
					status
					productDescription
					rebateCode
					rebateProgramName
					rejectionReason
					invoiceLineItemId
					ordinal
					payoutBatchId
				}
			}
		}
	}
`

export function useEnterpriseRebateInvoicesQuery(
	options?: Omit<Urql.UseQueryArgs<EnterpriseRebateInvoicesQueryVariables>, 'query'>
) {
	return Urql.useQuery<EnterpriseRebateInvoicesQuery, EnterpriseRebateInvoicesQueryVariables>({
		query: EnterpriseRebateInvoicesDocument,
		...options
	})
}
export const ApproveRebateDocument = gql`
	mutation ApproveRebate($rebateId: String!, $notes: String) {
		approveRebate(rebateId: $rebateId, notes: $notes) {
			success
			rebate {
				id
				status
				validatedAt
				reviewNotes
			}
			error
		}
	}
`

export function useApproveRebateMutation() {
	return Urql.useMutation<ApproveRebateMutation, ApproveRebateMutationVariables>(
		ApproveRebateDocument
	)
}
export const RejectRebateDocument = gql`
	mutation RejectRebate($rebateId: String!, $reason: String!, $notes: String) {
		rejectRebate(rebateId: $rebateId, reason: $reason, notes: $notes) {
			success
			rebate {
				id
				status
				rejectionReason
				reviewNotes
				validatedAt
				rebateProgramName
				detectedAmount
				invoiceId
			}
			error
		}
	}
`

export function useRejectRebateMutation() {
	return Urql.useMutation<RejectRebateMutation, RejectRebateMutationVariables>(RejectRebateDocument)
}
export const GetNormalizedProductsWithCountDocument = gql`
	query getNormalizedProductsWithCount(
		$where: NormalizedProductWhereInput
		$orderBy: [NormalizedProductOrderByInput!]
		$skip: Int
		$take: Int
	) {
		normalizedProductsWithCount(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			items {
				id
				uuid
				consolidatedPracticeId
				pimsProductDescription
				normalizedProductDescription
				pimsProductUid
				productReferenceId
				productVariantId
				metadata
				createdBy
				createdAt
				updatedAt
				isCheckedManually
				productReference {
					id
					name
					manufacturerId
					brandId
					categoryId
					daysOnTherapy
					notes
					createdAt
					updatedAt
				}
				productVariant {
					id
					productReferenceId
					species
					color
					minWeight
					maxWeight
					weightUnit
					doseOrPackSize
					notes
					createdAt
					updatedAt
				}
			}
			total
		}
	}
`

export function useGetNormalizedProductsWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<GetNormalizedProductsWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		GetNormalizedProductsWithCountQuery,
		GetNormalizedProductsWithCountQueryVariables
	>({ query: GetNormalizedProductsWithCountDocument, ...options })
}
export const GetNormalizedProductsDocument = gql`
	query getNormalizedProducts(
		$where: NormalizedProductWhereInput
		$orderBy: [NormalizedProductOrderByInput!]
		$skip: Int
		$take: Int
	) {
		normalizedProducts(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			id
			uuid
			consolidatedPracticeId
			pimsProductDescription
			normalizedProductDescription
			pimsProductUid
			productReferenceId
			productVariantId
			metadata
			createdBy
			createdAt
			updatedAt
			isCheckedManually
			productReference {
				id
				name
				manufacturerId
				brandId
				categoryId
				daysOnTherapy
				notes
				manufacturer {
					id
					name
				}
				brand {
					id
					name
				}
				category {
					id
					name
				}
				createdAt
				updatedAt
			}
			productVariant {
				id
				productReferenceId
				species
				color
				minWeight
				maxWeight
				weightUnit
				doseOrPackSize
				notes
				createdAt
				updatedAt
			}
		}
	}
`

export function useGetNormalizedProductsQuery(
	options?: Omit<Urql.UseQueryArgs<GetNormalizedProductsQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetNormalizedProductsQuery, GetNormalizedProductsQueryVariables>({
		query: GetNormalizedProductsDocument,
		...options
	})
}
export const GetProductReferencesDocument = gql`
	query getProductReferences(
		$where: ProductReferenceWhereInput
		$orderBy: [ProductReferenceOrderByInput!]
		$skip: Int
		$take: Int
	) {
		productReferences(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			id
			name
			manufacturerId
			brandId
			categoryId
			daysOnTherapy
			notes
			createdAt
			updatedAt
			manufacturer {
				id
				name
			}
			brand {
				id
				name
			}
			category {
				id
				name
			}
		}
	}
`

export function useGetProductReferencesQuery(
	options?: Omit<Urql.UseQueryArgs<GetProductReferencesQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetProductReferencesQuery, GetProductReferencesQueryVariables>({
		query: GetProductReferencesDocument,
		...options
	})
}
export const GetProductReferencesWithCountDocument = gql`
	query getProductReferencesWithCount(
		$where: ProductReferenceWhereInput
		$orderBy: [ProductReferenceOrderByInput!]
		$skip: Int
		$take: Int
	) {
		productReferencesWithCount(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			items {
				id
				name
				manufacturerId
				brandId
				categoryId
				daysOnTherapy
				notes
				createdAt
				updatedAt
				manufacturer {
					id
					name
				}
				brand {
					id
					name
				}
				category {
					id
					name
				}
			}
			total
		}
	}
`

export function useGetProductReferencesWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<GetProductReferencesWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		GetProductReferencesWithCountQuery,
		GetProductReferencesWithCountQueryVariables
	>({ query: GetProductReferencesWithCountDocument, ...options })
}
export const UpsertNormalizedProductDocument = gql`
	mutation upsertNormalizedProduct($upsertArgs: UpsertNormalizedProductInput!) {
		upsertNormalizedProduct(upsertArgs: $upsertArgs) {
			id
			uuid
			consolidatedPracticeId
			pimsProductDescription
			normalizedProductDescription
			pimsProductUid
			productReferenceId
			productVariantId
			metadata
			createdBy
			createdAt
			updatedAt
			productReference {
				id
				name
				manufacturerId
				brandId
				categoryId
				daysOnTherapy
				notes
				createdAt
				updatedAt
			}
			productVariant {
				id
				productReferenceId
				species
				color
				minWeight
				maxWeight
				weightUnit
				doseOrPackSize
				notes
				createdAt
				updatedAt
			}
		}
	}
`

export function useUpsertNormalizedProductMutation() {
	return Urql.useMutation<
		UpsertNormalizedProductMutation,
		UpsertNormalizedProductMutationVariables
	>(UpsertNormalizedProductDocument)
}
export const GetProductVariantsDocument = gql`
	query getProductVariants(
		$where: ProductVariantWhereInput
		$orderBy: [ProductVariantOrderByInput!]
		$skip: Int
		$take: Int
	) {
		productVariants(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			id
			productReferenceId
			productReference {
				id
				name
				manufacturer {
					id
					name
				}
				brand {
					id
					name
				}
				category {
					id
					name
				}
				daysOnTherapy
				notes
				createdAt
				updatedAt
			}
			species
			color
			minWeight
			maxWeight
			weightUnit
			doseOrPackSize
			notes
			createdAt
			updatedAt
		}
	}
`

export function useGetProductVariantsQuery(
	options?: Omit<Urql.UseQueryArgs<GetProductVariantsQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetProductVariantsQuery, GetProductVariantsQueryVariables>({
		query: GetProductVariantsDocument,
		...options
	})
}
export const GetProductVariantsWithCountDocument = gql`
	query getProductVariantsWithCount(
		$where: ProductVariantWhereInput
		$orderBy: [ProductVariantOrderByInput!]
		$skip: Int
		$take: Int
	) {
		productVariantsWithCount(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
			items {
				id
				productReferenceId
				productReference {
					id
					name
					manufacturerId
					brandId
					categoryId
					daysOnTherapy
					notes
					createdAt
					updatedAt
				}
				species
				color
				minWeight
				maxWeight
				weightUnit
				doseOrPackSize
				notes
				createdAt
				updatedAt
			}
			total
		}
	}
`

export function useGetProductVariantsWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<GetProductVariantsWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetProductVariantsWithCountQuery, GetProductVariantsWithCountQueryVariables>(
		{ query: GetProductVariantsWithCountDocument, ...options }
	)
}
export const UpsertProductVariantDocument = gql`
	mutation upsertProductVariant($upsertArgs: UpsertProductVariantInput!) {
		upsertProductVariant(upsertArgs: $upsertArgs) {
			id
			productReferenceId
			species
			color
			minWeight
			maxWeight
			weightUnit
			doseOrPackSize
			notes
		}
	}
`

export function useUpsertProductVariantMutation() {
	return Urql.useMutation<UpsertProductVariantMutation, UpsertProductVariantMutationVariables>(
		UpsertProductVariantDocument
	)
}
export const UpsertProductReferenceDocument = gql`
	mutation upsertProductReference($upsertArgs: UpsertProductReferenceInput!) {
		upsertProductReference(upsertArgs: $upsertArgs) {
			id
			name
			manufacturer {
				id
				name
			}
			brand {
				id
				name
			}
			category {
				id
				name
			}
			manufacturerId
			brandId
			categoryId
			daysOnTherapy
			notes
			createdAt
			updatedAt
		}
	}
`

export function useUpsertProductReferenceMutation() {
	return Urql.useMutation<UpsertProductReferenceMutation, UpsertProductReferenceMutationVariables>(
		UpsertProductReferenceDocument
	)
}
export const DeleteProductVariantDocument = gql`
	mutation deleteProductVariant($id: String!) {
		deleteProductVariant(id: $id)
	}
`

export function useDeleteProductVariantMutation() {
	return Urql.useMutation<DeleteProductVariantMutation, DeleteProductVariantMutationVariables>(
		DeleteProductVariantDocument
	)
}
export const DeleteProductReferenceDocument = gql`
	mutation deleteProductReference($id: String!) {
		deleteProductReference(id: $id)
	}
`

export function useDeleteProductReferenceMutation() {
	return Urql.useMutation<DeleteProductReferenceMutation, DeleteProductReferenceMutationVariables>(
		DeleteProductReferenceDocument
	)
}
export const DeleteNormalizedProductDocument = gql`
	mutation deleteNormalizedProduct($uuid: String!) {
		deleteNormalizedProduct(uuid: $uuid)
	}
`

export function useDeleteNormalizedProductMutation() {
	return Urql.useMutation<
		DeleteNormalizedProductMutation,
		DeleteNormalizedProductMutationVariables
	>(DeleteNormalizedProductDocument)
}
export const PracticeTerminalRebateProgramsDocument = gql`
	query PracticeTerminalRebatePrograms(
		$where: ListActivePracticeRebateProgramWhereInput
		$orderBy: [ListActivePracticeRebateProgramOrderByInput!]
	) {
		activePracticeRebatePrograms(where: $where, orderBy: $orderBy) {
			practiceRebatePrograms {
				id
				practiceMetadata: metadata
				practicePriority: priority
				rebateProgram {
					id
					name
					description
					metadata
				}
			}
		}
	}
`

export function usePracticeTerminalRebateProgramsQuery(
	options?: Omit<Urql.UseQueryArgs<PracticeTerminalRebateProgramsQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		PracticeTerminalRebateProgramsQuery,
		PracticeTerminalRebateProgramsQueryVariables
	>({ query: PracticeTerminalRebateProgramsDocument, ...options })
}
export const SearchPracticesWithRebatesDocument = gql`
	query searchPracticesWithRebates($where: ConsolidatedPracticeWhereInput, $skip: Int, $take: Int) {
		searchPracticesWithRebates(where: $where, skip: $skip, take: $take) {
			total
			skip
			take
			practices {
				id
				name
				isRebateEnabled
				terminalEnabledStatus
			}
		}
	}
`

export function useSearchPracticesWithRebatesQuery(
	options?: Omit<Urql.UseQueryArgs<SearchPracticesWithRebatesQueryVariables>, 'query'>
) {
	return Urql.useQuery<SearchPracticesWithRebatesQuery, SearchPracticesWithRebatesQueryVariables>({
		query: SearchPracticesWithRebatesDocument,
		...options
	})
}
export const DeleteNormalizedProductsPerPracticeDocument = gql`
	mutation deleteNormalizedProductsPerPractice($practiceId: String!) {
		deleteNormalizedProductsPerPractice(practiceId: $practiceId)
	}
`

export function useDeleteNormalizedProductsPerPracticeMutation() {
	return Urql.useMutation<
		DeleteNormalizedProductsPerPracticeMutation,
		DeleteNormalizedProductsPerPracticeMutationVariables
	>(DeleteNormalizedProductsPerPracticeDocument)
}
export const UpdatePracticeRebateProgramSettingsDocument = gql`
	mutation updatePracticeRebateProgramSettings(
		$id: String!
		$priority: Int
		$isTerminalOfferEnabled: Boolean
		$rebatesHandoffHoldoutPct: Float
		$terminalSuppressionKeywords: [String!]
	) {
		updatePracticeRebateProgramSettings(
			id: $id
			priority: $priority
			isTerminalOfferEnabled: $isTerminalOfferEnabled
			rebatesHandoffHoldoutPct: $rebatesHandoffHoldoutPct
			terminalSuppressionKeywords: $terminalSuppressionKeywords
		) {
			id
			practiceId
			rebateProgramId
			metadata
		}
	}
`

export function useUpdatePracticeRebateProgramSettingsMutation() {
	return Urql.useMutation<
		UpdatePracticeRebateProgramSettingsMutation,
		UpdatePracticeRebateProgramSettingsMutationVariables
	>(UpdatePracticeRebateProgramSettingsDocument)
}
export const GetBrandsManufacturersCategoriesDocument = gql`
	query getBrandsManufacturersCategories(
		$brandWhere: BrandReferenceWhereInput
		$brandOrderBy: [BrandReferenceOrderByInput!]
		$brandSkip: Int
		$brandTake: Int
		$manufacturerWhere: ManufacturerWhereInput
		$manufacturerOrderBy: [ManufacturerOrderByInput!]
		$manufacturerSkip: Int
		$manufacturerTake: Int
		$categoryWhere: CategoryReferenceWhereInput
		$categoryOrderBy: [CategoryReferenceOrderByInput!]
		$categorySkip: Int
		$categoryTake: Int
	) {
		brandReferences(
			where: $brandWhere
			orderBy: $brandOrderBy
			skip: $brandSkip
			take: $brandTake
		) {
			id
			name
			createdAt
			updatedAt
		}
		manufacturers(
			where: $manufacturerWhere
			orderBy: $manufacturerOrderBy
			skip: $manufacturerSkip
			take: $manufacturerTake
		) {
			id
			name
			status
			createdAt
			updatedAt
		}
		categoryReferences(
			where: $categoryWhere
			orderBy: $categoryOrderBy
			skip: $categorySkip
			take: $categoryTake
		) {
			id
			name
			createdAt
			updatedAt
		}
	}
`

export function useGetBrandsManufacturersCategoriesQuery(
	options?: Omit<Urql.UseQueryArgs<GetBrandsManufacturersCategoriesQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		GetBrandsManufacturersCategoriesQuery,
		GetBrandsManufacturersCategoriesQueryVariables
	>({ query: GetBrandsManufacturersCategoriesDocument, ...options })
}
export const GetPracticeForRefundPayoutDocument = gql`
	query GetPracticeForRefundPayout($where: PracticeWhereInput) {
		practices(take: 1, where: $where) {
			id
			stripeAccountId
			name
			consolidatorId
			country
			state
		}
	}
`

export function useGetPracticeForRefundPayoutQuery(
	options?: Omit<Urql.UseQueryArgs<GetPracticeForRefundPayoutQueryVariables>, 'query'>
) {
	return Urql.useQuery<GetPracticeForRefundPayoutQuery, GetPracticeForRefundPayoutQueryVariables>({
		query: GetPracticeForRefundPayoutDocument,
		...options
	})
}
export const TriggerRefundPayoutDocument = gql`
	mutation TriggerRefundPayout(
		$stripeAccountId: String!
		$amount: Float!
		$currency: String!
		$description: String
	) {
		triggerRefundPayout(
			stripeAccountId: $stripeAccountId
			amount: $amount
			currency: $currency
			description: $description
		) {
			practiceId
			stripeAccountId
			stripeTransferId
			stripePayoutId
			amount
			currency
			status
		}
	}
`

export function useTriggerRefundPayoutMutation() {
	return Urql.useMutation<TriggerRefundPayoutMutation, TriggerRefundPayoutMutationVariables>(
		TriggerRefundPayoutDocument
	)
}
export const RefundPayoutsDocument = gql`
	query RefundPayouts(
		$skip: Int
		$take: Int
		$orderBy: [RefundPayoutOrderByInput!]
		$where: RefundPayoutWhereInput
	) {
		refundPayouts(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			items {
				id
				issuedBy
				practiceId
				practiceName
				amountTransferred
				amountPaidOut
				currency
				description
				stripeTransferId
				stripePayoutId
				status
				errorReason
				createdAt
			}
			total
			skip
			take
		}
	}
`

export function useRefundPayoutsQuery(
	options?: Omit<Urql.UseQueryArgs<RefundPayoutsQueryVariables>, 'query'>
) {
	return Urql.useQuery<RefundPayoutsQuery, RefundPayoutsQueryVariables>({
		query: RefundPayoutsDocument,
		...options
	})
}
export const ListRefundRequestsDocument = gql`
	query ListRefundRequests(
		$skip: Int
		$take: Int
		$orderBy: [RefundRequestOrderByInput!]
		$where: RefundRequestWhereInput
		$all: Boolean
	) {
		listRefundRequests(skip: $skip, take: $take, orderBy: $orderBy, where: $where, all: $all) {
			total
			skip
			take
			items {
				id
				consolidatorId
				paymentIntentId
				paymentIntent {
					metadata
				}
				originalPaymentAmount
				originalPaymentProcessedAt
				requestedRefundAmount
				requestedById
				requestedByEmail
				requestedBy {
					name
					displayName
				}
				approverRole
				notesRequestor
				status
				pimsClientId
				writebackPimsClientId
				createdAt
				updatedAt
				practice {
					id
					name
					currentPims
				}
				chargeId
				notesApprover
				resolvedAt
				resolvedById
			}
		}
	}
`

export function useListRefundRequestsQuery(
	options?: Omit<Urql.UseQueryArgs<ListRefundRequestsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListRefundRequestsQuery, ListRefundRequestsQueryVariables>({
		query: ListRefundRequestsDocument,
		...options
	})
}
export const CreateRefundRequestDocument = gql`
	mutation CreateRefundRequest(
		$paymentIntentId: String!
		$pimsClientId: String
		$notes: String
		$requestedRefundAmount: Float!
		$chargeId: String
		$writebackPimsClientId: String
	) {
		upsertRefundRequest(
			paymentIntentId: $paymentIntentId
			pimsClientId: $pimsClientId
			notes: $notes
			chargeId: $chargeId
			requestedRefundAmount: $requestedRefundAmount
			writebackPimsClientId: $writebackPimsClientId
		) {
			id
			status
			requestedRefundAmount
		}
	}
`

export function useCreateRefundRequestMutation() {
	return Urql.useMutation<CreateRefundRequestMutation, CreateRefundRequestMutationVariables>(
		CreateRefundRequestDocument
	)
}
export const UpdateRefundRequestDocument = gql`
	mutation UpdateRefundRequest($id: ID!, $status: String!, $notes: String) {
		upsertRefundRequest(id: $id, status: $status, notes: $notes) {
			id
			consolidatorId
			paymentIntentId
			originalPaymentAmount
			originalPaymentProcessedAt
			requestedRefundAmount
			requestedById
			requestedByEmail
			approverRole
			notesRequestor
			notesApprover
			status
			pimsClientId
			writebackPimsClientId
			createdAt
			updatedAt
			chargeId
			notesApprover
			resolvedAt
			resolvedById
		}
	}
`

export function useUpdateRefundRequestMutation() {
	return Urql.useMutation<UpdateRefundRequestMutation, UpdateRefundRequestMutationVariables>(
		UpdateRefundRequestDocument
	)
}
export const ListMonthlyStatementsDocument = gql`
	query ListMonthlyStatements(
		$skip: Int
		$take: Int
		$orderBy: [MonthlyStatementOrderByInput!]
		$where: MonthlyStatementWhereInput
	) {
		monthlyStatements(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
			id
			month
			feeTier
			currency
			numAuthorized
			numSettled
			amountSettled
			surchargeVolume
			tipVolume
			totalFees
			otherFees
			practiceId
			feesCollected
			otherFees
			totalRefunded
			dayLines {
				day
				numAuthorized
				numSettled
				amountSettled
				totalFees
				surchargeVolume
				tipVolume
				totalRefunded
			}
			feeLines {
				feeType
				rate
				amount
				totalFees
			}
			paymentLines {
				paymentMethodType
				numAuthorized
				numSettled
				amountSettled
				totalFees
				surchargeVolume
				tipVolume
			}
		}
	}
`

export function useListMonthlyStatementsQuery(
	options?: Omit<Urql.UseQueryArgs<ListMonthlyStatementsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListMonthlyStatementsQuery, ListMonthlyStatementsQueryVariables>({
		query: ListMonthlyStatementsDocument,
		...options
	})
}
export const StoredPaymentMethodsDocument = gql`
	query StoredPaymentMethods(
		$where: StoredPaymentMethodWhereInput
		$orderBy: [StoredPaymentMethodOrderByInput!]
	) {
		storedPaymentMethods(where: $where, orderBy: $orderBy) {
			id
			customerId
			cardName
			cardBrand
			cardLast4
			cardType
			expiresMonth
			expiresYear
			postalCode
			city
			state
			addressLine1
			addressLine2
			country
			readMethod
			createdAt
			hasAcknowledgement
			acknowledgementMode
			acknowledgedAt
			signatureStatus
			signatureUrl
		}
	}
`

export function useStoredPaymentMethodsQuery(
	options?: Omit<Urql.UseQueryArgs<StoredPaymentMethodsQueryVariables>, 'query'>
) {
	return Urql.useQuery<StoredPaymentMethodsQuery, StoredPaymentMethodsQueryVariables>({
		query: StoredPaymentMethodsDocument,
		...options
	})
}
export const SubscriptionSchedulesDocument = gql`
	query SubscriptionSchedules(
		$skip: Int
		$take: Int
		$orderBy: [SubscriptionScheduleOrderByInput!]
		$where: SubscriptionScheduleWhereInput
		$all: Boolean
	) {
		subscriptionSchedules(orderBy: $orderBy, skip: $skip, take: $take, where: $where, all: $all) {
			id
			applicationFeePercent
			canceledAt
			completedAt
			customerId
			paymentMethodId
			paymentMethodType
			paymentMethodCardBrand
			paymentMethodCardLast4
			paymentMethodCardExpMonth
			paymentMethodCardExpYear
			paymentMethodBankAccountBankName
			paymentMethodBankAccountLast4
			paymentMethodMetadata
			description
			latestInvoiceId
			latestInvoicePaymentIntentId
			latestInvoiceStatus
			latestInvoiceAttemptCount
			latestInvoiceAmountPaid
			latestInvoiceAttempted
			latestInvoiceCreatedAt
			latestInvoiceNumber
			latestInvoicePaid
			latestInvoiceStatusTransitionPaidAt
			onBehalfOfAccountId
			transferDataDestinationAccountId
			metadata
			practiceId
			metadataClientId
			metadataClientName
			metadataClientFirstName
			metadataClientLastName
			consolidatorId
			petName
			phases
			releasedAt
			renewalInterval
			subscriptionId
			subscriptionScheduleStatus
			subscriptionStatus
			firstPaymentOn
			nextPaymentOn
			paymentAmount
			paymentsTotal
			paymentsRemaining
			stripeCreatedAt
			createdAt
			updatedAt
			pauseCollectionBehavior
			pauseCollectionResumesAt
			paymentsAttempted
			paymentsSkipped
			paymentsSucceeded
			paymentsFailed
			nextRetryDate
			attemptCount
			finalPaymentOn
			practice {
				id
				name
				consolidatorReferenceCode
				netsuiteId
				skyworldId
			}
		}
	}
`

export function useSubscriptionSchedulesQuery(
	options?: Omit<Urql.UseQueryArgs<SubscriptionSchedulesQueryVariables>, 'query'>
) {
	return Urql.useQuery<SubscriptionSchedulesQuery, SubscriptionSchedulesQueryVariables>({
		query: SubscriptionSchedulesDocument,
		...options
	})
}
export const SubscriptionSchedulesWithCountDocument = gql`
	query SubscriptionSchedulesWithCount(
		$skip: Int
		$take: Int
		$orderBy: [SubscriptionScheduleOrderByInput!]
		$where: SubscriptionScheduleWhereInput
		$all: Boolean
	) {
		subscriptionSchedulesWithCount(
			orderBy: $orderBy
			skip: $skip
			take: $take
			where: $where
			all: $all
		) {
			items {
				id
				applicationFeePercent
				canceledAt
				completedAt
				customerId
				paymentMethodId
				paymentMethodType
				paymentMethodCardBrand
				paymentMethodCardLast4
				paymentMethodCardExpMonth
				paymentMethodCardExpYear
				paymentMethodBankAccountBankName
				paymentMethodBankAccountLast4
				paymentMethodMetadata
				description
				latestInvoiceId
				latestInvoicePaymentIntentId
				latestInvoiceStatus
				latestInvoiceAttemptCount
				latestInvoiceAmountPaid
				latestInvoiceAttempted
				latestInvoiceCreatedAt
				latestInvoiceNumber
				latestInvoicePaid
				latestInvoiceStatusTransitionPaidAt
				onBehalfOfAccountId
				transferDataDestinationAccountId
				metadata
				practiceId
				metadataClientId
				metadataClientName
				metadataClientFirstName
				metadataClientLastName
				consolidatorId
				petName
				phases
				releasedAt
				renewalInterval
				subscriptionId
				subscriptionScheduleStatus
				subscriptionStatus
				firstPaymentOn
				nextPaymentOn
				paymentAmount
				paymentsTotal
				paymentsRemaining
				stripeCreatedAt
				createdAt
				updatedAt
				pauseCollectionBehavior
				pauseCollectionResumesAt
				paymentsAttempted
				paymentsSkipped
				paymentsSucceeded
				paymentsFailed
				nextRetryDate
				attemptCount
				finalPaymentOn
				practice {
					id
					name
					consolidatorReferenceCode
					netsuiteId
					skyworldId
				}
			}
			total
		}
	}
`

export function useSubscriptionSchedulesWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<SubscriptionSchedulesWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<
		SubscriptionSchedulesWithCountQuery,
		SubscriptionSchedulesWithCountQueryVariables
	>({ query: SubscriptionSchedulesWithCountDocument, ...options })
}
export const ListTerminalTipsDocument = gql`
	query ListTerminalTips(
		$take: Int
		$skip: Int
		$startDate: DateTimeISO
		$endDate: DateTimeISO
		$recipientId: String
	) {
		listTerminalTips(
			take: $take
			skip: $skip
			startDate: $startDate
			endDate: $endDate
			recipientId: $recipientId
		) {
			items {
				id
				createdAt
				tipAmount
				refundedTipAmount
				recipientName
				paymentIntentId
				paymentIntent {
					customerName
					cardholderName
					pimsClientId
					pimsInvoiceId
					baseAmount
					cardBrand
					last4
				}
			}
			total
			skip
			take
		}
	}
`

export function useListTerminalTipsQuery(
	options?: Omit<Urql.UseQueryArgs<ListTerminalTipsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListTerminalTipsQuery, ListTerminalTipsQueryVariables>({
		query: ListTerminalTipsDocument,
		...options
	})
}
export const ListTipRecipientsDocument = gql`
	query ListTipRecipients(
		$take: Int
		$where: TipRecipientWhereInput
		$orderBy: [TipRecipientOrderByInput!]
	) {
		listTipRecipients(take: $take, where: $where, orderBy: $orderBy) {
			id
			name
			isActive
		}
	}
`

export function useListTipRecipientsQuery(
	options?: Omit<Urql.UseQueryArgs<ListTipRecipientsQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListTipRecipientsQuery, ListTipRecipientsQueryVariables>({
		query: ListTipRecipientsDocument,
		...options
	})
}
export const UpsertTipRecipientDocument = gql`
	mutation UpsertTipRecipient($id: ID, $name: String!, $isActive: Boolean) {
		upsertTipRecipient(id: $id, name: $name, isActive: $isActive) {
			id
			name
			isActive
		}
	}
`

export function useUpsertTipRecipientMutation() {
	return Urql.useMutation<UpsertTipRecipientMutation, UpsertTipRecipientMutationVariables>(
		UpsertTipRecipientDocument
	)
}
export const TerminalTipSummaryDocument = gql`
	query TerminalTipSummary($startDate: DateTimeISO!, $endDate: DateTimeISO!) {
		terminalTipSummary(startDate: $startDate, endDate: $endDate) {
			recipientId
			recipientName
			tipCount
			tipVolume
			refundedTipVolume
		}
	}
`

export function useTerminalTipSummaryQuery(
	options: Omit<Urql.UseQueryArgs<TerminalTipSummaryQueryVariables>, 'query'>
) {
	return Urql.useQuery<TerminalTipSummaryQuery, TerminalTipSummaryQueryVariables>({
		query: TerminalTipSummaryDocument,
		...options
	})
}
export const ListUsersDocument = gql`
	query ListUsers(
		$skip: Int
		$take: Int
		$orderBy: [UserOrderByInput!]
		$where: UserWhereInput
		$all: Boolean
	) {
		listUsers(skip: $skip, take: $take, orderBy: $orderBy, where: $where, all: $all) {
			skip
			take
			items {
				consolidatorId
				createdAt
				createdBy
				dashboardUserId
				disabled
				displayName
				email
				emailMapped
				extraEmailForNotifications
				firstName
				id
				initialRole
				isAdmin
				isRegionalManager
				isScratchAdmin
				isUserNameLogin
				lastLoginDate
				lastName
				name
				passwordLastUpdatedAt
				practices {
					isRegionalManager
					isHospitalManager
					isStaff
					practice {
						id
						stripeAccountId
					}
				}
				primaryClinic {
					id
					name
					consolidatorReferenceCode2
					netsuiteId
					skyworldId
				}
				primaryClinicId
				primaryStripeAccountId
				uid
				updatedAt
				username
			}
		}
	}
`

export function useListUsersQuery(
	options?: Omit<Urql.UseQueryArgs<ListUsersQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListUsersQuery, ListUsersQueryVariables>({
		query: ListUsersDocument,
		...options
	})
}
export const ListUsersWithCountDocument = gql`
	query ListUsersWithCount(
		$skip: Int
		$take: Int
		$orderBy: [UserOrderByInput!]
		$where: UserWhereInput
		$all: Boolean
	) {
		listUsersWithCount(skip: $skip, take: $take, orderBy: $orderBy, where: $where, all: $all) {
			total
			skip
			take
			items {
				consolidatorId
				createdAt
				createdBy
				dashboardUserId
				disabled
				displayName
				email
				emailMapped
				extraEmailForNotifications
				firstName
				id
				initialRole
				isAdmin
				isRegionalManager
				isScratchAdmin
				isUserNameLogin
				lastLoginDate
				lastName
				name
				passwordLastUpdatedAt
				practices {
					isRegionalManager
					isHospitalManager
					isStaff
					practice {
						id
						stripeAccountId
					}
				}
				primaryClinic {
					id
					name
					consolidatorReferenceCode2
					netsuiteId
					skyworldId
				}
				primaryClinicId
				primaryStripeAccountId
				uid
				updatedAt
				username
			}
		}
	}
`

export function useListUsersWithCountQuery(
	options?: Omit<Urql.UseQueryArgs<ListUsersWithCountQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListUsersWithCountQuery, ListUsersWithCountQueryVariables>({
		query: ListUsersWithCountDocument,
		...options
	})
}
export const ListUserDocument = gql`
	query ListUser(
		$skip: Int
		$take: Int
		$orderBy: [UserOrderByInput!]
		$where: UserWhereInput
		$all: Boolean
	) {
		listUsers(skip: $skip, take: $take, orderBy: $orderBy, where: $where, all: $all) {
			items {
				consolidatorId
				createdAt
				createdBy
				dashboardUserId
				disabled
				displayName
				email
				emailMapped
				extraEmailForNotifications
				firstName
				id
				initialRole
				isAdmin
				isRegionalManager
				isScratchAdmin
				isUserNameLogin
				lastLoginDate
				lastName
				name
				passwordLastUpdatedAt
				practices {
					isHospitalManager
					isRegionalManager
					isStaff
					practice {
						id
						stripeAccountId
						consolidatorReferenceCode
						consolidatorReferenceCode2
						name
						isRebateEnabled
						isPaymentEnabled
						isLendingEnabled
					}
				}
				primaryClinic {
					id
					name
				}
				uid
				updatedAt
				username
			}
		}
	}
`

export function useListUserQuery(
	options?: Omit<Urql.UseQueryArgs<ListUserQueryVariables>, 'query'>
) {
	return Urql.useQuery<ListUserQuery, ListUserQueryVariables>({
		query: ListUserDocument,
		...options
	})
}
